import mustache from 'mustache';

import moment from 'moment-timezone';
import 'moment/locale/en-ca';
import 'moment/locale/fr-ca';

import { isCONRegion, isEXPRegion, isMXDRegion } from 'utils/misc';

import { AVAILABLE_LANGS } from '../constants';

const ext = process.env.REACT_APP_REGION_EXT;
const app = process.env.REACT_APP_BRAND_NAME;

export const loc = (field, lang = process.env.REACT_APP_REGION_LANGUAGE, dynamicText = {}) => {
    const translations = allTranslations[field];

    if (!translations) {
        return '';
    }

    let language = lang;
    const availableLangs = AVAILABLE_LANGS[process.env.REACT_APP_REGION_EXT];
    if (!availableLangs.includes(lang)) {
        language = 'en';
    }

    const fieldTranslation = translations[language];
    if (!fieldTranslation) {
        return '';
    }

    // Rendering dynamic strings using mustache (needs testing)
    let dynamicTranslation = mustache.render(fieldTranslation, dynamicText);

    if (dynamicTranslation.includes('&amp;')) {
        dynamicTranslation = dynamicTranslation.replace(/&amp;/g, '&');
    }

    // START: Using consecutive string replacement from array

    // const splitTranslation = fieldTranslation.split('%%%');
    // if (splitTranslation.length <= 1) {
    //     // No dynamic text to be inserted
    //     return fieldTranslation || '!';
    // }

    // let dynamicTranslation = '';
    // for (let i = 0; i < splitTranslation.length; i++) {
    //     dynamicTranslation += splitTranslation;
    //     if (i >= dynamicText.length) {
    //         dynamicTranslation += '!';
    //         continue;
    //     }
    //     dynamicTranslation += dynamicText[i];
    // }

    // END: Using consecutive string replacement from array

    return String(dynamicTranslation) || '';
};

const getAdjustedFormat = (lang, format) => {
    // handle custom language formats...
    if (lang === 'fr') {
        switch (format) {
            case 'MMM Do':
                return 'D MMMM';
            case 'MMM Do, YYYY':
                return 'D MMM, YYYY';
            case 'MMM Do h:mm A':
                return 'D MMMM, H[h]mm';
            case 'dddd, MMM Do YYYY':
                return 'dddd D MMMM YYYY';
            case 'h:mm a':
                return 'H[h]mm';
            case 'h:mma':
                return 'H[h]mm';
            case 'h:mm A':
                return 'H[h]mm';
            case 'ddd, h:mm a':
                return 'ddd [à] HH[h]mm';
            case 'ddd, h:mm A':
                return 'ddd [à] HH[h]mm';
            case 'ddd, h:mma':
                return 'ddd [à] HH[h]mm';
            case 'MMM D, YY h:mmA':
                return 'D MMM YY à H[h]mm';
            default:
                return format;
        }
    }

    return format;
};

export const locDate = (
    date,
    format,
    lang = process.env.REACT_APP_REGION_LANGUAGE,
    timezone = process.env.REACT_APP_REGION_TIMEZONE
) => {
    let locale;
    switch (lang) {
        case 'en':
            locale = 'en-ca';
            break;
        case 'fr':
            locale = 'fr-ca';
            break;
        default:
            locale = 'en-ca';
    }

    const adjustedFormat = getAdjustedFormat(lang, format);

    return moment(date)
        .tz(timezone)
        .locale(locale)
        .format(adjustedFormat);
};

const terms = {
    AUS: {
        registration1: {
            en: 'ReCollect. It’s worth it.',
            fr: ''
        },
        registration7: {
            en: 'Home or unit pickups. Cash out or donate returns!',
            fr: 'Ramassages résidentiels, de condos ou retour express. Encaissez ou donnez votre consigne!'
        },
        registration15: {
            en: 'Business pickups. Cash out or donate returns!',
            fr: 'Commerciaux ou retour express. Encaissez ou donnez votre consigne!'
        },
        organization: {
            en: 'Organisation',
            fr: ''
        },
        charityNumName: {
            en: `Australian Business Number`,
            fr: `Numéro d'enregistrement de l'organisme de bienfaisance`
        },
        REGISTRATION_TAGLINE: {
            en: `${app} picks up and pays you for your bottles & cans. We also take used clothing and old electronics off your hands free of charge.`,
            fr: `${app} vient chercher et vous rembourse vos contenants consignés. Nous récupérons également gratuitement vos vêtements usagés et vos vieux appareils électroniques.`
        },
        ETRANSFERS_NAME: {
            en: 'Electronic Fund Transfer',
            fr: 'Electronic Fund Transfer'
        },
        ETRANSFERS_NAME_SHORT: {
            en: 'EFT',
            fr: 'EFT'
        }
    },
    STD: {
        registration1: {
            en: 'Bottles & Cans. Clothing. Electronics.',
            fr: ''
        },
        registration7: {
            en: 'Home, condo pickups or Drop&Go. Cash out or donate returns!',
            fr:
                'Ramassages résidentiels, de condos ou retours express aux lieux de retour. Encaissez ou donnez votre consigne!'
        },
        registration15: {
            en: 'Business pickups or Drop&Go. Cash out or donate returns!',
            fr: 'Commerciaux ou retours express aux lieux de retour. Encaissez ou donnez votre consigne!'
        },
        organization: {
            en: 'Organization',
            fr: ''
        },
        charityNumName: {
            en: `Charity Registration Number`,
            fr: `Numéro d'enregistrement de l'organisme de bienfaisance`
        },
        REGISTRATION_TAGLINE: {
            en: `${app} picks up and pays you for your bottles & cans. We also take used clothing and old electronics off your hands free of charge.`,
            fr: `${app} vient chercher et vous rembourse vos contenants consignés. Nous récupérons également gratuitement vos vêtements usagés et vos vieux appareils électroniques.`
        },
        ETRANSFERS_NAME: {
            en: 'Interac e-Transfer',
            fr: 'Virement électronique'
        },
        ETRANSFERS_NAME_SHORT: {
            en: 'e-Transfer',
            fr: 'virement électronique'
        }
    },
    ABD: {
        registration1: {
            en: 'Bottles & Cans. Clothing. Electronics.',
            fr: ''
        },
        registration7: {
            en: 'Home, condo pickups or Bag Drop. Cash out or donate returns!',
            fr:
                'Ramassages résidentiels, de condos ou retours express aux lieux de retour. Encaissez ou donnez votre consigne!'
        },
        registration15: {
            en: 'Business pickups or Bag Drop. Cash out or donate returns!',
            fr: 'Commerciaux ou retours express aux lieux de retour. Encaissez ou donnez votre consigne!'
        },
        organization: {
            en: 'Organization',
            fr: ''
        },
        charityNumName: {
            en: `Charity Registration Number`,
            fr: `Numéro d'enregistrement de l'organisme de bienfaisance`
        },
        REGISTRATION_TAGLINE: {
            en: `${app} picks up and pays you for your bottles & cans. We also take used clothing and old electronics off your hands free of charge.`,
            fr: `${app} vient chercher et vous rembourse vos contenants consignés. Nous récupérons également gratuitement vos vêtements usagés et vos vieux appareils électroniques.`
        },
        ETRANSFERS_NAME: {
            en: 'Interac e-Transfer',
            fr: 'Virement électronique'
        },
        ETRANSFERS_NAME_SHORT: {
            en: 'e-Transfer',
            fr: 'virement électronique'
        }
    },
    EXP: {
        registration1: {
            en: '',
            fr: ''
        },
        registration7: {
            en: 'Individuals or households',
            fr: 'Particuliers ou ménages'
        },
        registration15: {
            en: 'Deposit refund issued to registered businesses',
            fr: 'Remboursement de dépôt délivré aux entreprises enregistrées'
        },
        organization: {
            en: 'Organization',
            fr: ''
        },
        charityNumName: {
            en: `Charity Registration Number`,
            fr: `Numéro d'enregistrement de l'organisme de bienfaisance`
        },
        REGISTRATION_TAGLINE: {
            en: `A convenient and cashless way to recycle used beverage containers`,
            fr: `Un moyen pratique et sans espèces de recycler les contenants de boissons usagés`
        },
        ETRANSFERS_NAME: {
            en: 'Interac e-Transfer',
            fr: 'Virement électronique'
        },
        ETRANSFERS_NAME_SHORT: {
            en: 'e-Transfer',
            fr: 'virement électronique'
        }
    },
    MXD: {
        registration1: {
            en: 'Bottles & Cans. Clothing. Electronics.',
            fr: ''
        },
        registration7: !isMXDRegion()
            ? {
                  en: 'Home, condo units pickups or Bag Drop. Cash out or donate returns!',
                  fr: 'Retours express aux lieux de retour '
              }
            : {
                  en: 'Bag deposit',
                  fr: 'Retour express'
              },
        registration15: !isMXDRegion()
            ? {
                  en: 'Business or Bag Drop. Cash out or donate returns!',
                  fr: 'Retours express aux lieux de retour ou ramassages commerciaux (consommation sur place)'
              }
            : {
                  en: 'Commercial collection',
                  fr: 'Collecte commerciale'
              },
        organization: {
            en: 'Organization',
            fr: ''
        },
        charityNumName: {
            en: `Charity Registration Number`,
            fr: `Numéro d'enregistrement de l'organisme de bienfaisance`
        },
        REGISTRATION_TAGLINE: {
            en: `Sign up below and discover new ways to collect your returnable containers.`,
            fr: `Inscrivez-vous ci-dessous et découvrez de nouvelles façons de récupérer vos contenants consignés.`
        },
        ETRANSFERS_NAME: {
            en: 'Interac e-Transfer',
            fr: 'Virement électronique'
        },
        ETRANSFERS_NAME_SHORT: {
            en: 'e-Transfer',
            fr: 'virement électronique'
        }
    },
    CON: {
        registration1: {
            en: 'Bottles & Cans.',
            fr: ''
        },
        registration7: {
            en: 'Return point services',
            fr: 'Services points de retour'
        },
        registration15: {
            en: 'Business or Bag Drop. Cash out returns!',
            fr: 'Affaires ou retour express. Retours encaissés'
        },
        organization: {
            en: 'Organization',
            fr: 'Organisation'
        },
        charityNumName: {
            en: `Charity Registration Number`,
            fr: `Numéro d'enregistrement de l'organisme de bienfaisance`
        },
        REGISTRATION_TAGLINE: {
            en: `Sign up below and discover new ways to collect your returnable containers.`,
            fr: `Inscrivez-vous ci-dessous et découvrez de nouvelles façons de récupérer vos contenants consignés.`
        },
        ETRANSFERS_NAME: {
            en: 'Interac e-Transfer',
            fr: 'Virement électronique'
        },
        ETRANSFERS_NAME_SHORT: {
            en: 'e-Transfer',
            fr: 'virement électronique'
        }
    }
}[ext];

const sideWidgetTranslations = {
    customerInfo: {
        en: 'Customer Info',
        fr: 'Customer Info'
    }
};

const confirmPickupTranslations = {
    confirmPickup1: {
        en: "We're coming to {{address}} on {{date}}!",
        fr: 'Nous arrivons à {{address}} le {{date}}!'
    },
    confirmPickup2a: {
        en: 'Enter the number of recycling bags we can expect, or click postpone to reschedule to the following week.',
        fr:
            'Saisissez le nombre de sacs de contenants consignés auxquels nous pouvons nous attendre ou cliquez sur reporter pour reporter à la semaine suivante.'
    },
    confirmPickup2b: {
        en: `Enter the number of recycling bags we can expect, or click postpone to reschedule {{frequencyWeeks}} weeks out.`,
        fr:
            'Entrez le nombre de sacs de contenants auxquels nous pouvons nous attendre, ou cliquez sur reporter pour replanifier {{frequencyWeeks}} semaines plus tard.'
    },
    confirmPickup3: {
        en: 'Confirm your pickup',
        fr: 'Confirmez votre collecte'
    },
    confirmPickup4: {
        en: 'You can still make changes to your pickup up until 7 AM on the day of the pickup.',
        fr: "Vous pouvez encore apporter des modifications à votre collecte jusqu'à 7 h le jour même de la collecte."
    },
    confirmPickup5: {
        en: 'Close',
        fr: 'Fermé'
    },
    confirmPickup6: {
        en: 'Not right now',
        fr: 'Pas tout de suite'
    },
    confirmPickup7: {
        en: 'Postpone by {{frequencyWeeks}} week',
        fr: "Reporté d'une semaine"
    },
    confirmPickup8: {
        en: 'Yes, I want this pickup',
        fr: 'Oui, je veux cette collecte'
    }
};

const cancelPickupTranslations = {
    cancelPickup1: {
        en: 'Cancel Your Pickup?',
        fr: 'Annuler votre collecte?'
    },
    cancelPickup2: {
        en: 'You can cancel your pickup up to one day before the date scheduled.',
        fr: "Vous pouvez annuler votre collecte jusqu'à un jour avant la date prévue."
    },
    cancelPickup3: {
        en: 'Why are you cancelling?',
        fr: 'Pourquoi annulez-vous?'
    },
    cancelPickup3a: {
        en: 'I need a pickup sooner',
        fr: "J'ai besoin d'une collecte plus tôt"
    },
    cancelPickup3b: {
        en: 'I will re-book later',
        fr: 'Je réserverai plus tard'
    },
    cancelPickup3c: {
        en: 'I gave the bags away',
        fr: "J'ai donné les sacs"
    },
    cancelPickup3d: {
        en: 'I don’t like this service',
        fr: "Je n'aime pas ce service"
    },
    cancelPickup3e: {
        en: 'Other',
        fr: 'Autre'
    },
    cancelPickup4: {
        en: 'Reason',
        fr: 'Raison'
    },
    cancelPickup5: {
        en: 'How can we do better',
        fr: 'Comment pouvons-nous faire mieux'
    },
    cancelPickup6: {
        en: 'Who did you donate to',
        fr: 'A qui avez-vous fait un don'
    },
    cancelPickup7: {
        en: 'Wait! Does this date work?',
        fr: 'Attendez! Est-ce que cette date fonctionne?'
    },
    cancelPickup8: {
        en: 'Your area is serviced next on {{date}}',
        fr: 'Votre zone sera desservie le {{date}}'
    },
    cancelPickup9: {
        en: 'No, cancel pickup',
        fr: 'Non, annuler la collecte'
    },
    cancelPickup10: {
        en: 'yes, use {{date}}',
        fr: 'oui, utilisez {{date}}'
    },
    cancelPickup11: {
        en: 'You have cancelled your pickup',
        fr: 'Vous avez annulé votre collecte'
    },
    cancelPickup12: {
        en: 'Wait! Can we leave the pickup reminder?',
        fr: 'Attendez! Pouvons-nous garder le rappel de collecte?'
    },
    cancelPickup13: {
        en: `{{brand}} works best with a recurring schedule. Leaving the pickup reminder, allows us to service your community better. There's no obligations or fees for leaving the reminder.`,
        fr:
            "{{brand}} fonctionne mieux avec un horaire récurrent. Conserver le rappel de collecte nous permet de mieux desservir votre communauté. Il n'y a aucune obligation ni frais pour garder le rappel."
    },
    cancelPickup14: { en: `Yes, But move reminder to {{date}}`, fr: 'Oui, mais déplacez le rappel vers {{date}}' },
    cancelPickup15: { en: 'Rescheduled pickup', fr: 'Collecte reportée' },
    cancelPickup16: {
        en: 'Failed to reschedule pickups. Please try again in a moment.',
        fr: 'Échec du report des collectes. Veuillez réessayer dans un instant.'
    },
    cancelPickup17: {
        en: 'Are you sure you want to cancel this commodity pickup?',
        fr: 'Êtes-vous sûr de vouloir annuler cette collecte de matières recyclables?'
    }
};

const pickupWidgetTranslations = {
    pickupWidgets2: {
        en: 'Your customer ID is {{id}}',
        fr: 'Votre identifiant client est {{id}}'
    },
    pickupWidgets3: {
        en: 'We got your {{commodityUOM}}s!',
        fr: 'Nous avons vos sacs!'
    },
    pickupWidgets4: {
        en: '{{{type}}} waiting for counts',
        fr: 'En attente du décompte du/des sacs'
    },
    pickupWidgets5a: {
        en: 'Details for your last {{orderType}}',
        fr: 'Détails de votre dernier {{orderType}}'
    },

    pickupWidgets5b: {
        en: '{{orderType}} Alert',
        fr: '{{orderType}} Alerte'
    },

    pickupWidgets6: {
        en: 'Suggestions for your next {{orderType}}',
        fr: 'Suggestions pour votre prochain {{orderType}}'
    },
    pickupWidgets7: {
        en: 'Awaiting driver confirmation',
        fr: 'En attente de confirmation du chauffeur'
    },
    pickupWidgets8: {
        en: 'Your pickups',
        fr: 'Vos collectes'
    },
    pickupWidgets9: {
        en: 'Your last pickup',
        fr: 'Votre dernière collecte'
    },
    pickupWidgets10: {
        en: 'Your next pickup',
        fr: 'Votre prochaine collecte'
    },
    pickupWidgets11: {
        en: '{{commodityUOM}}s will be counted within a maximum of {{daysToCount}} days.',
        fr: 'Les sacs seront comptés dans un délai maximum de {{daysToCount}} jours.'
    },
    pickupWidgets12a: {
        en: 'We have suggestions for you based on your last {{orderType}}. Press the info icon for details.',
        fr:
            "Nous avons des suggestions pour vous en fonction de votre dernier {{orderType}}. Appuyez sur l'icône d'information pour plus de détails."
    },
    pickupWidgets12b: {
        en: 'Your last return has issues that may suspend your account. Press the info icon for details.',
        // 'Your last return did not meet {{orderType}} requirements and may result in your account {{penaltyDetails}}. Press the info icon for more details.',
        fr:
            "Votre dernière déclaration comporte des problèmes susceptibles de suspendre votre compte. Appuyez sur l'icône d'informations pour plus de détails."
    },
    pickupWidgets12EXP: {
        en: 'A recent return did not meet requirements and may suspend your account. Click "i" for details.',
        fr:
            'Un retour récent ne répond pas aux exigences et peut suspendre votre compte. Cliquez sur "i" pour plus de détails.'
    },
    pickupWidgets12c: {
        en: 'being suspended',
        fr: 'la suspension de votre compte'
    },
    pickupWidgets12d: {
        en: 'being placed under review',
        fr: 'la mise en examen de votre compte'
    },
    pickupWidgets12e: {
        en: 'status changing.',
        fr: 'une modification du statut de votre compte'
    },
    pickupWidgets13: {
        en: 'Press here to get started!',
        fr: 'Appuyez pour commencer!'
    },
    pickupWidgets14: {
        en: 'Click here to book a pickup!',
        fr: 'Cliquez ici pour réserver une collecte!'
    },
    pickupWidgets15: {
        en: 'Affiliated with {{charityName}}',
        fr: 'Affilié à {{charityName}}'
    },
    pickupWidgets16: {
        en: 'Sorry we are not servicing this area at the moment, we will notify you when we are.',
        fr: "Restez à l'affût et nous vous informerons lorsqu'un chauffeur sera disponible!"
    },
    pickupWidgets17: {
        en: 'High Priority',
        fr: 'Haute priorité'
    },
    pickupWidgets18: {
        en: 'No donation preference',
        fr: 'Aucune préférence de don'
    },
    pickupWidgets19: {
        en: 'Donating to {{{charity}}}',
        fr: 'Faire un don à {{{charity}}}'
    },
    pickupWidgets20: {
        en: 'Write {{id}} on your bags!',
        fr: 'Écrivez {{id}} sur vos sacs !'
    },
    pickupWidgets21: {
        en: 'Action required: press here to confirm',
        fr: 'Action requise : appuyez ici pour confirmer'
    },
    pickupWidgets22: {
        en: 'You have {{numPickups}} pending pickups',
        fr: 'Vous avez {{numPickups}} collectes en attente'
    },
    pickupWidgets23: {
        en: 'Your pickups',
        fr: 'Vos collectes'
    },
    pickupWidgets24: {
        en: 'Your last {{{pickup}}} was completed on {{date}}. See history for more details.',
        fr: "Votre dernière {{{pickup}}} a été complétée le {{date}}. Consultez l'historique pour plus de détails."
    },
    pickupWidgetsExpQuickDropAlt: {
        en: 'Drop-Off',
        fr: 'Déposer'
    },
    pickupWidgets25: {
        en: 'There was a problem with your last pickup scheduled for {{date}}. See history for more details',
        fr:
            "Il y a eu un problème avec votre dernière collecte prévue pour le {{date}}. Consultez l'historique pour plus de détails"
    },
    pickupWidgets26: {
        en: 'We got your pickup!',
        fr: 'Nous avons bien reçu votre demande de collecte!'
    },
    pickupWidgets27: {
        en: 'We got your pickups!',
        fr: 'Nous avons bien reçu vos demandes de collecte!'
    },
    pickupWidgets28: {
        en: 'Picked up at {{time}} on {{date}}',
        fr: 'Récupéré à {{time}} le {{date}}'
    },
    pickupWidgets29: {
        en: 'Your items will be processed shortly and your account updated within {{daysToCount}} days of pickup.',
        fr:
            'Vos articles seront traités sous peu et votre compte sera mis à jour dans les {{daysToCount}} jours suivant la collecte.'
    },
    pickupWidgets30: {
        en: 'Only certain beverage containers are eligible for a refund. For more information please follow the link',
        fr:
            "Seuls certains contenants sont admissibles à un remboursement de consigne. Pour plus d'informations, veuillez suivre le lien"
    },
    pickupWidgets31: {
        en: 'We have a few suggestions to help make the process smoother next time. We kindly ask that you:',
        fr:
            'Nous avons quelques suggestions pour faciliter le processus la prochaine fois. Nous vous prions de bien vouloir :'
    },
    pickupWidgets32: {
        en: 'Your Last {{{type}}}',
        fr: 'Votre dernier {{{type}}}'
    },
    pickupWidgets32b: {
        en: 'Your last drop-off',
        fr: 'Votre dernier dépôt'
    },
    pickupWidgets33: {
        en: 'Bags will be counted and your account updated within {{{days}}} days of the drop off date.',
        fr: 'Vos sacs seront comptés et votre compte client sera crédité dans les prochains {{{days}}} jours.'
    },
    pickupWidgets34: {
        en: 'Set donation preference',
        fr: 'Définir les préférences de don'
    },
    pickupWidgets34Exp: {
        en: 'Set Automatic Donation',
        fr: 'Définir le don Automatique'
    },
    pickupWidgets35: {
        en: 'Select Organization',
        fr: "Sélectionner l'organisme"
    },
    pickupWidgets36: {
        en: 'Select an organization to automatically donate your balance to.',
        fr: 'Sélectionnez un organisme auquel votre solde sera automatiquement donné.'
    },
    pickupWidgets37: {
        en: 'Automatic Donation Preference',
        fr: 'Préférence de don automatique'
    }
};

const managePickupsDialogTranslations = {
    managePickups1: {
        en: 'not donating',
        fr: 'ne pas faire de don'
    },
    managePickups2: {
        en: 'no promo',
        fr: 'pas de promo'
    },
    managePickups3: {
        en: 'edit',
        fr: 'modifier'
    },
    managePickups4: {
        en: 'cancel',
        fr: 'annuler'
    },
    managePickups5: {
        en: 'Book additional pickup',
        fr: 'Réserver une collecte supplémentaire'
    },
    managePickups6: {
        en: 'Multi-location Pickups',
        fr: 'Collectes à emplacements multiples'
    },
    managePickups7a: {
        en: 'Do you need to manage multiple locations?',
        fr: 'Avez-vous besoin de gérer plusieurs emplacements?'
    },
    managePickups7email: {
        en: 'Email us',
        fr: 'Envoyez-nous un courriel'
    },
    managePickups7b: {
        en: 'to enable this feature and increase your pickup limit!',
        fr: 'pour activer cette fonctionnalité et augmenter votre limite de collectes!'
    },
    managePickups8: {
        en: 'Manage Your Pickups',
        fr: 'Modifiez vos collectes'
    }
};

const sidebarTranslations = {
    admin: {
        en: 'Administrator',
        fr: 'Administrateur'
    },
    dashboard: {
        en: 'Dashboard',
        fr: 'Tableau De Bord'
    },
    home: {
        en: 'Home',
        fr: 'Accueil'
    },
    history: {
        en: 'History',
        fr: 'Historique'
    },
    organisation: {
        en: 'Organization',
        fr: 'Organization'
    },
    donations: {
        en: 'Donations',
        fr: 'Dons'
    },
    taxReceipts: {
        en: 'Tax Receipts',
        fr: 'Reçus Fiscaux'
    },
    subdivisions: {
        en: 'Subdivisions',
        fr: 'Sous-divisions'
    },
    emailOutDirectly: {
        en: 'Email Out Directly',
        fr: 'Envoyer directement par courriel'
    },
    account: {
        en: 'Account',
        fr: 'Profil'
    },
    mfa: {
        en: 'Multi-Factor Authentication',
        fr: 'Authentification à multiples facteurs'
    },
    getStartedHere: {
        en: 'Get Started Here',
        fr: 'Commencer ici'
    },
    editPickup: {
        en: 'Edit Pickup',
        fr: 'Modifier la collecte'
    },
    cashOut: {
        en: 'Cash Out',
        fr: 'Remboursement'
    },
    cashOutExp: {
        en: 'Redeem Funds',
        fr: 'Échanger des fonds'
    },
    cashOutAndDisable: {
        en: 'Cash Out and Close Account',
        fr: 'Remboursement et fermer le compte'
    },
    redeemAndDisable: {
        en: 'Redeem and Close Account',
        fr: 'Rembourser et fermer le compte'
    },
    donateAndDisable: {
        en: 'Donate and Close Account',
        fr: 'Faire un don et fermer le compte'
    },
    cashOutAndDelete: {
        en: 'Cash Out and Delete Account',
        fr: 'Remboursement et supprimer le compte'
    },
    redeemAndDelete: {
        en: 'Redeem and Delete Account',
        fr: 'Rembourser et supprimer le compte'
    },
    donateAndDelete: {
        en: 'Donate and Delete Account',
        fr: 'Faire un don et supprimer le compte'
    },
    redeem: {
        en: 'Cash Out',
        fr: 'Remboursement'
    },
    redeemedBy: {
        en: 'Redeemed By',
        fr: 'Échangé par'
    },
    earnMoney: {
        en: 'Earn Money',
        fr: "Gagnez de l'argent"
    },
    growthPlan: {
        en: 'Growth Plan',
        fr: 'Plan de croissance'
    },
    growthTips: {
        en: 'Growth Tips',
        fr: 'Conseils de croissance'
    },
    impactReport: {
        en: 'Impact Report',
        fr: "Rapport d'impact"
    },
    volumeReport: {
        en: 'Volume Report',
        fr: 'Rapport de volumes'
    },
    clerkReport: {
        en: 'Clerk Report',
        fr: 'Rapport du commis'
    },
    liveCounts: {
        en: 'Live Counts',
        fr: 'Décomptes en temps réel'
    },
    nightMode: {
        en: 'Night Mode',
        fr: 'Mode Nuit'
    },
    signOut: {
        en: 'Sign Out',
        fr: 'Se déconnecter'
    },
    signOutAll: {
        en: 'Sign Out All Devices',
        fr: 'Déconnectez tous les appareils'
    },
    removeDevice: {
        en: 'Remove Device',
        fr: `Enlevez l'appareil`
    },
    hasPushNotification: {
        en: 'Push notificiation enabled',
        fr: `Notification push activée`
    },
    removeTrustedDevice: {
        en: 'Remove Trusted Device',
        fr: "Retirer l'appareil de confiance"
    },
    help: {
        en: 'Help',
        fr: 'Aide'
    },
    openDoor: {
        en: 'Unlock Door',
        fr: 'Ouvre la porte'
    },
    printLabels: {
        en: 'Print Labels',
        fr: 'Imprimer des autocollants'
    },
    requestLabels: {
        en: 'Request Labels',
        fr: 'Demander des autocollants'
    },
    donateExpressApp: {
        en: 'Donate Funds',
        fr: 'Faire un don de fonds'
    },
    pendingApproval: {
        en: 'Pending Approval',
        fr: "En attente d'approbation"
    },
    tripStatistics: {
        en: 'Trip Statistics',
        fr: 'Statistiques de trajet'
    },
    OTCExternal: {
        en: 'OTC & External',
        fr: 'OTC & Externe'
    },
    processorsAndTransporters: {
        en: 'Processors & Transporters',
        fr: 'Processeurs et transporteurs'
    },
    processors: {
        en: 'Processors',
        fr: 'Processeurs'
    }
};

const dashboardTranslations = {
    dashboardFinancial1: {
        en: '{{organization}} Balance',
        fr: "Solde de l'organisation"
    },
    dashboardFinancial2: {
        en: 'Previous cash out of {{amount}} pending',
        fr: 'Remboursement précédent de {{amount}} en attente'
    },
    dashboardFinancial2EXP: {
        en: 'Previous redemption of {{amount}} pending',
        fr: 'Remboursement précédent de {{amount}} en attente'
    },
    dashboardFinancial3: {
        en: 'Previous cash out of {{amount}} complete',
        fr: 'Remboursement précédent de {{amount}} terminé'
    },
    dashboardFinancial3EXP: {
        en: 'Previous redemption of {{amount}} complete',
        fr: 'Remboursement précédent de {{amount}} terminé'
    },
    dashboardFinancial3b: {
        en: 'Previous cash out of {{amount}} cancelled',
        fr: 'Encaissement précédent de {{amount}} annulé'
    },
    dashboardFinancial3bEXP: {
        en: 'Previous redemption of {{amount}} cancelled',
        fr: 'Remboursement précédent de {{amount}} annulé'
    },
    dashboardFinancial4: {
        en: '{{amount}} donated from your last return',
        fr: '{{amount}} en don depuis votre dernier retour'
    },
    dashboardFinancial4b: {
        en: '{{amount}} was donated to {{{charity}}}',
        fr: '{{amount}} reversé à {{{charity}}}'
    },
    dashboardFinancial5: {
        en: 'Outstanding Tax Receipts',
        fr: 'Reçus fiscaux impayés'
    },
    dashboardFinancial6: {
        en: 'Account Balance',
        fr: 'Solde du compte'
    },
    dashboardFinancial7: {
        en: 'You are donating to {{{charity}}}',
        fr: 'Vous faites un don à {{{charity}}}'
    },
    dashboardFinancial8: {
        en: 'days left to redeem',
        fr: 'jours restants pour racheter'
    },
    dashboardStats1: {
        en: 'Total revenue',
        fr: 'Revenu total'
    },
    dashboardStats2: {
        en: 'Total donations',
        fr: 'Total des dons'
    },
    dashboardStats3: {
        en: 'Total containers',
        fr: 'Total des contenants'
    },
    dashboardStats4: {
        en: 'Greenhouse gas saved',
        fr: 'Gaz à effet de serre économisé'
    },
    dashboardStats5: {
        en: 'Energy saved',
        fr: 'Énergie économisée'
    },
    dashboardStats6: {
        en: 'Spared from landfill',
        fr: "Détourné du site d'enfouissement"
    },
    dashboardStats7: {
        en: 'All Locations',
        fr: 'Tous les emplacements'
    },
    dashboardCharityInfo1: {
        en: 'Teams/Groups/Bottle drives:',
        fr: 'Equipes/Groupes/Collectes de contenants:'
    },
    dashboardCharityInfo2: {
        en: 'Website',
        fr: 'Site Internet'
    },
    dashboardCharityInfo3: {
        en: 'Referral link',
        fr: 'Lien de référence'
    },
    dashboardCharityInfo4: {
        en: 'E-Transfer email:',
        fr: 'Courriel de transfert électronique:'
    },
    dashboardCharityInfo5: {
        en: 'Referral link will be assigned when your application is approved.',
        fr: 'Le lien de référence sera attribué lorsque votre candidature sera approuvée.'
    },
    dashboardGrowthPlan1: {
        en: 'Your Growth Plan',
        fr: 'Votre plan de croissance'
    },
    dashboardGrowthPlan1EXP: {
        en: 'Your Growth Tips',
        fr: 'Vos conseils de croissance'
    },
    dashboardGrowthPlan2: {
        en: 'Come here once approved to view your growth plan',
        fr: 'Venez ici une fois approuvé pour voir votre plan de croissance'
    },
    dashboardGrowthPlan2EXP: {
        en: 'Come here once approved to view your growth tips',
        fr: 'Venez ici une fois approuvé pour consulter vos conseils de croissance'
    },
    dashboardGrowthPlan3: {
        en: 'Growth Plan Information',
        fr: 'Renseignements sur le plan de croissance'
    },
    dashboardGrowthPlan3EXP: {
        en: 'Growth Tips Information',
        fr: 'Informations sur les conseils de croissance'
    },
    dashboardGrowthInfo1: {
        en: 'Current status',
        fr: 'Statut actuel'
    },
    dashboardGrowthInfo2: {
        en: 'Your growth plan will be available when your {{organization}} is approved.',
        fr: 'Votre plan de croissance sera disponible lorsque votre {{organization}} aura été approuvée.'
    },
    dashboardGrowthInfo2EXP: {
        en: 'Your growth tips will be available when your {{organization}} is approved.',
        fr: 'Vos conseils de croissance seront disponibles lorsque votre {{organization}} sera approuvée.'
    },
    dashboardGrowthInfo3: {
        en: 'Waiting for approval',
        fr: "En attente d'approbation"
    },
    dashboardGrowthInfo4: {
        en:
            "We've created {{countCompletable}} simple tasks based on best practices to help boost your recycling program's visibility. From adding a donation link to your website to ordering custom bags, these tasks are easy to complete in any order!",
        fr:
            "Nous avons créé {{countCompletable}} tâches simples basées sur les meilleures pratiques pour aider à augmenter la visibilité de votre programme de recyclage. Qu'il s'agisse d'ajouter un lien de don à votre site web ou de commander des sacs personnalisés, ces tâches sont faciles à réaliser dans n'importe quel ordre!"
    },
    dashboardGrowthInfo4EXP: {
        en: 'We have compiled {{countCompletable}} tips and tricks to help you promote your organization!',
        fr:
            'Nous avons rassemblé {{countCompletable}} conseils et astuces pour vous aider à promouvoir votre organisation !'
    },
    dashboardGrowthInfo5: {
        en: 'You have {{countComplete}} out of {{countCompletable}} tasks in your growth plan completed!',
        fr: 'Vous avez {{countComplete}} tâches sur {{countCompletable}} complétées dans votre plan de croissance!'
    },
    dashboardGrowthInfo5EXP: {
        en: 'You have completed {{countComplete}} out of {{countCompletable}} tips to promote your organization!',
        fr:
            'Vous avez complété {{countComplete}} sur {{countCompletable}} conseils pour promouvoir votre organisation !'
    },
    dashboardGrowthInfo6: {
        en: 'Become a Featured {{organization}}',
        fr: 'Devenez une Organisations Affiliés'
    },
    dashboardGrowthInfo7a: {
        en: 'You are a featured charity!',
        fr: 'Vous êtes une œuvre de charité mise en vedette !'
    },
    dashboardGrowthInfo7b: {
        en: "Complete the last {{countRemaining}} tasks to further boost {{charityName}}'s program visibility.",
        fr:
            "Terminez et soumettez 5 éléments ou plus du Plan de croissance pour que {{organization}} soit qualifiée comme organisation en vedette. Les organisations en vedette sont présentées aux clients de {{brand}} lorsqu'ils s'inscrivent, réservent une collecte et consultent leur tableau de bord. "
    },
    dashboardGrowthInfo7aEXP: {
        en:
            'Complete and submit 5 or more tips to qualify for a Featured {{organization}} position. Featured {{organization}}s are shown to {{brand}} customers when they register as well as on the customers dashboard.',
        fr:
            "Terminez et soumettez 5 conseils ou plus pour que {{organization}} soit qualifiée comme organisation en vedette. Les organisations en vedette sont présentées aux clients de {{brand}} lorsqu'ils s'inscrivent ainsi que sur le tableau de bord des clients."
    },
    dashboardGrowthInfo7c: {
        en: 'Complete {{countRemaining}} more',
        fr: 'Complétez encore {{countRemaining}} tâches'
    },
    dashboardGrowthInfo7d: {
        en: 'tasks and we will feature {{charityName}} to users during sign-up, bookings, and dashboards.',
        fr:
            "tâches, et nous mettrons {{charityName}} en vedette auprès des utilisateurs lors de l'inscription, des réservations et sur les tableaux de bord."
    },
    dashboardGrowthInfo7e: {
        en: 'Increase Your Visibility',
        fr: 'Augmentez Votre Visibilité'
    },
    dashboardGrowthInfo7f: {
        en: "tasks to boost {{charityName}}'s visibility.",
        fr: 'tâches pour augmenter la visibilité de {{charityName}}.'
    },
    dashboardGrowthInfo7g: {
        en: '100% Refund Promo Code',
        fr: 'Code Promo Pour un Remboursement de 100%'
    },
    dashboardGrowthInfo7h: {
        en: 'Featured {{organization}}s receive an exclusive 100% refund promo code!',
        fr: "L'Organisme Affilié peut également bénéficier d'un code promotionnel de remboursement à 100 % !"
    },
    dashboardGrowthInfo7i: {
        en: 'Tasks',
        fr: 'Tâches'
    },
    dashboardGrowthInfo8: {
        en: 'Your charity QR code',
        fr: 'Votre code QR caritatif'
    },
    dashboardGrowthInfo8aEXP: {
        en: 'When scanned, this QR code sets automatic donations to your account.',
        fr: "Lorsqu'il est scanné, ce code QR configure des dons automatiques à votre compte."
    },
    dashboardGrowthInfo8bEXP: {
        en:
            'Tip: To protect your supporters and avoid scammers, display your QR code securely in public spaces, and check regularly to ensure it hasn’t been tampered with.',
        fr:
            'Conseil : Pour protéger vos supporteurs et éviter les fraudeurs, affichez votre code QR de manière sécurisée dans les espaces publics, et vérifiez régulièrement qu’il n’a pas été altéré.'
    },
    dashboardGrowthInfo9: {
        en: 'Upload High Res. Image',
        fr: 'Télécharger une image haute résolution'
    },
    dashboardGrowthInfo10: {
        en: 'Upload Image',
        fr: "Télécharger l'image"
    },
    dashboardGrowthInfo11: {
        en: 'Not approved',
        fr: 'Non approuvé'
    },
    dashboardGrowthInfo12: {
        en: 'Logo uploaded successfully',
        fr: 'Logo téléchargé avec succès'
    },
    dashboardGrowthInfo13: {
        en: 'Preview Unavailable',
        fr: 'Aperçu indisponible'
    },
    dashboardCharityLogo1: {
        en: 'Upload High Resolution Logo',
        fr: 'Télécharger le logo haute résolution'
    },
    dashboardCharityLogo2: {
        en: 'Upload your logo! We prefer vector files of your logo (SVG, EPS, PDF or AI)',
        fr: 'Téléchargez votre logo! Nous privilégions les fichiers vectoriels de votre logo (SVG, EPS, PDF ou AI)'
    },
    dashboardCharityLogo2EXP: {
        en:
            'Upload your logo! We prefer vector files of your logo (SVG, EPS, PDF or AI). For the best possible results, please ensure your logo is at least 4000px.',
        fr:
            "Téléchargez votre logo ! Nous préférons les fichiers vectoriels de votre logo (SVG, EPS, PDF ou AI). Pour obtenir les meilleurs résultats possibles, veuillez vous assurer que votre logo a une résolution d'au moins 4000px."
    },
    dashboardCharityLogo3: {
        en:
            'WARNING: Logo is of low resolution and may result in poor quality of printed materials. If you can, reupload a higher resolution file (greater than 4000px).',
        fr:
            'AVERTISSEMENT : Le logo est de faible résolution et peut entraîner une mauvaise qualité des documents imprimés. Si vous le pouvez, téléchargez à nouveau un fichier de résolution supérieure (supérieure à 4 000 pixels).'
    },
    dashboardCharityLogo4: {
        en: 'Upload photo',
        fr: 'Télécharger la photo'
    },
    dashboardSetting1: {
        en: 'Organization',
        fr: 'Organisme'
    },
    dashboardSetting2: {
        en: 'Name',
        fr: 'Nom'
    },
    dashboardSetting3: {
        en: 'This {{organization}} issues tax receipts',
        fr: 'Cet organisme délivre des reçus fiscaux'
    },
    dashboardSetting4: {
        en: 'Charity Registration Number',
        fr: "Numéro d'enregistrement de l'organisme de bienfaisance"
    },
    dashboardSetting5: {
        en: '{{organization}} E-mail (financial)',
        fr: "Courriel de l'organisation (comptabilité)"
    },
    dashboardSetting6: {
        en: 'Website',
        fr: 'Site Internet'
    },
    dashboardSetting7: {
        en: 'Address',
        fr: 'Adresse'
    },
    dashboardSetting8: {
        en: 'GPS Override (Advanced)',
        fr: 'Remplacement GPS (avancé)'
    },
    dashboardSetting9: {
        en: 'Please do not change these values if you are unsure what they mean.',
        fr: "Veuillez ne pas modifier ces valeurs si vous n'êtes pas certain de leur signification."
    },
    dashboardSetting10: {
        en: `${terms.organization.en} Logo`,
        fr: "Logo de l'organisation"
    },
    dashboardSetting11: {
        en: 'Upload Image',
        fr: "Télécharger l'image"
    },
    dashboardSetting12: {
        en: 'Image to be uploaded:',
        fr: 'Image à importer :'
    },
    dashboardSetting12a: {
        en: 'Accepted file types: webp, heif, heic, gif, jpg, jpeg, png',
        fr: 'Types de fichiers acceptés : webp, heif, heic, gif, jpg, jpeg, png'
    },
    dashboardSetting13: {
        en: 'Mission & Vision',
        fr: 'Mission et vision'
    },
    dashboardSetting14: {
        en: 'Tax Receipts',
        fr: 'Reçus fiscaux'
    },
    dashboardSetting15: {
        en: 'Minimum Donation Cut Off',
        fr: 'Don minimum'
    },
    dashboardSetting16: {
        en:
            "The minimum donation amount required to issue a tax receipt. Donations will be summed over the year and carried over to the next year if they don't meet this requirement.",
        fr:
            "Le montant minimum de don requis pour délivrer un reçu fiscal. Les dons seront additionnés sur l'année et reportés à l'année suivante s'ils ne répondent pas à cette exigence."
    },
    dashboardSetting17: {
        en: 'Tax Receipt Year End Date',
        fr: "Date de fin d'année du reçu fiscal"
    },
    dashboardSetting18: {
        en: 'The date when you issue your tax receipts for the year.',
        fr: "La date à laquelle vous émettez vos reçus fiscaux pour l'année."
    },
    dashboardSetting19: {
        en: 'Subdivisions',
        fr: 'Sous-divisions'
    },
    dashboardSetting20: {
        en:
            'Enter your groups, teams, divisions, players, representatives, bottle drives, and companies for your organization below. Donors will be presented an option to specify which subdivision they want to donate to. Leave this empty and donors will only have a general donation option for your organization.',
        fr:
            "Entrez ci-dessous vos groupes, équipes, divisions, joueurs, représentants, services de collecte et entreprises pour votre organisation. Les donateurs auront la possibilité de spécifier à quelle sous-division ils souhaitent faire un don. Laissez ce champ vide et les donateurs n'auront qu'une option de don générale pour votre organisation."
    },
    dashboardSetting21: {
        en: 'You have no active subdivisions. Use the input above to create one.',
        fr: "Vous n'avez aucune sous-division active. Utilisez l'entrée ci-dessus pour en créer un."
    },
    dashboardSetting22: {
        en: 'Teams, Groups, Companies or Divisions',
        fr: 'Equipes, Groupes, Entreprises ou Divisions'
    },
    dashboardSetting23: {
        en: 'Referral link',
        fr: 'Lien de référence'
    },
    dashboardSetting24: {
        en: 'This field is required',
        fr: 'Ce champ est requis'
    },
    dashboardSetting25: {
        en: 'Invalid e-mail format',
        fr: 'Format de courriel invalide'
    },
    dashboardSetting26: {
        en: 'Must start with http:// or https://',
        fr: 'Doit commencer par http:// ou https://'
    },
    dashboardSetting27: {
        en: 'Submit changes?',
        fr: 'Soumettre des changements?'
    },
    dashboardSetting28: {
        en:
            'Your {{organization}} will require re-approval after you submit your changes. The approval process takes up to 2 business days.',
        fr:
            "Votre organisation devra obtenir une nouvelle approbation une fois que vous aurez soumis vos modifications. Le processus d'approbation prend jusqu'à 2 jours ouvrables."
    },
    dashboardSetting29: {
        en: 'Successfully updated your {{organization}}.',
        fr: 'Votre organisation a bien été mise à jour.'
    },
    dashboardSetting30: {
        en: 'Successfully updated your tax receipt settings.',
        fr: 'Les paramètres de votre reçu fiscal ont été mis à jour avec succés.'
    },
    dashboardSetting31: {
        en: 'Enter {{organization}} address',
        fr: "Entrer l'addresse de l'{{organization}}"
    },
    dashboardSetting32: {
        en: 'Click image to change',
        fr: "Cliquer sur l'image pour changer"
    },
    dashboardSetting33: {
        en: 'not selected',
        fr: 'non sélectionnée :'
    },
    dashboardSetting34: {
        en: `Account Owners`,
        fr: `Accès à la visualisation`
    },
    dashboardSubdivision1: {
        en: 'Are you sure you want to remove {{{charity}}}',
        fr: 'Êtes-vous sûr de vouloir supprimer {{{charity}}}'
    },
    dashboardSubdivision2: {
        en: 'Add/Remove Permissions',
        fr: 'Ajouter/supprimer des autorisations'
    },
    dashboardSubdivision3: {
        en: 'Users',
        fr: 'Utilisateurs'
    },
    dashboardSubdivision4: {
        en: 'Please enter a valid email address.',
        fr: 'Veuillez saisir une adresse courriel valide.'
    },
    dashboardSubdivision5: {
        en: '{{value}} is already a subdivision',
        fr: '{{value}} est déjà une sous-division'
    },
    dashboardSubdivision6: {
        en: 'No one can view this subdivision right now.',
        fr: 'Personne ne peut voir cette sous-division pour le moment.'
    },
    dashboardSubdivision7: {
        en: 'Click the edit button to manage permissions.',
        fr: 'Cliquez sur le bouton Modifier pour gérer les autorisations.'
    },
    done: {
        en: 'Done',
        fr: 'Fait'
    },
    clockIn: {
        en: 'Clock In',
        fr: 'Entrée'
    },
    proceedTo: {
        en: 'Proceed to',
        fr: 'Dirigez-vous vers'
    },
    proceedToAndOffloadTruck: {
        en: 'Proceed to {{depotLocation}}, take picture of truck contents.',
        fr: 'Rendez-vous à {{depotLocation}}, prenez une photo du contenu du camion'
    },
    prepareForNextTrip: {
        en: 'Prepare for next trip.',
        fr: 'Préparez-vous pour le prochain trajet.'
    },
    youAreToFarAway: {
        en: 'You are too far away!',
        fr: 'Vous êtes trop loin!'
    },
    moveCloserToStart: {
        en: 'Please move closer to the starting location.',
        fr: 'Veuillez vous rapprocher du point de départ.'
    },
    moveCloserToEnd: {
        en: `You're too far from the depot. Please move closer to finish.`,
        fr: `Vous êtes trop loin du dépôt. Veuillez vous rapprocher pour terminer.`
    },
    clockInMessage: {
        en: 'press Clock In once at starting location.',
        fr: "appuyez une fois sur Entrée à l'emplacement de départ."
    },
    clockOut: {
        en: 'Clock Out',
        fr: 'Sortie'
    },
    startRoute: {
        en: 'Start Route',
        fr: "Démarrer l'itinéraire"
    },
    endRoute: {
        en: 'End Route',
        fr: 'Terminer le parcours'
    },
    finishTrip: {
        en: 'Finish Trip',
        fr: 'Terminer le trajet'
    },
    nevermind: {
        en: 'Nevermind',
        fr: 'Annuler'
    },
    saved: {
        en: 'Saved.',
        fr: 'Enregistré.'
    },
    dashboardMain1: {
        en: 'Featured',
        fr: 'Affilié'
    },
    dashboardMain2: {
        en: 'Not approved',
        fr: 'Non approuvé'
    },
    dashboardMain3: {
        en: 'Approved',
        fr: 'Approuvé'
    },
    dashboardMain4a: {
        en: 'Need some help? Check out',
        fr: "Besoin d'aide? Consultez "
    },
    dashboardMain4b: {
        en: 'Your Donations Section ',
        fr: 'votre section de dons '
    },
    dashboardMain4c: {
        en: 'for reporting and tax receipts. Visit ',
        fr: 'pour les rapports et les reçus fiscaux. Visitez '
    },
    dashboardMain4d: {
        en: 'Your Growth Plan ',
        fr: 'Votre plan de croissance '
    },
    dashboardMain4dEXP: {
        en: 'Your Growth Tips ',
        fr: 'Vos conseils de croissance '
    },
    dashboardMain4e: {
        en: 'for tools to get more donations!',
        fr: "pour des outils permettant d'obtenir plus de dons!"
    },
    dashboardMain5: {
        en: 'Referral link and growth plan will be available once your application is approved.',
        fr: 'Le lien de référence et le Plan de croissance seront disponibles une fois votre candidature approuvée.'
    },
    dashboardMain5EXP: {
        en: 'Referral link and growth tips will be available once your application is approved.',
        fr: 'Lien de référence et conseils de croissance seront disponibles une fois votre demande approuvée.'
    },
    dashboardMain6: {
        en: 'Your Referral Links',
        fr: 'Vos liens de référence'
    },
    dashboardMain7: {
        en: 'General Link',
        fr: 'Lien général'
    },
    dashboardMain8: {
        en: 'Teams/Groups/Bottle drive Specific Links',
        fr: 'Liens spécifiques vers Équipes/Groupes/Collecte de contenants'
    },
    dashboardMain9: {
        en: 'Close/open',
        fr: 'Fermé/ouvert'
    },
    dashboardMain10: {
        en: 'Donors',
        fr: 'Donateurs'
    },
    dashboardMain11: {
        en: 'Approval pending',
        fr: "En attente d'approbation"
    },
    dashboardMain12: {
        en: 'Not Featured',
        fr: 'Non présenté'
    },
    dashboardUpdate1: {
        en: 'Donate now',
        fr: 'Faire un don maintenant'
    },
    dashboardUpdate2: {
        en: 'Visit website',
        fr: 'Visitez le site Web'
    },
    dashboardUpdate3: {
        en: 'This charity issues tax receipts for your donations',
        fr: 'Cet organisme de bienfaisance délivre des reçus fiscaux pour vos dons'
    },
    dashboardUpdate4: {
        en: 'This {{organization}} does not issue tax receipts',
        fr: "Cet organisme de bienfaisance ne délivre pas de reçus d'impôt"
    },
    dashboardUpdate5: {
        en: 'Update preference',
        fr: 'Mettre à jour les préférences'
    },
    dashboardUpdate6: {
        en:
            'Your email address {{email}} has not been verified. Please check your spam/junk folder for verification or send again.',
        fr:
            "Votre adresse courriel {{email}} n'a pas été vérifiée. Veuillez vérifier votre dossier spam / courrier indésirable pour vérification ou renvoyer."
    },
    dashboardUpdate7: {
        en: 'Send again',
        fr: 'Envoyer à nouveau'
    },
    dashboardUpdate8: {
        en: 'Note: tax receipts are not available for Quick Registration users.',
        fr: 'Remarque : les reçus fiscaux ne sont pas disponibles pour les utilisateurs de Quick Registration.'
    },
    dashboardUpdate9: {
        en:
            'Your account has not been verified. Please verify your email address to ensure we can process future cash outs. When you registered for Express, a verification email was sent to {{email}}. If you don’t see an email from us, please check your junk/spam folder. Alternately you can resend the email using the “send again” button or change the email in your profile below.',
        fr: `Votre compte n'a pas été vérifié. Veuillez vérifier votre adresse courriel pour assurer le traitement de vos versements futurs. Lors de votre inscription à Express, un courriel de vérification a été envoyé à {{email}}. Si vous ne voyez pas de courriel de notre part, veuillez vérifier votre dossier de courriels indésirables/pourriel. Vous pouvez également renvoyer le courriel en utilisant le bouton « envoyer à nouveau » ou modifier le courriel dans votre profil ci-dessous.`
    },
    dashboardUpdate10: {
        en: 'Email Verification Required',
        fr: 'Vérification de courriel requise'
    },
    dashboardUpdate11: {
        en:
            'Your email address {{email}} must be verified before redemptions can be processed. Please check your spam/junk folder for verification or send again.',
        fr:
            'Votre adresse courriel {{email}} doit être vérifiée avant que les demandes de remboursement puissent être traitées. Veuillez vérifier votre dossier de pourriels/courriels indésirables pour la vérification ou envoyez à nouveau.'
    },
    dashboardUpdate12: {
        en: 'Your account is currently pending approval for the {{{collectionProgram}}} collections program',
        fr:
            "Votre compte est actuellement en attente d'approbation pour le programme de collecte {{{collectionProgram}}}"
    },
    dashboardUpdate13: {
        en:
            'Your account has been rejected from the {{{collectionProgram}}} collections program for the following reasons: {{{reasons}}}',
        fr:
            'Votre compte a été rejeté du programme de collecte {{{collectionProgram}}} pour les raisons suivantes : {{{reasons}}}'
    },
    dashboardHistory1: {
        en: 'Pickups',
        fr: 'Collectes'
    },
    dashboardHistory2: {
        en: 'Walk-ins',
        fr: 'Sur place'
    },
    dashboardHistory3: {
        en: 'cash outs',
        fr: 'remboursements'
    },
    dashboardHistory4: {
        en: 'tax receipts',
        fr: 'reçus fiscaux'
    },
    dashboardHistory5: {
        en: 'Donation sent to',
        fr: 'Don envoyé à'
    },
    dashboardHistory6: {
        en: 'Donated',
        fr: 'donné'
    },
    dashboardHistory7: {
        en: 'Counted',
        fr: 'compté'
    },
    dashboardHistory8: {
        en: 'pending',
        fr: 'en attente'
    },
    dashboardHistory9: {
        en: 'bag',
        fr: 'sac'
    },
    dashboardHistory10: {
        en: 'Cancelled',
        fr: 'annulé'
    },
    dashboardHistory11: {
        en: 'Scheduled',
        fr: 'programmé'
    },
    dashboardHistory12: {
        en: 'Processing',
        fr: 'traitement'
    },
    dashboardHistory13: {
        en: 'Collected',
        fr: 'collecté'
    },
    dashboardHistory14: {
        en: 'Processed',
        fr: 'traité'
    },
    dashboardHistory15: {
        en: 'Referral',
        fr: 'Référence'
    },
    dashboardHistory16: {
        en: 'Credited',
        fr: 'Remboursée'
    },
    dashboardHistory17: {
        en: 'Paid In Cash',
        fr: 'Payé en argent'
    },
    dashboardHistory18: {
        en: 'Counts Pending',
        fr: 'Décomptes en attente'
    },
    dashboardHistory19: {
        en: 'Customer Requesting More Information',
        fr: 'Client demande davantage d’informations'
    },
    dashboardHistory20: {
        en: 'Bagtag',
        fr: 'Autocollant de sac'
    },
    dashboardHistory21: {
        en: 'We encountered the following issues with your order',
        fr: 'Nous avons rencontré les problèmes suivants avec votre commande'
    },
    dashboardHistory22: {
        en: 'View Details',
        fr: 'Voir détails'
    },
    dashboardHistory23: {
        en: 'Distance from drop location',
        fr: "Distance jusqu'à l’emplacement du dépôt"
    },
    dashboardHistory24: {
        en: 'Drop off date',
        fr: 'Date de dépôt'
    },
    dashboardHistory25: {
        en: 'This is from the lost & found',
        fr: 'Ceci provient des "perdus et retrouvés"'
    },
    dashboardHistory26: {
        en: 'Awaiting the driver',
        fr: 'En attente du chauffeur'
    },
    dashboardHistory27: {
        en: 'Cancelled by {{cancelledBy}}',
        fr: 'Annulé par {{cancelledBy}}'
    },
    dashboardHistory28: {
        en: 'Counting items',
        fr: 'Décompte des contenants'
    },
    dashboardHistory29: {
        en: 'Awaiting counts',
        fr: 'En attendes des décomptes'
    },
    dashboardHistory30: {
        en: 'We encountered the following issues with your pickup',
        fr: 'Nous avons rencontré les problèmes suivants avec votre collecte'
    },
    dashboardHistory31: {
        en: 'Receipt',
        fr: 'Reçu'
    },
    dashboardHistory32: {
        en: 'Created by',
        fr: 'Créer par'
    },
    dashboardHistory33: {
        en: 'Adjustments / {{{quickDropType}}} / {{walkInType}}',
        fr: 'Ajustements / {{{quickDropType}}} / {{walkInType}}'
    },
    dashboardHistory34: {
        en: 'Tax receipt will be issued after',
        fr: 'Reçu fiscal sera émis après'
    },
    dashboardHistory35: {
        en: 'Tax receipt will be issued soon.',
        fr: 'Reçu fiscal sera émis bientôt.'
    },
    dashboardHistory36: {
        en: 'You are not eligible for a tax receipt until your total donation amount surpasses {{amount}}',
        fr:
            'Vous n’êtes pas admissible à un reçu fiscal tant que le montant total de votre don n’a pas dépassé {{amount}}'
    },
    dashboardHistory37: {
        en: 'Tax receipt issued for this donation',
        fr: 'Reçu fiscal émis pour ce don'
    },
    dashboardHistory38: {
        en: 'Please contact {{{charity}}} - {{charityRegistrationNumber}} for tax receipt info',
        fr:
            'Veuillez contacter {{{charity}}} - {{charityRegistrationNumber}} pour obtenir des informations sur les reçus fiscaux'
    },
    dashboardHistory39: {
        en: 'You did not request a tax receipt',
        fr: 'Vous n’avez pas demandé de reçu fiscal'
    },
    dashboardHistory40: {
        en: 'Tax receipt requested',
        fr: 'Reçu fiscal demandé'
    },
    dashboardHistory41: {
        en: 'Donation Breakdown',
        fr: 'Répartition des dons'
    },
    dashboardHistory42: {
        en: 'Tip left for driver',
        fr: 'Pourboire laissé pour le chauffeur'
    },

    dashboardHistory46: {
        en: 'Pickup booked for',
        fr: 'Collecte réservée pour'
    },
    dashboardHistory47: {
        en: 'Recycling bags',
        fr: 'Sacs de contenants consignés'
    },
    dashboardHistory48: {
        en: 'Clothing bags',
        fr: 'Sacs de vêtements'
    },
    dashboardHistory49: {
        en: 'Electronic kgs',
        fr: "Kgs d'électronique"
    },
    dashboardHistory50: {
        en: 'To be picked up by {{name}} for {{collector}}',
        fr: 'À récupérer par {{name}} pour {{collector}}'
    },
    dashboardHistory51: {
        en: 'Aborted by {{name}} ({{collector}})',
        fr: 'Annulé par {{name}} ({{collector}})'
    },
    dashboardHistory52: {
        en: 'Distance',
        fr: 'Distance'
    },
    dashboardHistory53: {
        en: 'Received by driver. Will be counted within 48 hours',
        fr: 'Reçu par le chauffeur. Sera compté dans les 48 heures'
    },
    dashboardHistory54: {
        en: 'Received by driver. Will be processed within 7 business days.',
        fr: 'Reçu par le chauffeur. Sera traité dans les 7 jours ouvrables.'
    },
    dashboardHistory55: {
        en: 'Please check back later for updated values.',
        fr: 'Veuillez vérifier plus tard pour les valeurs mises à jour.'
    },
    dashboardHistory56: {
        en: 'Dropped Off',
        fr: 'déposé'
    },
    dashboardHistory56Exp: {
        en: 'Scanned',
        fr: 'Numérisé'
    },
    dashboardHistory57: {
        en: 'Rescheduled to {{date}}',
        fr: 'Reporté à {{date}}'
    },
    dashboardHistory58: {
        en: 'Pickup Details',
        fr: 'Détails de la collecte'
    },
    dashboardHistory59: {
        en: 'Processing Details',
        fr: 'Détails du traitement'
    },
    redemptionDetails: { en: 'Redemption Details', fr: 'Détails du rachat' },
    receiptDownloadNotReady: {
        en: 'A redemption receipt becomes available for download once processing is complete.',
        fr: 'Un reçu d’échange devient disponible pour téléchargement une fois le traitement terminé.'
    },
    dashboardHistory60: {
        en: 'Deposited',
        fr: 'se déposer'
    },
    dashboardHistory61: {
        en: 'Cancelled',
        fr: 'Annulé'
    },
    dashboardHistory62: {
        en: 'Drop Off Details',
        fr: 'Détails du dépôt'
    },
    dashboardHistory63: {
        en: '{{taxName}} on deposits',
        fr: '{{taxName}} sur les dépôts'
    },
    dashboardHistory64: {
        en: '{{taxName}} on fees',
        fr: '{{taxName}} sur les frais'
    },
    dashboardHistory65: {
        en: 'Payment Processed',
        fr: 'Paiement traité'
    },
    dashboardHistory66: {
        en:
            'We had troubles completing your collection. Issue: {{reason}}. Please double check your address, if you suspect your bags have been stolen, please contact local authorities. For future collections hide your bags from walking traffic.',
        fr:
            'Nous avons eu du mal à terminer votre collection. Problème : {{reason}}. Veuillez vérifier votre adresse. Si vous pensez que vos sacs ont été volés, veuillez contacter les autorités locales. Pour les futures collections, cachez vos sacs du trafic piétonnier.'
    },
    dashboardHistory67: {
        en: `On {{date}}, at {{time}}, you dropped off`,
        fr: `Le {{date}}, à {{time}}, vous avez déposé`
    },
    dashboardHistory68: {
        en: 'On {{date}}, at {{time}}, we collected',
        fr: `Le {{date}}, à {{time}}, nous avons collecté`
    },
    dashboardHistory69: {
        en: ` you printed {{count}} labels at {{{location}}}`,
        fr: ` vous avez imprimé {{count}} autocollants à {{{location}}}`
    },
    dashboardHistory70: {
        en: 'Total {{taxName}}',
        fr: '{{taxName}} totale'
    },
    dashboardHistory71: {
        en:
            'You are scheduled for collection. The driver will arrive between 8am and 5pm. For the exact time of arrival, please check the app or website on the morning of your collection.',
        fr: `Vous êtes programmé pour la collecte. Le chauffeur arrivera entre 8h et 17h. Pour connaître l'heure exacte d'arrivée, veuillez vérifier l'application ou le site web le matin de votre collecte.`
    },
    dashboardHistory72: {
        en: 'Your bags were processed on',
        fr: `Vos sacs ont été traités le`
    },
    dashboardHistory73: {
        en: 'Your account balance has been adjusted by {{{adjustmentAmount}}} due to a {{{adjustmentReason}}}',
        fr: `Le solde de votre compte a été ajusté de {{{adjustmentAmount}}} en raison d'un {{{adjustmentReason}}}`
    },
    dashboardHistory73EXP: {
        en: 'Your account balance has been updated by {{{adjustmentAmount}}} due to a {{{adjustmentReason}}}',
        fr: `Le solde de votre compte a été mis à jour de {{{adjustmentAmount}}} en raison d'un {{{adjustmentReason}}}`
    },
    dashboardHistory73b: {
        en: 'Your account balance has been adjusted',
        fr: `Le solde de votre compte a été ajusté`
    },
    dashboardHistory74: {
        en: 'Total {{count}}',
        fr: '{{count}} totale'
    },
    dashboardHistory75: {
        en: 'Order Note: {{{referenceNote}}}',
        fr: `Note de bon: {{{referenceNote}}}`
    },
    dashboardHistory76: {
        en:
            'These records were carried over from our previous system and do not reflect recent drop-offs. They are here for your reference only—no action is needed.',
        fr:
            "Ces registres ont été transférés de notre système précédent et ne reflètent pas les dépôts récents. Ils sont fournis à titre de référence uniquement—aucune action n'est requise."
    },
    dashboardHistory77: {
        en:
            'These records were carried over from our previous system and do not reflect recent redemptions. They are here for your reference only—no action is needed.',
        fr:
            "Ces registres ont été transférés de notre système précédent et ne reflètent pas les rachats récents. Ils sont fournis à titre de référence uniquement—aucune action n'est requise."
    },
    dashboardHistory78: {
        en:
            'These records were carried over from our previous system and do not reflect recent donations. They are here for your reference only—no action is needed.',
        fr:
            "Ces archives ont été transférées de notre système précédent et ne reflètent pas les dons récents. Elles sont ici uniquement pour votre information—aucune action n'est requise."
    },
    dashboardHistory79: {
        en: 'Beverage containers for recycling',
        fr: 'Contenants de boissons à recycler'
    },
    dashboardHistory80: {
        en: 'Refund Declaration',
        fr: 'Déclaration remboursement'
    },
    dashboardHistory81: {
        en: 'Total {{count}}',
        fr: 'Total'
    },
    dashboardHistory82: {
        en: 'Not processed or currently being processed',
        fr: 'Non traité ou en cours de traitement'
    },
    switchAcc1: {
        en: 'Heads up! You have multiple accounts',
        fr: 'Attention! Vous avez plusieurs comptes'
    },
    switchAcc2: {
        en:
            'All charity accounts must have a personal account linked to it. Your charity account is separate from your personal account. You can switch between your accounts from the side menu.',
        fr:
            "Tous les comptes de charité doivent être liés à un compte personnel. Votre compte de charité est distinct de votre compte personnel. Vous pouvez passer d'un compte à l'autre à partir du menu latéral."
    },
    charityType1: {
        en: 'Select Account Type',
        fr: 'Sélectionnez le type de compte'
    },
    charityType2: {
        en:
            'We require some additional information about your account. Please specify which type of account applies to you.',
        fr:
            "Nous avons besoin de quelques informations supplémentaires sur votre compte. Veuillez préciser quel type de compte s'applique à vous."
    },
    environmentalStats1: {
        en:
            "I've spared {{landfillStat}} kg from landfill, saved {{energyStat}} kWh of energy, and prevented {{emissionStat}} kg of greenhouse gas emissions by recycling with {{brand}}, and I think you should too!",
        fr:
            "J'ai épargné {{landfillStat}} kg du site d'enfouissement, économisé {{energyStat}} kWh d'énergie et évité {{emissionStat}} kg d'émissions de gaz à effet de serre en recyclant avec {{brand}}, et je pense que vous devriez aussi!"
    },
    locationFilter: {
        en: 'Filter By Location',
        fr: 'Filtrer par emplacement'
    },
    dateFilter: {
        en: 'Filter By Date',
        fr: 'Filtrer par date'
    },
    timespan: {
        en: 'Timespan',
        fr: 'Période'
    },
    hourly: {
        en: 'Hourly',
        fr: 'Horaire'
    },
    daily: {
        en: 'Daily',
        fr: 'Quotidien'
    },
    weekly: {
        en: 'Weekly',
        fr: 'Hebdomadaire'
    },
    monthly: {
        en: 'Monthly',
        fr: 'Mensuel'
    },
    quarterly: {
        en: 'Quarterly',
        fr: 'Tous les trois mois'
    },
    allTime: {
        en: 'All Time',
        fr: 'Tout le temps'
    },
    noData: {
        en: 'No Data',
        fr: 'Aucune donnée'
    }
};

const charitySnackBarTranslations = {
    charitySnackbar1: {
        en: 'Image copied to clipboard',
        fr: 'Image copiée dans le presse-papiers'
    },
    charitySnackbar2: {
        en: 'Image saved to documents',
        fr: 'Image enregistrée dans des documents'
    },
    charitySnackbar3: {
        en: 'Error saving file',
        fr: 'Erreur lors de l’enregistrement du fichier'
    },
    charitySnackbar4: {
        en: 'Error while copying to clipboard',
        fr: 'Erreur lors de la copie dans le Presse-papiers'
    },
    charitySnackbar5: {
        en: 'Code copied to your clipboard.',
        fr: 'Code copié dans votre presse-papiers.'
    },
    charitySnackbar6: {
        en: 'Email sent successfully',
        fr: 'Courriel envoyé avec succès'
    },
    charitySnackbar7: {
        en: 'Promo code copied to your clipboard',
        fr: 'Code promotionnel copié dans votre presse-papiers'
    },
    charitySnackbar8: {
        en: 'Successfully applied for a promo code',
        fr: 'Demande de code promotionnel réussie'
    },
    charitySnackbar9: {
        en: 'Are you sure you want to apply for a promo code.',
        fr: 'Êtes-vous sûr de vouloir demander un code promotionnel?'
    },
    charitySnackbar10: {
        en: 'Logo updated successfully',
        fr: 'Logo mis à jour avec succès'
    },
    charitySnackbar11: {
        en: 'Successfully submitted task for verification',
        fr: 'Tâche soumise avec succès pour vérification'
    },
    charitySnackbar12: {
        en: 'Error submitting task for verification',
        fr: 'Erreur lors de l’envoi de la tâche pour vérification'
    },
    charitySnackbar12a: {
        en: 'Error saving customization',
        fr: 'Error saving customization3:36 p.m.'
    },
    charitySnackbar13: {
        en: 'Are you sure you want to submit an order for {{type}}?',
        fr: 'Êtes-vous sûr de vouloir passer une commande pour {{type}}'
    },
    charitySnackbar14: {
        en: 'Minimum donation threshold cannot be negative.',
        fr: 'Le seuil minimum de don ne peut pas être négatif.'
    },
    charitySnackbar15: {
        en: '{{name}} saved to documents folder',
        fr: '{{name}} enregistré dans le dossier documents'
    },
    charitySnackbar16: {
        en: 'Cannot download file',
        fr: 'Impossible de télécharger le fichier'
    },
    charitySnackbar17: {
        en: 'Are you sure you want to {{customText}}?',
        fr: 'Êtes-vous sûr de vouloir {{customText}}?'
    },
    charitySnackbar18: {
        en: 'Error setting account type',
        fr: 'Erreur lors de la définition du type de compte'
    },
    charitySnackbar19: {
        en: 'Brand color updated successfully.',
        fr: 'Couleur de la marque mise à jour avec succès.'
    },
    charitySnackbar20: {
        en: 'Logo and color updated successfully.',
        fr: 'Logo et couleur mis à jour avec succès'
    }
};

const charitySelectTranslations = {
    charitySelect1: {
        en: 'Enter your address',
        fr: 'Entrez votre adresse'
    },
    charitySelect2: {
        en:
            'Tax receipts can only be issued to conventionally registered customer accounts. Tax receipt preference can be modified in account settings',
        fr:
            'Les reçus fiscaux ne peuvent être émis que sur des comptes clients enregistrés de manière conventionnelle. La préférence de reçu fiscal peut être modifiée dans les paramètres du compte'
    },
    charitySelect3: {
        en:
            'Use the search bar below to find your cause of choice! Some {{organization}}s allow donations to a specific team or group.',
        fr:
            'Utilisez la barre de recherche ci-dessous pour trouver votre cause préférée! Certains {{organization}} permettent des dons à une équipe ou un groupe spécifique.'
    },
    charitySelect4: {
        en: 'Change donation preference?',
        fr: 'Changer la préférence de don?'
    },
    charitySelect5: {
        en: 'Would you like to set your donation preference to',
        fr: 'Souhaitez-vous définir votre préférence de don à'
    },
    charitySelect6: {
        en: 'Your current account balance will be unaffected.',
        fr: 'Le solde de votre compte courant ne sera pas affecté.'
    }
};

const charityStatsTranslations = {
    charityStats1: {
        en: '{{organization}} Statistics',
        fr: 'Statistiques {{organization}}'
    },
    charityStats2: {
        en: 'Current donors',
        fr: 'Donateurs actuels'
    },
    charityStats3: {
        en: '# of shares on social media',
        fr: 'nombre de partages sur les réseaux sociaux'
    },
    charityStats4: {
        en: 'Featured {{organization}}',
        fr: '{{organization}} Affilié'
    },
    charityStats5a: {
        en: 'Fundraising is a lot of work. We have created the ',
        fr: 'La collecte de fonds représente beaucoup de travail. Nous avons créé la section '
    },
    charityStats5b: {
        en: 'Featured {{organization}}',
        fr: '{{organization}} Affilié'
    },
    charityStats5c: {
        en:
            ' section to help with this. {{organization}} that are actively promoting themselves using {{brand}} will be showcased as a Featured {{organization}} on the dashboard of all users and on the registration page! Follow the steps below to become a Featured {{organization}}',
        fr:
            ' pour vous aider. {{organization}} qui font activement la promotion en utilisant {{brand}} sera présenté en tant que {{organization}} en vedette sur le tableau de bord de tous les utilisateurs et sur la page d’inscription! Suivez les étapes ci-dessous pour devenir un {{organization}} en vedette'
    },
    charityStats6a: {
        en: 'Add a link to ',
        fr: 'Ajouter un lien vers '
    },
    charityStats6b: {
        en: " on your website (bonus points if it's on the home page)",
        fr: ' sur votre site web (points bonus s’il est sur la page d’accueil)'
    },
    charityStats7: {
        en: 'Follow our social media accounts',
        fr: 'Suivez nous sur les médias sociaux'
    },
    charityStats8: {
        en: 'Share our posts',
        fr: 'Partager nos publications'
    },
    charityStats9: {
        en: 'Tag us in your posts',
        fr: 'Identifiez-nous dans vos publications'
    },
    charityStats10: {
        en: 'Give us a 5 star review on',
        fr: 'Donnez-nous un avis 5 étoiles sur'
    },
    charityStats11: {
        en: 'We will return the favor and like/share/rate your social media accounts!',
        fr: 'Nous vous rendrons la pareille et aimerons / partagerons / évaluerons vos comptes de médias sociaux!'
    },
    charityStats12: {
        en: 'Share your {{organization}} for more donations!',
        fr: 'Partagez votre {{organization}} pour plus de dons!'
    },
    charityStats13: {
        en: 'Start Virtual Bottle Drive',
        fr: 'Démarrer une collecte virtuelle de contenants'
    }
};

const growthPlanTranslations = {
    growthPlan1: {
        en: 'Your Growth Plan Progress',
        fr: 'Progression de votre plan de croissance'
    },
    growthPlan1EXP: {
        en: 'Your Growth Tips Progress',
        fr: 'Votre progression des conseils de croissance'
    },
    growthPlan2: {
        en: 'You have {{count}} out of {{total}} tasks in your growth plan completed!',
        fr: 'Vous avez {{count}} tâches sur {{total}} complétées dans votre plan de croissance!'
    },
    growthPlan2EXP: {
        en: 'You have {{count}} out of {{total}} tasks in your growth tips completed!',
        fr: 'Vous avez {{count}} tâches sur {{total}} complétées dans votre plan de croissance!'
    },
    growthPlan3: {
        en: '{{count}} of your tasks are expired, please resubmit them.',
        fr: '{{count}} de vos tâches ont expiré, veuillez les soumettre à nouveau.'
    },
    growthPlan4: {
        en: 'Congratulations, You are currently a featured {{organization}}!',
        fr: 'Félicitations, vous êtes actuellement une {{organization}} en vedette !'
    },
    growthPlan5: {
        en: 'Complete {{count}} more task(s) to qualify as a featured {{organization}}!',
        fr:
            'Terminez {{count}} autre(s) tâche(s) pour que {{organization}} soit qualifié(e) comme organisation en vedette!'
    },
    growthPlan6: {
        en: 'How To Become Featured',
        fr: 'Comment devenir vedette'
    },
    growthPlan7: {
        en: 'Replace & Customize',
        fr: 'Remplacer et personnaliser'
    },
    growthPlan8: {
        en: 'Customize Marketing Assets',
        fr: 'Personnaliser les éléments marketing'
    },
    growthPlan9: {
        en: 'Brand Color',
        fr: 'Couleur de marque'
    },
    growthPlan10: {
        en: 'Click to select brand color',
        fr: 'Cliquez pour sélectionner la couleur de marque'
    },
    growthPlan11: {
        en: '(required for approval)',
        fr: "(requis pour l'approbation)"
    },
    growthPlan12: {
        en: 'This will update all generated assets to use the new logo/color. Are you sure you wish to continue?',
        fr:
            'Ceci mettra à jour tous les éléments générés pour utiliser le nouveau logo/la nouvelle couleur. Êtes-vous sûr de vouloir continuer?'
    }
};

const growthTranslations = {
    growthGeneral1: {
        en: 'State',
        fr: 'État'
    },
    growthGeneral2: {
        en: 'Approved',
        fr: 'Approuvé'
    },
    growthGeneral3: {
        en: 'Rejected',
        fr: 'Rejeté'
    },
    growthGeneral4: {
        en: 'Expired',
        fr: 'Expiré'
    },
    growthGeneral5: {
        en: 'Expires',
        fr: 'Expire'
    },
    growthGeneral6: {
        en: 'Submitted',
        fr: 'Soumis'
    },
    growthGeneral7: {
        en: 'Your Donation Link',
        fr: 'Votre lien de don'
    },
    growthGeneral8: {
        en: 'Why It Works',
        fr: 'Pourquoi ça marche'
    },
    growthGeneral9: {
        en: 'What To Do',
        fr: 'Que faire'
    },
    growthGeneral10: {
        en: 'Being Reviewed',
        fr: "En cours d'examen"
    },
    growthGeneral11: {
        en: 'Order succesfully created!',
        fr: 'Commande créée avec succès !'
    },
    growthGeneral12: {
        en: 'Expired',
        fr: 'Expire'
    },
    growthGeneral13: {
        en: 'Put your donation link in your bio.',
        fr: 'Mettez votre lien de don dans votre bio.'
    },
    growthGeneral14: {
        en: 'Follow & Like our social media page:',
        fr: 'Suivez et aimez notre page de médias sociaux:'
    },
    growthGeneral15: {
        en: "Share an interesting post from our account (we'll return the favor!)",
        fr: 'Partagez une publication intéressante de notre compte (nous vous rendrons la pareille !)'
    },
    growthGeneral16: {
        en: 'Make your own posts using some of our examples:',
        fr: 'Créez vos propres publications en utilisant certains de nos exemples :'
    },
    growthGeneral17: {
        en: 'Once Approved',
        fr: 'Une fois approuvé'
    },
    growthGeneral18: {
        en: 'Your submission was rejected for the following reason(s):',
        fr: 'Votre souscription a été rejetée pour les raisons suivantes :'
    },
    growthGeneral19: {
        en: 'Your donation link will appear here once approved',
        fr: 'Votre lien de don apparaîtra ici une fois approuvé'
    },
    growthGeneral20: {
        en: 'Referral link copied to your clipboard.',
        fr: 'Lien de référence copié dans votre presse-papiers.'
    },
    growthGeneral21: {
        en: 'Send Email',
        fr: 'Envoyer courriel'
    },
    growthGeneral22: {
        en: 'you are no longer featured',
        fr: 'vous n’êtes plus en vedette'
    },
    growthGeneral23: {
        en: 'subscription ended/disabled by {{brand}}',
        fr: 'abonnement terminé/désactivé par {{brand}}'
    },
    growthGeneral24: {
        en: 'Click the button below to apply:',
        fr: 'Cliquez sur le bouton ci-dessous pour postuler :'
    },
    growthGeneral25: {
        en:
            'You have completed {{count}} of {{total}} growth items! Please complete {{remaining}} more item(s) for your promocode.',
        fr:
            'Vous avez complété {{count}} des {{total}} éléments de croissance! Veuillez compléter {{remaining}} élément(s) supplémentaire(s) pour votre code promotionnel.'
    },
    growthGeneral26: {
        en: 'Active',
        fr: 'Actif'
    },
    growthGeneral27: {
        en: 'Not Active',
        fr: 'non actif'
    },
    growthGeneral28: {
        en: 'This promo code is active. Customers will be able to use it to donate to you.',
        fr: 'Ce code promotionnel est actif. Les clients pourront l’utiliser pour vous faire un don.'
    },
    growthGeneral29: {
        en:
            'This promo code is no longer active ({{inactivePromoReason}}). You will only receive the standard rate for deposits donated.',
        fr:
            'Ce code promotionnel n’est plus actif ({{inactivePromoReason}}). Vous ne recevrez que le taux standard pour les dépôts donnés.'
    },
    growthGeneral30: {
        en: "Send us an email using the form below to let us know you're interested:",
        fr:
            'Envoyez-nous un courriel en utilisant le formulaire ci-dessous pour nous faire savoir que vous êtes intéressé:'
    },
    growthGeneral31: {
        en: 'Order {{type}}',
        fr: 'Commande {{type}}'
    },
    growthGeneral32: {
        en: 'Resubmit Verification',
        fr: 'Resoumettre la vérification'
    },
    growthGeneral33: {
        en: 'Growth plan',
        fr: 'Plan de croissance'
    },
    growthGeneral33EXP: {
        en: 'Growth tips',
        fr: 'Conseils de croissance'
    },
    growthGeneral34: {
        en: 'Please Verify Your Submission With A Link',
        fr: 'Veuillez vérifier votre souscription avec un lien'
    },
    growthGeneral35: {
        en: 'Please Upload A Photo',
        fr: 'Veuillez télécharger une photo'
    },
    growthGeneral36: {
        en: 'Photo',
        fr: 'Photo'
    },
    growthGeneral37: {
        en:
            'By registering through this referral form your returns will be donated to this {{organization}} by default (you can always change it later)',
        fr:
            'En vous inscrivant via ce formulaire de référence, vos retours seront donnés à cette {{organisation}} par défaut (vous pouvez toujours le modifier plus tard)'
    },
    growthGeneral38: {
        en: 'An address is required when requesting a tax receipt',
        fr: 'Une adresse est requise lors de la demande d’un reçu fiscal'
    },
    growthGeneral39: {
        en: 'Submit Verification',
        fr: 'Soumettre la vérification'
    },
    growthGeneral40: {
        en: 'Please provide the following information',
        fr: "S'il vous plaît fournir les informations suivantes"
    },
    submissionStatus: {
        en: 'Submission Status',
        fr: 'Statut de la soumission'
    },
    growthVerifyTask1: {
        en: 'Verify Task Complete',
        fr: 'Vérifier que la tâche est terminée'
    },
    growthVerifyTask2: {
        en: 'Provide proof of the completed task with a {{obj}}',
        fr: 'Fournissez une preuve de la tâche complétée avec un {{obj}}'
    },
    growthVerifyTask3: {
        en: 'link',
        fr: 'lien'
    },
    growthVerifyTask4: {
        en: 'picture',
        fr: 'photo'
    },
    growthVerifyTask5: {
        en: 'link or picture',
        fr: 'lien ou photo'
    },
    growthVerifyTask6: {
        en: 'Please come back once approved',
        fr: 'Prière de revenir une fois approuvé'
    },
    growthPostInfo1: {
        en: 'Copy a variation of the code below and',
        fr: 'Copiez une variante du code ci-dessous et'
    },
    growthPostInfo2: {
        en: 'Put your link in your menu',
        fr: 'Mettez votre lien dans votre menu'
    },
    growthPostInfo3: {
        en: 'Put your link on your homepage',
        fr: "Mettez votre lien sur votre page d'accueil"
    },
    growthPostInfo4: {
        en: 'Code',
        fr: 'Code'
    },
    growthPostInfo5: {
        en: 'Preview',
        fr: 'Aperçu'
    },
    growthPostInfo6: {
        en: 'Image',
        fr: 'Image'
    },
    growthPostInfo7: {
        en: 'Text',
        fr: 'Texte'
    },
    growthPostInfo8: {
        en: 'DONATE YOUR RECYCLING (FREE PICKUP)',
        fr: 'DONNEZ VOS CONTENANTS (COLLECTE GRATUITE)'
    },
    growthPostInfo8EXP: {
        en: 'DONATE YOUR RECYCLING',
        fr: 'DONNEZ VOS CONTENANTS'
    },
    growthPostInfo9: {
        en: 'Please come back once approved',
        fr: 'Veuillez revenir une fois approuvé'
    },
    growthPostInfo10: {
        en: 'Example',
        fr: 'Exemple'
    },
    growthNewsLetters1: {
        en: 'Make your own newsletter using this example:',
        fr: 'Créez votre propre infolettre en utilisant cet exemple :'
    },
    growthNewsLetters2: {
        en: "We've partnered with {{brand}}",
        fr: 'Nous avons établi un partenariat avec {{brand}}'
    },
    growthNewsLetters2EXP: {
        en: 'Got empty beverage containers at home? Donate them to our cause with {{brand}}',
        fr: 'Vous avez des contenants de boissons vides à la maison ? Faites-en don à notre cause avec {{brand}} !'
    },
    growthNewsLetters3: {
        en:
            'What is {{brand}}? A door-to-door bottle collection service that makes refundable recycling and fundraising easier than 1,2,3',
        fr:
            "Qu'est-ce que {{brand}}? Un service de dépôt volontaire et de collecte porte à porte de contenants consignés qui rend le remboursement de consigne et la collecte de fonds plus faciles que 1,2,3"
    },
    growthNewsLetters3EXP: {
        en: '{{brand}} makes donations easy, to get started:',
        fr: '{{brand}} facilite les dons. Pour commencer :'
    },
    growthNewsLetters4: {
        en: 'Download the app and book a pickup using {{{website}}}',
        fr: "Téléchargez l'application et réservez une collecte en utilisant {{{website}}}"
    },
    growthNewsLetters4EXPa: {
        en:
            'Log-in to your account through the Return-It App (found on Google Play Store or the iOS App store) or visit {{{website}}}.',
        fr:
            "Connectez-vous à votre compte via l'application Return-It (disponible sur Google Play Store ou l'App Store iOS) ou visitez {{{website}}}."
    },
    growthNewsLetters4EXPb: {
        en: 'Don’t have an account? Sign up for a free Return-It account at {{{website}}}',
        fr: "Vous n'avez pas de compte ? Inscrivez-vous gratuitement pour un compte Return-It sur {{{website}}}."
    },
    growthNewsLetters5: {
        en: 'Place your bags outside',
        fr: "Déposez vos sacs à l'extérieur"
    },
    growthNewsLetters5EXPa: {
        en: 'Donate to our organization using the following link: ',
        fr: 'Faites un don à notre organisation en utilisant le lien suivant :'
    },
    growthNewsLetters5EXPb: {
        en: 'You’ll have the option to set auto-donations or a one-time donation.',
        fr: 'Vous aurez la possibilité de configurer des dons automatiques ou de faire un don unique.'
    },
    growthNewsLetters6: {
        en: 'Receive a refund or donate to us!',
        fr: 'Recevez un remboursement ou faites-nous un don !'
    },
    growthNewsLetters6EXP: {
        en: 'Return all your empty beverage containers to a Return-It Express location, every container counts!',
        fr:
            'Retournez tous vos contenants de boissons vides à un emplacement Return-It Express, chaque contenant compte !'
    },
    growthNewsLetters7: {
        en:
            '{{brand}} will allow everyone to donate directly to our {{organization}} with ease. Spread the word by sharing our {{brand}} posts on social media!',
        fr:
            '{{brand}} permettra à chacun de faire un don directement à notre organisation en toute simplicité. Faites passer le mot en partageant nos publications {{brand}} sur les réseaux sociaux !'
    },
    growthTwitter1: {
        en:
            "Hey (insert city)! We've partnered with {{socialMediaHandle}}, a bottle collection service that will let you donate your bottle refund directly to us! They'll even pick them up for you.",
        fr:
            'Hey (insérer la ville)! Nous avons établi un partenariat avec {{socialMediaHandle}}, un service de collecte decontenants consignés qui vous permettra de nous faire directement don de votre remboursement consigne! Ils viendront même les chercher pour vous.'
    },
    growthTwitter2: {
        en: 'Download the app today and select our charity upon refund.',
        fr:
            "Téléchargez l'application aujourd'hui et sélectionnez notre organisme de bienfaisance lors du remboursement."
    },
    growthTwitter3: {
        en:
            'Want an easy way to give back to us? Download {{socialMediaHandle}} and donate your bottle refund to us! They even pick them up for you!',
        fr:
            'Vous voulez un moyen facile de nous redonner? Téléchargez {{socialMediaHandle}} et faites-nous don de votre remboursement de contenants consignés! Ils les récupèrent même pour vous !'
    },
    growthTwitter4: {
        en: 'We’ve partnered with {{socialMediaHandle}} to take your stinky bottles off your hands.',
        fr: 'Nous nous sommes associés à {{socialMediaHandle}} pour vous débarrasser de vos contenants tout collants!'
    },
    growthTwitter5: {
        en: 'Download the app and start donating your bottles to us today!',
        fr: "Téléchargez l'application et commencez à nous faire don de vos contenants consignés dès aujourd'hui!"
    },
    growthTwitter6: {
        en:
            "{{socialMediaHandle}} is an easy way to give! Place your bottles outside for a pickup and we'll receive the refund as a donation! Download the app today",
        fr:
            "{{socialMediaHandle}} est un moyen facile de donner! Placez vos bouteilles à l'extérieur pour une collecte et nous recevrons le remboursement comme don! Téléchargez l'application aujourd'hui"
    },
    growthTwitterEXP1: {
        en: 'Donate your deposit refund for a cause!',
        fr: 'Faites don de votre remboursement de consigne pour une cause !'
    },
    growthTwitterEXP2: {
        en:
            'You can now support us by donating your deposit refund through the Return-It App. Simply select our organization when you are ready to donate your refund and help make a difference!',
        fr:
            "Vous pouvez désormais nous soutenir en faisant don de votre remboursement de consigne via l'application Return-It. Il vous suffit de sélectionner notre organisation lorsque vous êtes prêt à faire un don de votre remboursement et à contribuer à faire une différence !"
    },
    growthTwitterEXP3: {
        en: 'Get started today:',
        fr: "Commencez dès aujourd'hui :"
    },
    growthTwitterEXP4: {
        en: 'An easy way to give back!',
        fr: 'Une façon simple de redonner !'
    },
    growthTwitterEXP5: {
        en:
            'Recycle your empty beverage containers and donate your refund to us through the Return-It App. It’s quick, easy, and helps support our cause. Thank you for making a difference!',
        fr:
            "Recyclez vos contenants de boissons vides et faites don de votre remboursement à notre organisation via l'application Return-It. C'est rapide, simple et cela contribue à soutenir notre cause. Merci de faire une différence !"
    },
    growthTwitterEXP6: {
        en:
            'Looking for an easy way to give back? Recycle your empty beverage containers and donate your refund through the Return-It App to support us!',
        fr:
            "Vous cherchez une façon simple de redonner ? Recyclez vos contenants de boissons vides et faites don de votre remboursement via l'application Return-It pour nous soutenir !"
    },
    growthTwitterEXP7: {
        en: 'Get started by downloading the app:',
        fr: "Commencez par télécharger l'application :"
    },
    growthInstagram1: {
        en:
            'Have bags of bottles lying around? Donate them to us using {{socialMediaHandle}}. Download the app using the link in our bio.',
        fr:
            "Vous avez des sacs de contenants consignés qui traînent? Faites-nous en don en utilisant {{socialMediaHandle}}. Téléchargez l'application en utilisant le lien dans notre bio."
    },
    growthInstagram2: {
        en:
            "Looking for ways to help us out? We've partnered with {{socialMediaHandle}}! Download the app, book a bottle pickup and donate your refund directly to us. Link in bio to download today!",
        fr:
            "À la recherche de façons de nous aider? Nous avons établi un partenariat avec {{socialMediaHandle}}! Téléchargez l'application, réservez une collecte de bouteilles et faites-nous don de votre remboursement directement. Lien dans la bio pour télécharger dès aujourd'hui!"
    },
    growthInstagram3: {
        en:
            "Looking for ways to help us out? We've partnered with {{socialMediaHandle}}! Download the app, book a bottle pickup and donate your refund directly to us. Link in bio to download today!",
        fr:
            "À la recherche de façons de nous aider? Nous avons établi un partenariat avec {{socialMediaHandle}}! Téléchargez l'application, réservez une collecte de bouteilles et faites-nous don de votre remboursement directement. Lien dans la bio pour télécharger dès aujourd'hui!"
    },
    growthInstagram4: {
        en:
            "We need you bottles! Download {{socialMediaHandle}} and start donating your bottles directly to us! They'll pick them up for you, make sure you select {{{charity}}} upon refund. Link in bio to download today.",
        fr:
            "Nous avons besoin de vos contenants consignés! Téléchargez {{socialMediaHandle}} et commencez à nous faire don de vos contenants directement! Ils les récupéreront pour vous, assurez-vous de sélectionner {{{charity}}} lors du remboursement. Lien dans la bio à télécharger aujourd'hui."
    },
    growthFacebook1: {
        en:
            "Looking for new ways to help us out? We've partnered with {{socialMediaHandle}}. Download the app, book a pickup, place your bags and donate your refund directly to {{{charity}}}.",
        fr:
            "À la recherche de nouvelles façons de nous aider? Nous avons établi un partenariat avec {{socialMediaHandle}}. Téléchargez l'application, réservez une collecte, placez vos sacs et faites don de votre remboursement directement à {{{charity}}}."
    },
    growthFacebook2: {
        en:
            'Do you have bottles piling up? Let {{socialMediaHandle}} take them off your hands! Download the app today and donate your bottle refund directly to us!',
        fr:
            "Vous avez des contenants consignés qui s'entassent? Laissez {{socialMediaHandle}} vous en débarrasser! Téléchargez l'application aujourd'hui et faites-nous directement don de votre remboursement de consigne!"
    },
    growthFacebook3: {
        en:
            "We've partnered with {{socialMediaHandle}}! Download the app and start donating your bottle refunds directly to us.",
        fr:
            "Nous avons établi un partenariat avec {{socialMediaHandle}}! Téléchargez l'application et commencez à nous faire directement don de vos remboursements de consigne."
    },
    growthFacebook4: {
        en:
            "We want your bottles! Use {{socialMediaHandle}} to start donating your bottles directly to us! You won't even have to leave the house. Download the app and select {{{charity}}} upon refund.",
        fr:
            "On veut vos contenants consignés! Utilisez {{socialMediaHandle}} pour commencer à nous faire don de vos contenants directement! Vous n'aurez même pas à quitter la maison. Téléchargez l'application et sélectionnez {{{charity}}} lors du remboursement."
    },
    growthLinkedIn1: {
        en: '{{{charity}}} is now accepting bottle donations through {{socialMediaHandle}}!',
        fr: '{{{charity}}} accepte désormais les dons de contenants consignés via {{socialMediaHandle}} !'
    },
    growthLinkedIn2: {
        en: 'You can support {{{charity}}} today by using our {{socialMediaHandle}} referral link ->',
        fr:
            "Vous pouvez soutenir {{{charity}}} aujourd'hui en utilisant notre lien de référence {{socialMediaHandle}} >"
    },
    growthLinkedIn3: {
        en:
            'When you sign up for {{socialMediaHandle}} with this referral link, this will pledge your bottles toward supporting our cause! The great part, you can either download the {{socialMediaHandle}} on your iPhone or Android or alternatively get started on your computer today at {{brand}}!',
        fr:
            "Lorsque vous vous inscrivez à {{socialMediaHandle}} avec ce lien de référence, cela engagera vos contenants à soutenir notre cause! La partie intéressante, vous pouvez soit télécharger {{socialMediaHandle}}App sur votre iPhone, Android ou sur votre ordinateur dès aujourd'hui sur {{brand}}!"
    },
    growthLinkedIn4: {
        en:
            '#consignaction #charity #nonprofit #giveback #donate #community #fundraising #recycle #reuse #environment #sustainability ',
        fr: '#consignaction'
    },
    growthLinkedIn4b: {
        en:
            '#consignaction #charity #nonprofit #giveback #donate #community #fundraising #recycle #reuse #environment #sustainability ',
        fr: '#consignaction'
    },
    growthLinkedIn5: {
        en:
            'Hey Hey! We have teamed up with {{socialMediaHandle}} and now you can support us by donating your bottles through their App!',
        fr:
            'Hey! Nous nous sommes associés à {{socialMediaHandle}} et vous pouvez maintenant nous soutenir en faisant don de vos contenants consignés via leur application !'
    },
    growthLinkedIn6: {
        en:
            'Get started today by downloading the App from the Apple or Android store and booking a pickup using our referral link ->',
        fr:
            "Commencez dès aujourd'hui en téléchargeant l'application depuis l'Apple Store ou Google Play et en réservant une collecte en utilisant notre lien de référence ->"
    },
    growthLinkedIn7: {
        en: 'By using our referral code, your bottle funds will go directly to supporting our cause!',
        fr:
            'En utilisant notre code de référence, les montants de consigne de vos contenants consignés serviront directement à soutenir notre cause!'
    },
    growthLinkedIn8: {
        en:
            'We need your bottles! Download the {{socialMediaHandle}} App today from the Apple App or Google Play Store and start donating your bottles directly to us!',
        fr:
            "Nous avons besoin de vos contenats consignés! Téléchargez l'application {{socialMediaHandle}} dès aujourd'hui depuis l'application Apple ou Google Play Store et commencez à nous faire directement don de vos contenants!"
    },
    growthLinkedIn9: {
        en:
            'The great part about {{socialMediaHandle}} is they will pickup your bottles and make sure the funds go toward supporting our cause!',
        fr:
            "Le point fort de {{socialMediaHandle}}, c'est qu'ils ramasseront vos bouteilles et s'assureront que les fonds servent à soutenir notre cause!"
    },
    growthLinkedIn10: {
        en: 'Get started today and use the referral link here ->',
        fr: "Commencez dès aujourd'hui et utilisez le lien de référence ici ->"
    },
    growthLinkedIn11: {
        en:
            'When you use our referral link and book your first pickup, the funds will automatically be set to be donated to {{{charity}}}!',
        fr:
            'Lorsque vous utilisez notre lien de référence et réservez votre première collecte, les fonds seront automatiquement destinés à être donnés à {{{charity}}} !'
    },
    growthLinkedIn12: {
        en: "Did you know Albertan's helped raise $500,000 through {{{socialMediaHandle}}}?!",
        fr: 'Saviez-vous que les québécois ont aidé à amasser 500 000 $ grâce à {{{socialMediaHandle}}} ?!'
    },
    growthLinkedIn13: {
        en:
            '{{{charity}}} has partnered up with {{socialMediaHandle}} to give you the option to support us by donating your bottles!',
        fr:
            "{{{charity}}} s'est associé à {{socialMediaHandle}} pour vous donner la possibilité de nous soutenir en faisant don de vos contenants consignés!"
    },
    growthLinkedIn14: {
        en:
            'Getting signed up is easy! Just use our referral link below and your first pickup will be set to donate the funds toward supporting our cause!',
        fr:
            "S'inscrire est facile! Utilisez simplement notre lien de référence ci-dessous et votre première collecte sera configurée pour donner les fonds afin de soutenir notre cause!"
    },
    growthLinkedIn15: {
        en: 'Here is our referral link! ->',
        fr: 'Voici notre lien de référence! ->'
    },
    growthLinkedIn16: {
        en: 'Get started today on your computer or download the {{brand}} App on your Apple or Android device!',
        fr:
            "Commencez dès aujourd'hui sur votre ordinateur ou téléchargez l'application {{brand}} sur votre appareil Apple ou Android !"
    },
    growBlog1: {
        en: 'Write a blog post using the examples given below:',
        fr: 'Rédigez un article de blog en utilisant les exemples ci-dessous:'
    },
    growBlog1EXPa: {
        en: 'Write your blog post and make sure you include the following instructions below.',
        fr: "Rédigez votre article de blog et assurez-vous d'inclure les instructions suivantes."
    },
    growBlog1EXPb: {
        en: '{{brand}} makes donations easy, to get started: ',
        fr: '{{brand}} simplifie les dons. Pour commencer :'
    },
    growBlog2: {
        en: '{{{charity}}} has partnered with {{brand}}',
        fr: "{{{charity}}} s'est associé à {{brand}}"
    },
    growBlog3: {
        en: 'Recycling Donations to {{{charity}}} with {{brand}}',
        fr: 'Dons de recyclage à {{{charity}}} avec {{brand}}'
    },
    growBlog4: {
        en: 'Donate to {{{charity}}} with {{brand}}',
        fr: 'Faites un don à {{{charity}}} avec {{brand}}'
    },
    growBlog5: {
        en: '{{{charity}}} wants your bottles & cans! {{brand}} Fundraising',
        fr: '{{{charity}}} veut vos contenants consignés! Collecte de fonds de {{brand}}'
    },
    growBlog6: {
        en: 'Make sure you put your link down on your page so people can easily donate',
        fr: 'Assurez-vous de mettre votre lien sur votre page afin que les gens puissent facilement faire un don'
    },
    growOrder1: {
        en:
            'Your email should contain a high resolution logo for us to use. We will create the proofs (for free!) and email you the results to be printed.',
        fr:
            'Votre courriel doit contenir un logo en haute résolution que nous pourrons utiliser. Nous créerons les maquettes (gratuitement !) et vous enverrons les résultats par courriel pour impression.'
    },
    growOrder1a: {
        en: 'Custom Posters & Hangers Order - {{charityName}}',
        fr: "Commande d'affiches et de cintres personnalisés - {{charityName}}"
    },
    growOrder2: {
        en:
            'Press the order button below. If prompted, upload a high resolution logo for us to use. We will generate and email you the proofs to be printed. Once printed, submit a picture below to verify.',
        fr:
            'Cliquez sur le bouton de commande ci-dessous. Si demandé, téléversez un logo haute résolution pour notre utilisation. Nous générerons et vous enverrons par courriel les épreuves à imprimer. Une fois imprimé, soumettez une photo ci-dessous pour vérification.'
    },
    growOrder2a: {
        en: 'Drop Bin Order - {{charityName}}',
        fr: 'Commande de bac de dépôt - {{charityName}}'
    },
    growOrder3: {
        en: 'Please email',
        fr: 'Veuillez envoyer un courriel à'
    },
    growOrder3a: {
        en: 'with the subject',
        fr: 'avec pour objet'
    },
    growOrder3b: {
        en: 'Custom Bag Order - {{charityName}}',
        fr: 'Commande de sacs personnalisés - {{charityName}}'
    },
    growOrder3c: {
        en: 'Your email should include the following information',
        fr: 'Votre courriel doit inclure les informations suivantes'
    },
    growOrder4: {
        en: 'Send an email to',
        fr: 'Envoyez un courriel à'
    },
    growOrder4a: {
        en: 'Event Invitation- {{charityName}}',
        fr: "Invitation à l'événement - {{charityName}}"
    },
    growOrder5: {
        en:
            'Call / Email any of the news outlets in your area letting them know you are looking for recycling donations to help your cause.',
        fr:
            'Appelez / envoyez un courriel aux médias de votre région pour leur faire savoir que vous recherchez des dons de recyclage pour aider votre cause.'
    },
    growOrder5EXP: {
        en: 'Call / Email any of the news outlets in your area and share your story.',
        fr: "Appelez ou envoyez un courriel à l'un des médias de votre région et partagez votre histoire."
    },
    growOrder6: {
        en: 'This is your promo code:',
        fr: 'Voici votre code promotionnel:'
    },
    growOrder7: {
        en: 'Copy Promo Code',
        fr: 'Copier le code promotionnel'
    },
    growOrder8: {
        en:
            'Distribute this to all your donors. Customers can only use this promocode when donating to you and you will recieve more deposits from them when they do.',
        fr:
            "Distribuez-le à tous vos donateurs. Les clients ne peuvent utiliser ce code promotionnel que lorsqu'ils vous font un don et vous recevrez plus de dépôts de leur part lorsqu'ils le feront."
    },
    growOrder9: {
        en:
            'Download your personalized {{type}} design, upload it to your favorite print company (we’re fans of VistaPrint), and print as many as you need. Hand them out, snap a pic of the final product and submit it, and voilà—task complete!',
        fr:
            "Téléchargez votre design personnalisé de {{type}}, téléchargez-le sur votre site d'impression préféré (nous aimons VistaPrint), et imprimez-en autant que nécessaire. Distribuez-les, prenez une photo du produit final et soumettez-la, et voilà—tâche accomplie !"
    },
    growOrder10: {
        en: 'See the included preview to get a look at the design. Interested? Email us at',
        fr: 'Consultez l’aperçu inclus pour voir le design. Intéressé(e) ? Envoyez-nous un courriel à '
    },
    growOrder10a: {
        en:
            'and include your name, organization name, and the best way to contact you. While not free, they’re heavily discounted through {{brand}}’s bulk pricing.',
        fr:
            'et incluez votre nom, le nom de votre organisation et le meilleur moyen de vous contacter. Bien qu’ils ne soient pas gratuits, ils bénéficient de tarifs fortement réduits grâce aux prix de gros de {{brand}}.'
    },
    growthEvent1: {
        en: 'Request Attendance',
        fr: 'Demande de Présence'
    },
    growthEvent2: {
        en:
            'Enter your event details below and request our attendance. Please allow for a minimum of 2 weeks notice for events. After the event is finished, submit a picture below to verify.',
        fr:
            "Entrez les détails de votre événement ci-dessous et demandez notre  présence à votre événement. Veuillez prévoir un préavis minimum de 2 semaines pour les événements. Une fois l'événement terminé, soumettez une photo ci-dessous pour vérifier."
    },
    tooltip1: {
        en: 'Upload New',
        fr: 'Télécharger nouveau'
    },
    tooltip2: {
        en: 'View Photo',
        fr: 'Voir la photo'
    },
    household1: {
        en: 'Your returns chart will be shown after your first bag is counted.',
        fr: 'Votre tableau des retours sera affiché après le comptage de votre premier sac.'
    }
};

const taxReceiptsTranslations = {
    taxReceipts1: {
        en: 'Tax Receipt Tracking',
        fr: 'Avis au donateur'
    },
    taxReceipts2: {
        en: 'Notify {{count}} Donors',
        fr: 'Notifier {{count}} donateurs'
    },
    taxReceipts3: {
        en: 'The system will notify donors that {{{charity}}} is reviewing their donation details.',
        fr: 'Le système notifiera les donateurs que {{{charity}}} examine les détails de leurs dons.'
    },
    taxReceipts4: {
        en: 'Continue',
        fr: 'Continuer'
    },
    taxReceipts5: {
        en: 'You have outstanding donations to notify customers for {{yearsToIssue}}',
        fr: 'Vous avez des dons en attente de notification aux clients pour {{yearsToIssue}}'
    },
    taxReceipts6: {
        en:
            'Donations are consolidated into a single donation per customer ({{minTaxReceiptAmount}} minimum per donation). This section tracks tax receipts only—it does not issue them. Notifications simply inform donors that their receipt has been reviewed and sent by your organization.',
        fr:
            "Les dons sont regroupés en un seul don par client (minimum de {{minTaxReceiptAmount}} par don). Cette section ne fait que suivre les reçus d'impôt—elle ne les émet pas. Les notifications informent simplement les donateurs que leur reçu a été examiné et envoyé par votre organisation."
    },
    taxReceipts7a: {
        en:
            'Simply select the year you would like to issue your receipts for and press the issue button to notify the users that their tax receipts are being prepared. Your tax-receipt-year-end date is ',
        fr:
            "Sélectionnez simplement l'année pour laquelle vous souhaitez émettre vos reçus et appuyez sur le bouton d'émission pour informer les utilisateurs que leurs reçus fiscaux sont en cours de préparation. La date de fin d'année de votre reçu fiscal est le "
    },
    taxReceipts7b: {
        en: '. If you would like to change the year end date, contact {{brand}} to have this updated.',
        fr: ". Si vous souhaitez modifier la date de fin d'année, contactez {{brand}} pour la mettre à jour."
    },
    taxReceipts8: {
        en: 'In progress',
        fr: 'En cours'
    },
    taxReceipts9: {
        en:
            'Notifications to donors for the current year can only be sent after your tax receipt year-end date, {{endOfTaxYear}}. Contact {{brand}} to update this date.',
        fr:
            "Les notifications aux donateurs pour l'année en cours ne peuvent être envoyées qu'après votre date de fin d'année fiscale pour les reçus d'impôt, soit le {{endOfTaxYear}}. Contactez {{brand}} pour mettre à jour cette date."
    },
    taxReceipts10: {
        en: 'Notifications for {{year}}',
        fr: 'Notifications pour {{année}}'
    },
    taxReceipts11: {
        en: '{{count}} Sent',
        fr: '{{count}} Envoyée'
    },
    taxReceipts12: {
        en: '{{count}} Not sent',
        fr: '{{count}} Non envoyée'
    },
    taxReceipts13: {
        en: 'Information',
        fr: 'Information'
    },
    taxReceipts14: {
        en:
            'This table shows consolidated donations that have been or are ready to be notified to customers. Every row in the table represents the consolidated donations along with the total monetary value. By notifying the donors, we will send an update to the users by email and history that tax receipts are being prepared. We cannot issue the physical tax receipts, your charity must still do that.',
        fr:
            "Ce tableau présente les dons regroupés qui ont été ou sont prêts à être notifiés aux clients. Chaque ligne du tableau représente les dons regroupés ainsi que la valeur monétaire totale. En notifiant les donateurs, nous enverrons une mise à jour aux utilisateurs par courriel et dans l'historique indiquant que les reçus d'impôt sont en cours de préparation. Nous ne pouvons pas émettre les reçus d'impôt physiques, votre organisme de bienfaisance doit toujours s'en charger."
    },
    taxReceipts15: {
        en: 'Download All',
        fr: 'Tout télécharger'
    },
    taxReceipts16: {
        en: 'DEFERRED',
        fr: 'DIFFÉRÉ'
    },
    taxReceipts17: {
        en: 'Select a date period',
        fr: 'Sélectionner une date de période'
    },
    taxReceipts18: {
        en:
            'The system only notifies users by email and app history that tax receipts are being prepared. We cannot issue the physical tax receipts. You, the charity, must still do that.',
        fr:
            "Le système informe uniquement les utilisateurs par courriel et par l'historique de l'application que des reçus fiscaux sont en cours de préparation. Nous ne pouvons pas délivrer les reçus fiscaux physiques. Vous, l'organisme de charité, devez encore le faire."
    },
    taxReceipts19: {
        en: 'Select the end of your current tax year. By default, this date is set to December 31st.',
        fr: "Sélectionnez la fin de votre année d'imposition en cours. Par défaut, cette date est fixée au 31 décembre."
    },
    taxReceipts20: {
        en: 'SENT',
        fr: 'Envoyée'
    },
    taxReceipts21: {
        en: 'NOT SENT',
        fr: 'Non envoyée'
    },
    taxReceipts22: {
        en: 'Select date period',
        fr: 'Sélectionnez la période'
    },
    taxReceipts23: {
        en: 'Unredeemed donations',
        fr: 'Dons non remboursés'
    },
    taxReceipts24: {
        en:
            'This list shows donations which have not been redeemed. For reconciliation purposes when a redemption is executed this list will move to the redeemed donations list and a CSV will be generated matching the total redemption with donor information and amounts.',
        fr:
            "Cette liste répertorie les dons qui n'ont pas été remboursés. À des fins de centralisation, lorsqu'un remboursement est exécuté, cette liste passera à la liste des dons échangés et un fichier CSV sera généré correspondant au remboursement total avec les informations et les montants des donateurs."
    },
    taxReceipts25: {
        en: 'Download CSV',
        fr: 'Télécharger CSV'
    },
    taxReceipts26: {
        en: 'Redeemed donations',
        fr: 'Dons réclamés'
    },
    taxReceipts27: {
        en:
            "Use the drop-down list to select a redemption to display the associated donation information. If the user is muted or grayed out it's because the user selected not to receive a tax receipt. The exported CSV will only include people who want tax receipts.",
        fr:
            "Utilisez la liste déroulante pour sélectionner une réclamation afin d'afficher les informations de don associées. Si l'utilisateur est grisé, c'est parce qu'il a choisi de ne pas recevoir de reçu fiscal. Le CSV exporté n'inclura que les personnes qui souhaitent recevoir des reçus fiscaux."
    },
    taxReceipts28: {
        en: 'Select redemption',
        fr: 'Sélectionnez le remboursement'
    },
    taxReceipts29: {
        en: 'Monthly Container Breakdown',
        fr: 'Répartition mensuelle des contenants'
    },
    taxReceipts30: {
        en: 'Material',
        fr: 'Matière'
    },
    taxReceipts31: {
        en: 'Small Containers',
        fr: 'Petits contenants'
    },
    taxReceipts32: {
        en: 'Large Containers',
        fr: 'Grands contenants'
    },
    taxReceipts33: {
        en: 'Total Containers',
        fr: 'Nombre total de contenants'
    },
    taxReceipts34: {
        en: 'Rows per page',
        fr: 'Lignes par page'
    },
    taxReceipts35: {
        en: 'Legacy donations',
        fr: 'Dons testamentaires'
    },
    taxReceipts36: {
        en: 'Notify Donors',
        fr: 'Avis au donateur'
    },
    taxReceiptCol1: {
        en: 'Name',
        fr: 'Nom'
    },
    taxReceiptCol2: {
        en: 'E-mail',
        fr: 'courriel'
    },
    taxReceiptCol3: {
        en: 'Phone',
        fr: 'Téléphone'
    },
    taxReceiptCol4: {
        en: 'Address',
        fr: 'Adresse'
    },
    taxReceiptCol5: {
        en: '# Donations',
        fr: '# dons'
    },
    taxReceiptCol6: {
        en: 'Total Amount',
        fr: 'Montant total'
    },
    taxReceiptCol7: {
        en: 'First Donation',
        fr: 'Premier don'
    },
    taxReceiptCol8: {
        en: 'Last Donation',
        fr: 'Dernier don'
    },
    taxReceiptCol9: {
        en: 'Date Issued',
        fr: 'Date de délivrance'
    },
    taxReceiptCol10: {
        en: 'Receipt Year',
        fr: 'Année de réception'
    },
    taxReceiptCol11: {
        en: 'Last Pickup Date',
        fr: 'Date de la dernière collecte'
    },
    taxReceiptCol12: {
        en: 'Grouping',
        fr: 'Regroupement'
    },
    taxReceiptCol13: {
        en: 'Amount',
        fr: 'Montant'
    },
    taxReceiptCol14: {
        en: 'Pickup Date',
        fr: 'Date de collecte'
    },
    taxReceiptCol15: {
        en: 'Business Name',
        fr: "Nom de l'entreprise"
    },
    taxReceiptCol16: {
        en: 'Donation Date',
        fr: 'Date du don'
    },
    taxReceiptCol17: {
        en: 'Last Donation Date',
        fr: 'Date du dernier don'
    }
};

const referralTranslations = {
    referal1: {
        en: 'Email Out Directly',
        fr: 'Envoyer directement par courriel'
    },
    referal2: {
        en:
            'Start by adding the email addresses of everyone who you want to participate. Enter them one by one or copy paste a comma/space delimited list!',
        fr:
            'Commencez par ajouter les adresses courriel de toutes les personnes dont la participation est souhaitée. Entrez-les un par un ou copiez-collez une liste délimitée par des virgules/espaces!'
    },
    referal3: {
        en: 'Emails',
        fr: 'Courriels'
    },
    referal4: {
        en: 'Add email',
        fr: 'Ajouter un courriel'
    },
    referal5: {
        en: 'Send',
        fr: 'Envoyer'
    },
    referal6: {
        en: 'Invalid email format',
        fr: 'Format de courriel invalide'
    },
    referal7: {
        en: 'Emails sent!',
        fr: 'Courriels envoyés!'
    },
    referal8: {
        en: 'Email is already added to the list',
        fr: 'Le courriel est déjà ajouté à la liste'
    },
    referralScreen1: {
        en: `If you love using ${app} give us a 5 star review! It only takes a moment and helps us expand to new areas!`,
        fr: ``
    },
    referralScreen2: {
        en: `Invite`,
        fr: `Inviter`
    },
    referralScreen3: {
        en: `Copy Link`,
        fr: `Copier le lien`
    },
    referralScreen4: {
        en: `Invite your friends!`,
        fr: `Invite tes amis!`
    },
    referralScreen5: {
        en: 'Press to Invite!',
        fr: 'Appuyer pour Inviter!'
    },
    referralScreen7: {
        en: 'Long press on the qr code to save or copy it',
        fr: 'Code QR de parrainage'
    }
};

const historyTranslations = {
    history1: {
        en: 'Filters',
        fr: 'Filtres'
    },
    history2: {
        en: 'Donations',
        fr: 'Dons'
    },
    history3: {
        en: 'Redemptions',
        fr: 'Remboursements'
    },
    history4: {
        en: 'Donation by {{{name}}} to {{{charity}}}',
        fr: 'Don de par {{{name}}} à {{{charity}}}'
    },
    history5: {
        en: 'More',
        fr: 'Plus'
    },
    history6: {
        en: 'No history entries exist yet',
        fr: "Aucune entrée d'historique n'existe encore"
    },
    history7: {
        en: 'No items have been found. Check your filters to show more.',
        fr: 'Aucun élément n’a été trouvé. Vérifiez vos filtres pour en voir davantage.'
    },
    history8: {
        en: 'Account credited!',
        fr: 'Compte crédité!'
    },
    history9: {
        en: 'You have received a compensation from {{brand}}.',
        fr: 'Vous avez reçu une compensation de {{brand}}.'
    },
    history10: {
        en: 'Pickup photo',
        fr: 'Photo de collecte'
    },
    history11: {
        en: 'The customer would like to know when their counts will be processed',
        fr: 'Le client souhaite savoir quand ses décomptes seront effectués'
    },
    history12: {
        en: 'Reason',
        fr: 'Raison'
    },
    history13: {
        en: 'Cash delivered to {{{name}}}',
        fr: 'Argent remis à {{{name}}}'
    },
    history14: {
        en: 'Tax Receipt issued by',
        fr: 'Reçu fiscal émis par'
    },
    history15: {
        en: 'Picked up by',
        fr: 'Récupérer par'
    },
    history16: {
        en: 'Printed at',
        fr: 'Imprimé à'
    },
    history17: {
        en: 'labels scanned at',
        fr: 'autocollants numérisées à'
    },
    history18: {
        en: 'dropped off at',
        fr: 'déposé à'
    },
    history19: {
        en: 'Referral bonus from {{name}}',
        fr: 'Bonus de parrainage de {{name}}'
    },
    history20: {
        en: 'Loading History...',
        fr: "Chargement de l'historique..."
    },
    labels: {
        en: 'Labels',
        fr: 'Autocollants'
    },
    labelsPrinted: {
        en: 'Labels Printed',
        fr: 'Autocollants imprimés'
    },
    labelsReprinted: {
        en: 'Labels Reprinted',
        fr: 'Autocollants Réimprimés'
    },
    labelsScanned: {
        en: 'Labels Scanned',
        fr: 'Autocollants Numérisées'
    },
    adminOnly: {
        en: 'Admin-Only',
        fr: "Réservé à l'administration"
    },
    viewTrip: {
        en: 'View Trip',
        fr: 'Voir le trajet'
    },
    viewOrder: {
        en: 'View Order',
        fr: 'Voir la commande'
    },
    viewOrderHistory: {
        en: 'View Order History',
        fr: "Consulter l'historique des commandes"
    },
    orderHistory: {
        en: 'Order History',
        fr: 'Historique des commandes'
    },
    viewCustomer: {
        en: 'View Customer',
        fr: 'Voir le Client'
    },
    pickupRescheduled: {
        en: 'Pickup Rescheduled',
        fr: 'Ramassage reporté'
    },
    rescheduledBy: {
        en: 'Rescheduled by',
        fr: 'Reporté par'
    }
};

const registrationTranslations = {
    registration1a: {
        en: `First time hearing about ${app}? Learn more through our website at`,
        fr: `C'est la première fois que vous entendez parler de ${app}? Apprenez-en plus sur`
    },
    registration1b: {
        en: `and the`,
        fr: `et`
    },
    registration2a: {
        en: `First time hearing about ${app}? Learn more through our`,
        fr: `C'est la première fois que vous entendez parler de ${app}? Apprenez-en plus grâce à notre`
    },
    registration2b: {
        en: 'and',
        fr: 'et'
    },
    registration2c: {
        en: 'You can also check out our website at',
        fr: "Vous y retrouverez plus d'information ici: "
    },
    registration2d: {
        en: 'to learn about the program and to see where the pickup service is currently available',
        fr: 'pour en savoir plus sur le programme et voir où le service de collecte est actuellement disponible'
    },
    registration3: {
        en: 'Personal',
        fr: 'Inscription personnelle'
    },
    registration4: {
        en: 'Fundraising & Group',
        fr: 'Collecte de fonds et inscription de groupe'
    },
    registration4a: {
        en: 'Group',
        fr: 'Inscription de groupe'
    },
    registration4b: {
        en: 'Charity',
        fr: 'Collecte de fonds'
    },
    registration5: {
        en: 'Start A Bottle Drive',
        fr: 'Démarrer une collecte de contenants'
    },
    registration6: {
        en: 'Become A Collector Partner',
        fr: 'Devenir un Récupérateur Partenaire'
    },
    registration8: {
        en: 'Accept donations for charities, schools, not-4-profit, sports teams, fundraisers',
        fr: 'Acceptez les dons pour votre organisme de bienfaisance, école, équipe sportive ou autre OBNL'
    },
    registration8a: {
        en: 'Bottle drives and fundraising for schools, community groups, or sports teams',
        fr:
            'Collectes de bouteilles et collectes de fonds pour les écoles, les groupes communautaires ou les équipes sportives'
    },
    registration8b: {
        en: 'Registered charitable organizations',
        fr: 'Organisations caritatives enregistrées'
    },
    registration9: {
        en: 'Request a trailer drop off or help with all things bottle drive related.',
        fr: `Demandez un dépôt de remorque ou de l'aide pour tout ce qui concerne la conduite de bouteilles.`
    },
    registration10: {
        en: `Expand to new areas, collect, and accept volume from ${app}.`,
        fr: `Développez-vous dans de nouveaux marchés, collectez et acceptez les contenants de ${app}`
    },
    registration11: {
        en: `Change account type`,
        fr: 'Changer le type de compte'
    },
    registration12: {
        en: `More information`,
        fr: `Plus d'information`
    },
    registration13: {
        en: `Different number for label printing?`,
        fr: `Numéro différent pour l'impression des autocollants ?`
    },
    registration14: {
        en: 'Business',
        fr: "Inscription d'entreprise"
    },
    registration16: {
        en: '{{{ collectionProgram }}} Collections',
        fr: '{{{ collectionProgram }}} Collections'
    },
    registration17: {
        en: 'Industrial, Commercial & Institutional',
        fr: 'Industriel, Commercial et Institutionnel'
    },
    registrationInfo1: {
        en: `If you request a cheque, it will be issued to the first and last name on your ${app} account.`,
        fr: `Si vous demandez un chèque, il sera émis au prénom et nom de famille associés à votre compte ${app}.`
    },
    registrationInfo2a: {
        en: `The phone number associated with your account will be used to print labels and for two-factor authentication during registration and login.`,
        fr: `Le numéro de téléphone associé à votre compte sera utilisé pour imprimer des autocollants et pour l'authentification à deux facteurs lors de l'inscription et de la connexion.`
    },
    registrationInfo2b: {
        en: `The phone number associated with your account will be used for sms notifications and for two-factor authentication during registration and login.`,
        fr: `Le numéro de téléphone associé à votre compte sera utilisé pour les notifications par SMS et pour l'authentification à deux facteurs lors de l'inscription et de la connexion.`
    },
    registrationInfo3: {
        en: `The email associated with your ${app} account will be used to notify you of any updates to your account and to facilitate Interac e-Transfers.`,
        fr: `L'adresse courriel associée à votre compte ${app} sera utilisée pour vous informer de toute mise à jour de votre compte et pour faciliter les virements Interac.`
    },
    registrationInfo4: {
        en: 'The address provided during registration will be used to deliver cheques if requested.',
        fr: `L'adresse fournie lors de l'inscription sera utilisée pour délivrer les chèques sur demande.`
    },
    registrationInfo5a: {
        en: `Cheques will be issued to the registered business name and will appear when you print labels at an ${app} location.`,
        fr: `Les chèques seront émis au nom de l'entreprise enregistrée et apparaîtront lorsque vous imprimerez des autocollants dans un emplacement ${app}.`
    },
    registrationInfo5b: {
        en: `Cheques will be issued to the registered business name.`,
        fr: `Les chèques seront émis au nom de l'entreprise enregistrée.`
    },
    registrationInfo6: {
        en:
            'A company is said to be "doing business as" when the name under which they operate their business differs from its legal, registered name.',
        fr: `On dit qu'une entreprise « fait affaire sous le nom » lorsque le nom sous lequel elle exploite son entreprise diffère de son nom légal enregistré.`
    },

    registrationType1: {
        en: `Create a Personal Account`,
        fr: `Créer un compte personnel`
    },
    registrationType2: {
        en: `Create a Group Account`,
        fr: `Créer un compte de groupe`
    },
    registrationType2a: {
        en: `Create a Charity Account`,
        fr: `Créer un compte caritatif`
    },
    registrationType3: {
        en: `Sign Up For Depot Software`,
        fr: `S'enregistrer pour le logiciel de dépôt`
    },
    registrationType4: {
        en: 'Start A Bottle Drive',
        fr: 'Démarrer une collecte de contenants'
    },
    registrationType5: {
        en: 'Create a Business Account',
        fr: 'Créer un compte professionnel'
    },
    registrationType6: {
        en: 'Sign Up for the Collections Program',
        fr: 'Inscrivez-vous au Programme Collections'
    },
    registrationDescriptions1: {
        en: `Don't waste your day waiting at the bottle depot! Sign up below, schedule a pickup, and cash out or donate online!`,
        fr: `Ne perdez pas votre journée à attendre au dépôt de bouteilles! Inscrivez-vous ci-dessous, planifiez une collecte et encaissez ou faites un don en ligne!`
    },
    registrationDescriptions2: {
        en: `Use ${app} to promote your fundraising efforts. Sign up your ${terms.organization.en} below.`,
        fr: `Utilisez ${app} pour promouvoir vos efforts de collecte de fonds. Inscrivez votre organisme ci-dessous et laissez nos clients vous faire don de leurs contenants consignés!`
    },
    registrationDescriptions3: {
        en: `We have a variety of software systems that support Bottle Depots, including a Drop&Go system which eliminates lines and streamlines the payout process.`,
        fr: `Nous avons une variété de systèmes logiciels qui prennent en charge les lieux de retour de contenants consignés, y compris un système de conteneur extérieur POD qui permettent de déposer les sacs sans attente.`
    },
    registrationDescriptions4: {
        en: `Is your organization running a bottle drive, clothing drive, or electronics drive? Fill out the form below and we will confirm your booking. On the day of your bottle drive A SkipTheDepot truck will arrive at the end to collect your bags and have them processed. Your proceeds will be available via e-transfer with history recorded in your account.`,
        fr: `
        Votre organisation organise-t-elle une collecte de bouteilles, une collecte de vêtements ou une collecte d'appareils électroniques ? Remplissez le formulaire ci-dessous et nous confirmerons votre réservation. Le jour de votre collecte de bouteilles, un camion SkipTheDepot arrivera à la fin pour récupérer vos sacs et les faire traiter. Vos bénéfices seront disponibles par virement électronique avec un historique enregistré dans votre compte.`
    },
    registrationDescriptions5: {
        en: `{{brand}} allows business and community groups to donate their recyclables to a worthy cause. It's free to register and you choose who gets your donations! Company bottle drives are a great way for companies, corporations, businesses, and community groups to a local charity with ease.`,
        fr: `{{brand}} permet aux entreprises et aux groupes communautaires de faire don de leurs matières recyclables à une bonne cause. L'inscription est gratuite et vous choisissez qui reçoit vos dons ! Les collectes de bouteilles d'entreprise sont un excellent moyen pour les entreprises, les sociétés, les entreprises et les groupes communautaires de se rendre facilement à un organisme de bienfaisance local.`
    },
    registrationDescriptions6: {
        en: `A convenient and cashless way to recycle used beverage containers`,
        fr: `Un moyen pratique et sans espèces de recycler les contenants de boissons usagés`
    },
    registrationOrg1: {
        en: `Connect Account`,
        fr: `Connecter un compte`
    },
    registrationOrg2: {
        en: `Create Administrator Account`,
        fr: `Créer un Compte Administrateur`
    },
    registrationOrg3: {
        en: `Connect your existing account to manage the {{accountText}} you are about to register.`,
        fr: `Connectez votre compte existant pour gérer le {compte} que vous êtes sur le point d’enregistrer`
    },
    registrationOrg4: {
        en: `This account will be used to manage the {{accountText}} you are about to register.`,
        fr: `Ce compte sera utilisé pour gérer l'organisme que vous êtes sur le point d'enregistrer.`
    },
    registrationOrg4EXP: {
        en:
            "All Charity and Group Accounts must have a personal account linked to it. If you don't have one the system will create one for you. You will receive a separate email for your personal account and instructions on how to use the Express program.",
        fr:
            "Tous les comptes caritatifs et de groupe doivent être associés à un compte personnel. Si vous n'en avez pas, le système en créera un pour vous. Vous recevrez un courriel distinct pour votre compte personnel et des instructions sur l'utilisation du programme Express."
    },
    registrationOrg5: {
        en: `I have a personal account already`,
        fr: `J'ai déjà un compte`
    },
    registrationOrg6: {
        en: `Fill out information about your ${terms.organization.en.toLowerCase()}. Remember that this information will be visible to all our customers.`,
        fr: `Remplissez les informations sur votre organisme. N'oubliez pas que ces informations seront visibles par tous nos clients.`
    },
    registrationOrg7: {
        en: `E-mail to receive donations/redemptions`,
        fr: `Courriel pour recevoir des dons/rachats`
    },
    registrationOrg8: {
        en: `Mission & Vision`,
        fr: `Mission et vision`
    },
    registrationOrg9: {
        en: `Enter ${terms.organization.en.toLowerCase()} address`,
        fr: ``
    },
    registrationOrg10: {
        en: `GPS Override (Advanced)`,
        fr: `Remplacement du GPS (avancé)`
    },
    registrationOrg11: {
        en: `Please do not change these values if you are unsure what they mean.`,
        fr: `Veuillez ne pas modifier ces valeurs si vous n'êtes pas certain de leur signification.`
    },
    registrationOrg12: {
        en: `My ${terms.organization.en.toLowerCase()} issues tax receipts`,
        fr: `Mon organisme émet des reçus fiscaux`
    },
    registrationOrg13: {
        en: `My ${terms.organization.en.toLowerCase()} has multiple groups/teams`,
        fr: `Mon organisme a plusieurs groupes/équipes`
    },
    registrationOrg14: {
        en: `teams, groups, companies or divisions`,
        fr: `équipes, groupes, sociétés ou divisions`
    },
    registrationOrg15: {
        en: `${terms.organization.en} Website`,
        fr: `Site de l'organisme`
    },
    registrationOrg16: {
        en: `${terms.organization.en} Name`,
        fr: `Nom de l'organisme`
    },
    registrationOrg17: {
        en: `${terms.organization.en} E-mail (financial)`,
        fr: `courriel de l'organisme (financier)`
    },
    registrationOrg18: {
        en: `Create ${terms.organization.en}`,
        fr: `Créer un organisme`
    },
    registrationOrg19: {
        en: `${terms.organization.en}'s Registered Name`,
        fr: `Nom enregistré de l'organisation`
    },
    registrationOrg20: {
        en: `Automatically close this ${terms.organization.en.toLowerCase()} after a specified date.`,
        fr: 'Fermez automatiquement cette organisation après une date spécifiée.'
    },
    registrationOrg21: {
        en: `${terms.organization.en} Scheme ID`,
        fr: `identifiant du schéma d'organisation`
    },

    registration2fa1: {
        en: `Please update your phone number.`,
        fr: `Veuillez mettre à jour votre numéro de téléphone.`
    },
    registration2fa2: {
        en: `Your account is protected with two-factor authentication. We've sent you a text message at {{formattedPhoneNumber}}. Please enter the code below.`,
        fr: `Votre compte est protégé par une authentification à deux facteurs. Nous vous avons envoyé un SMS à {{formattedPhoneNumber}}. Veuillez entrer le code ci-dessous.`
    },
    registration2fa3: {
        en: `*Warning: sms will be sent - do not use random phone numbers*`,
        fr: `* Attention: des sms seront envoyés - n’utilisez pas de numéros de téléphone aléatoires`
    },
    registration2fa4: {
        en: `Having trouble logging in? Contact us at`,
        fr: `Vous rencontrez des difficultés pour vous connecter ? Contactez-nous au`
    },
    registration2fa5: {
        en: `Retry available in`,
        fr: `Nouvelle tentative disponible dans`
    },
    registration2fa6: {
        en: `Authentication Code`,
        fr: `Code d’authentification`
    },
    registration2fa7: {
        en: `Trust this device`,
        fr: `Faire confiance à cet appareil`
    },
    registration2fa8: {
        en: 'I did not receive a SMS',
        fr: `Je n'ai pas reçu de SMS`
    },
    registration2fa9: {
        en: 'Is this your number? {{phone}}',
        fr: `Est-ce votre numéro? {{phone}}`
    },
    registration2fa10: {
        en: 'Customer Support has been contacted and will reach out shortly.',
        fr: 'Le service client a été contacté et vous contactera sous peu.'
    },
    registration2fa11: {
        en: 'Double Check Your Phone Number',
        fr: 'Vérifiez votre numéro de téléphone'
    },
    registration2fa12: {
        en: 'Please correct your phone number and click resend.',
        fr: 'Veuillez corriger votre numéro de téléphone et cliquer sur renvoyer.'
    },
    registration2fa13: {
        en: `An authentication code has been sent to`,
        fr: `Un code d'authentification a été envoyé à`
    },
    registration2fa14: {
        en: `Change Number`,
        fr: `Changer de numéro`
    },
    registration2fa15: {
        en: `I need to update my phone number`,
        fr: `Je dois mettre à jour mon numéro de téléphone`
    },
    registration2fa16: {
        en: `If this issue persists, please email`,
        fr: `Si ce problème persiste, veuillez envoyer un courriel à`
    },
    registration2fa17: {
        en: `A verification code has been sent to the phone number associated with your account`,
        fr: `Un code de vérification a été envoyé au numéro de téléphone associé à votre compte`
    },
    registration2fa18: {
        en: `Please make sure that your phone number has been entered correctly. If you are using a landline, please select '{{{voiceChannelSelect}}}'. If the issue persists, contact support at `,
        fr: `Veuillez vous assurer que votre numéro de téléphone a été saisi correctement. Si vous utilisez un téléphone fixe, veuillez sélectionner '{{{voiceChannelSelect}}}'. Si le problème persiste, contactez le soutien à `
    },
    registration2fa19: {
        en: `A verification code will be sent to the phone number associated with your account after clicking Send Code`,
        fr: `Un code de vérification sera envoyé au numéro de téléphone associé à votre compte après avoir cliqué sur Envoyer le code`
    },
    registrationEmailVerification1: {
        en: `*Warning: email will be sent - do not use random email*`,
        fr: `*Attention : un email sera envoyé - n'utilisez pas une adresse email aléatoire*`
    },
    registrationEmailVerification2: {
        en: `Verification Code`,
        fr: `Code de vérification`
    },
    registrationRetry: {
        en: `Retry available in`,
        fr: `Nouvelle tentative disponible dans`
    },
    smsUnavailable: {
        en: `SMS unavailable for landline numbers`,
        fr: `SMS indisponible pour les numéros de téléphone fixe`
    },
    sendCodeVia: {
        en: `Send via:`,
        fr: `Envoyer par :`
    },
    switchToVoice: {
        en: `Switch to Voice`,
        fr: `Passer à l'appel vocal`
    },
    switchToSMS: {
        en: `Switch to SMS`,
        fr: `Passer au SMS`
    },
    resendCode: {
        en: `Resend Code`,
        fr: `Renvoyer le code`
    },
    resendCodeVia: {
        en: `Resend code via`,
        fr: `Renvoyer le code par`
    },
    voice: {
        en: `Voice`,
        fr: `Vocal`
    },
    failedToSendCode: {
        en: `Failed to send verification code`,
        fr: `Échec de l'envoi du code de vérification`
    },
    completingRegistration: {
        en: 'Completing registration...',
        fr: "Finalisation de l'inscription..."
    },
    weSendCode: {
        en: `We will send a verification code to`,
        fr: `Nous enverrons un code de vérification à`
    },
    sendCode: {
        en: `Send Code`,
        fr: `Envoyer le code`
    },
    sendViaEmail: {
        en: 'Send code via email',
        fr: 'Envoyer le code par email'
    },
    resendViaEmail: {
        en: 'Resend code via email',
        fr: 'Renvoyer le code par email'
    },
    resendViaText: {
        en: 'Resend code via text message',
        fr: 'Renvoyer le code par SMS'
    },
    resendViaVoice: {
        en: 'Resend code via voice call',
        fr: 'Renvoyer le code par appel vocal'
    },
    sendViaText: {
        en: 'Send code via text message',
        fr: 'Envoyer le code par SMS'
    },
    sendViaVoice: {
        en: 'Send code via voice call',
        fr: 'Envoyer le code par appel vocal'
    },
    verifyPhone: {
        en: 'Verify your phone number',
        fr: 'Vérifiez votre numéro de téléphone'
    },
    confirmItsYou: {
        en: "Confirm it's you",
        fr: "Confirme que c'est toi"
    },
    phoneNumberVerified: {
        en: 'Phone number verified',
        fr: 'Numéro de téléphone vérifié'
    },
    verifyEmail: {
        en: 'Verify your email',
        fr: 'Vérifiez votre e-mail'
    },
    regBottleDrive1: {
        en: `Enter the name of your company bottle drive and select the charity that donations will go towards`,
        fr: `Entrez le nom de la collecte de contenants de votre entreprise et sélectionnez l'organisme de bienfaisance auquel les dons iront:`
    },
    regBottleDrive2: {
        en: `Bottle drive name`,
        fr: `Nom de la collecte de contenants`
    },
    regBottleDrive3: {
        en: `Can't find the organization you want? Contact us`,
        fr: `Vous ne trouvez pas l'organisme que vous souhaitez? Contactez-nous`
    },
    registrationOAuth1: {
        en: `Successfully authenticated with`,
        fr: `Authentifié avec succès avec:`
    },
    registrationOAuth2: {
        en: `To complete registration, please provide an email address.`,
        fr: `Pour compléter l'inscription, veuillez fournir une adresse courriel.`
    },
    registrationOAuth2a: {
        en: `To complete registration, please provide a phone number.`,
        fr: `Pour compléter l'inscription, veuillez fournir un numéro de téléphone.`
    },
    registrationOAuth2b: {
        en:
            "e-Transfer will use your direct email address instead of Apple's private relay for payment notifications. Add it now or when making your first transfer.",
        fr:
            "e-Transfer utilisera votre adresse e-mail directe au lieu du relais privé d'Apple pour les notifications de paiement. Ajoutez-la maintenant ou lors de votre premier transfert."
    },
    registrationOAuth2c: {
        en: 'You need to provide a non relay email for e-transfers',
        fr: 'Vous devez fournir un courriel non-relais pour les virements électroniques'
    },
    registrationOAuth3: {
        en: `This will be your default e-transfer email.`,
        fr: `Il s’agira de votre courriel de transfert électronique par défaut.`
    },
    registrationOAuth4: {
        en: `It can be changed at any time.`,
        fr: ``
    },
    registrationOAuth5: {
        en: `By clicking "Continue", you agree to`,
        fr: `En cliquant sur « Continuer », vous acceptez`
    },
    registrationOAuth6: {
        en: `and acknowledge you have read the`,
        fr: `et reconnaissez que vous avez lu le`
    },

    registrationOAuth7: {
        en: `Sign up with {{platform}}`,
        fr: `S’inscrire avec {{platform}}`
    },
    registrationOAuth8: {
        en: `Log in using {{platform}}`,
        fr: `Se connecter avec {{platform}}`
    },

    registrationOAuth9: {
        en: `Sign up for Mobile with {{platform}}`,
        fr: `S’inscrire avec {{platform}}`
    },
    registrationOAuth10: {
        en: `Continue on Mobile with {{platform}}`,
        fr: `Continuer avec {{platform}}`
    },
    registrationOAuth11: {
        en: `Create account using {{platform}}`,
        fr: `Créer un compte avec {{platform}}`
    },

    registrationBottleDrive1: {
        en: 'Estimated number of bags',
        fr: 'Nombre estimé de sacs'
    },
    registrationBottleDrive2: {
        en: 'Referring Bottle Depot',
        fr: 'Dépôt de bouteilles référant'
    },
    registrationBottleDrive3: {
        en: 'Thank you, we will be in touch shortly.',
        fr: 'Merci, nous vous contacterons sous peu.'
    },
    registrationBottleDrive4: {
        en: 'Organization / Charity',
        fr: 'Organisation / Charité'
    },

    accountLink1: {
        en: `Account linked!`,
        fr: `Compte lié!`
    },
    accountLink2: {
        en: `You have successfully linked your account with {{accountType}}! To continue with your new account, please login with the account you have linked it to!`,
        fr: `Vous avez réussi à lier votre compte à {{accountType}} ! Pour continuer avec votre nouveau compte, veuillez vous connecter avec le compte auquel vous l’avez lié!`
    },
    accountLink3: {
        en: `go to login`,
        fr: `aller à la connexion`
    }
};

const loginTranslations = {
    login1a: {
        en: `Don't have an account?`,
        fr: `Besoin d'un compte?`
    },
    login1b: {
        en: `Sign up here`,
        fr: `Inscrivez-vous ici`
    },
    login1c: {
        en: `to book a pickup, {{{dropAndGo}}} start a bottle drive or register your ${terms.organization.en.toLowerCase()}`,
        fr: `pour réserver une collecte, utiliser les conteneurs extérieurs POD, démarrer une collecte de contenants consignés ou enregistrer votre organisme.`
    },
    login2: {
        en: 'Logging In',
        fr: 'Connexion'
    },
    login3a: {
        en: 'Looking for more information?',
        fr: 'Vous cherchez plus d’informations ?'
    },
    login3b: {
        en: 'Help Center',
        fr: "Centre d'aide"
    },
    emailPasswordReset1: {
        en: `Reset password`,
        fr: `Réinitialiser le mot de passe`
    },
    emailPasswordReset2: {
        en: `Please enter the e-mail address connected with your account. If the e-mail matches, you will be sent a reset link. Please check your junk mail folder if you do not see the email.`,
        fr: `Veuillez saisir l’adresse courriel associée à votre compte. Si l'adresse correspond, vous recevrez un lien de réinitialisation. Veuillez vérifier votre dossier de courrier indésirable si vous ne voyez pas le courriel.`
    },
    emailPasswordReset3: {
        en: `Having trouble resetting your password? Contact us at`,
        fr: `Vous rencontrez des difficultés pour réinitialiser votre mot de passe ? Contactez-nous au`
    },
    failedLogin1: {
        en: `Multiple Failed Attempts`,
        fr: `Tentatives infructueuses multiples`
    },
    failedLogin2: {
        en: `Your account has been locked until {{lockAccountUntil}}. If you have concerns about your account or believe you have received this message in error, please contact us at`,
        fr: `Votre compte a été verrouillé jusqu’à {{lockAccountUntil}}. Si vous avez des préoccupations au sujet de votre compte ou si vous pensez avoir reçu ce message par erreur, veuillez nous contacter à l’adresse`
    },
    failedLogin3: {
        en: `Your account has been locked. If you have concerns about your account or believe you have received this message in error, please contact us at`,
        fr: `Votre compte a été verrouillé. Si vous avez des préoccupations concernant votre compte ou croyez avoir reçu ce message par erreur, veuillez nous contacter à`
    },
    identityVerificationUnavailable: {
        en: `If you have concerns about your account or are unable to log in, please contact us at`,
        fr: `Si vous avez des inquiétudes concernant votre compte ou si vous ne parvenez pas à vous connecter, veuillez nous contacter à`
    },

    loginMessage1: {
        en: `Could not apply promo, {{reason}}`,
        fr: `Impossible d’appliquer promo, {{reason}}`
    },
    loginMessage2: {
        en: `Promo applied!`,
        fr: `Promotion appliquée!`
    },
    loginMessage3: {
        en: `Error applying promo.`,
        fr: `Erreur lors de l’application de la promotion.`
    },
    fbDiscontinued1: {
        en: `Support for Facebook sign in has been discontinued, please use the following link to create a password for your account.`,
        fr: `La prise en charge de la connexion Facebook a été interrompue, veuillez utiliser le lien suivant pour créer un mot de passe pour votre compte.`
    },
    invalidCredential: { en: 'Invalid credential', fr: 'Identifiants non valides' },
    IPNotAuthorized: { en: 'IP not authorized', fr: 'Adresse IP non autorisée' },
    invalidCollector: {
        en: 'Invalid collector, please re-link device',
        fr: "Collecteur invalide, veuillez relier l'appareil"
    },
    serverUnreachable: {
        en: 'Server is unreachable',
        fr: 'Serveur inaccessible'
    }
};

const words = {
    issued: {
        en: 'issued',
        fr: 'émis'
    },
    request: {
        en: 'request',
        fr: 'demander'
    },
    order: {
        en: 'order',
        fr: 'commande'
    },
    Order: {
        en: 'Order',
        fr: 'Commande'
    },
    suspended: {
        en: 'Suspended',
        fr: 'Suspendue'
    },
    underReview: {
        en: 'Under Review',
        fr: 'En cours de révision'
    },
    refunded: {
        en: 'refunded',
        fr: 'remboursé'
    },
    remove: {
        en: 'remove',
        fr: 'retirer'
    },
    information: {
        en: 'information',
        fr: 'information'
    },
    hours: {
        en: 'Hours',
        fr: 'Heures'
    },
    days: {
        en: 'days',
        fr: 'jours'
    },
    weeks: {
        en: 'weeks',
        fr: 'semaines'
    },
    closed: {
        en: 'Closed',
        fr: 'Fermé'
    },
    or: {
        en: 'or',
        fr: 'ou'
    },
    for: {
        en: 'for',
        fr: 'pour'
    },
    receipt: {
        en: 'Receipt',
        fr: 'Reçu'
    },
    redemptionReceipt: {
        en: 'Redemption Receipt',
        fr: 'Reçu d’échange'
    },
    adjustment: {
        en: 'Adjustment',
        fr: 'Ajustement'
    },
    pickup: {
        en: 'Pickup',
        fr: 'Collecte'
    },
    cheque: {
        en: 'Cheque',
        fr: 'Chèque'
    },
    to: {
        en: 'to',
        fr: 'à'
    },
    value: {
        en: 'Value',
        fr: 'Valeur'
    },
    sent: {
        en: 'sent',
        fr: 'expédié'
    },
    submit: {
        en: 'Submit',
        fr: 'Soumettre'
    },
    submit2: {
        en: 'Submit',
        fr: 'Terminé'
    },
    status: {
        en: 'Status',
        fr: 'Statut'
    },
    none: {
        en: 'None',
        fr: 'Aucun'
    },
    morning: {
        en: 'Morning',
        fr: 'Matin'
    },
    anytime: {
        en: 'Anytime',
        fr: 'En tout temps'
    },
    afternoon: {
        en: 'Afternoon',
        fr: 'Après midi'
    },
    add: {
        en: 'Add',
        fr: 'Ajouter'
    },
    use: {
        en: 'Use',
        fr: 'Utilisez'
    },
    search: {
        en: 'Search',
        fr: 'Rechercher'
    },
    verifying: {
        en: `Verifying`,
        fr: `en vérification`
    },
    location: {
        en: 'Location',
        fr: 'Emplacement'
    },
    locations: {
        en: 'Locations',
        fr: 'Emplacements'
    },
    change: {
        en: 'Change',
        fr: 'Modifier'
    },
    confirm: {
        en: 'Confirm',
        fr: 'Confirmer'
    },
    no: {
        en: 'No',
        fr: 'Non'
    },
    yes: {
        en: 'Yes',
        fr: 'Oui'
    },
    reason: {
        en: 'Reason',
        fr: 'Raison'
    },
    save: {
        en: 'Save',
        fr: 'Enregistrer'
    },
    close: {
        en: 'Close',
        fr: 'Fermer'
    },
    revert: {
        en: 'Revert',
        fr: 'Revenir'
    },
    dismiss: {
        en: 'Dismiss',
        fr: 'Rejeter'
    },
    send: {
        en: 'Send',
        fr: 'Envoyer'
    },
    authenticating: {
        en: 'Authenticating',
        fr: 'Authentification'
    },
    registration: {
        en: 'Registration',
        fr: 'Inscription'
    },
    okay: {
        en: 'Okay',
        fr: 'D’accord'
    },
    ok: {
        en: 'Ok',
        fr: 'D’accord'
    },
    cancel: {
        en: 'Cancel',
        fr: 'Annuler'
    },
    download: {
        en: 'Download',
        fr: 'Télécharger'
    },
    reset: {
        en: 'Reset',
        fr: 'Réinitialiser'
    },
    continue: {
        en: 'Continue',
        fr: 'Continuer'
    },
    with: {
        en: 'with',
        fr: 'avec'
    },
    website: {
        en: 'website',
        fr: 'site web'
    },
    create: {
        en: 'Create',
        fr: 'Créer'
    },
    name: {
        en: 'name',
        fr: 'nom'
    },
    Name: {
        en: 'Name',
        fr: 'Nom'
    },
    next: {
        en: 'Next',
        fr: 'Suivant'
    },
    back: {
        en: 'Back',
        fr: 'Retour'
    },
    rates: {
        en: 'Rates',
        fr: 'Taux'
    },
    verify: {
        en: 'Verify',
        fr: 'Vérifier'
    },
    financial: {
        en: 'Financial',
        fr: 'Financier'
    },
    email: {
        en: `Email`,
        fr: `Courriel`
    },
    emails: {
        en: 'Emails',
        fr: 'Courriels'
    },
    address: {
        en: 'Address',
        fr: 'Adresse'
    },
    companyAddress: {
        en: 'Address',
        fr: 'Adresse'
    },
    latitude: {
        en: `Latitude`,
        fr: `Latitude`
    },
    longitude: {
        en: `Longitude`,
        fr: `Longitude`
    },
    password: {
        en: `Password`,
        fr: `Mot de passe`
    },
    refresh: {
        en: 'refresh',
        fr: 'rafraîchir'
    },

    approved: {
        en: 'Approved',
        fr: 'Approuvé'
    },
    donate: {
        en: 'Donate',
        fr: 'Faire un don'
    },
    time: {
        en: 'Time',
        fr: 'Temps'
    },
    details: {
        en: 'Details',
        fr: 'Détails'
    },
    approve: {
        en: 'Approve',
        fr: 'Approuver'
    },
    reject: {
        en: 'Reject',
        fr: 'Rejeter'
    },
    other: {
        en: 'Other',
        fr: 'Autre'
    },
    type: {
        en: 'Type',
        fr: 'Taper'
    },
    types: {
        en: 'Types',
        fr: 'les types'
    },
    high: {
        en: 'High',
        fr: 'Haute'
    },
    beverage: {
        en: 'beverage',
        fr: 'boisson'
    },
    electronics: {
        en: 'electronics',
        fr: 'électronique'
    },
    elec: {
        en: 'elec',
        fr: 'élec'
    },
    clothing: {
        en: 'clothing',
        fr: 'vêtements'
    },
    cloth: {
        en: 'cloth',
        cr: 'vêt'
    },
    depot: {
        en: 'depot',
        fr: 'dépôt'
    },
    driver: {
        en: 'Driver',
        fr: 'Chauffeur'
    },
    items: {
        en: 'Items',
        fr: 'articles'
    },
    clerk: {
        en: 'Clerk',
        fr: 'Commis'
    },
    clerks: {
        en: 'Clerks',
        fr: 'Commis'
    },
    containers: {
        en: 'Containers',
        fr: 'Contenants'
    },
    all: {
        en: 'All',
        fr: 'Tous'
    },
    both: {
        en: 'Both',
        fr: 'Les Deux'
    },
    fees: {
        en: 'Fees',
        fr: 'frais'
    },
    discount: {
        en: 'discount',
        fr: 'rabais'
    },
    ea: {
        en: 'ea',
        fr: 'chaque'
    },
    bag: {
        en: 'bag',
        fr: 'sac'
    },
    sac: {
        en: 'bag',
        fr: 'sac'
    },
    call: {
        en: 'Call',
        fr: 'Appeler'
    },
    unavailable: {
        en: 'Unavailable',
        fr: 'Indisponible'
    },
    deposits: {
        en: 'Deposits',
        fr: 'Dépôts'
    },
    complaints: {
        en: 'Complaints',
        fr: 'Plaintes'
    },
    of: {
        en: 'of',
        fr: 'de'
    },
    at: {
        en: 'at',
        fr: 'à'
    },
    printed: {
        en: 'Printed',
        fr: 'Imprimé'
    },
    on: {
        en: 'On',
        fr: 'Le'
    },
    book: {
        en: 'book',
        fr: 'réserver'
    },
    frequency: {
        en: 'Frequency',
        fr: 'Fréquence'
    },
    skip: {
        en: 'skip',
        fr: 'ignorer'
    },
    unskip: {
        en: 'unskip',
        fr: 'annuler le saut'
    },
    trip: {
        en: 'trip',
        fr: 'trajet'
    },
    trips: {
        en: 'Trips',
        fr: 'Trajets'
    },
    routes: {
        en: 'routes',
        fr: 'routes'
    },
    bags: {
        en: 'bags',
        fr: 'sacs'
    },
    completed: {
        en: 'completed',
        fr: 'complété'
    },
    import: {
        en: 'import',
        fr: 'importer'
    },
    priority: {
        en: 'priority',
        fr: 'priorité'
    },
    comment: {
        en: 'Comment',
        fr: 'Commentaire'
    },
    abort: {
        en: 'Abort',
        fr: 'Annulé' //Avorter - to get an abortion - dont use
    },
    skipped: {
        en: 'Skipped',
        fr: 'Sauté'
    },
    aborted: {
        en: 'Aborted',
        fr: 'Annulé'
    },
    accuracy: {
        en: 'Accuracy',
        fr: 'Précision'
    },
    complete: {
        en: 'Complete',
        fr: 'Complété'
    },
    incomplete: {
        en: 'Incomplete',
        fr: 'Incomplet'
    },
    pickups: {
        en: 'Pickups',
        fr: 'Collectes'
    },
    left: {
        en: 'left',
        fr: 'restant'
    },
    today: {
        en: 'Today',
        fr: `Aujourd'hui`
    },
    compliments: {
        en: 'Compliments',
        fr: 'Compliments'
    },
    day: {
        en: 'Day',
        fr: 'Jour'
    },
    distance: {
        en: 'Distance',
        fr: 'Distance'
    },
    phone: {
        en: 'Phone',
        fr: 'Téléphone'
    },
    phones: {
        en: 'Phones',
        fr: 'Téléphones'
    },
    directions: {
        en: 'Directions',
        fr: 'Directives'
    },
    bagtag: {
        en: 'Bagtag',
        fr: 'Étiquette de sac'
    },
    bagtags: {
        en: 'Bagtags',
        fr: 'Étiquettes de sacs'
    },
    early: {
        en: 'Early',
        fr: 'tôt'
    },
    late: {
        en: 'Late',
        fr: 'En retard'
    },
    guest: {
        en: 'Guest',
        fr: 'Invité'
    },
    notes: {
        en: 'Notes',
        fr: 'Notes'
    },
    processing: {
        en: 'Processing',
        fr: 'Traitement'
    },
    rescheduled: {
        en: 'Rescheduled',
        fr: 'Reporté'
    },
    duration: {
        en: 'Duration',
        fr: 'Durée'
    },
    odometer: {
        en: 'Odometer',
        fr: 'Odomètre.'
    },
    undo: { en: 'undo', fr: 'défaire' },
    pay: { en: 'Pay', fr: 'Paiement' },
    pay2: { en: 'Pay', fr: 'Payer' },
    tips: { en: 'Tips', fr: 'Pourboires' },
    units: { en: 'Units', fr: 'Unités' },
    worked: { en: 'Worked', fr: 'Travaillé' },
    approximately: { en: 'Approximately', fr: 'Approximativement' },
    professional: { en: 'Professional', fr: 'Professionnel' },
    upcoming: { en: 'Upcoming', fr: 'À venir' },
    stats: { en: 'Stats', fr: 'Statistiques' },
    accurate: {
        en: 'Accurate',
        fr: 'Précis'
    },
    sorted: {
        en: 'Sorted',
        fr: 'Trié'
    },
    reported: {
        en: 'Reported',
        fr: 'Signalé'
    },
    set: {
        en: 'Set',
        fr: 'Définir'
    },
    remaining: {
        en: 'Remaining',
        fr: 'Restant'
    },
    vacation: {
        en: 'Vacation',
        fr: 'Vacances'
    },
    avg: {
        en: 'Avg',
        fr: 'Moy'
    },
    total: {
        en: 'Total',
        fr: 'Total'
    },
    finances: {
        en: 'Finances',
        fr: 'Finances'
    },
    employees: {
        en: 'Employees',
        fr: 'Employés'
    },
    calendar: {
        en: 'Calendar',
        fr: 'Calendrier'
    },
    Forecasting: {
        en: 'Forecasting',
        fr: 'Prévisions'
    },
    Legend: {
        en: 'Legend',
        fr: 'Prévisions'
    },
    totaling: {
        en: 'Totaling',
        fr: 'Totalisant'
    },
    commodity: {
        en: 'Commodity',
        fr: 'Marchandise'
    },
    inventoryAndTransfers: {
        en: 'Inventory & Transfers',
        fr: 'Inventaire et Transferts'
    },
    pendingTransfers: {
        en: 'Pending Transfers',
        fr: 'Transferts en attente'
    },
    completedTransfers: {
        en: 'Completed Transfers',
        fr: 'Transferts terminés'
    },
    inventory: {
        en: 'Inventory',
        fr: 'Inventaire'
    },
    commodities: {
        en: 'Commodities',
        fr: 'Marchandises'
    },
    ban: {
        en: 'Ban',
        fr: 'Bannir'
    },
    unban: {
        en: 'Unban',
        fr: 'Débannir'
    },
    logout: {
        en: 'Logout',
        fr: 'Se Déconnecter'
    },
    edit: {
        en: 'Edit',
        fr: 'Modifier'
    },
    tag: {
        en: 'Tag',
        fr: 'Étiquette'
    },
    nonRef: {
        en: 'Non-ref',
        fr: 'Non-rem'
    },
    bins: {
        en: 'Bins',
        fr: 'Bacs'
    },
    warning: {
        en: 'Warning',
        fr: 'Avertissement'
    },
    recalculated: {
        en: 'recalculated',
        fr: 'recalculé'
    },
    reconnect: {
        en: 'Reconnect',
        fr: 'Reconnecter'
    },
    timezone: {
        en: 'Timezone',
        fr: 'Fuseau Horaire'
    },
    breakdown: {
        en: 'Breakdown',
        fr: 'Répartition'
    },
    unassigned: {
        en: 'Unassigned',
        fr: 'Non assigné'
    },
    unrouted: {
        en: 'Unrouted',
        fr: 'Non routé'
    },
    assign: {
        en: 'Assign',
        fr: 'Assigner'
    },
    reassign: {
        en: 'Reassign',
        fr: 'Réassigner'
    },
    reschedule: {
        en: 'Reschedule',
        fr: 'Replanifier'
    },
    modifiers: {
        en: 'Modifiers',
        fr: 'Modificateurs'
    },
    master: {
        en: 'Master',
        fr: 'Maître'
    },
    zones: {
        en: 'Zones',
        fr: 'Zones'
    },
    show: {
        en: 'Show',
        fr: 'Afficher'
    },
    hide: {
        en: 'Hide',
        fr: 'Masquer'
    },
    lunch: {
        en: 'lunch',
        fr: 'dîner '
    },
    breaks: {
        en: 'Breaks',
        fr: 'Pauses'
    },
    payment: {
        en: 'Payment',
        fr: 'Paiement'
    },
    delete: {
        en: 'Delete',
        fr: 'Supprimer'
    },
    confirmed: {
        en: 'Confirmed',
        fr: 'Confirmé'
    },
    unchanged: {
        en: 'Unchanged',
        fr: 'Inchangé'
    },
    unconfirmed: {
        en: 'Unconfirmed',
        fr: 'Non confirmé'
    },
    always: {
        en: 'Always',
        fr: 'Toujours'
    },
    recurring: {
        en: 'Recurring',
        fr: 'Récurrent'
    },
    cost: {
        en: 'Cost',
        fr: 'Coût'
    },
    csf: {
        en: 'CSF',
        fr: 'FSC'
    },
    efficiency: {
        en: 'Efficiency',
        fr: 'Efficacité'
    },
    commission: {
        en: 'Commission',
        fr: 'Commission'
    },
    difference: {
        en: 'Difference',
        fr: 'Différence'
    },
    group: {
        en: 'Group',
        fr: 'Groupe'
    },
    locations: {
        en: 'Locations',
        fr: 'Lieux'
    },
    zone: {
        en: 'Zone',
        fr: 'Zone'
    },
    month: {
        en: 'Month',
        fr: 'Mois'
    },
    week: {
        en: 'Week',
        fr: 'Semaine'
    },
    year: {
        en: 'Year',
        fr: 'Année'
    },
    start: {
        en: 'Start',
        fr: 'Début'
    },
    destination: {
        en: 'Destination',
        fr: 'Destination'
    },
    volume: {
        en: 'Volume',
        fr: 'Volume'
    },
    loads: {
        en: 'Loads',
        fr: 'Charges'
    },
    options: { en: 'Options', fr: 'Options' },
    manual: {
        en: 'Manual',
        fr: 'Manuel'
    },
    automatic: {
        en: 'Automatic',
        fr: 'Automatique'
    },
    commercial: {
        en: 'Commercial',
        fr: 'Commercial'
    },
    disabled: {
        en: 'Disabled',
        fr: 'Désactivé'
    },
    fullscreen: {
        en: 'Fullscreen',
        fr: 'Plein écran'
    },
    windowedMode: {
        en: 'Windowed Mode',
        fr: 'Mode Fenêtré'
    },
    lock: {
        en: 'Lock',
        fr: 'Verrouiller'
    },
    wage: {
        en: 'Wage',
        fr: 'Salaire'
    },
    orderType: { en: 'Order Type', fr: 'Type de commande' },
    filters: {
        en: 'Filters',
        fr: 'Filtres'
    },
    true: {
        en: 'true',
        fr: 'vrai'
    },
    false: {
        en: 'false',
        fr: 'faux'
    },
    eta: {
        en: 'ETA',
        fr: 'HEA'
    },
    preference: {
        en: 'Preference',
        fr: 'Préférence'
    },
    every: {
        en: 'Every',
        fr: 'Chaque'
    },
    serviced: {
        en: 'Serviced',
        fr: 'Effectué '
    },
    dates: {
        en: 'Dates',
        fr: 'Dates'
    },
    complaint: {
        en: 'Complaint',
        fr: 'Plainte'
    },
    issue: {
        en: 'Issue',
        fr: 'Problème'
    },
    issues: {
        en: 'Issues',
        fr: 'Problèmes'
    },
    duplicate: {
        en: 'Duplicate',
        fr: 'Duplicata'
    },
    apiError: {
        en: 'API Error',
        fr: 'Erreur API'
    },
    approval: {
        en: 'Approval',
        fr: 'Approbation'
    },
    rogue: {
        en: 'Rogue',
        fr: 'Voyou'
    },
    modifier: {
        en: 'Modifier',
        fr: 'Modifier'
    },
    overdue: {
        en: 'Overdue',
        fr: 'En retard'
    },
    lostCredit: { en: 'Lost Credit', fr: 'Crédit perdu' },
    booked: {
        en: 'Booked',
        fr: 'Réservé'
    },
    owner: {
        en: 'Owner',
        fr: 'Propriétaire'
    },
    mine: {
        en: 'Mine',
        fr: 'Mien'
    },
    orders: {
        en: 'Orders',
        fr: 'Commandes'
    },
    empty: {
        en: 'Empty',
        fr: 'Vide'
    },
    counter: {
        en: 'Counter',
        fr: 'Compteur'
    },
    counters: {
        en: 'Counters',
        fr: 'Compteurs'
    },
    large: {
        en: 'Large',
        fr: 'Grande'
    },
    normal: {
        en: 'Normal',
        fr: 'Normale'
    },
    small: {
        en: 'Small',
        fr: 'Petite'
    },
    mode: {
        en: 'mode',
        fr: 'mode'
    },
    old: {
        en: 'Old',
        fr: 'ancien'
    },
    requested: {
        en: 'Requested',
        fr: 'Demandé'
    },
    field: {
        en: 'Field',
        fr: 'Champ'
    },
    accepted: {
        en: 'Accepted',
        fr: 'Accepté'
    },
    rejected: {
        en: 'Rejected',
        fr: 'Rejeté'
    },
    resolution: {
        en: 'Resolution',
        fr: 'Résolution'
    },
    awaitingDecision: {
        en: 'Awaiting decision',
        fr: 'En attente de décision'
    },
    country: {
        en: 'Country',
        fr: 'Pays'
    },
    province: {
        en: 'Province',
        fr: 'Province'
    },
    city: { en: 'City', fr: 'Ville' },
    notice: {
        en: 'Notice',
        fr: 'Avis'
    },
    times: { en: 'Times', fr: 'Fois' },
    clear: { en: 'Clear', fr: 'Vider' },
    summary: { en: 'Summary', fr: 'Résumé' },
    totalQuantity: { en: 'Total Quantity', fr: 'Quantité totale' },
    totalAmount: {
        en: 'Total amount',
        fr: 'Montant total'
    },
    attach: {
        en: 'Attach',
        fr: 'Attache'
    },
    print: { en: 'Print', fr: 'Imprimer' },
    find: { en: 'Find', fr: 'Trouver' },
    reopen: { en: 'Reopen', fr: 'rouvrir' },
    enter: { en: 'Enter', fr: 'Entrer' },
    reporting: { en: 'Reporting', fr: 'Rapports' },
    link: { en: 'Link', fr: 'Lien' },
    onHold: { en: 'On Hold', fr: 'En Attente' },
    finish: { en: 'Finish', fr: 'Finir' },
    PIN: { en: 'PIN', fr: 'NIP' },
    donation: { en: 'Donation', fr: 'Donation' },
    returns: { en: 'Returns', fr: 'Retours' },
    label: { en: 'Label', fr: 'Étiquette' }
};

const generalTranslations = {
    actionDisabled: {
        en: 'Action disabled',
        fr: 'Action désactivée'
    },
    collectionsDialog1: {
        en:
            'You cannot perform this action as your account is not approved. Please contact a system administrator for more details.',
        fr:
            "Vous ne pouvez pas effectuer cette action car votre compte n'est pas approuvé. Veuillez contacter un administrateur système pour plus de détails."
    },
    resendVerification: {
        en: `Resend verification link`,
        fr: `Renvoyer le lien de vérification`
    },
    enableEmailVerificationHelp: {
        en: `When enabled, you'll need to verify both your current and new email addresses when changing your email. This provides an extra layer of security for your account.`,
        fr: `Lorsqu'elle est activée, vous devrez vérifier à la fois votre adresse email actuelle et votre nouvelle adresse lors du changement de votre email. Cela fournit une couche de sécurité supplémentaire pour votre compte.`
    },
    resendAuthorization: {
        en: `Resend authorization link`,
        fr: `Renvoyer le lien d'autorisation`
    },
    confirmPickup: {
        en: `Confirm Pickup`,
        fr: `Confirmer la collecte`
    },
    goBack: {
        en: `Go back`,
        fr: `Retourner`
    },
    noThanks: {
        en: 'No thanks',
        fr: 'Non merci'
    },
    areYouSure: {
        en: 'Are you sure?',
        fr: 'Êtes-vous sûr'
    },
    confirmDeletion: {
        en: 'Are you sure you want to delete this?',
        fr: 'Êtes-vous sûr de vouloir supprimer ceci ?'
    },
    networkError: {
        en: `Something's not quite right`,
        fr: 'Quelque chose ne va pas tout à fait'
    },
    signUp: {
        en: 'Sign Up',
        fr: `S'inscrire`
    },
    createNewAccount: {
        en: 'Create new account',
        fr: 'Créer un compte'
    },
    createAccount: {
        en: 'Create Account',
        fr: `Créer un compte`
    },
    accountSignUp: {
        en: 'Account Sign Up',
        fr: `S'inscrire`
    },
    homeAndBusinessSignUp: {
        en: 'Home & Business Sign Up',
        fr: `S'inscrire`
    },
    signIn: {
        en: 'Sign In',
        fr: `Se connecter`
    },
    logIn: {
        en: 'Log In',
        fr: `Se connecter`
    },
    twoFactorAuthentication: {
        en: 'Two-Factor Authentication',
        fr: `Authentification à deux facteurs`
    },
    contactUs: {
        en: 'Contact Us',
        fr: `Nous contacter`
    },
    accountType: {
        en: 'Account Type',
        fr: 'Type de compte'
    },
    addPromoCode: {
        en: 'Add promo code',
        fr: 'Ajouter un code promotionnel'
    },
    forgotPassword: {
        en: 'Forgot Password?',
        fr: 'Mot de passe oublié?'
    },
    rememberMe: {
        en: 'Remember Me',
        fr: 'Se souvenir de moi'
    },
    repeatPassword: {
        en: 'Repeat Password',
        fr: 'Répéter le mot de passe'
    },
    enterPassword: {
        en: 'You must enter a password',
        fr: 'Il faut entrer un mot de passe'
    },
    enterName: {
        en: 'You must enter a name',
        fr: 'Il faut saisir un nom'
    },
    enterAddress: {
        en: 'You must enter an address',
        fr: 'Vous devez entrer une adresse'
    },
    enterDuration: {
        en: 'You must enter a duration',
        fr: 'Vous devez entrer une durée'
    },
    selectIcon: {
        en: 'You must select an icon',
        fr: 'Il faut choisir une icône'
    },
    selectColor: {
        en: 'You must select an color',
        fr: 'Il faut choisir une couleur'
    },
    selectGroup: {
        en: 'You must select a group',
        fr: 'Vous devez sélectionner un groupe'
    },
    selectAccountType: {
        en: 'You must select an account type',
        fr: 'Vous devez sélectionner un type de compte'
    },
    atLeastOnePermission: {
        en: 'At least one permission is required',
        fr: 'Au moins une permission est requise'
    },
    emailRequired: {
        en: 'Email is required',
        fr: 'Le courriel est requis'
    },
    phoneRequired: {
        en: 'Phone number is required',
        fr: 'Le numéro de téléphone est requis'
    },
    tooShort: {
        en: 'This must be at least 6 characters long',
        fr: 'Ceci doit comporter au moins 6 caractères'
    },
    alreadyHaveAccount: {
        en: `Already have an account?`,
        fr: 'Vous avez déjà un compte?'
    },
    ifDifferent: {
        en: 'if different',
        fr: 'si différent'
    },
    companyAddress: {
        en: 'Company Address',
        fr: 'Adresse de la société'
    },
    viewInOtherLanguage: {
        en: `View this app in another language`,
        fr: 'Afficher dans une autre langue'
    },
    language: {
        en: `Language`,
        fr: 'Langue'
    },
    termAgreement1: {
        en: `By clicking "Create Account" or "Log in", you agree to ${app}`,
        fr: `En cliquant sur "Créer une compte" ou "Connectez-vous", vous adhérez aux`
    },
    termsAndConditions: {
        en: `Terms and Conditions`,
        fr: `Termes et Conditions`
    },
    termAgreement2: {
        en: `and acknowledge you have read the`,
        fr: `de ${app} et reconnaissez avoir lu`
    },
    privacyNotice: {
        en: `Privacy Notice`,
        fr: `L'avis de confidentialité`
    },
    howItWorks: {
        en: `How It Works`,
        fr: `Comment ça marche`
    },
    howItWorksUnavailable: {
        en: `No information currently configured, please try again later.`,
        fr: `Aucune information actuellement configurée, veuillez réessayer plus tard.`
    },
    frequentQuestions: {
        en: 'Frequent questions',
        fr: 'Questions fréquentes'
    },
    phoneNumber: {
        en: `Phone Number`,
        fr: `Numéro de Téléphone`
    },
    businessPhoneNumber: {
        en: `Business Phone Number`,
        fr: `Numéro de téléphone professionnel`
    },
    firstName: {
        en: `First Name`,
        fr: `Prénom`
    },
    lastName: {
        en: `Last Name`,
        fr: `Nom de famille`
    },
    contactFirstName: {
        en: `Contact First Name`,
        fr: `Prénom du contact`
    },
    contactLastName: {
        en: `Contact Last Name`,
        fr: `Nom de famille du contact`
    },
    companybottledrive: {
        en: `company bottle drive`,
        fr: ``
    },
    textMessage: {
        en: `Text Message`,
        fr: `Message texte`
    },
    voiceCall: {
        en: `Voice Call`,
        fr: `Appel vocal`
    },
    bottleDrive: {
        en: `Bottle Drive`,
        fr: ``
    },
    referAppa: {
        en: `Use the website or download the ${app} app from the`,
        fr: `Utilisez le site Web ou téléchargez l'application ${app} à partir de `
    },
    referAppb: {
        en: 'or',
        fr: 'ou de'
    },
    confirmationDialog1: {
        en: 'Please type {{word}} to confirm',
        fr: 'Veuillez saisir {{word}} pour confirmer'
    },
    confirmationDialog2: {
        en: 'WARNING',
        fr: 'AVERTISSEMENT'
    },
    approvalPending: {
        en: 'Approval pending',
        fr: "En attente d'approbation"
    },
    pending: {
        en: 'Pending',
        fr: 'En attente'
    },
    notApproved: {
        en: 'Not approved',
        fr: 'Non approuvé'
    },
    qrDownload: {
        en: 'QRCode',
        fr: 'QRCode'
    },
    comingSoon: {
        en: 'Coming Soon...',
        fr: 'À venir...'
    },
    collector: {
        en: 'Collector',
        fr: 'Collecteur'
    },
    collectors: {
        en: 'Collectors',
        fr: 'Collecteurs'
    },
    resend: {
        en: 'Resend',
        fr: 'Renvoyer'
    },
    update: {
        en: 'Update',
        fr: 'Mise à jour'
    },
    cancelLogin: {
        en: 'Cancel Login',
        fr: 'Annuler Connexion'
    },
    pleaseSpecify: {
        en: `Please Specify`,
        fr: 'veuillez préciser'
    },
    grossAmount: {
        en: 'Gross Amount',
        fr: 'Montant brut'
    },
    serviceFee: {
        en: 'Service Fee',
        fr: 'frais de service'
    },
    serviceFeeTax: {
        en: '{{taxName}} on Service Fee',
        fr: '{{taxName}} sur les frais de service'
    },
    serviceFeeGST: {
        en: 'Taxes on Service Fee',
        fr: 'Taxes sur les frais de service'
    },
    totalRefund: {
        en: 'Total Refund',
        fr: 'Remboursement total'
    },
    totalOwing: {
        en: 'Total Charged',
        fr: 'Total facturé'
    },
    totalPickups: {
        en: 'Total Pickups',
        fr: 'Total des collectes'
    },
    subTotal: {
        en: 'Sub Total',
        fr: 'Sous-total'
    },
    balancePaid: {
        en: 'Balance Paid',
        fr: 'Solde payé'
    },
    loggedOut: {
        en: 'Logged Out',
        fr: 'Déconnecté'
    },
    inactiveLogOut: {
        en: 'You were logged out for inactivity',
        fr: 'Vous avez été déconnecté pour inactivité'
    },
    youHaveBeenLoggedOut: {
        en: 'You have been logged out',
        fr: 'Vous avez été déconnecté'
    },
    securityQuestion: {
        en: 'Security Question',
        fr: 'Question de sécurité'
    },
    currentSecurityQuestion: {
        en: 'Current Security Question',
        fr: 'Question de sécurité actuelle'
    },
    scanQRCode: {
        en: 'Scan QR Code',
        fr: 'Scanner le code QR'
    },
    scanBagtag: {
        en: 'Scan Bagtag',
        fr: "Scanner l'étiquette du sac"
    },
    scanRVM: {
        en: 'Scan RVM',
        fr: 'Scannez le code QR sur le rvm'
    },
    bagtagOrLabel: {
        en: 'Bagtag/Label',
        fr: 'Étiquette de sac'
    },
    bagtagNotFound: {
        en: 'The bagtag is not available for processing',
        fr: "L'étiquette du sac n'est pas disponible pour le traitement"
    },
    QRTitle: {
        en: 'Authentication',
        fr: 'Authentification'
    },
    showQRCodeSubTitle: {
        en:
            'Here’s your member number. Download, save, or screenshot the barcode to identify yourself and track your refunds.',
        fr:
            'Voici votre numéro de membre. Téléchargez, enregistrez ou capturez le code-barres pour vous identifier et suivre vos remboursements.'
    },
    scanQRCodeSubTitle: {
        en: 'Scan the code displayed on the Consignaction device to authenticate.',
        fr: 'Scannez le code affiché sur l’appareil Consignaction pour vous authentifier.'
    },
    scan: {
        en: 'Scan',
        fr: 'Balayer'
    },
    show: {
        en: 'Show',
        fr: 'Afficher'
    },
    scanToAuthenticate: {
        en: 'Scan to Authenticate',
        fr: "Balayer pour s'authentifier"
    },
    showToAuthenticate: {
        en: 'Show to Authenticate',
        fr: "Afficher pour s'authentifier"
    },
    scanQRCodeBagtagSubTitle: {
        en: 'Scan the bagtag using your phone',
        fr: "Scannez l'étiquette de sac à l'aide de votre téléphone"
    },
    scanQRCodeRVMSubTitle: {
        en: 'Use your device to scan the RVM QR code',
        fr: 'Utilisez votre appareil pour scanner le code QR RVM'
    },
    scanQRCodeButton: {
        en: 'Press here to scan a QR code',
        fr: 'Appuyez ici pour scanner un code QR'
    },
    scanQRSuccessTitle: {
        en: "You're all set!",
        fr: 'Vous êtes prêt !'
    },
    scanQRSuccess: {
        en:
            'The QR code has been successfully validated. Complete your transaction by placing your containers in the machine. Thank you for using our QR scanning feature. If you need any further assistance or have any questions, please feel free to reach out.',
        fr:
            "Le code QR a été validé avec succès. Complétez votre transaction en plaçant vos contenants dans la machine. Merci d'utiliser notre fonction de numérisation de code QR. Si vous avez besoin d'aide supplémentaire ou si vous avez des questions, n'hésitez pas à nous contacter."
    },
    scanQRCameraError: {
        en: 'Unable to connect to camera. Please ensure camera permissions are enabled.',
        fr: `"Impossible de se connecter à la caméra. Veuillez vous assurer que les autorisations de caméra sont activées."`
    },
    scanQRFail: {
        en:
            "The QR code you've scanned is invalid. Please ensure it's well-lit and fully visible for a clear scan. If the problem continues, try refreshing or restarting the app. Contact support for further help. Thank you for your understanding.",
        fr:
            "Le code QR scanné est invalide. Assurez-vous qu'il est bien éclairé et totalement visible pour un scan claire. Si le problème persiste, essayez de rafraîchir ou de redémarrer l'application. Contactez le support pour plus d'aide. Merci de votre compréhension."
    },
    bagtagVerified: {
        en: 'Bagtag verified',
        fr: 'Étiquette de bagage vérifiée'
    },
    invalidContainerInputTitle: {
        en: 'Enter Valid Containers Rejected By Machine',
        fr: 'Saisir les contenants valides rejetés par la machine'
    },
    invalidContainerInstructions: {
        en: 'Process your bag and enter the number of valid 10¢ and 25¢ containers rejected by the machine below.',
        fr:
            'Traitez votre sac et saisissez ci-dessous le nombre de contenants valides de 10¢ et 25¢ rejetés par la machine.'
    },
    invalidContainersSubmit: {
        en: 'Invalid containers submitted',
        fr: 'Conteneurs non valides soumis'
    },
    invalidContainers1: {
        en: '10¢ Containers (rejected)',
        fr: 'Contenants de 10¢ (rejetés)'
    },
    invalidContainers2: {
        en: '25¢ Containers (rejected)',
        fr: 'Contenants de 25¢ (rejetés)'
    },
    noPickupBooked: {
        en: 'No Pickup Booked',
        fr: 'Aucune collecte réservée'
    },
    netTax: {
        en: 'Net Tax',
        fr: 'taxe nette'
    },
    taxBreakdown: {
        en: 'Tax Breakdown',
        fr: 'Répartition des impôts'
    },
    totalDeposits: {
        en: 'Total Deposits',
        fr: 'Total des dépôts'
    },
    depositBreakdown: {
        en: 'Deposit Breakdown',
        fr: 'Ventilation des dépôts'
    },
    accountAdjustment: {
        en: 'Account Adjustment',
        fr: 'Ajustement de compte'
    },
    openingBalanceOn: {
        en: 'Opening Balance on {{date}}',
        fr: `Solde d'ouverture le {{date}}`
    },
    pastTransactions: {
        en: 'Past Transactions',
        fr: `Transactions Passées`
    },
    transactionsBefore: {
        en: 'Transactions Before {{date}}',
        fr: `Solde d'ouverture le {{date}}`
    },
    pastRedemptions: {
        en: 'Past Redemptions',
        fr: `Rachats Passés`
    },
    pastDonations: {
        en: 'Past Donations',
        fr: `Dons passés`
    },
    legacyDonations: {
        en: 'Legacy Donations',
        fr: `Dons de Lagacy`
    },
    rvm: {
        en: 'Reverse Vending Machine',
        fr: 'Machine récupératrice à l’unité'
    },
    bagDrop: {
        en: 'Bag Drop',
        fr: 'Retour express'
    },
    openNow: {
        en: 'Open Now',
        fr: 'Ouvrez maintenant'
    },
    noLocationFound: {
        en: 'No Location Found',
        fr: 'Aucune localisation trouvée'
    },
    processedOn: {
        en: 'Processed on',
        fr: 'Traité sur'
    },
    printedOn: {
        en: 'Printed On',
        fr: `Imprimé sur`
    },
    showAll: {
        en: 'Show all',
        fr: 'Afficher tout'
    },
    showLess: {
        en: 'Show less',
        fr: 'Afficher moins'
    },
    showMore: {
        en: 'Show More',
        fr: 'Montre plus'
    },
    technologyFilter: {
        en: 'Filters',
        fr: 'Filtres'
    },
    noTechnology: {
        en: 'No Technology',
        fr: 'Aucune technologie'
    },
    resolvedComplaints: {
        en: 'Resolved Complaints',
        fr: `Plaintes résolues`
    },
    unresolvedComplaints: {
        en: 'Unresolved Complaints',
        fr: 'Plaintes non résolues'
    },
    paymentReceived: {
        en: 'Payment received',
        fr: `Paiement reçu`
    },
    dateAtTime: {
        en: `{{date}}, at {{time}},`,
        fr: `{{date}}, à {{time}},`
    },
    weCollected: {
        en: 'we collected',
        fr: `nous avons collecté`
    },
    youDroppedOff: {
        en: `you dropped off`,
        fr: `vous avez déposé`
    },
    youDroppedOffRogue: {
        en: `You dropped off`,
        fr: `Vous avez déposé`
    },
    ReceiptNumber: {
        en: `Receipt Number`,
        fr: `Numéro de reçu`
    },
    Quantity: {
        en: `Quantity`,
        fr: `Quantité`
    },
    Unitprice: {
        en: `Unit price`,
        fr: `Prix unitaire`
    },
    Amount: {
        en: `Amount`,
        fr: `Montant`
    },
    Count: {
        en: `Count`,
        fr: `Compter`
    },
    RefundTo: {
        en: `Refund To`,
        fr: `Remboursement à`
    },
    BillTo: {
        en: `Bill To`,
        fr: `Facturer à`
    },
    Invoice: {
        en: 'Invoice',
        fr: 'Facture'
    },
    startDate: {
        en: 'Start Date',
        fr: 'Date de début'
    },
    endDate: {
        en: 'End Date',
        fr: 'Date de fin'
    },
    addNew: {
        en: 'Add New',
        fr: 'Ajouter nouveau'
    },
    admin: {
        en: 'Admin',
        fr: 'Administrateur'
    },
    employee: {
        en: 'Employee',
        fr: 'Employé'
    },
    technology: {
        en: 'Technology',
        fr: 'Technologie'
    },
    columnFilters: {
        en: 'Column Filters',
        fr: 'Filtres de colonne'
    },
    collectorFilters: {
        en: 'Collector Filters',
        fr: 'Filtres de collecteurs'
    },
    technologyFilters: {
        en: 'Technology Filters',
        fr: 'Filtres de technologie'
    },
    collectorType: {
        en: 'Collector Type',
        fr: 'Type de percepteur'
    },
    systemHistory: {
        en: 'System History',
        fr: 'Historique du système'
    },
    banAccount: {
        en: 'Ban Account',
        fr: 'Bannir le compte'
    },
    unbanAccount: {
        en: 'Unban Account',
        fr: 'Débannir le compte'
    },
    unlockAccount: {
        en: 'Unlock Account',
        fr: 'Déverrouiller le compte'
    },
    viewAccount: {
        en: 'View Account',
        fr: 'Voir le compte'
    },
    OOS: {
        en: 'Out of System',
        fr: 'Hors du système'
    },
    noTranslationExists: {
        en: 'No Translation exists',
        fr: "Aucune traduction n'existe"
    },
    currentDate: {
        en: 'Current date',
        fr: 'Date actuelle'
    },
    newDate: {
        en: 'New date',
        fr: 'Nouvelle date'
    },
    nextDate: {
        en: 'Next date',
        fr: 'Prochaine date'
    },
    nextDates: {
        en: 'Next dates',
        fr: 'Prochaines dates'
    },
    cannotBeNegative: {
        en: 'Cannot be negative',
        fr: 'Ne peut pas être négatif'
    },
    generalError: {
        en: 'Error, please try again',
        fr: 'Erreur, veuillez réessayer'
    },
    generalError2: {
        en: 'An error occurred',
        fr: "Une erreur s'est produite"
    },
    orderNotFound: {
        en: 'The order could not be found',
        fr: 'La commande n’a pas pu être trouvée'
    },
    orderAlreadyClosed: {
        en: 'The order has already been closed',
        fr: 'La commande a déjà été clôturée'
    },
    orderAlreadyRedeemed: {
        en: 'The order has already been redeemed',
        fr: 'La consigne a déjà été encaissée'
    },
    unsavedChanges: {
        en: 'You have unsaved changes',
        fr: 'Changes non enregistrées'
    },
    wholeNumber: {
        en: 'This must be a whole number',
        fr: 'Ce doit être un nombre entier'
    },
    numberValue: {
        en: 'Must be a number value',
        fr: 'Doit être une valeur numérique'
    },
    exactly4Digit: {
        en: 'Must be exactly 4 digit number',
        fr: 'Doit être un nombre exactement à 4 chiffres'
    },
    exactly4to6Digit: {
        en: 'Must be 4 to 6 digit number',
        fr: 'Doit être un nombre exactement à 4 chiffres'
    },
    mustBePositive: {
        en: 'This must be positive',
        fr: 'Ce doit être positif'
    },
    enterValue: {
        en: 'You must enter a value',
        fr: 'Vous devez entrer une valeur'
    },
    enterLocation: {
        en: 'You must enter a location',
        fr: 'Vous devez entrer un lieu'
    },
    specifyStartLocation: {
        en: 'You must specify a starting location',
        fr: 'Vous devez spécifier un point de départ'
    },
    selectDestination: {
        en: 'You must select a destination',
        fr: 'Vous devez sélectionner une destination'
    },
    stops: {
        en: 'stops',
        fr: 'arrêts'
    },
    updateRequired: {
        en: 'Update Required',
        fr: 'Mise à jour requise'
    },
    refreshDialogBody: {
        en:
            'We have introduced important changes that require you to update to the latest version of the app. Please refresh the page to continue.',
        fr: `Nous avons apporté des modifications importantes qui nécessitent la mise à jour vers la dernière version de l'application. Veuillez actualiser la page pour continuer.`
    },
    currentVersion: {
        en: 'Your current version {{{VERSION}}}',
        fr: 'Votre version actuelle {{{VERSION}}}'
    },
    lostAndFound: {
        en: 'Lost and Found',
        fr: 'Objets perdus et trouvés'
    },
    typeToSearch: {
        en: 'Type to search...',
        fr: 'Tapez pour rechercher...'
    },
    alwaysOpenSearch: {
        en: 'Always open search',
        fr: 'Toujours ouvrir la recherche'
    },
    whenReturningToOrder: {
        en: 'When returning to the order dashboard, open search input automatically.',
        fr: 'Lors du retour au tableau de bord des commandes, ouvrir automatiquement la saisie de recherche.'
    },
    POR: {
        en: 'POR',
        fr: 'POR'
    },
    dontRedirectAfterAction: {
        en: "Don't redirect after action",
        fr: "Ne pas rediriger après l'action"
    },
    pageWillNoLongerRedirect: {
        en: 'Page will no longer redirect when closing or deleting orders.',
        fr: 'La page ne redirigera plus lors de la fermeture ou de la suppression de commandes.'
    },
    afterCloseDeleteOrder: {
        en: 'After closing, or deleting an order, remain on current user instead of redirecting to order dashboard.',
        fr:
            "Après la fermeture ou la suppression d'une commande, rester sur l'utilisateur actuel au lieu de rediriger vers le tableau de bord des commandes."
    },
    hidePresetKeys: {
        en: 'Hide Preset Keys',
        fr: 'Masquer les touches prédéfinies'
    },
    hideOnScreenKeyboard: {
        en: 'Hide on screen keyboard',
        fr: "Masquer le clavier à l'écran"
    },
    hideKeyboard: {
        en: 'Hide Keypad',
        fr: 'Masquer le pavé numérique'
    },
    keySize: {
        en: 'Key Size',
        fr: 'Taille des touches'
    },
    entryMode: {
        en: 'Entry Mode',
        fr: 'Mode de saisie'
    },
    postalCode: {
        en: 'Postal Code',
        fr: 'Code Postal'
    },
    useThisLocation: {
        en: 'Use This Location',
        fr: 'Utiliser cette adresse'
    },
    doesThisLookCorrect: {
        en: 'Does this look correct? Edit any details as needed:',
        fr: 'Est-ce que cela semble correct? Modifiez les détails au besoin :'
    },
    openMap: {
        en: 'Open Map',
        fr: 'Ouvrir la carte'
    },
    findYourLocation: {
        en: 'Find Your Location on the Map',
        fr: 'Trouvez votre emplacement sur la carte'
    },
    clickBelowToOpenMap: {
        en: 'Click the button below to open the map, then find your home address and place a pin.',
        fr:
            'Cliquez sur le bouton ci-dessous pour ouvrir la carte, puis trouvez votre adresse de domicile et placez une épingle.'
    },
    iCannotFindMyAddress: {
        en: 'I cannot find my address',
        fr: 'Je ne trouve pas mon adresse'
    },
    locationChangesRequireConf: {
        en:
            'Quick note: Location changes made through this tool will require confirmation by a staff member to ensure accuracy.',
        fr:
            "Note rapide : Les changements d'adresse effectués par cet outil nécessiteront une confirmation par un membre du personnel pour assurer la précision."
    },
    goToViewUserToResolve: {
        en:
            "To resolve this request, navigate to 'View User' and review the address details. You  can then choose to accept or reject the address change.",
        fr:
            "Pour résoudre cette demande, accédez à 'Voir le client' et examinez les détails de l'adresse. Vous pouvez ensuite choisir d'accepter ou de rejeter le changement d'adresse."
    },
    orApproveRejectBelow: {
        en: 'Alternatively, you can approve or reject the address change directly below.',
        fr: "Vous pouvez également approuver ou rejeter le changement d'adresse ci-dessous."
    },
    driverGPSResolution: {
        en: `Review and approve or reject the driver's GPS location adjustment for this pickup.`,
        fr: `Examinez et approuvez ou rejetez l'ajustement de localisation GPS du chauffeur pour cette collecte.`
    },
    viewInGoogleMaps: {
        en: 'View in Google maps',
        fr: 'Voir dans Google Maps'
    },
    invalidPostalCodeFormat: {
        en: 'Invalid postal code format: {{format}}',
        fr: 'Format de code postal invalide : {{format}}'
    },
    actualEndTime: {
        en: 'Actual End Time',
        fr: 'Heure de fin réelle'
    },
    scheduledStartTime: {
        en: 'Scheduled Start Time',
        fr: 'Heure de début prévue'
    },
    actualStartTime: {
        en: 'Actual Start Time',
        fr: 'Heure de début réelle'
    },
    truckUsed: {
        en: 'Truck Used',
        fr: 'Camion utilisé'
    },
    truckOdometer: {
        en: 'Truck Odometer',
        fr: 'Odomètre du camion'
    },
    lateReason2: {
        en: 'Late Reason',
        fr: 'Raison du retard'
    },
    streetAddress: {
        en: 'Street Address',
        fr: 'Adresse civique'
    },
    poBoxPostalCode: {
        en: 'PO Box Postal Code',
        fr: 'Code postal (case postale)'
    },
    poBoxCity: {
        en: 'PO Box City',
        fr: 'Ville (case postale)'
    },
    poBoxProvince: {
        en: 'PO Box Province',
        fr: 'Province (case postale)'
    },
    poBoxNumber: {
        en: 'PO Box #',
        fr: 'Numéro de case postale'
    },
    iWantToUseMyPoBox: {
        en: 'I want to use my PO Box',
        fr: 'Je veux utiliser ma case postale'
    },
    pickupThatAreRescheduled: {
        en:
            'There are {{pickupsTotal}} pickups that will be scheduled on this day after their existing collection is completed.',
        fr:
            'Il y a {{pickupsTotal}} collectes qui seront planifiées pour cette journée après que leur collecte existante soit terminée.'
    },
    toBeScheduled: {
        en: 'To be Scheduled',
        fr: 'À planifier'
    },
    legendNotConfirmed: {
        en: 'Number of pickups not confirmed',
        fr: 'Nombre de collectes non confirmées'
    },
    legendToBeScheduled: {
        en: 'Number of pickups to be scheduled',
        fr: 'Nombre de collectes à planifier'
    },
    signOutConfirmation: {
        en: 'Are you sure you want to sign out?',
        fr: 'Êtes-vous sûr de vouloir fermer la session?'
    },
    lockConfirmation: {
        en: 'Are you sure you want to lock this device?',
        fr: 'Êtes-vous certain de vouloir verrouiller cet appareil ?'
    },
    putOnHold: {
        en: 'Put on Hold',
        fr: 'Mettre en attente'
    },
    viewOptions: { en: 'View Options', fr: "Options d'affichage" },
    proximityRequirement: {
        en:
            'Enforce proximity requirement: drivers can only complete, abort, or skip pickups when within the configured maximum distance',
        fr:
            "Exiger la proximité : les conducteurs peuvent seulement compléter, abandonner ou sauter les collectes lorsqu'ils sont à l'intérieur de la distance maximale configurée"
    },
    overRideProximityRequirement: {
        en:
            'Override Settings proximity requirement distance: drivers can only complete, abort, or skip pickups when within the configured maximum distance',
        fr:
            "Outrepasser la distance d'exigence de proximité des paramètres : les conducteurs peuvent seulement compléter, abandonner ou sauter les collectes lorsqu'ils sont à l'intérieur de la distance maximale configurée"
    },
    en: {
        en: 'English',
        fr: 'Anglais'
    },
    fr: {
        en: 'French',
        fr: 'Français'
    },
    rescheduledOverCancel: {
        en: 'Rescheduled instead of canceling',
        fr: "Reporté au lieu d'annuler"
    },
    skippedAt: {
        en: 'Skipped at',
        fr: 'Sauté à'
    },
    completedBy: {
        en: 'Completed By',
        fr: 'Complété par'
    },
    groupBy: {
        en: 'Group By',
        fr: 'Grouper par'
    },
    dateCompleted: {
        en: 'Date Completed',
        fr: "Date d'achèvement"
    },
    dateRange: {
        en: 'Date Range',
        fr: 'Plage de dates'
    },
    getAppTitle: {
        en: 'Get the app!',
        fr: "Téléchargez l'application!"
    },
    getAppContent: {
        en: 'Get a better experience by downloading\u00A0our\u00A0app.',
        fr: "Profitez d'une meilleure expérience en téléchargeant notre application."
    },
    getAppDownloadPlayStore: {
        en: 'Download on Google Play',
        fr: 'Disponible sur Google Play'
    },
    getAppDownloadAppStore: {
        en: 'Download on App Store',
        fr: "Télécharger dans l'App Store"
    },
    noThanksText: {
        en: 'No thanks, continue in browser',
        fr: 'Non merci, continuer dans le navigateur'
    }
};

const errors = {
    errorDialog1: {
        en: `For security reasons, your session has ended due to inactivity. Please sign in again.`,
        fr: `Pour des raisons de sécurité, votre session a pris fin en raison d’une inactivité. Veuillez vous reconnecter.`
    },
    errorDialog2: {
        en: `You do not have permissions to perform this action.`,
        fr: `Vous n'êtes pas autorisé à effectuer cette action.`
    },
    errorDialog3: {
        en: `The file you tried to upload is too large. Please check the size restrictions of the uploader.`,
        fr: `Le fichier que vous avez essayé de télécharger est trop volumineux. Veuillez vérifier les restrictions de taille du téléchargeur.`
    },
    errorDialog4: {
        en: `We couldn't complete your request. This could be due to a temporary connection issue, an outdated app version, or a browser cache problem. Let's get you back on track with these quick fixes:`,
        fr: `Nous n'avons pas pu traiter votre demande. Cela pourrait être dû à un problème de connexion temporaire, à une version obsolète de l'application ou à un problème de cache du navigateur. Remettez-vous sur la bonne voie avec ces solutions rapides :`
    },
    errorDialog5: {
        en: `The file you tried to upload is too large {{size}}. Please check the size restrictions of the uploader.`,
        fr: `Le fichier que vous avez essayé de télécharger est trop volumineux. Veuillez vérifier les restrictions de taille du téléchargeur.`
    },
    errorDialog6: {
        en: `Please check the size restrictions of the uploader.`,
        fr: `Veuillez vérifier les restrictions de taille du téléchargeur.`
    },
    errorDialog7: {
        en: `Update required`,
        fr: `Mise à jour requise`
    },
    errorDialog8: {
        en: `Your application is out of date. Please update before retrying.`,
        fr: `Votre application n'est plus à jour. Veuillez mettre à jour avant de réessayer.`
    },
    errorDialog9: {
        en: `An error occurred due to version mismatch. Please re-open your browser before retrying.`,
        fr: `Une erreur s'est produite en raison d'une incompatibilité de version. Veuillez rouvrir votre navigateur avant de réessayer.`
    },
    errorDialog10: {
        en: `Server maintenance`,
        fr: `Maintenance du serveur`
    },
    errorDialog11: {
        en: `We are performing quick server maintenance. Please check back in a few minutes!`,
        fr: `Nous effectuons une maintenance rapide du serveur. Veuillez réessayer dans quelques minutes!`
    },
    errorDialog12: {
        en: `Sorry for the inconvenience.`,
        fr: `Désolé pour le dérangement.`
    },
    errorDialog13: {
        en: `Account Banned`,
        fr: `Compte banni`
    },
    errorDialog14: {
        en: `Your account has been banned, please contact us at`,
        fr: `Votre compte a été banni, veuillez nous contacter à {link} pour plus d'informations.`
    },
    errorDialog15: {
        en: `for more information.`,
        fr: ``
    },
    errorDialog16: {
        en: `Too many requests made. Please try again in a moment.`,
        fr: `Trop de demandes. Veuillez réessayer dans un instant.`
    },
    errorDialog17: {
        en: 'Check your internet connection',
        fr: 'Vérifiez votre connexion internet'
    },
    errorDialog18Web: {
        en: 'Refresh the page',
        fr: 'Actualisez la page'
    },
    errorDialog18App: {
        en: 'Restart your app',
        fr: 'Redémarrez votre application'
    },
    errorDialog19Web: {
        en: 'Clear your browser cache',
        fr: 'Videz le cache de votre navigateur'
    },
    errorDialog19App: {
        en: 'Re-install the app',
        fr: `Réinstallez l'application`
    },
    errorDialog20: {
        en: 'Sign out and sign back in',
        fr: 'Déconnectez-vous et reconnectez-vous'
    },
    errorDialog21: {
        en: 'If problems persist, contact our support team',
        fr: 'Si le problème persiste, contactez notre équipe de support'
    },
    errorDialog22: {
        en: 'Your app is out of date, please update to the latest version',
        fr: `Votre application n'est pas à jour, veuillez la mettre à jour vers la dernière version`
    },
    errorDialog23: {
        en: `Operation time limit exceeded`,
        fr: `Délai d'attente de l'opération dépassé`
    },
    errorDialog24: {
        en: `We couldn't complete your request due to the operation taking too long. This could be due to a temporary server load issue. Let's get you back on track with these quick fixes:`,
        fr: `Nous n'avons pas pu traiter votre demande car l'opération a pris trop de temps. Cela pourrait être dû à une charge temporaire du serveur. Remettez-vous sur la bonne voie avec ces solutions rapides :`
    },
    errorDialog25: {
        en: `If possible try adding/changing any filters`,
        fr: `Si possible, essayez d'ajouter/modifier des filtres`
    },
    missingPagePermissions: {
        en: 'You do not have permissions to view this page.',
        fr: "Vous n'avez pas les autorisations nécessaires pour afficher cette page."
    }
};

const snackbar = {
    verificationLinkSent: {
        en: `Sent verification link successfully, check your email.`,
        fr: `Lien de vérification envoyé avec succès, vérifiez votre courrier électronique.`
    },
    verificationLinkFailed: {
        en: `Error sending verification link.`,
        fr: `Erreur lors de l'envoi du lien de vérification.`
    },
    authorizationEmailFailed: {
        en: `Error sending authentication link.`,
        fr: ``
    },
    oneStepPickupFail: {
        en: `Could not confirm your pickup. Please try again or log in to confirm your pickup from your account.`,
        fr: `Impossible de confirmer votre collecte. Veuillez réessayer ou vous connecter pour confirmer votre collecte à partir de votre compte.`
    },
    errorSubmittingTip: {
        en: `Error submitting tip.`,
        fr: `Erreur lors de l'envoi du conseil.`
    },
    thanksForFeedback: {
        en: `Thank you for the feedback. We will get back to you as soon as we can.`,
        fr: `Merci pour votre retour. Nous vous répondrons dès que possible.`
    },
    thanksForFeedbackEXP: {
        en: 'Thank you for your feedback. For help with a specific issue, please reach out to Customer Service.',
        fr:
            'Merci pour vos commentaires. Pour toute aide concernant un problème spécifique, veuillez contacter le Service Client.'
    },
    copiedReferraLink: {
        en: `Referral link copied to your clipboard.`,
        fr: `Lien de parrainage copié dans votre presse-papiers.`
    },
    copiedToClipboard: {
        en: `Copied {{str}} to your clipboard!`,
        fr: `Copié {{str}} dans votre presse-papier !`
    },
    copyFailed: {
        en: `Unable to copy value to clipboard`,
        fr: `Impossible de copier la valeur dans le presse-papiers`
    },
    refererNotQualified: {
        en: 'Referer not qualified for referrals',
        fr: 'Référent non qualifié pour les références'
    },
    unableToApplyPromo: {
        en: 'Unable to apply promo',
        fr: 'Impossible d’appliquer la promotion'
    },
    orgLinkInvalid: {
        en: `${terms.organization.en} link is invalid.`,
        fr: `Le lien ${terms.organization.en} n’est pas valide.`
    },
    orgLinkExpired: {
        en: `This campaign is no longer accepting donations. We appreciate your interest and support. Please adjust your donation preference accordingly. Thank you!`,
        fr: `Cette campagne n'accepte plus de dons. Nous apprécions votre intérêt et votre soutien. Veuillez ajuster vos préférences de don en conséquence. Merci!`
    },
    campaignClosed: {
        en: `Campaign Closed`,
        fr: `Campagne clôturée`
    },
    fileTooLarge: {
        en: `Image file size too large. Max file size of 1MB`,
        fr: `Taille du fichier image trop grande. Taille maximale du fichier de 1 Mo`
    },
    fileTooLarge2: {
        en: `Image size too large. Images larger than 65536 (256x256) pixels will not render on static maps.`,
        fr: `Taille de l'image trop importante. Les images de plus de 65 536 pixels (256 × 256) ne s'afficheront pas sur les cartes statiques.`
    },
    uploadLogoFirst: {
        en: `Please upload your logo first.`,
        fr: `Veuillez d’abord télécharger votre logo.`
    },
    invalidImageFormat: {
        en: `Invalid image format.`,
        fr: `Format d'image invalide.`
    },
    badRequest: {
        en: `Bad request.`,
        fr: `Mauvais demande`
    },
    somethingWentWrong: {
        en: `Something went wrong. Please try again in a moment.`,
        fr: `Quelque chose a mal tourné. Veuillez réessayer dans un instant.`
    },
    authCodeSent: {
        en: `Authentication Code Sent`,
        fr: `Code d’authentification envoyé`
    },
    emailVerificationCodeSent: {
        en: `Email Verification Code Sent`,
        fr: `Code de vérification envoyé`
    },
    verifyCurrentEmail: {
        en: `Verify Current Email`,
        fr: `Vérifier l'email actuel`
    },
    verifyNewEmail: {
        en: `Verify New Email`,
        fr: `Vérifier le nouvel email`
    },
    currentEmailVerificationDesc: {
        en: `A verification code has been sent to your current email`,
        fr: `Un code de vérification a été envoyé à votre email actuel`
    },
    newEmailVerificationDesc: {
        en: `A verification code has been sent to your new email`,
        fr: `Un code de vérification a été envoyé à votre nouvel email`
    },
    afterCurrentEmailVerified: {
        en: `After verification, you'll be asked to verify: {{newEmail}}`,
        fr: `Après vérification, il vous sera demandé de vérifier : {{newEmail}}`
    },
    nowVerifyNewEmail: {
        en: `Current email verified! Now verifying new email...`,
        fr: `Email actuel vérifié ! Vérification du nouvel email en cours...`
    },
    emailVerificationRequired: {
        en: `Email verification required to update your email address`,
        fr: `Vérification de l'email requise pour mettre à jour votre adresse email`
    },
    pleaseEnterCompleteCode: {
        en: `Please Enter Complete Code`,
        fr: `Veuillez saisir le code complet`
    },
    otpExpiry: {
        en: `The verification code will expire in `,
        fr: `Le code de vérification expirera dans `
    },
    didntReceiveCode: {
        en: `Didn't receive Code`,
        fr: `Vous n'avez pas reçu le code`
    },
    identityVerified: {
        en: `Identity Verified`,
        fr: `Identité Vérifiée`
    },
    unauthorized: {
        en: `You do not have permissions to perform that action`,
        fr: `Vous n'avez pas les autorisations pour effectuer cette action`
    },
    tooManyAttempts: {
        en: `Too many failed attempts, try again later`,
        fr: `Trop de tentatives infructueuses, réessayez plus tard`
    },
    backupCodeResent: {
        en: `Backup code resent to your email`,
        fr: `Code de secours renvoyé à votre email`
    },
    failedSendBackupCode: {
        en: `Failed to send backup code`,
        fr: `Échec de l'envoi du code de secours`
    },
    lostDeviceEmailBackup: {
        en: `Lost access to your device? Send backup code to email`,
        fr: `Accès perdu à votre appareil? Envoyer un code de secours par email`
    },
    emailBackupActive: {
        en: `Email backup code (5 digits)`,
        fr: `Code de secours par email (5 chiffres)`
    },
    backupCodeSentEmail: {
        en: `Backup code sent to your email`,
        fr: `Code de secours envoyé à votre email`
    },
    registration2faEmailBackup: {
        en: `We've sent a backup verification code to {{email}}. Please enter the 5-digit code below.`,
        fr: `Nous avons envoyé un code de vérification de secours à {{email}}. Veuillez entrer le code à 5 chiffres ci-dessous.`
    },
    connectionErr: {
        en: `Connection error occurred`,
        fr: `Une erreur de connexion s’est produite`
    },
    invalidAuthCode: {
        en: `Invalid authentication code`,
        fr: `Code d’authentification non valide`
    },
    invalidVerificationCode: {
        en: `Invalid verification code`,
        fr: `Code de vérification invalide`
    },
    errorVerifyingCreds: {
        en: `Error verifying user credentials`,
        fr: `Erreur lors de la vérification des informations d’identification de l’utilisateur`
    },
    serverUnreachable: {
        en: `Server is unreachable`,
        fr: `Le serveur est inaccessible`
    },
    serverError: {
        en: `Server error occurred`,
        fr: `Une erreur de serveur s’est produite`
    },
    contactFormSuccess: {
        en: `Thank you for reaching out! We will get back to you within a few days.`,
        fr: `Merci d’avoir tendu la main! Nous reviendrons vers vous dans quelques jours.`
    },
    emailMatchCheck: {
        en: 'If the e-mail matches, you will receive a reset link shortly.',
        fr: 'Si le courriel correspond, vous recevrez un lien de réinitialisation sous peu.'
    },
    enterAuthCode: {
        en: 'Please enter authentication code',
        fr: 'Veuillez saisir le code d’authentification'
    },
    authInterrupted: {
        en: 'Authentication popup process was interrupted or request timed out. Please try again.',
        fr:
            'Le processus de fenêtre contextuelle d’authentification a été interrompu ou la demande a expiré. Veuillez réessayer.'
    },
    invalidCreds: {
        en: 'Invalid email or password',
        fr: 'Adresse courriel ou mot de passe non valide'
    },
    emailOAuthAlreadyRegistered: {
        en: `The email provided is already registered via {{provider}} authentication. Please use that method of authentication to log in. If you are having trouble accessing your account, please contact us at {{serviceEmailAddress}}`,
        fr:
            "L'e-mail fourni est déjà enregistré via l'authentification {{provider}}. Veuillez utiliser cette méthode d'authentification pour vous connecter. Si vous rencontrez des difficultés pour accéder à votre compte, veuillez nous contacter à {{serviceEmailAddress}}"
    },
    authCodeFailed: {
        en: 'Authentication code is incorrect or may have expired',
        fr: 'Le code d’authentification est incorrect ou a peut-être expiré'
    },
    identityVerificationFailed: {
        en: 'We could not verify your identity based on the information provided',
        fr: `Nous n'avons pas pu vérifier votre identité sur la base des informations fournies`
    },
    verificationSuccessful: {
        en: 'Verification Successful',
        fr: `Vérification réussie`
    },
    invalidOAuthProvider: {
        en: 'Invalid auth provider supplied',
        fr: "Fournisseur d'authentification non valide fourni"
    },
    OAuthOtherApp: {
        en: 'Unable to use OAuth inside of another application',
        fr: "Impossible d'utiliser OAuth dans une autre application"
    },
    errorOAuthVia: {
        en: 'Error authenticating via {{providerType}}',
        fr: "Erreur d'authentification via {{providerType}}"
    },
    googleAlreadyLinked: {
        en:
            'It appears you already have an account linked with your Google account. Please sign in with Google authentication. If you are unable to access your account, please contact us at {{serviceEmailAddress}}',
        fr:
            "Il semble que vous ayez déjà un compte lié à votre compte Google. Veuillez vous connecter avec l'authentification Google. Si vous ne parvenez pas à accéder à votre compte, veuillez nous contacter à {{serviceEmailAddress}}"
    },
    facebookAlreadyLinked: {
        en:
            'It appears you already have an account linked with your Facebook account. Please sign in with Facebook authentication. If you are unable to access your account, please contact us at {{serviceEmailAddress}}',
        fr:
            "Il semble que vous ayez déjà un compte lié à votre compte Facebook. Veuillez vous connecter avec l'authentification Facebook. Si vous ne parvenez pas à accéder à votre compte, veuillez nous contacter à {{serviceEmailAddress}}"
    },
    errorAuthViaOAuth: {
        en: 'Unable to authenticate with oAuth, please use a different method or try again.',
        fr: 'Impossible de vous authentifier avec oAuth, veuillez utiliser une autre méthode ou réessayer.'
    },
    authProcessInterrupted: {
        en: 'Authentication popup process was interrupted. Please try again.',
        fr: "Le processus contextuel d'authentification a été interrompu. Veuillez réessayer."
    },
    authPopupBlocked: {
        en: 'Popup was blocked by the browser. Unable to complete authentication process',
        fr: "La popup a été bloquée par le navigateur. Impossible de terminer le processus d'authentification"
    },
    oAuthGenericError: {
        en: 'An error occurred during the authentication process',
        fr: "Une erreur s'est produite lors du processus d'authentification"
    },
    unexpectedAccountType: {
        en: 'Unexpected account type.',
        fr: 'Type de compte inattendu.'
    },
    updatedNotificationSettings: {
        en: 'Successfully updated your notification settings.',
        fr: 'Vos paramètres de notification ont bien été mis à jour.'
    },
    trustedDevice: {
        en: 'Trusted Device',
        fr: 'Appareil de confiance'
    },
    clearTrustedDevices: {
        en: 'Successfully cleared list of trusted devices.',
        fr: 'Effacer avec succès la liste des appareils approuvés.'
    },
    trustedDeviceRemoved: {
        en: 'Successfully removed the trusted device.',
        fr: "L'appareil de confiance a été retiré avec succès."
    },
    changedPassword: {
        en: 'Successfully changed your password.',
        fr: 'Votre mot de passe a été modifié avec succès.'
    },
    changePasswordFailed: {
        en: 'Error! Check your current password and try again.',
        fr: 'Erreur! Vérifiez votre mot de passe actuel et réessayez.'
    },
    resetPassword: {
        en: 'Reset Password',
        fr: 'Réinitialiser le Mot de Passe'
    },
    resetPasswordSuccess: {
        en: 'Password reset successfully',
        fr: 'Mot de passe réinitialisé avec succès'
    },
    resetPasswordFailed: {
        en: 'Unable to reset password',
        fr: 'Impossible de réinitialiser le mot de passe'
    },
    updated2FA: {
        en: 'Successfully updated your two-factor authentication settings.',
        fr: "Vos paramètres d'authentification à deux facteurs ont été mis à jour avec succès."
    },
    update2FAFailed: {
        en: 'Error updating two-factor authentication.',
        fr: "Erreur lors de la mise à jour de l'authentification à deux facteurs."
    },
    verificationEmailSent: {
        en: 'Verification email has been sent.',
        fr: 'Un courriel de vérification a été envoyé.'
    },
    emailVerified: {
        en: 'Email verified.',
        fr: 'Courriel vérifié.'
    },
    authorizationEmailSent: {
        en: 'A link to authorize {{email}} has been sent to {{accountEmail}}.',
        fr: `Un lien pour autoriser {{email}} a été envoyé à {{accountEmail}}..`
    },
    emailAuthorizationRemoved: {
        en: 'Authorization for {{email}} has been removed.',
        fr: `L'autorisation pour {{email}} a été supprimée.`
    },
    duplicateAuthorizationEmail: {
        en: 'You have already request authorization for {{email}}',
        fr: 'Vous avez déjà demandé une autorisation pour {{email}}'
    },
    accountDeleteFailed: {
        en: 'Unable to delete account. Please Try again in a moment.',
        fr: 'Impossible de supprimer le compte. Veuillez réessayer dans un instant.'
    },
    accountDeleteSucceeded: {
        en: 'Your account has been deleted.',
        fr: 'Votre compte a été supprimé'
    },
    accountDeleteSucceededWithCashOut: {
        en: 'Your account has been deleted and your cashout request is being processed.',
        fr: "Votre compte a été supprimé et votre demande d'encaissement est en cours de traitement."
    },
    updatedProfile: {
        en: 'Successfully updated your profile.',
        fr: 'Votre profil a été mis à jour avec succès.'
    },
    submissionInProgress: {
        en: 'Submission in progress. Please try again in a moment.',
        fr: 'Soumission en cours. Veuillez réessayer dans un instant.'
    },
    accountClosed: {
        en: 'Your account is closed. Please contact us at {{servicePhone}}',
        fr: 'Votre compte est fermé. Veuillez nous contacter au {{servicePhone}}.'
    },
    accountSuspended: {
        en: 'Your account is suspended. Please contact us at {{servicePhone}}.',
        fr: 'Votre compte est suspendu. Veuillez nous contacter au {{servicePhone}}.'
    },
    accountDeleted: {
        en: 'Your account is deleted. Please contact us at {{servicePhone}}.',
        fr: 'Votre compte est supprimé. Veuillez nous contacter au {{servicePhone}}.'
    },
    updatedProfileWithEmailAuthentication: {
        en: 'Please check {{email}} to confirm these changes.',
        fr: 'Veuillez vérifier {{email}} pour confirmer ces modifications'
    },
    updatedProfileWithAddressAuthentication: {
        en: 'Your address change request has been submitted and is pending admin approval.',
        fr: `Votre demande de changement d'adresse a été soumise et est en attente d'approbation de l'administrateur.`
    },
    resetLinkSent: {
        en: 'Password reset link sent, check your email.',
        fr: 'Lien de réinitialisation de mot de passe envoyé, vérifiez vos courriels.'
    },
    resetLinkNotSent: {
        en: 'Error sending password reset link.',
        fr: 'Erreur lors de l’envoi du lien de réinitialisation du mot de passe.'
    },
    deviceSignOut: {
        en: 'Device successfully signed out',
        fr: `L'appareil s'est déconnecté avec succès`
    },
    deviceRemoved: {
        en: 'Device successfully removed',
        fr: `Appareil supprimé avec succès`
    },
    uploadPermissionError: {
        en: 'You must give the app permission to access your images',
        fr: `Vous devez autoriser l'application à accéder à vos images`
    },
    cameraPermissionError: {
        en: 'You must give the app permission to access your camera',
        fr: `Vous devez autoriser l'application à accéder à votre caméra`
    },
    photoProcessingError: {
        en: 'An error occurred while processing your photo. Please try again.',
        fr: `Une erreur s'est produite lors du traitement de votre photo. Veuillez réessayer.`
    },
    pendingApproval: {
        en: 'Pending Approval',
        fr: 'En attente de validation'
    },
    driverPermission: {
        en: 'You do not have permissions to view driver accounts',
        fr: "Vous n'avez pas les permissions pour consulter les comptes des chauffeurs"
    },
    collectorPermission: {
        en: 'You do not have permissions to view collector accounts',
        fr: "Vous n'avez pas les permissions pour consulter les comptes des collecteurs"
    },
    adminPermission: {
        en: 'You do not have permissions to view system administrator accounts',
        fr: "Vous n'avez pas les permissions pour consulter les comptes des administrateurs système"
    },
    userLoggedOut: {
        en: 'User logged out successfully',
        fr: "L'utilisateur s'est déconnecté avec succès"
    },
    requestedPickupDeleted: {
        en: 'Requested pickup successfully deleted',
        fr: 'Collecte demandée supprimée avec succès'
    },
    createdCommodityPickup: {
        en: 'Successfully created commodity pickup',
        fr: 'Collecte de marchandises créée avec succès'
    },
    completedCommodityPickup: {
        en: 'Successfully completed commodity pickups',
        fr: 'Collectes de marchandises complétées avec succès'
    },
    updatedCommodityPickup: {
        en: 'Successfully updated commodity pickups',
        fr: 'Collectes de marchandises mises à jour avec succès'
    },
    undidCommodityPickup: {
        en: 'Successfully undid commodity pickups',
        fr: 'Annulation réussie des collectes de marchandises'
    },
    cantUndoTransaction: {
        en: 'Cannot undo the last transaction, the last transaction is unknown',
        fr: "Impossible d'annuler la dernière transaction, la dernière transaction est inconnue"
    },
    fetchingTrips: {
        en: 'Fetching trips...',
        fr: 'Récupération des trajets...'
    },
    failedToFetchTrips: {
        en: 'Failed to fetch trips',
        fr: 'Échec de récupération des trajets'
    },
    tripsFetched: {
        en: 'Trips fetched',
        fr: 'Trajets récupérés'
    },
    recalcingTrip: {
        en: 'Recalculating trip',
        fr: 'Recalcul du trajet'
    },
    recalcTripFailed: {
        en: 'Failed to recalculate trip',
        fr: 'Échec de recalcul du trajet'
    },
    tripRecalced: {
        en: 'Trip {{trip}} recalculated',
        fr: 'Trajet {{trip}} recalculé'
    },
    etaNotificationSent: {
        en: 'ETA notifications sent',
        fr: "Notifications d'heure d'arrivée prévue envoyées"
    },
    etaNotificationFailed: {
        en: 'Unable to send ETA notifications',
        fr: "Impossible d'envoyer les notifications d'heure d'arrivée prévue"
    },
    assignPickupToTrip: {
        en: 'Assigning pickups to trips',
        fr: 'Attribution des collectes aux trajets'
    },
    pickupsAssigned: {
        en: 'Pickups assigned to trips',
        fr: 'Collectes attribuées aux trajets'
    },
    pickupsAssignedFail: {
        en: 'Unable to assign pickups to trips',
        fr: "Impossible d'attribuer des collectes aux trajets"
    },
    googleAPIError: {
        en: 'Google API Error',
        fr: "Erreur de l'API Google"
    },
    movingPickup: {
        en: 'Moving pickup to start of trip',
        fr: 'Déplacement de la collecte au début du trajet'
    },
    unableSetFirstPickup: {
        en: 'Unable to set first pickup',
        fr: 'Impossible de définir la première collecte'
    },
    errorManualOrdering: {
        en: 'Error {{status}} manual ordering',
        fr: 'Erreur {{status}} de classement manuel'
    },
    unservicedPickups: {
        en: 'Unserviced Pickups',
        fr: 'Ramassages non desservis'
    },
    pickupAlreadyCompleted: {
        en: 'Pickup has already been completed',
        fr: 'Collecte déjà complétée'
    },
    pickupCollectorNull: {
        en: 'Pickup collector value is null',
        fr: 'La valeur du collecteur de ramassage est nulle.'
    },
    noRoutedPickups: {
        en: 'No routed pickups.',
        fr: 'Aucune collecte planifiée.'
    },
    manualOrdering: {
        en: 'Manual Ordering',
        fr: 'Commande manuelle'
    },
    idCopied: {
        en: 'ID copied!',
        fr: 'ID copié!'
    },
    pickupCompletedUpdating: {
        en: 'Pickup completed. Updating trip...',
        fr: 'Collecte complétée. Mise à jour du trajet...'
    },
    tripUpdateComplete: {
        en: 'Trip Update complete.',
        fr: 'Mise à jour du trajet terminée.'
    },
    pickupCompletedRecalculating: {
        en: 'Pickup completed. Recalculating trip...',
        fr: 'Collecte complétée. Recalcul du trajet...'
    },
    failedToSkipPickup: {
        en: 'Failed to skip this pickup. Please try again in a moment.',
        fr: 'Échec du saut de cette collecte. Veuillez réessayer dans un instant.'
    },
    pickupBookedForLocation: {
        en: 'Pickup booked for the location ',
        fr: "Collecte réservée pour l'emplacement "
    },
    locationRemoved: {
        en: 'Location Removed',
        fr: 'Emplacement supprimé'
    },
    errorRetrievingData: {
        en: 'An error occurred retrieving the data. Please try again.',
        fr: "Une erreur s'est produite lors de la récupération des données. Veuillez réessayer."
    }
};

const redemptionTranslations = {
    redemption1: {
        en: 'Cash Out',
        fr: 'Remboursement'
    },
    redemption1Exp: {
        en: 'Redemption Options',
        fr: 'Options de Rachat'
    },
    redemption2: {
        en: 'How would you like to cash out?',
        fr: 'Comment souhaitez-vous retirer votre argent?'
    },
    redemption2EXP: {
        en: 'How would you like to redeem your balance?',
        fr: 'Comment souhaitez-vous utiliser votre solde?'
    },
    redemption3: {
        en: 'Please select one of the available cash out options.',
        fr: "Veuillez sélectionner l'une des options de retrait disponibles."
    },
    redemption3EXP: {
        en: 'Select a redemption method.',
        fr: 'Sélectionnez une méthode de remboursement.'
    },
    redemption4: {
        en: 'Interac e-Transfer',
        fr: 'Virement Interac'
    },
    redemption5: {
        en: 'Cheque',
        fr: 'Chèque'
    },
    redemption6: {
        en: 'Bank Transfer',
        fr: 'Virement bancaire'
    },
    redemption7: {
        en: 'Cash',
        fr: 'En espèces'
    },
    redemption8: {
        en: 'E-Transfer information',
        fr: 'Informations sur le virement électronique'
    },
    redemption8a: {
        en: 'E-Transfer security',
        fr: 'Sécurité des virement électronique'
    },
    redemption9: {
        en:
            'Enter the email address to send the {{name}} to. You will have to enter your passphrase to accept the transfer.',
        fr:
            "Entrez l'adresse courriel à laquelle envoyer le {{name}}. Vous devrez entrer votre mot de passe pour accepter le transfert."
    },
    redemption10: {
        en: 'Enter a passphrase you will use to accept the e-transfer email.',
        fr: 'Entrez une phrase que vous utiliserez pour accepter le transfert électronique reçu par courriel.'
    },
    redemption11: {
        en: 'use your account password as your passphrase.',
        fr: 'le mot de passe de votre compte comme phrase de passe.'
    },
    redemption11a: {
        en: 'Do not ',
        fr: 'N’utilisez pas'
    },
    redemption12: {
        en: 'Choose a security answer below. You will need to enter this later to accept the e-Transfer.',
        fr:
            'Choisissez une réponse de sécurité ci-dessous. Vous devrez la saisir plus tard pour accepter le virement Interac.'
    },
    redemption12a: {
        en: 'Write it down!',
        fr: 'Notez-la bien!'
    },
    redemption13: {
        en: 'Security question',
        fr: 'Question de sécurité'
    },
    redemption14: {
        en: 'who is my favourite sports star?',
        fr: 'quelle est ma star sportive préférée?'
    },
    redemption15: {
        en: 'what is my favourite tv show?',
        fr: 'quelle est mon émission de télévision préférée ?'
    },
    redemption16: {
        en: 'what is my favourite food?',
        fr: 'quelle est mon plat préféré?'
    },
    redemption17: {
        en: 'who is my favourite movie star?',
        fr: 'quelle est ma star de cinéma préférée?'
    },
    redemption18: {
        en: 'what is my favourite movie?',
        fr: 'quel est mon film préféré?'
    },
    redemption19: {
        en: 'Answer',
        fr: 'réponse'
    },
    redemption20: {
        en: 'Answer should be a combination of 6-15 letters or numbers.',
        fr: 'La réponse doit être une combinaison de 6 à 15 lettres ou chiffres.'
    },
    redemption21: {
        en: 'Answer should only contain letters and numbers with no spaces.',
        fr: 'La réponse ne doit contenir que des lettres et des chiffres sans espaces.'
    },
    redemption22: {
        en: 'Summary',
        fr: 'Sommaire'
    },
    redemption23a: {
        en: 'There is {{method}} fee of {{amount}}.',
        fr: "Des frais de {{method}} de {{amount}} s'appliquent."
    },
    redemption23b: {
        en: 'You should receive an {{method}} in 1 business day.',
        fr: 'Vous devriez recevoir un {{method}} dans un délai de 1 jour ouvrable.'
    },
    redemption24: {
        en: 'Write down your security answer',
        fr: 'Notez votre réponse de sécurité'
    },
    redemption25a: {
        en: 'Your security answer is ',
        fr: 'Votre réponse de sécurité est '
    },
    redemption25b: {
        en: '. Please write this down as you will need to provide this to your bank to complete the e-Transfer',
        fr: '. Veuillez noter ceci car vous devrez le fournir à votre banque pour compléter le virement électronique'
    },
    redemption26: {
        en: 'Fee',
        fr: 'Frais'
    },
    redemptionFee: {
        en: 'Redemption Fee',
        fr: 'Frais de rachat'
    },
    redemption27: {
        en: 'Net amount',
        fr: 'Montant net'
    },
    redemption28: {
        en: 'Interac e-Transfer (${{limit}} yearly limit)',
        fr: 'Virement Interac (limite annuelle de {{limit}} $)'
    },
    redemption29: {
        en: 'Interac e-Transfer (Minimum balance of ${{limit}} required.)',
        fr: 'Virement Interac (Un solde minimum de ${{limit}} est requis.)'
    },
    redemption30: {
        en: 'Cheque information',
        fr: 'Information du chèque'
    },
    redemption31: {
        en: 'The cheque will be sent to the address below.',
        fr: "Le chèque sera envoyé à l'adresse ci-dessous."
    },
    redemption31a: {
        en:
            "Note: All details pertain to the primary {{organization}} administrator. To make changes, please update the administrator's account, not the {{organization}} itself.",
        fr:
            'Remarque : Toutes les informations concernent l’administrateur principal de l’organisation. Pour apporter des modifications, veuillez mettre à jour le compte de l’administrateur et non l’organisation elle-même.'
    },
    redemption32: {
        en: 'Account Name',
        fr: 'nom du compte'
    },
    redemption33: {
        en: 'Street Address',
        fr: 'adresse'
    },
    redemption34: {
        en: 'City',
        fr: 'ville'
    },
    redemption35: {
        en: 'Postal Code',
        fr: 'code postal'
    },
    redemption36: {
        en: 'Country',
        fr: 'pays'
    },
    redemption37: {
        en: 'This field is required',
        fr: 'Ce champ est requis'
    },
    redemption38: {
        en: 'There is a cheque fee of $1.50.You should receive a cheque in 3-5 business days.',
        fr:
            "Des frais de chèque de 1,50 $ s'appliquent. Vous devriez recevoir un chèque dans un délai de 3 à 5 jours ouvrables."
    },
    redemption39: {
        en: 'Cheque (Balance needs to be over ${{minimum}} to receive a cheque)',
        fr: 'Chèque (le solde doit être supérieur à {{minimum}} $ pour être échangé avec un chèque)'
    },
    redemption40: {
        en: 'Bank transfer information',
        fr: 'Informations sur le virement bancaire'
    },
    redemption41: {
        en: 'Account Number',
        fr: 'numéro de compte'
    },
    redemption42: {
        en: 'should be 7-12 digits',
        fr: 'devrait être un numéro de 7 à 12 chiffres'
    },
    redemption43: {
        en: 'Transit Number',
        fr: 'Numéro de transit'
    },
    redemption44: {
        en: 'should be 5 digits',
        fr: 'devrait être de 5 chiffres'
    },
    redemption45: {
        en: 'institution number',
        fr: "numéro d'établissement"
    },
    redemption46: {
        en: 'should be 3 digits',
        fr: 'devrait être de 3 chiffres'
    },
    redemption47: {
        en: 'should only contain digits',
        fr: 'ne doit contenir que des chiffres'
    },
    redemption48: {
        en: 'There is a Bank Transfer fee of $1.50.You should receive a Bank Transfer in 3-5 business days.',
        fr:
            "Des frais de virement bancaire de 1,50 $ s'appliquent. Vous devriez recevoir un virement bancaire dans un délai de 3 à 5 jours ouvrés."
    },
    redemption49: {
        en: 'Cash (Minimum balance of ${{minimum}} required.)',
        fr: 'Argent comptant (Un solde minimum de ${{minimum}} est requis.)'
    },
    redemption50: {
        en: 'You are about to cash out {{balance}} to {{{charity}}} via {{method}}. Is this correct?',
        fr: "Vous êtes sur le point d'échanger {{balance}} avec {{{charity}}} via {{method}}. Est-ce correct?"
    },
    redemption50EXP: {
        en: 'You are about to redeem {{balance}} to {{{charity}}} via {{method}}. Is this correct?',
        fr: 'Vous êtes sur le point de faire un don de {{balance}} à {{{charity}}} via {{method}}. Est-ce correct?'
    },
    redemption51: {
        en: 'You have requested a cash out!',
        fr: 'Vous avez demandé un remboursement!'
    },
    redemption51EXP: {
        en: 'You have requested a redemption!',
        fr: 'Vous avez demandé un remboursement!'
    },
    redemption52: {
        en: 'No cash out methods available at this moment.',
        fr: 'Aucune méthode de retrait disponible pour le moment.'
    },
    redemption52EXP: {
        en: 'No redemption methods are available right now.',
        fr: 'Aucune méthode de remboursement n’est disponible pour le moment.'
    },
    redemption53: {
        en: 'Cannot cash out an amount less than $0',
        fr: "Impossible d'échanger un montant inférieur à 0 $"
    },
    redemption53EXP: {
        en: 'The redemption amount must be more than $0.',
        fr: 'Le montant du remboursement doit être supérieur à 0 $.'
    },
    redemption54a: {
        en: 'A minimum balance of ',
        fr: 'Un solde minimum de '
    },
    redemption54b: {
        en: ' is required to cash out.',
        fr: ' est requis pour effectuer un remboursement.'
    },
    redemption54bEXP: {
        en: ' is required to redeem.',
        fr: ' est requis pour un remboursement.'
    },
    redemption55: {
        en: 'You may donate regardless of your balance.',
        fr: 'Vous pouvez faire un don quel que soit votre solde.'
    },
    redemption56: {
        en: 'You currently do not have a balance to cash out.',
        fr: "Vous n'avez actuellement aucun solde à remboursé."
    },
    redemption56EXP: {
        en: 'Your balance isn’t high enough to redeem.',
        fr: 'Votre solde n’est pas suffisant pour un remboursement.'
    },
    redemption57: {
        en: 'Current balance:',
        fr: 'Solde actuel:'
    },
    redemption58: {
        en: 'sent',
        fr: 'expédié'
    },
    redemption59: {
        en: 'requested  to',
        fr: 'demandé à'
    },
    redemption60: {
        en: 'Your charity must be approved before cashing out.',
        fr: 'Votre organisme de bienfaisance doit être approuvé avant de procéder à un remboursement'
    },
    redemption61: {
        // eslint-disable-next-line no-template-curly-in-string
        en: 'Bank Transfer (Balance needs to be over ${{minimum}} to receive a bank transfer)',
        // eslint-disable-next-line no-template-curly-in-string
        fr: 'Virement bancaire (le solde doit être supérieur à ${{minimum}} pour être échangé par virement bancaire)'
    },
    redemption62: {
        en: 'You are about to donate {{balance}} to {{{charity}}}. Is this correct?',
        fr: 'Vous êtes sur le point de faire un don {{balance}} à {{{charity}}}. Est-ce exact?'
    },
    redemption63: {
        en: 'You have donated your returns to {{{charity}}}!',
        fr: 'Vous avez fait don de votre consigne à {{{charity}}}!'
    },
    redemption64: {
        en: 'Bank transfer information from previous bank transfer:',
        fr: 'Informations sur le virement bancaire du remboursement précédent:'
    },
    redemption65: {
        en: 'Cash out method',
        fr: 'Méthode de retrait'
    },
    redemption65EXP: {
        en: 'Redemption Method',
        fr: 'Méthode de remboursement'
    },
    redemption66: {
        en: 'Redeem Outstanding Balance',
        fr: 'Échanger le solde impayé'
    },
    redemption67: {
        en: 'Province',
        fr: 'Province'
    },
    redemption68: {
        en: 'You may redeem with a cheque if you are over your e-Transfer limit.',
        fr: 'Vous pouvez échanger avec un chèque si vous dépassez votre limite de transfert électronique.'
    },
    redemption69: {
        en: `The following {{userAmount}} users have pending redemptions linked to the infractions you resolved. If you believe there's no foul play, leave the requests selected to approve them. If you suspect any users of bad intentions, unselect those and their redemption requests will be reversed.`,
        fr: `Les {{userAmount}} utilisateurs suivants ont des rachats en attente liés aux infractions que vous avez résolues. Si vous pensez qu'il n'y a pas d'acte criminel, laissez les demandes sélectionnées pour les approuver. Si vous soupçonnez des utilisateurs de mauvaises intentions, désélectionnez-les et leurs demandes de rachat seront annulées.`
    },
    redemption70: {
        en: 'Please note: {{type}} requests take between {{min}} and {{max}} {{units}} to complete.',
        fr:
            'Veuillez noter : les demandes de {{type}} prennent entre {{min}} et {{max}} {{units}} pour être complétées.'
    },
    redemption71a: { en: 'If you', fr: 'Si vous' },
    redemption71b: { en: 'do not', fr: 'ne souhaitez pas' },
    redemption71c: {
        en:
            'want to donate, select "Redeem funds without donation" as your redemption preference below. Otherwise proceed with donation.',
        fr:
            'faire de don, sélectionnez « Encaisser les fonds sans donation » comme préférence de rachat ci-dessous. Sinon, procédez avec le don.'
    },
    redemption72: {
        en: 'Note: all redemptions are for the full account balance.',
        fr: 'Remarque : tous les remboursements portent sur la totalité du solde du compte.'
    },
    redemption73: {
        en:
            'If you wish to donate, select "Donate Funds" as your redemption preference below and then select a group or charity from the second drop-down. Otherwise, click next to proceed without donating.',
        fr:
            'Si vous souhaitez faire un don, sélectionnez « Faire un don des fonds » comme préférence de rachat ci-dessous, puis choisissez un groupe ou un organisme de bienfaisance dans le deuxième menu déroulant. Sinon, cliquez sur suivant pour continuer sans faire de don.'
    },
    redemption74: {
        en: '{{field}} is missing! Please update in ',
        fr: '{{field}} est manquant! Veuillez le mettre à jour dans '
    },
    redemption75: {
        en: 'No cash out option selected',
        fr: 'Aucune option d’encaissement sélectionnée'
    },
    redemption75EXP: {
        en: 'No redemption option selected',
        fr: 'Aucune option de remboursement sélectionnée'
    },
    redemption76: {
        en: 'Please Select an Organization',
        fr: 'Veuillez sélectionner une organisation'
    },
    redemption77: {
        en: 'Donate To',
        fr: 'Faire un don à'
    },
    directDeposit: {
        en: 'Direct Deposit',
        fr: 'Dépôt direct'
    },
    customerSubscription1: {
        en: 'Customer Subscriptions',
        fr: 'Abonnements clients'
    },
    customerSubscription2: {
        en: 'Currently no fees on this customer',
        fr: 'Actuellement aucun frais sur ce client'
    },
    customerSubscription3: {
        en:
            'Outstanding subscriptions will be charged onto your next pickup. If you have any questions or concerns about any of your subscriptions, please contact us at',
        fr:
            'Les abonnements en suspens seront facturés lors de votre prochaine collecte. Si vous avez des questions ou des préoccupations concernant vos abonnements, veuillez nous contacter à'
    },
    apiStatusSent: { en: 'Sent: Awaiting confirmation from API', fr: "Envoyé: en attente de confirmation de l'API" },
    apiStatusReceived: {
        en: 'Received: Awaiting acceptance by customer',
        fr: "Reçu : En attente d'acceptation par le client"
    },
    apiStatusRejected: { en: 'Rejected', fr: 'Rejeté' },
    apiStatusAccepted: { en: 'Accepted: Deposited in customer account', fr: 'Accepté : Déposé sur le compte client' },
    timeSpanHours: {
        en: '{{time1}} to {{time2}} hours',
        fr: '{{time1}} à {{time2}} heures'
    },
    timeSpanBusinessHours: {
        en: '{{time1}} to {{time2}} business hours',
        fr: '{{time1}} à {{time2}} heures ouvrables'
    },
    timeSpanDays: {
        en: '{{time1}} to {{time2}} days',
        fr: '{{time1}} à {{time2}} jours'
    },
    timeSpanBusinessDays: {
        en: '{{time1}} to {{time2}} business days',
        fr: '{{time1}} à {{time2}} jours ouvrables'
    },
    timeSpanWeeks: {
        en: '{{time1}} to {{time2}} weeks',
        fr: '{{time1}} à {{time2}} semaines'
    },
    maxTimeHours: {
        en: '{{time2}} hours',
        fr: '{{time2}} heures'
    },
    maxTimeDays: {
        en: '{{time2}} days',
        fr: '{{time2}} jours'
    },
    maxTimeWeeks: {
        en: '{{time2}} weeks',
        fr: '{{time2}} semaines'
    }
};

const impactReportTranslations = {
    impactReport1: {
        en: 'Environmental Impact Report',
        fr: "Rapport d'impact environnemental"
    },
    impactReport2a: {
        en: 'Keep it up {{user}}!',
        fr: 'Continuez comme ça {{user}}!'
    },
    impactReport2b: {
        en:
            ' Recycling helps keep our landfills clear, reduces greenhouse gas emissions, and lowers your carbon footprint.',
        fr:
            " Le recyclage aide à détourner la matière des sites d'enfouissement, à réduire les émissions de gaz à effet de serre et à réduire votre empreinte carbone."
    },
    impactReport3a: {
        en: 'As of ',
        fr: 'Au '
    },
    impactReport3b: {
        en: ' you have:',
        fr: ' vous avez :'
    },
    impactReport4: {
        en: 'Carbon Emissions Avoided',
        fr: 'Émissions de carbone évitées'
    },
    impactReport5: {
        en: 'Energy saved',
        fr: 'Énergie économisée'
    },
    impactReport6: {
        en: 'Spared from landfill',
        fr: "Détourné du site d'enfouissement"
    },
    impactReport7: {
        en: 'Get Others To Participate - Share Now!',
        fr: 'Invitez les autres à participer - Partagez maintenant!'
    },
    impactReport8: {
        en: 'Active Bins',
        fr: 'Bacs actifs'
    },
    share: {
        en: 'Share',
        fr: 'Partager'
    },
    impactReport9: {
        en: 'No thanks',
        fr: 'Non merci'
    },
    impactReport10: {
        en: 'Continue',
        fr: 'Continuer'
    },
    impactReport11: {
        en: 'That is equivalent to {{count}} cars off the road this month!',
        fr: ''
    },
    impactReport12: {
        en: 'Total returns',
        fr: 'montants cumulatifs'
    },
    impactReport13: {
        en: 'Total donated',
        fr: 'Nombre de dons'
    },
    impactReport14: {
        en: 'Total containers',
        fr: 'Nombre de contenants'
    },
    impactReport15: {
        en: 'Total bags',
        fr: 'Nombre de sacs'
    },
    impactReport16: {
        en: 'Total electronics',
        fr: "Nombre d'appareils électroniques"
    },
    impactReport17: {
        en: 'Water saved',
        fr: 'Eau économisée'
    },
    impactReport18: {
        en:
            'Estimated landfill diversion, CO₂ reduction, energy, and water savings are based on industry averages and meant for illustrative purposes rather than exact individual measurements. For actual environmental program performance, find more information ',
        fr:
            "Les estimations de diversion des déchets, de réduction des émissions de CO₂, d'économies d'énergie et d'eau sont basées sur des moyennes industrielles et sont destinées à des fins illustratives plutôt qu'à des mesures individuelles exactes. Pour des informations détaillées sur les performances réelles du programme environnemental, trouvez plus d'informations "
    },
    impactReport19: {
        en: 'More information about these numbers',
        fr: 'Plus d’informations sur ces chiffres'
    },
    here: {
        en: 'here',
        fr: 'ici'
    }
};

const account = {
    accountDisabled1: {
        en: 'Account Closed',
        fr: 'Compte désactivé'
    },
    accountDisabled2: {
        en: 'Your account is closed. Click the button below to reopen it.',
        fr: 'Votre compte est désactivé. Cliquez sur le bouton ci-dessous pour le réactiver.'
    },
    accountDisabled3: {
        en: 'Reopen Account',
        fr: 'Réactiver le compte'
    },
    accountDisabled4: {
        en: 'Your account has been closed.\nIf this is an error, contact {{brandname}} at {{contact}}.',
        fr: "Votre compte a été fermé.\nS'il s'agit d'une erreur, contactez {{brandname}} à {{contact}}."
    },

    disableAccount1: {
        en: `Are you sure you want to close your account?`,
        fr: `Voulez-vous vraiment désactiver votre compte?`
    },
    disableAccount2: {
        en: `You still have pending pickups for today. Closing your account will cancel all pending pickups.`,
        fr: `Vous avez encore des collectes en attente pour aujourd'hui. La fermeture de votre compte annulera toutes les collectes en attente.`
    },
    disableAccount3: {
        en: `Why are you closing your account?`,
        fr: `Pourquoi désactivez-vous votre compte ?`
    },
    disableAccount4: {
        en: `I already have an account`,
        fr: `J'ai déjà un compte`
    },
    disableAccount5: {
        en: `I don't like this service`,
        fr: `Je n'aime pas ce service`
    },
    disableAccount6: {
        en: `I'm recycling a different way`,
        fr: `Je recycle autrement`
    },
    disableAccount7: {
        en: `Other`,
        fr: `Autre`
    },
    disableAccount8: {
        en: `What can we do better?`,
        fr: `Que peut-on ameliorer?`
    },
    disableAccount9: {
        en: `What is your preferred method?`,
        fr: `Quelle est votre méthode préférée`
    },

    twoFactorAuthentication1: {
        en: `This action requires additional verification`,
        fr: `Cette action nécessite une vérification supplémentaire`
    },
    twoFactorAuthentication2: {
        en: `Please select your preferred method to receive your authentication code at {{formattedPhoneNumber}} and then enter the code below.`,
        fr: `Veuillez sélectionner votre méthode préférée pour recevoir votre code d'authentification à {{formattedPhoneNumber}}, puis entrez le code ci-dessous.`
    },
    twoFactorAuthentication3: {
        en: 'Send code via text message',
        fr: 'Envoyer le code par SMS'
    },
    twoFactorAuthentication4: {
        en: 'Send code via voice call',
        fr: 'Envoyer le code par appel vocal'
    },

    deleteAccount1: {
        en: `Are you sure you want to delete your account?`,
        fr: `Êtes-vous sûr de vouloir supprimer votre compte?`
    },
    deleteAccount2a: {
        en: `You have a remaining account balance of {{balance}}. Before deleting your account`,
        fr: `Il vous reste un solde de compte de {{balance}}. Avant de supprimer votre compte`
    },
    deleteAccount2b: {
        en: `you must redeem your remaining balance!`,
        fr: `vous devez utiliser votre solde restant!`
    },
    deleteAccount3a: {
        en: `Deleting your account is permanent and cannot be undone.`,
        fr: `La suppression de votre compte est permanente et ne peut pas être annulée.`
    },
    deleteAccount3b: {
        en:
            'All of your account information will be removed, and all labels will become invalid. If you have bags waiting to be processed, please wait until they are complete to receive your funds. To continue, type',
        fr:
            "Toutes les informations de votre compte seront supprimées et toutes les étiquettes deviendront invalides. Si vous avez des sacs en attente de traitement, veuillez attendre qu'ils soient terminés pour recevoir vos fonds. Pour continuer, tapez "
    },
    deleteAccount3c: {
        en: `in the box below and then press `,
        fr: 'dans la case ci-dessous, puis appuyez sur '
    },
    deleteAccount4a: {
        en: 'You still have pending pickups for today.',
        fr: "Vous avez encore des collectes en attente pour aujourd'hui."
    },
    deleteAccount4b: {
        en: 'Deleting your account will cancel all pending pickups.',
        fr: 'La suppression de votre compte annulera toutes les collectes en attente.'
    },
    deleteAccount5: {
        en: 'Why are you deleting your account?',
        fr: 'Pourquoi supprimez-vous votre compte?'
    },
    accountSettings1: {
        en: "I'd like to receive a tax receipt when donating",
        fr: "Je souhaite recevoir un reçu fiscal lors d'un Don"
    },
    accountSettings2: {
        en: 'Use two-factor authentication',
        fr: "Utiliser l'authentification à deux facteurs"
    },
    accountSettings2EXP: {
        en: 'Phone Number Authenticated',
        fr: 'Numéro de téléphone authentifié'
    },
    accountSettings2EXPa: {
        en: 'Phone two-factor authentication is mandatory for all Return-It Express Accounts',
        fr: "L'authentification à deux facteurs par téléphone est obligatoire pour tous les comptes Return-It Express."
    },
    accountSettings2a: {
        en:
            'Your phone number is required for two-factor authentication. Codes are sent to this number, and invalid numbers will block sign-in.',
        fr:
            "Votre numéro de téléphone est requis pour l'authentification à deux facteurs. Les codes sont envoyés à ce numéro, et les numéros invalides empêcheront la connexion."
    },
    accountSettings2b: {
        en: 'This feature is mandatory but can be disabled for valid reasons. Please contact support for assistance.',
        fr:
            "Cette fonctionnalité est obligatoire, mais elle peut être désactivée pour des raisons valables. Veuillez contacter le support pour obtenir de l'aide."
    },
    accountSettings3: {
        en: 'Current password',
        fr: 'Mot de passe actuel'
    },
    accountSettings4: {
        en: 'New password',
        fr: 'Nouveau mot de passe'
    },
    accountSettings5: {
        en: 'Repeat new password',
        fr: 'Répété le nouveau mot de passe'
    },
    accountSettings6: {
        en: 'Passwords should match',
        fr: 'Les mots de passe doivent correspondre'
    },
    accountSettings7: {
        en: 'Notification Settings',
        fr: 'Paramètres de Notification'
    },
    accountSettings8: {
        en: 'Email Notifications',
        fr: 'Notifications par courriel'
    },
    accountSettings8a: {
        en: 'Essential Email Notifications',
        fr: 'Notifications essentielles par courriel'
    },
    accountSettings8b: {
        en:
            'Essential emails are emails that still get sent when a user disables their email notifications. These include pickup, confirmation, and other warning emails.',
        fr:
            "Les courriels essentiels sont des courriels qui sont encore envoyés lorsqu'un utilisateur désactive ses notifications par courriel. Ceux-ci incluent les courriels de collecte, de confirmation et autres avertissements."
    },
    accountSettings9: {
        en: 'SMS Notifications',
        fr: 'Notifications SMS'
    },
    accountSettings10: {
        en: 'Push Notifications',
        fr: 'Notifications App'
    },
    accountSettings11: {
        en: 'Push Notifications (App not installed)',
        fr: 'Notifications App (App non installée)'
    },
    accountSettings12: {
        en: 'Donation Notifications',
        fr: 'Notifications de dons'
    },
    accountSettings13: {
        en: 'Reopen Account',
        fr: 'Réactiver le compte'
    },
    accountSettings14: {
        en: 'Close Account',
        fr: 'Désactiver le Compte'
    },
    accountSettings15: {
        en: `Reopen Account to start receiving notifications from ${app}`,
        fr: `Réactiver le compte pour commencer à recevoir des notifications de ${app}`
    },
    accountSettings16a: {
        en: `Close your account to stop receiving notifications from ${app}.`,
        fr: `Désactivez votre compte pour ne plus recevoir de notifications de ${app}.`
    },
    accountSettings16b: {
        en: `This will cancel all of your unfinished pickups.`,
        fr: `Ceci annulera toutes vos collectes non terminées.`
    },

    accountSettings17: {
        en: `Delete Account`,
        fr: `Supprimer le Compte`
    },

    accountSettings18: {
        en: `Action required`,
        fr: `Action requise`
    },
    accountSettings19: {
        en: `Please fill out missing information in your profile.`,
        fr: `Veuillez remplir les informations manquantes dans votre profil.`
    },
    accountSettings20: {
        en: 'Profile Incomplete',
        fr: 'Profil non complété'
    },
    accountSettings20a: {
        en: 'Switch from {{provider}} account to Email & Password Login.',
        fr: 'Passer du compte {{provider}} à la connexion par courriel et mot de passe.'
    },
    accountSettings21: {
        en: 'The following information needs to be updated:',
        fr: 'Les informations suivantes doivent être mises à jour:'
    },
    accountSettings22: {
        en: `Please update this information on the Account page to complete your registration.`,
        fr: `Veuillez mettre à jour ces informations sur la page Compte pour terminer votre inscription.`
    },
    accountSettings23: {
        en: `Please verify your email before proceeding. You should have received an email at {{email}}. You can change your email in the form below and get a verification letter sent to a new address.`,
        fr: `Veuillez vérifier votre adresse courriel avant de continuer. Vous devriez avoir reçu un courriel à l’adresse {{email}}. Vous pouvez modifier votre adresse courriel dans le formulaire ci-dessous et recevoir une lettre de vérification envoyée à une nouvelle adresse.`
    },
    accountSettings24: {
        en: `Send again`,
        fr: `Envoyer à nouveau`
    },
    accountSettings25: {
        en: `Clear All Trusted Devices`,
        fr: `Effacer tous les appareils de confiance`
    },
    accountSettings26: {
        en: `Viewing Access`,
        fr: `Accès à la visualisation`
    },
    accountSettings27: {
        en: `The following users have viewing access to your account.`,
        fr: `Les utilisateurs suivants ont un accès visuel à votre compte.`
    },
    accountSettings28: {
        en: 'Doing Business As',
        fr: 'Faire des affaires comme'
    },
    accountSettings28a: {
        en: 'Trading Name',
        fr: 'Faire des affaires comme'
    },
    accountSettings29: {
        en: 'Registered Business Name',
        fr: "Nom enregistré de l'entreprise"
    },
    accountSettings30: {
        en: 'Business Number',
        fr: 'Numéro d’entreprise'
    },
    accountSettings31: {
        en: 'If you need your account type changed, please contact us.',
        fr: 'Si vous avez besoin de modifier votre type de compte, veuillez nous contacter.'
    },
    accountSettings32: {
        en: 'Authorized Emails',
        fr: 'E-mails autorisés'
    },
    accountSettings33: {
        en: `Welcome to the New ${app} Platform.`,
        fr: `Bienvenue sur la Nouvelle Plateforme ${app}`
    },
    accountSettings34: {
        en:
            'Please check your old email account ({{oldEmail}}) to approve the change to your new email account ({{newEmail}}).',
        fr:
            'Veuillez vérifier votre ancien compte courriel ({{oldEmail}}) pour approuver le changement vers votre nouveau compte courriel ({{newEmail}}).'
    },
    accountSettings35a: {
        en: 'Approval will expire in {{minutes}} minute(s).',
        fr: "L'approbation expirera dans {{minutes}} minute(s)."
    },
    accountSettings35b: {
        en: 'Approval will expire in less than 1 minute.',
        fr: "L'approbation expirera dans moins d'une minute"
    },
    accountSettings35c: {
        en: 'Approval will expire in {{hours}} hour(s).',
        fr: "L'approbation expirera dans {{hours}} heure(s)."
    },
    accountSettings36: {
        en: 'Cancel Request',
        fr: "Demande d'annulation"
    },
    accountSettings36a: {
        en: 'Are you sure you want to cancel your pending email change request?',
        fr: 'Êtes-vous certain de vouloir annuler votre demande de changement de courriel en attente?'
    },
    accountSettings37: {
        en: 'Please confirm your password below',
        fr: 'Veuillez confirmer votre mot de passe ci-dessous'
    },
    accountSettings38: {
        en: 'To complete the transfer of your account to the new platform we need to confirm your password.',
        fr:
            'Pour compléter le transfert de votre compte vers la nouvelle plateforme, nous devons confirmer votre mot de passe.'
    },
    accountSettings39: {
        en: 'Password',
        fr: 'Mot de passe'
    },
    accountSettings40: {
        en: 'Confirm Password',
        fr: 'Confirmez le mot de passe'
    },
    accountSettings41: {
        en: 'Business Type (select all that apply)',
        fr: `Type d'entreprise (sélectionnez tout ce qui s'applique)`
    },
    accountSettings42: {
        en:
            'Your account uses {{{provider}}} authentication. To switch to email and password authentication, press the button below.',
        fr: `Votre compte utilise l'authentification {{{provider}}}. Pour passer à l'authentification par e-mail et mot de passe, cliquez sur le bouton ci-dessous.`
    },
    accountSettings42b: {
        en:
            'Your account uses {{{provider}}} authentication and a private relay to hide your personal email address. To switch to email and password authentication, update your email address from the account details above.',
        fr: `Votre compte utilise l'authentification {{{provider}}} et un relais privé pour masquer votre adresse e-mail personnelle. Pour passer à l'authentification par e-mail et mot de passe, mettez à jour votre adresse e-mail à partir des informations de compte ci-dessus.`
    },
    accountSettings43: {
        en:
            'Are you sure you want to use your email and password instead of {{provider}} to log in? This cannot be undone.',
        fr: `Voulez-vous vraiment utiliser votre adresse e-mail et votre mot de passe plutôt que {{provider}} pour vous connecter ? Cette action est irréversible.`
    },
    accountSettings44: {
        en: 'Use Email & Password to Login',
        fr: `Utilisez l'e-mail et le mot de passe pour vous connecter`
    },
    accountSettings45: {
        en:
            'Your account is registered through {{{provider}}}. Changing your email will switch to email/password login, preventing future {{{provider}}} sign-ins.',
        fr: `Votre compte est enregistré auprès de {{{provider}}}. En modifiant votre adresse e-mail, vous passerez à la connexion par e-mail et mot de passe, empêchant ainsi toute connexion ultérieure à {{{provider}}}.`
    },
    accountSetting46: {
        en: 'Are you sure you want to confirm this address change request?',
        fr: "Êtes-vous sûr de vouloir confirmer cette demande de changement d'adresse?"
    },
    accountSetting47: {
        en: 'Are you sure you want to cancel your pending address change request?',
        fr: "Êtes-vous sûr de vouloir annuler votre demande de changement d'adresse en attente?"
    },
    accountSettings48: {
        en: 'Your address change request has been submitted and is pending admin approval.',
        fr: "Votre demande de changement d'adresse a été soumise et est en attente d'approbation par un administrateur."
    },
    accountSettings49: {
        en: `Your custom address will need to be verified by staff before you can get started. This usually takes 1-2 business days, and you'll have full access to all services once it's approved.`,
        fr: `"Votre adresse personnalisée devra être vérifiée par notre équipe avant que vous puissiez commencer. Cela prend habituellement de 1 à 2 jours ouvrables, et vous aurez accès complet à tous les services une fois qu'elle sera approuvée.`
    },
    accountSettings49b: {
        en: `While you wait, you can still print labels and submit bags for processing.`,
        fr: `En attendant, vous pouvez toujours imprimer les étiquettes et soumettre vos sacs pour traitement.`
    },
    accountSettings50: {
        en: `Enable Email & Preserve`,
        fr: `Activer l'e-mail et préserver`
    },
    accountSettings51: {
        en: `Warning - This will enable notifications for this account on staging`,
        fr: `Avertissement - Ceci activera les notifications pour ce compte en staging`
    },
    accountSettings52: {
        en: `Simple Clerk Info (No Email / Phone)`,
        fr: `Informations simples sur le commis (pas de courriel ni de téléphone)`
    },
    accountSettings53: {
        en: 'Use email verification',
        fr: 'Utiliser la vérification par courriel'
    },
    accountSettings54a: {
        en: 'You are removing {{provider}} sign-in. Set a password to keep access to your account.',
        fr:
            "Vous supprimez la connexion avec {{provider}}. Définissez un mot de passe pour conserver l'accès à votre compte."
    },
    accountSettings54b: {
        en: 'After this, you will log in using {{email}} and your password instead of {{provider}}.',
        fr:
            "Après cela, vous vous connecterez en utilisant {{email}} et votre mot de passe plutôt qu'avec {{provider}}."
    },
    passwordReset1: {
        en: `Your password has been successfully changed! You can sign into your account with your new password.`,
        fr: `Votre mot de passe a été modifié avec succès! Vous pouvez vous connecter à votre compte avec votre nouveau mot de passe.`
    },
    passwordReset2: {
        en: `Change password`,
        fr: `Changer le mot de passe`
    },
    passwordReset3: {
        en: `New Password`,
        fr: `Nouveau Mot de Passe`
    },
    passwordReset4: {
        en: `Repeat new password`,
        fr: `Répéter le nouveau mot de passe`
    },
    passwordReset5: {
        en: `Resend password reset link`,
        fr: `Renvoyer le lien de réinitialisation du mot de passe`
    },
    passwordReset6: {
        en: `Back to login`,
        fr: `Retour à la connexion`
    },
    passwordReset7: {
        en: `Passwords should match`,
        fr: `Les mots de passe doivent correspondre`
    },
    passwordReset8: {
        en: 'Confirm New Password',
        fr: 'Confirmer le Nouveau Mot de Passe'
    },
    devices: {
        en: 'Devices',
        fr: `Dispositifs`
    }
};

const volumnReportTranslations = {
    volumeReport1: {
        en: 'Please select the date range for the report to be downloaded',
        fr: 'Veuillez sélectionner la plage de dates pour le rapport à télécharger'
    }
};

const pickupDialogTranslations = {
    appServiceType1: {
        en: 'Residential',
        fr: 'Résidentiel'
    },
    appServiceType2: {
        en: 'Residential Pickup',
        fr: 'Collecte résidentielle'
    },
    appServiceType3: {
        en: 'Condo',
        fr: 'Condo'
    },
    appServiceType4: {
        en: 'Condo Pickup',
        fr: 'Collecte pour condos'
    },
    appServiceType5: {
        en: 'Commercial',
        fr: 'Commercial'
    },
    appServiceType6: {
        en: 'Commercial Pickup',
        fr: 'Collecte commerciale'
    },
    appServiceType7: {
        en: 'Drop&Go',
        fr: 'Retour express'
    },
    appServiceType8: {
        en: 'Bottle Drive',
        fr: 'Collecte de contenants consignés'
    },
    appServiceType9: {
        en: 'refund',
        fr: 'remboursement'
    },
    pickupDialog1: {
        en: 'Select Service',
        fr: 'Sélectionnez le service'
    },
    pickupDialog2: !isMXDRegion()
        ? {
              en: 'What do you need?',
              fr: 'De quoi avez-vous besoin?'
          }
        : {
              en: 'Select the desired service',
              fr: 'Sélectionnez le service voulu'
          },
    pickupDialog3: {
        en:
            "Select this if you want a pickup from your house! A driver will arrive between 8 AM and 5 PM on the day you select. Don't worry, you will be able to see an estimated time of arrival in the app on the morning of your pickup. If you can't wait around, hide your bags outside and tell the driver where to look in the directions. Once picked up, we'll count your containers and credit your account, where you can keep or donate your refund. ",
        fr:
            "Sélectionnez cette option si vous désirez une collecte à domicile! Un chauffeur arrivera entre 8 h et 17 h le jour que vous aurez choisi. Ne vous inquiétez pas, vous pourrez voir une heure d'arrivée estimée dans l'application le matin de votre collecte. Si vous ne pouvez pas attendre, cachez vos sacs à l'extérieur et indiquez au chauffeur où chercher dans les directives. Une fois la collecte effectuée, nous compterons vos contenants et créditerons votre compte, où vous pourrez conserver ou donner votre remboursement. "
    },
    pickupDialog3b: {
        en: 'If possible, please place everything into large bags and label them with ',
        fr: 'Si possible, veuillez tout placer dans de grands sacs et les étiqueter avec '
    },
    pickupDialog4: {
        en: 'Residential Location',
        fr: 'Emplacement résidentiel'
    },
    pickupDialog5: {
        en: 'Where is the pickup?',
        fr: 'Où est la collecte?'
    },
    pickupDialog6: {
        en: 'Where is the pickup?',
        fr: 'Où est la collecte?'
    },
    pickupDialog7: {
        en: 'Unit number',
        fr: 'Numéro de local'
    },
    pickupDialog8: {
        en: 'Location',
        fr: 'Emplacement'
    },
    pickupDialog9: !isMXDRegion()
        ? {
              en:
                  'Your address will determine your available pickup days. As our customer base increases, the more availability we will be able to offer, so tell your friends about {{brand}}!',
              fr:
                  'Votre adresse déterminera vos jours de collecte disponibles. Au fur et à mesure que notre clientèle augmente, nous pourrons offrir plus de disponibilités, alors parlez de {{brand}} à vos amis!'
          }
        : {
              en: 'Your address will determine your available pickup days.',
              fr: 'Votre adresse déterminera les jours de collecte disponibles.'
          },

    pickupDialog10: isMXDRegion()
        ? {
              en: 'Specify in which premises your establishment is located',
              fr: 'Précisez dans quel local votre établissement se situe'
          }
        : isCONRegion()
        ? {
              en:
                  'We serve the commercial premises of on-site consumption establishments. Use the unit # field and comments area on the last page to specify where your business is located and where to find your bags.',
              fr:
                  'Nous desservons les locaux commerciaux des établissements de consommation sur place. Utilisez le champ unité # et la zone commentaires sur la dernière page pour spécifier où se trouve votre commerce et où trouver vos sacs.'
          }
        : {
              en:
                  'We service {{condoName}}, multifamily complexes, and apartments. Use the Unit # field and the comments box on the last page to specify where your home is located and where your bags can be found.',
              fr:
                  'Nous desservons des {{condoName}}, des complexes multifamiliaux et des appartements. Utilisez le champ Unit # et la zone de commentaires sur la dernière page pour spécifier où se trouve votre maison et où trouver vos sacs.'
          },

    date: {
        en: 'Date',
        fr: 'Date'
    },
    pickupDialog12: {
        en: 'Your community is picked up on {{days}}',
        fr: 'Votre secteur est ramassé le {{days}}'
    },
    pickupDialog12a: {
        en: 'Admins can book on any date. Customers can only book on: {{days}}s (Next: {{nextDate}})',
        fr:
            'Les administrateurs peuvent réserver à n’importe quelle date. Les clients ne peuvent réserver que les jours suivants : {{days}} (Prochaine date : {{nextDate}}).'
    },
    pickupDialog13: {
        en: 'Time Window',
        fr: 'Plage Horaire'
    },
    pickupDialog14: {
        en: 'Estimated time of arrival will be shown on the morning of your pickup',
        fr: "L'heure d'arrivée estimée sera affichée le matin de votre collecte"
    },
    pickupDialog15: {
        en: 'How often?',
        fr: 'À quelle fréquence?'
    },
    pickupDialog16: {
        en: 'Frequency',
        fr: 'Fréquence'
    },
    pickupDialog17: {
        en: 'One time pickup',
        fr: 'Collecte ponctuelle'
    },
    pickupDialog18: {
        en: 'Every 1 week',
        fr: 'Toutes les semaines'
    },
    pickupDialog19: {
        en: 'Every {{frequencyWeeks}} weeks',
        fr: 'Toutes les {{frequencyWeeks}} semaines'
    },
    pickupDialog20: {
        en: '(high volume)',
        fr: '(volume élevé)'
    },
    pickupDialog21: {
        en: '(regular)',
        fr: '(régulier)'
    },
    pickupDialog22: {
        en: '(low volume)',
        fr: '(faible volume)'
    },
    pickupDialog23: {
        en: '(very low volume)',
        fr: '(très faible volume)'
    },
    recyclables: !isMXDRegion()
        ? {
              en: 'Recyclables',
              fr: 'Recyclables'
          }
        : {
              en: 'Quantity of containers to pick up',
              fr: 'Quantité de contenants à récupérer'
          },
    adminOptions: {
        en: 'Override Options',
        fr: 'Options de remplacement'
    },
    pickupDialog25: {
        en: 'How much are we picking up?',
        fr: 'Combien de sacs collectons-nous?'
    },
    pickupDialog26: {
        en: 'Number of garbage-sized bags.',
        fr: 'Nombre de sacs à poubelle'
    },
    bottleRecycling: {
        en: 'Bottle Recycling',
        fr: 'Recyclage de Contenants'
    },
    accepted: {
        en: 'Accepted',
        fr: 'Accepté'
    },
    acceptedMaterials: {
        en: 'Accepted Materials',
        fr: 'Matériaux acceptés'
    },
    description: {
        en: 'Description',
        fr: 'Description'
    },
    lowVolumeFeeWarning: {
        en:
            'Please ensure you have {{lowVolumeContainerThreshold}} or more containers per pickup. A small fee may be applied for consistent low-volume collections.',
        fr:
            "Veuillez vous assurer d'avoir {{lowVolumeContainerThreshold}} contenants ou plus par collecte. Des frais minimes pourraient être appliqués pour les collectes à faible volume de façon constante."
    },
    pickupDialog27: {
        en: 'customer requires {{{binCount}}} bin',
        fr: 'le client a besoin de {{{binCount}}} bac'
    },
    // pickupDialog28a: {
    //     en: "Don't use {{{commodityUnits}}}s? Press here for other options",
    //     fr: "Vous n'utilisez pas des {{{commodityUnits}}}s? Appuyez ici pour d'autres options"
    // },
    pickupDialog28a: {
        en: 'Cases, Boxes, Bins',
        fr: 'Caisses, Boîtes, Bacs'
    },
    // pickupDialog28b: {
    //     en: 'Press here to hide other options',
    //     fr: 'Appuyez ici pour masquer les autres options'
    // },
    pickupDialog28b: {
        en: 'Hide other options',
        fr: 'Masquer les autres options'
    },
    pickupDialog28c: {
        en: 'Boxes or Bins? Press here',
        fr: 'Boîtes ou Bacs? Appuyez ici'
    },
    pickupDialog29: {
        en: 'Please use large bags for future pickups if possible. Use the inputs below for any non bagged items.',
        fr:
            'Veuillez utiliser de grands sacs pour les collectes futures si possible. Utilisez les entrées ci-dessous pour tout article non ensaché.'
    },
    pickupDialog30: {
        en: 'Clothing Donation',
        fr: 'Don de Vêtements'
    },
    pickupDialog31: {
        en: 'Garbage-sized bags',
        fr: 'Sacs à poubelle'
    },
    electronics: {
        en: 'Electronics',
        fr: 'Électronique'
    },
    pickupDialog33: {
        en: 'Number of items',
        fr: "Nombre d'objets"
    },
    pickupDialog34a: {
        en: 'Your ID is ',
        fr: 'Votre identifiant est '
    },
    pickupDialog34b: !isMXDRegion()
        ? {
              en: '. Please write this on your bag(s) if you can.',
              fr: ". Veuillez l'écrire sur votre (vos) sac (s) si vous le pouvez."
          }
        : {
              en: '. Please write this on your bag(s) or place the sticker with your QR code',
              fr: ". Veuillez l'écrire sur votre (vos) sac(s) ou apposez l'autocollant avec votre code QR"
          },
    pickupDialog35a: {
        en: 'When should we pickup?',
        fr: 'Quand souhaitez-vous planifier la collecte?'
    },
    pickupDialog35b: {
        en:
            'The applied promo code is restricted to the date below. If you would like to change the date of your pickup, please remove the promo code',
        fr:
            'Le code promotionnel appliqué est limité à la date ci-dessous. Si vous souhaitez modifier la date de votre collecte, veuillez supprimer le code promotionnel'
    },
    confirmation: {
        en: 'Confirmation',
        fr: 'Confirmation'
    },
    pickupDialog36: {
        en: 'Pickup picture confirmation',
        fr: 'Confirmation de collecte par photo'
    },
    pickupDialog37: {
        en: 'Large volumes pickups need to be verified with a picture. Please take a picture of your pickup.',
        fr:
            'Une confirmation par photo est requise pour les collectes de grands volumes. Veuillez prendre une photo de votre collecte.'
    },
    pickupDialog38: {
        en: 'If you do not believe this is a large volume pickup please check the number of items you have entered.',
        fr:
            "Si vous ne croyez pas qu'il s'agit d'une collecte de grand volume, veuillez vérifier le nombre d'articles que vous avez saisis."
    },
    pickupDialog39: {
        en:
            'Please take a picture of your containers for verification. Not required, but helpful if something goes missing.',
        fr:
            'Veuillez prendre une photo de vos sacs de contenants pour vérification. Ce n’est pas obligatoire mais fortement recommandé en cas de disparition des sacs.'
    },
    pickupDialog40: {
        en: 'Where will the bags be?',
        fr: 'Où seront les sacs ?'
    },
    pickupDialog41: {
        en: 'Directions/Comments​',
        fr: 'Instructions/Commentaires​'
    },
    specialInstructions: {
        en: 'Special instructions',
        fr: 'Instructions spéciales'
    },
    pickupDialog43: {
        en:
            'Your personal information is kept private and will only be relayed to the driver. If you need to be contacted by the driver (ie. call on arrival), please specify.',
        fr:
            "Vos informations personnelles sont gardées privées et ne seront transmises qu'au chauffeur. Si vous avez besoin d'être contacté par le chauffeur (c'est-à-dire appeler à l'arrivée), veuillez le préciser."
    },
    pickupDialog44aResidential: !isMXDRegion()
        ? {
              en:
                  "Log in after 8 AM on your pickup day for an estimated time of arrival. If you can't wait around, hide your bags in a secure location outside and update your directions above.",
              fr:
                  "Connectez-vous après 8h le jour de votre collecte pour connaître l'heure d'arrivée estimée. Si vous ne pouvez pas attendre, cachez vos sacs dans un endroit sécuritaire à l'extérieur et mettez à jour vos directives ci-dessus."
          }
        : {
              en:
                  'Make sure your bags of containers and crates of glass containers are ready and accessible on collection day.',
              fr:
                  'Assurez-vous que vos sacs de contenants et caisses de contenants de verre sont prêts et accessibles le jour de la collecte.'
          },
    pickupDialog44aCondo: !isMXDRegion()
        ? {
              en:
                  "Log in after 8 AM on your pickup day for an estimated time of arrival. If you can't wait around, place your bags on ground floor in a secure location and update your directions above.",
              fr:
                  "Connectez-vous après 8h le jour de votre collecte pour connaître l'heure d'arrivée estimée. Si vous ne pouvez pas attendre, placez vos sacs au rez-de-chaussée dans un endroit sécuritaire et mettez à jour vos directives ci-dessus."
          }
        : {
              en:
                  'Make sure your bags of containers and crates of glass containers are ready and accessible on collection day.',
              fr:
                  'Assurez-vous que vos sacs de contenants et caisses de contenants de verre sont prêts et accessibles le jour de la collecte.'
          },
    pickupDialog44aCommercial: !isMXDRegion()
        ? {
              en:
                  'Log in after 8 AM on your pickup day for an estimated time of arrival. Please make sure the driver can access your recycling / recycling room and knows who to talk to using the directions above.',
              fr:
                  "Connectez-vous après 8h le jour de votre collecte pour connaître l'heure d'arrivée estimée. Veuillez vous assurer que le chauffeur peut accéder à votre recyclage / salle de recyclage et sait à qui parler en utilisant les directives ci-dessus."
          }
        : {
              en:
                  'Make sure your bags of containers and crates of glass containers are ready and accessible on collection day.',
              fr:
                  'Assurez-vous que vos sacs de contenants et caisses de contenants de verre sont prêts et accessibles le jour de la collecte.'
          },
    pickupDialog44bResidential: {
        en:
            'Please DO NOT leave your bags in plain sight of walking traffic, in the alley, or inside your home/{{condoName}}. We cannot enter private residences.',
        fr:
            "Veuillez NE PAS laisser vos sacs à la vue de la circulation piétonne, dans la ruelle ou à l'intérieur de votre maison/{{condoName}}. Nous ne pouvons pas entrer dans les résidences privées."
    },
    pickupDialog44bCondo: {
        en:
            'Please DO NOT leave your bags in plain sight of walking traffic, outside of your main building, or inside your home/{{condoName}}. We cannot enter private residences.',
        fr:
            "Veuillez NE PAS laisser vos sacs à la vue de la circulation piétonne, dans la ruelle ou à l'intérieur de votre maison/{{condoName}}. Nous ne pouvons pas entrer dans les résidences privées."
    },
    pickupDialog45: {
        en: 'What number to contact?',
        fr: 'Quel numéro contacter?'
    },
    pickupDialog46: {
        en: "We'll use {{number}} to contact you if needed.",
        fr: 'Nous utiliserons {{number}} pour vous contacter si nécessaire.'
    },
    pickupDialog47: {
        en: 'Use a different number for this pickup',
        fr: 'Utiliser un numéro différent pour cette collecte'
    },
    phoneNumber: {
        en: 'Phone Number',
        fr: 'Numéro de Téléphone'
    },
    pickupDialog49: {
        en: 'Want to donate?',
        fr: 'Faire un don'
    },
    organizationName: {
        en: '{{organizationName}}',
        fr: 'Organisme'
    },
    pickupDialog50: {
        en: 'Select {{organizationName}}',
        fr: "Sélectionner l'organisme"
    },
    pickupDialog50Exp: {
        en: 'Select a Charity or Group',
        fr: 'Sélectionnez un Organisme de Bienfaisance ou un Groupe'
    },
    pickupDialog51: {
        en: 'Search for a Charity or Group',
        fr: 'Rechercher une œuvre de charité ou un groupe'
    },
    pickupDialog52: {
        en: 'This charity issues tax receipts for your donations',
        fr: 'Cet organisme de bienfaisance délivre des reçus fiscaux pour vos dons'
    },
    pickupDialog52a: {
        en: 'Registered Charities',
        fr: 'Organismes de bienfaisance enregistrés'
    },
    pickupDialog52b: {
        en: 'Registered Charity',
        fr: 'Organisme de bienfaisance enregistré'
    },
    pickupDialog53: {
        en: 'You will not receive tax receipts for donating to this organization.',
        fr: 'Vous ne recevrez pas de reçus fiscaux pour avoir fait un don à cette organisme.'
    },
    featuredOrganizations: {
        en: 'Featured {{organizationName}}',
        fr: 'Organisme Affilié'
    },
    pickupDialog55: {
        en:
            "These are our featured {{organizationName}}s. There are over {{num}} {{organizationName}}s registered on {{brand}}, use the search bar above if you cannot find the one you're looking for.",
        fr:
            'Voici nos organismes vedettes. Il y a plus de {{num}} organismes enregistrées sur {{brand}}, utilisez la barre de recherche ci-dessus si vous ne trouvez pas celle que vous recherchez.'
    },
    pickupDialog55EXP: {
        en:
            'These are featured {{organizationName}}s. There are over {{num}} {{organizationName}}s using the Return-It Express program for fundraising, use the search bar above if you cannot find the one you are looking for.',
        fr:
            'Voici les {{organizationName}}s mis en vedette. Plus de {{num}} {{organizationName}}s utilisent le programme Return-It Express pour la collecte de fonds. Utilisez la barre de recherche ci-dessus si vous ne trouvez pas celui que vous cherchez.'
    },
    pickupDialog56: {
        en:
            "These are our featured {{organizationName}}s. There are {{num}} {{organizationName}}s registered on {{brand}}, use the search bar above if you cannot find the one you're looking for.",
        fr:
            'Voici nos organismes vedettes. Il y a {{num}} organismes enregistrées sur {{brand}}, utilisez la barre de recherche ci-dessus si vous ne trouvez pas celle que vous recherchez.'
    },
    pickupDialog56EXP: {
        en:
            'These are featured {{organizationName}}s. There are {{num}} {{organizationName}}s using the Return-It Express program for fundraising, use the search bar above if you cannot find the one you are looking for.',
        fr:
            'Voici les {{organizationName}}s mis en vedette. Plus de {{num}} {{organizationName}}s utilisent le programme Return-It Express pour la collecte de fonds. Utilisez la barre de recherche ci-dessus si vous ne trouvez pas celui que vous cherchez.'
    },
    pickupDialog57: {
        en:
            "These are our featured {{organizationName}}s. There is one {{organizationName}} registered on {{brand}}, use the search bar above if you cannot find the one you're looking for.",
        fr:
            'Voici nos organismes vedettes. Il y a un organisme enregistrées sur {{brand}}, utilisez la barre de recherche ci-dessus si vous ne trouvez pas celle que vous recherchez.'
    },
    pickupDialog57EXP: {
        en:
            'These are featured {{organizationName}}s. There is one {{organizationName}}s using the Return-It Express program for fundraising, use the search bar above if you cannot find the one you are looking for.',
        fr:
            'Voici les {{organizationName}}s mis en vedette. Un {{organizationName}} utilise le programme Return-It Express pour la collecte de fonds. Utilisez la barre de recherche ci-dessus si vous ne trouvez pas celui que vous cherchez.'
    },
    pickupDialog58: {
        en: 'Any promo codes?',
        fr: 'Des codes promotionnels?'
    },
    pickupDialog59: {
        en: 'Promo code is invalid:',
        fr: "Le code promotionnel n'est pas valide :"
    },
    pickupDialog60: {
        en: 'Use Previous Address',
        fr: "Utiliser l'adresse précédente"
    },
    pickupDialog61: {
        en: 'conditions apply',
        fr: "des conditions s'appliquent"
    },
    pickupDialog62: {
        en: 'team/group/bottle drive',
        fr: 'équipe/groupe/collecte de contenants'
    },
    pickupDialog63: {
        en: 'Request tax receipt (if available)',
        fr: 'Demander un reçu fiscal (si disponible)'
    },
    pickupDialog64: {
        en: 'Tax receipts',
        fr: 'Reçus fiscaux'
    },
    pickupDialog65: {
        en:
            'By selecting this option, the charity will get access to your full name, current address, and e-mail in order to send you a tax receipt. Tax receipts are issued independently from {{appName}}. For details, including whether a tax receipt will be provided, please contact the charity directly.',
        fr:
            "En sélectionnant cette option, l'organisme de bienfaisance aura accès à votre nom complet, votre adresse actuelle et votre adresse e-mail afin de vous envoyer un reçu fiscal. Les reçus fiscaux sont émis indépendamment de {{appName}}. Pour plus de détails, notamment si un reçu fiscal sera fourni, veuillez contacter directement l'organisme de bienfaisance."
    },
    pickupDialog66: {
        en: "Heads up! We don't have an available driver for this date. Please select another day",
        fr:
            "Nous n'avons malheureusement pas de chauffeur disponible pour cette date. Veuillez sélectionner un autre jour"
    },
    pickupDialog67: {
        en: 'We do not service your area yet',
        fr: 'Nous ne desservons pas encore votre région'
    },
    pickupDialog68: {
        en: 'Next booking date',
        fr: 'Prochaine date de réservation'
    },
    pickupDialog69: {
        en: 'No Bookings',
        fr: 'Aucune réservation'
    },
    pickupDialog70: {
        en: 'Please confirm your address for the tax receipt',
        fr: 'Veuillez confirmer votre adresse pour le reçu fiscal'
    },
    pickupDialog71: {
        en: 'Invalid number of bags',
        fr: 'Nombre de sacs invalide'
    },
    pickupDialog72a: {
        en: 'Service unavailable in your area. Please contact customer support for assistance.',
        fr: `Service indisponible dans votre région. Veuillez contacter le service client pour obtenir de l'aide.`
    },
    pickupDialog72b: {
        en: 'Cannot proceed. Zone missing required payload for customer type.',
        fr: `Impossible de continuer. Zone manquante pour le type de client.`
    },
    inactive: {
        en: 'INACTIVE',
        fr: 'INACTIF'
    },
    promoCode: {
        en: 'Promo Code',
        fr: 'Code Promotionnel'
    },
    promo: {
        en: 'Promo',
        fr: 'Promo'
    },
    apply: {
        en: 'apply',
        fr: 'appliquer'
    },
    code: {
        en: 'Code',
        fr: 'Code'
    },
    customerCode: {
        en: 'Customer Code',
        fr: 'Code client'
    },
    required: {
        en: 'required',
        fr: 'requise'
    },
    noDonation: {
        en: 'No donation',
        fr: 'Aucun don'
    },
    noDonationExp: {
        en: 'Redeem funds without donating',
        fr: 'Échanger des fonds sans faire de don'
    },
    cannotRedeemWithoutDonation: {
        en: 'Donation currently required for redemption',
        fr: 'Don requis actuellement pour le remboursement'
    },
    donationPreferenceLocked: {
        en: 'Donation Preference Locked',
        fr: 'Préférence de don verrouillée'
    },
    donationPreferenceLockedMessage: {
        en:
            'You are not allowed to change your donation preference. Please contact {{brandname}} if you need to change this.',
        fr:
            "Vous n'êtes pas autorisé à modifier vos préférences de don. Veuillez contacter {{brandname}} si vous avez besoin de changer cela."
    },
    allowedTypes: {
        en: 'Insert the accepted formats (For commercial collection = BGE bags)',
        fr: 'Insérer les formats acceptés (Pour collecte commerciale = sacs BGE)'
    },
    pickupDialog72: {
        en:
            'Your refund is currently set to be donated to the organization below. You can update or remove your donation anytime.',
        fr:
            'Votre remboursement est actuellement destiné à être donné à l’organisation ci-dessous. Vous pouvez mettre à jour ou annuler votre don à tout moment.'
    },
    pickupDialog73: {
        en: 'If you want to donate your refund, select an organization from the list below.',
        fr:
            'Si vous souhaitez faire don de votre remboursement, sélectionnez une organisation dans la liste ci-dessous.'
    }
};

const promoErrors = {
    doesNotExist: {
        en: 'does not exist',
        fr: `n'existe pas`
    },
    promotionEnded: {
        en: 'promotion ended',
        fr: 'promotion terminée'
    },
    noLongerActive: {
        en: 'no longer active',
        fr: "n'est plus actif"
    },
    internalUse: {
        en: 'reserved for internal use only',
        fr: 'réservé à un usage interne uniquement'
    },
    wrongCommodity: {
        en: 'not applicable to this commodity',
        fr: "Ne s'applique pas à ce produit"
    },
    ownCode: {
        en: 'cannot use your own code',
        fr: 'vous ne pouvez pas utiliser votre propre code'
    },
    notStarted: {
        en: 'not available for use until {{date}}',
        fr: "indisponible jusqu'au {{date}}"
    },
    expired: {
        en: 'expired',
        fr: 'expiré'
    },
    noUsesLeft: {
        en: 'all codes used up',
        fr: 'tous les codes utilisés'
    },
    newCustomerOnly: {
        en: 'reserved for new customers only',
        fr: 'réservé aux nouveaux clients uniquement'
    },
    alreadyUsed: {
        en: 'a similar promo code has been used already',
        fr: 'un code promotionnel similaire a déjà été utilisé'
    },
    charityDonationOnly: {
        en: 'reserved for donations to the affiliated charity',
        fr: "réservé aux dons à l'organisme de bienfaisance affilié"
    },
    blockedZone: {
        en: 'this promotion is not available in your region',
        fr: "cette promotion n'est pas disponible dans votre région"
    },
    blockedCollector: {
        en: 'this promotion is not available for your collector',
        fr: "cette promotion n'est pas disponible pour votre collecteur"
    }
};

const pickupDialogSelectTranslations = {
    pickupDialogSelect1: {
        en: '{{name}} pickup',
        fr: 'collecte de condo'
    },
    pickupDialogSelect2: {
        en:
            "Select this if you want pickups from your {{name}}! Enter your unit number, location, and date. A driver will arrive between 8 AM and 5 PM on the day you select. Don't worry, you will be able to see an estimated time of arrival in the app on the morning of your pickup. If you can't wait around to meet the driver, use your building's recycling room and talk to your {{name}} management board about setting up a designated area. Once picked up, we'll count your containers and credit your account, where you can keep or donate your refund. ",
        fr:
            "Sélectionnez ceci si vous souhaitez des collectes de votre {{name}}! Entrez votre numéro d'unité, l'emplacement et la date. Un chauffeur arrivera entre 8h et 17h le jour que vous choisissez. Ne vous inquiétez pas, vous pourrez voir une heure d'arrivée estimée dans l'application le matin de votre collecte. Si vous ne pouvez pas attendre pour rencontrer le chauffeur, utilisez la salle de recyclage de votre immeuble et parlez au conseil d'administration de votre {{name}} pour établir une zone désignée. Une fois ramassés, nous compterons vos contenants et créditerons votre compte, où vous pourrez conserver ou faire don de votre remboursement. "
    },
    pickupDialogSelect2b: {
        en: 'Please place everything into large bags and label them with ',
        fr: 'Veuillez tout placer dans de grands sacs et les étiqueter avec '
    },
    pickupDialogSelect3: {
        en: 'Buzzer Code',
        fr: 'Code de Sonnerie'
    },
    pickupDialogSelect4: {
        en:
            'We service {{name}}s, multifamily complexes, and apartments. Use the Buzzer Code field and the comments box on the last page to specify how the driver can contact you once they arrive.',
        fr:
            'Nous desservons des condos, des complexes multifamiliaux et des appartements. Utilisez le champ code de sonnerie et la zone de commentaires sur la dernière page pour spécifier comment le chauffeur peut vous contacter une fois arrivé.'
    },
    pickupDialogSelect5: {
        en:
            'Please leave your bags on the ground floor in a safe spot or run them down when the driver arrives. You will be notified 15 minutes before arrival.',
        fr:
            "Veuillez laisser vos sacs au rez-de-chaussée dans un endroit sûr ou les déposer à l'arrivée du chauffeur. Vous serez prévenu 15 minutes avant votre arrivée."
    },
    pickupDialogSelect6: {
        en: 'commercial pickup',
        fr: 'collecte commerciale'
    },
    pickupDialogSelect7: !isMXDRegion()
        ? {
              en:
                  "Select this if you want pickups from your high-volume business! Enter your business location, date and pickup frequency (weekly, monthly, etc). A driver will arrive between 8 AM and 5 PM on the day you select. Don't worry, you will be able to see an estimated time of arrival in the app on the morning of your pickup. In the directions section, please specify where the driver can find your bags, any security codes and hours of operation they should be aware of. Once picked up, we'll count your containers and credit your account, where you can keep or donate your refund. ",
              fr:
                  "Sélectionnez ceci si vous souhaitez des collectes de votre entreprise à haut volume! Entrez l'emplacement de votre entreprise, la date et la fréquence de collecte (hebdomadaire, mensuelle, etc.). Un chauffeur arrivera entre 8h et 17h le jour que vous choisissez. Ne vous inquiétez pas, vous pourrez voir une heure d'arrivée estimée dans l'application le matin de votre collecte. Dans la section des directives, veuillez préciser où le chauffeur peut trouver vos sacs, tous les codes de sécurité et les heures d'ouverture dont ils devraient être informés. Une fois ramassés, nous compterons vos contenants et créditerons votre compte, où vous pourrez conserver ou faire don de votre remboursement. "
          }
        : {
              en:
                  'Select this option if you want to get a pickup for your business. Please enter your contact details and instructions for retrieving your bags. Your bags will be counted and your customer account credited. Remember to properly identify your bags with your identification tags.',
              fr:
                  "Sélectionnez cette option si vous souhaitez obtenir une collecte pour votre entreprise. Veuillez entrer vos coordonnées et les instructions pour récupérer vos sacs. Vos sacs seront comptés et votre compte client sera crédité. N'oubliez pas d'identifier correctement vos sacs avec vos étiquettes d'identification."
          },

    pickupDialogSelect7b: {
        en: 'If possible, please place everything into large bags and label them with ',
        fr: 'Si possible, veuillez tout placer dans de grands sacs et les étiqueter avec '
    },
    pickupDialogSelect9: {
        en: 'Commercial/business pickup',
        fr: 'Collecte commerciale'
    },
    pickupDialogSelect8: {
        en: 'Doing Business As',
        fr: 'Faire des affaires comme'
    },
    pickupDialogSelect8a: {
        en: 'Trading Name',
        fr: 'Faire des affaires comme'
    },
    pickupDialogSelect: {
        en: 'Enter your business name to help our drivers navigate to your pickup faster.',
        fr:
            'Entrez le nom de votre entreprise pour aider nos chauffeurs à se rendre plus rapidement à votre lieu de collecte.'
    },
    pending1: {
        en: 'Your cash out of {{amount}} is being processed. You should receive a transfer no later than {{date}}.',
        fr:
            'Votre remboursement de {{amount}} est en cours de traitement. Vous devriez recevoir un virement au plus tard le {{date}}.'
    },
    pending1EXP: {
        en: 'Your redemption of {{amount}} is being processed.',
        fr: 'Votre remboursement de {{amount}} est en cours de traitement.'
    }
};

const pickupDialogDropAndGoTranslations = {
    pickupDialogDrop1: {
        en: 'drop&go',
        fr: 'retour express'
    },
    pickupDialogDrop2:
        !isMXDRegion() && !isCONRegion() && !isEXPRegion()
            ? {
                  en:
                      'Select this if you want to drop off your bags and skip the line at a valid {{{type}}} location. ',
                  fr:
                      "Sélectionnez cette option si vous souhaitez déposer vos sacs dans un conteneur extérieur 'POD' et éviter les files d'attente! "
              }
            : {
                  en: 'Select this option and follow the instructions to locate bag depots in your area.',
                  fr:
                      'Sélectionnez cette option et suivez les instructions pour repérer les dépôts de sacs de votre région.'
              },

    pickupDialogDrop2b: {
        en: 'Please label your bags with ',
        fr: 'Veuillez étiqueter vos sacs avec '
    },
    pickupDialogDrop3: {
        en: 'How to recycle with {{{type}}}',
        fr: 'Retour express'
    },
    pickupDialogDrop4: !isMXDRegion()
        ? {
              en: 'Write this on your bags:',
              fr: 'Écrivez ceci sur vos sacs:'
          }
        : {
              en: 'This is your customer code:',
              fr: 'Ceci est votre code client:'
          },
    pickupDialogDrop5:
        !isMXDRegion() && !isEXPRegion()
            ? {
                  en:
                      'Why wait? {{{type}}} lets you skip the line for your empties refund. Select the closest {{{type}}} location and bring your recyclables in during their hours of operation. When you arrive at the depot, use the app to snap a picture and confirm your drop off. Leave the bags in the designated {{{type}}} area or bin (inside the depot). Your bags will be counted and account credited within 48 hours.',
                  fr:
                      "Pourquoi attendre? Retour express vous permet d'éviter les files d'attente et les machines en panne pour le remboursement de vos contenants consignés. Sélectionnez le lieu de retour le plus proche et apportez vos contenants consignés pendant leurs heures d'ouverture. Lorsque vous arrivez au lieu de retour, utilisez l'application pour afficher votre code-client QR et passer le sous un scanneur afin de débarrer la porte. Déposez les sacs à l'intérieur du conteneur puis refermer bien la porte. Vos sacs seront comptés et votre compte crédité dans les 48 heures."
              }
            : isMXDRegion()
            ? {
                  en:
                      'Clearly identify your bags and place them inside the container. Your bags will be sorted and counted and your customer account will be credited with the value of the deposit in the next few days.',
                  fr:
                      "Identifiez bien vos sacs et déposez-les à l'intérieur du conteneur.  Vos sacs seront triés et comptés et votre compte client sera crédité de la valeur de la consigne dans les prochains jours."
              }
            : {
                  en:
                      'Bring your bagged containers the following location. Tag each bag with an express label and then drop the bags in the designated Express drop off area. Express labels can be shipped to your home (for a fee) or printed on location from the Express Kiosk.',
                  fr:
                      'Apportez vos contenants en sac à l’endroit suivant. Étiquetez chaque sac avec une autocollant express, puis déposez les sacs dans la zone de dépôt express désignée. Les autocollants express peuvent être expédiées à votre domicile (moyennant des frais) ou imprimés sur place à partir du kiosque express.'
              },
    pickupDialogDrop6: {
        en: 'location',
        fr: 'emplacement'
    },
    pickupDialogDrop7: {
        en: 'open',
        fr: 'ouvert'
    },
    pickupDialogDrop7b: {
        en: 'closing soon',
        fr: 'fermeture bientôt'
    },
    pickupDialogDrop8: {
        en: 'closed',
        fr: 'fermé'
    },
    pickupDialogDrop8b: {
        en: 'opening soon',
        fr: 'ouverture prochaine'
    },
    pickupDialogDrop9: {
        en: 'get directions',
        fr: 'obtenir des directions'
    },
    pickupDialogDrop9b: {
        en: 'request labels',
        fr: 'demander des autocollants'
    },
    pickupDialogDrop9c: {
        en: 'Call Location',
        fr: 'Appelez cet endroit'
    },
    pickupDialogDrop9d: {
        en: `Continue with ${app} drop off`,
        fr: `Continuer avec le dépôt de ${app}`
    },
    pickupDialogDrop9e: {
        en: `Continue with`,
        fr: `Continuez avec`
    },
    pickupDialogDrop10: {
        en: 'hours of operation',
        fr: "heures d'ouverture"
    },
    pickupDialogDrop11: {
        en: 'How much are you dropping off?',
        fr: 'Combien de sacs déposer vous?'
    },
    pickupDialogDrop12: {
        en: 'GPS Not registering.',
        fr: 'GPS non enregistré.'
    },
    pickupDialogDrop13: {
        en: 'Please turn your location services ON and press the refresh button.',
        fr: "Veuillez activer vos services de localisation et appuyer sur le bouton d'actualisation."
    },
    pickupDialogDrop14: {
        en: 'Click here if your GPS is not working',
        fr: 'Cliquez ici si votre GPS ne fonctionne pas'
    },
    pickupDialogDrop15: {
        en: 'refresh',
        fr: 'rafraîchir'
    },
    pickupDialogDrop16: {
        en: 'back',
        fr: 'retour'
    },
    new: {
        en: 'New',
        fr: 'NOUVEAU'
    },
    pickupDialogDrop17: {
        en: 'Please ask the front counter for the override code',
        fr: 'Veuillez demander le code de dérogation au comptoir'
    },
    pickupDialogDrop18: {
        en: 'override code',
        fr: 'remplacer le code'
    },
    pickupDialogDrop19: {
        en: 'submit code',
        fr: 'soumettre le code'
    },
    pickupDialogDrop20: !isMXDRegion()
        ? {
              en: '{{{type}}} picture confirmation',
              fr: "Confirmation de l'image {{{type}}}"
          }
        : {
              en: 'Take a photo',
              fr: 'Prenez une photo'
          },
    pickupDialogDrop21: !isMXDRegion()
        ? {
              en:
                  'Please take a picture of your bags and then leave them in the designated Drop&Go area or bin (inside the depot). The picture is for security and gives us a record of your bags.',
              fr:
                  "Veuillez prendre une photo de vos sacs et les laisser ensuite dans la zone Drop&Go désignée ou dans la poubelle (à l'intérieur du dépôt). La photo est pour la sécurité et nous donne un enregistrement de vos sacs."
          }
        : {
              en:
                  'Please take a picture of all the bags you put in the container. To open the door, follow the steps to display your QR code which you can scan under the door. The photo gives us additional proof of your deposit.',
              fr:
                  'Veuillez prendre une photo de tous les sacs que vous déposez dans le conteneur.  Pour ouvrir la porte, poursuivez les étapes pour afficher votre code QR que vous pourrez balayer sous la porte.  La photo nous donne une preuve additionnelle de votre dépôt.'
          },
    pickupDialogDrop22: {
        en: 'Please take a photo of your bags.',
        fr: 'Veuillez prendre une photo de vos sacs.'
    },
    pickupDialogDrop23a: {
        en: 'upload photo',
        fr: 'Télécharger la photo'
    },
    pickupDialogDrop23b: {
        en: 'take photo',
        fr: 'prendre une photo'
    },
    pickupDialogDrop24: {
        en: 'This is the closest {{{type}}} location',
        fr: "Il s'agit de l'emplacement {{{type}}} le plus proche"
    },
    pickupDialogDrop24b: {
        en: 'Closest Location',
        fr: 'Emplacement le plus proche'
    },
    pickupDialogDrop25: {
        en: 'This is not the closest {{{type}}} location',
        fr: "Ce n'est pas l'emplacement {{{type}}} le plus proche"
    },
    pickupDialogDrop25b: {
        en: 'Not Closest Location',
        fr: "Pas l'emplacement le plus proche"
    },
    pickupDialogDrop26: {
        en:
            'You currently have a {{{type}}} being processed. Please wait to receive your counts before submitting another one.',
        fr:
            "Vous avez actuellement un {{{type}}} en cours de traitement. Veuillez attendre de recevoir vos décomptes avant d'en soumettre un autre."
    },
    pickupDialogDrop27: {
        en: 'There are currently no {{{type}}} locations available.',
        fr: "Il n'y a actuellement aucun emplacement {{{type}}} disponible."
    },

    pickupDialogDrop28: {
        en: 'QR Scan',
        fr: 'Balayez le code QR'
    },
    pickupDialogDrop28a: {
        en: 'Please scan the following qr code to deposit your bags.',
        fr: 'Veuillez balayer le code QR pour déposer vos sacs.'
    },

    pickupDialogDrop29: {
        en: 'Label printing',
        fr: 'Impression des autocollants'
    },
    pickupDialogDrop29a: {
        en:
            'If you have not already printed your labels, go inside one of these two shops and scan the code below on the printing module:',
        fr:
            "Si vous n'avez pas déja imprimé vos autocollants, rendez-vous à l'intérieur de l'un de ces deux commerces et scanner le code ci-dessous sur le module d'impression:"
    },
    pickupDialogDrop29b: {
        en: '41 boul. Charest Est (Familiprix)',
        fr: '41 boul. Charest Est (Familiprix)'
    },
    pickupDialogDrop29c: {
        en: '1805 1ère Avenue (Couche-Tard)',
        fr: '1805 1ère Avenue (Couche-Tard)'
    },
    pickupDialogDrop30: {
        en: 'Scan your QR code on the print booth to print ID labels',
        fr: "Balayez votre code QR sur le module d'impression pour imprimer des autocollants d'identification"
    },
    pickupDialogDrop31: {
        en: 'The printing booth is located in the store next to the bag deposit site.',
        fr: `Le module d'impression est situé dans le commerce voisin du lieu de retour.`
    },
    pickupDialogDrop32: {
        en:
            'Identify each of your bags of containers using the self-adhesive labels on which is your QR code and your 4-character code.',
        fr: `Identifiez chacun de vos sacs de contenants à l’aide des autocollants autocollantes sur lesquelles se trouve votre code QR et votre code à 4 caractères.`
    },
    pickupDialogDrop33: {
        en:
            'Scan your QR code on the scanner under the container door to drop your bags or follow the steps for a bag drop in the app.',
        fr: `Balayez votre code QR sur le lecteur optique situé sous la porte du conteneur pour déposer vos sacs ou suivez les étapes d'un retour express dans l'application.`
    },
    pickupDialogDrop34: {
        en: 'Print Booth Information',
        fr: `Informations sur le module d'impression`
    },
    pickupDialogDrop35: {
        en: 'Were all bags deposited?',
        fr: `Tous les sacs ont-ils été déposés?`
    },
    pickupDialogDrop36: {
        en: 'Are you sure you want to cancel your {{{type}}}?',
        fr: `Êtes-vous sûr de vouloir annuler votre {{{type}}}?`
    },
    pickupDialogDrop37: {
        en: `Login at the ${app} kiosk to print your labels.`,
        fr: `Connectez-vous au kiosque ${app} pour imprimer vos autocollants.`
    },
    pickupDialogDrop38: {
        en: 'Place your unsorted containers in a clear or transparent plastic bag and tag your bags, one tag per bag.',
        fr:
            'Placez vos contenants non triés dans un sac en plastique transparent ou transparent et étiquetez vos sacs, une autocollants par sac.'
    },
    pickupDialogDrop39: {
        en:
            'At the Express and GO station, text your Express & Go Passcode to 778-400-5253, receive your one-time PIN to open the door.',
        fr: `À la gare Express et GO, envoyez votre code d'accès Express & Go au 778 400-5253 et recevez votre code PIN à usage unique pour ouvrir la porte.`
    },
    pickupDialogDrop40: {
        en: 'Scan the label before dropping off the bag(s).',
        fr: `Scannez l'autocollants avant de déposer le(s) sac(s).`
    },
    pickupDialogDrop41: {
        en: 'Drop off your bag(s)!',
        fr: 'Déposez votre(vos) sac(s) !'
    },
    pickupDialogDrop42: {
        en: 'Complete your return',
        fr: 'Complétez votre retour'
    },
    pickupDialogDrop43: {
        en: 'Refer to hours of operation',
        fr: "Se référer aux heures d'ouverture"
    },
    pickupDialogDrop44: {
        en: 'Request one-time PIN',
        fr: 'Demander un code PIN à usage unique'
    },
    pickupDialogDrop45: {
        en: 'Text {{kantechPasscode}} to {{kantechPhoneNumber}} to receive your one-time PIN',
        fr: 'Envoyez {{kantechPasscode}} à {{kantechPhoneNumber}} pour recevoir votre code PIN à usage unique'
    },
    pickupDialogDrop46: {
        en: 'Your one-time PIN',
        fr: 'Votre code PIN à usage unique'
    },
    pickupDialogDrop47: {
        en: 'Expires in ',
        fr: 'Expire dans '
    },
    pickupDialogDrop48: {
        en: 'Select this if you want to drop off your bags at a valid Reverse Vending Machine location.',
        fr:
            'Sélectionnez cette option si vous souhaitez déposer vos sacs dans un emplacement de machine récupératrice à l’unité valide.'
    },
    pickupDialogDrop49: {
        en: 'Set {{{name}}} as your preferred location?',
        fr: 'Définir {{{name}}} comme emplacement préféré ?'
    },
    pickupDialogDrop50: {
        en: 'Remove {{{name}}} as your preferred location?',
        fr: 'Supprimer {{{name}}} comme emplacement préféré ?'
    },
    pickupDialogDrop51: {
        en: 'preferred location',
        fr: 'emplacement préféré'
    },
    pickupDialogDrop52: {
        en: 'Refresh Location',
        fr: "Actualiser l'emplacement"
    },
    pickupDialogDrop53: {
        en: 'Verify Location',
        fr: "Vérifier l'emplacement"
    },
    pickupDialogDrop54: {
        en: 'location services',
        fr: 'services de localisation'
    },
    pickupDialogDrop55: {
        en: "Ensuring you're at the right spot. One sec!",
        fr: 'Prendre un instant pour vérifier que vous êtes au bon endroit. Une seconde !'
    },
    pickupDialogDrop55Exp: {
        en: 'Verifying proximity to Express & Go access door. Please wait.',
        fr: 'Vérification de la proximité de la porte d’accès Express & Go. Veuillez patienter.'
    },
    pickupDialogDrop56: {
        en: 'Open Status',
        fr: 'Statut ouvert'
    },
    pickupDialogDrop57: {
        en: 'Drop Off Type',
        fr: 'Type de dépôt'
    },
    pickupDialogDrop58: {
        en: 'Materials',
        fr: 'Matériels'
    },
    pickupDialogDrop59: {
        en: 'Opens {{time}}.',
        fr: 'ouvre à {{time}}.'
    }
};

const pickupDialogBottleDriveTranslations = {
    pickupDialogBottleDrive1: {
        en: 'Bottle drives',
        fr: 'Collecte de contenants'
    },
    pickupDialogBottleDrive2: {
        en:
            'Select this if you are organizing a high volume (over 200 bags) bottle drive and want a trailer or truck to pickup your pile of bags.',
        fr:
            "Sélectionnez cette option si vous organisez une collecte de bouteilles à volume élevé (plus de 200 sacs) et que vous souhaitez qu'une remorque ou un camion récupère votre pile de sacs."
    },
    pickupDialogBottleDrive3: {
        en: 'Want to donate to a bottle drive?',
        fr: 'Vous souhaitez faire un don pour une collecte de conmtenants consignés?'
    },
    pickupDialogBottleDrive4: {
        en: 'Select Bottle Drive to Donate to:',
        fr: 'Sélectionnez Collecte de Contenants pour faire un don à :'
    },
    pickupDialogBottleDrive5: {
        en: 'donate now',
        fr: 'faite un don maintenant'
    },
    pickupDialogBottleDrive6: {
        en: 'Want to start a bottle drive?',
        fr: 'Vous souhaitez démarrer une collecte de contenants consigés?'
    },
    pickupDialogBottleDrive7: {
        en:
            'Want a better way to run a Bottle Drive? We have trucks on the road five days a week, year round, ready to pick up your donations!',
        fr:
            "Vous voulez une meilleure façon d'amasser des contenants consignés? Nous avons des camions sur la route cinq jours par semaine, toute l'année, prêts à ramasser vos dons!"
    },
    pickupDialogBottleDrive8: {
        en: 'Indicate the full name of your company',
        fr: 'Indiquer le nom complet de votre entreprise'
    },

    pickupDialogBottleDrive9: {
        en: '',
        fr: '' // Leave blank
    },
    pickupDialogBottleDrive10: {
        en:
            'Is your organization running a bottle drive, clothing drive, or electronics drive? Fill out the form below and we will confirm your booking. On the day of your bottle drive A SkipTheDepot truck will arrive at the end to collect your bags and have them processed. Your proceeds will be available via e-transfer with history recorded in your account.',
        fr: `
        Votre organisation organise-t-elle une collecte de bouteilles, une collecte de vêtements ou une collecte d'appareils électroniques ? Remplissez le formulaire ci-dessous et nous confirmerons votre réservation. Le jour de votre collecte de bouteilles, un camion SkipTheDepot arrivera à la fin pour récupérer vos sacs et les faire traiter. Vos bénéfices seront disponibles par virement électronique avec un historique enregistré dans votre compte.`
    },
    pickupDialogBottleDrive11: {
        en: 'You must have over 40 bags to book.',
        fr: 'Vous devez avoir plus de 40 sacs à réserver.'
    },
    pickupDialogBottleDrive12: {
        en: 'You need to book your bottle drive at least three days ahead.',
        fr: "Vous devez réserver votre collecte de bouteilles au moins trois jours à l'avance."
    },
    pickupDialogError1: {
        en:
            "Looks like we weren't able to find you a pickup date! Don't worry, we've been notified about it already and will contact you soon about your pickup!",
        fr:
            "Nous n'avons pas pu vous trouver une date de collecte! Ne vous inquiétez pas, nous en avons déjà été informés et nous vous contacterons bientôt au sujet de votre collecte!"
    },
    pickupDialogError2: {
        en:
            "This area isn't open for public bookings until {{date}}. Please contact {{email}} if you need an exception.",
        fr:
            "Cette zone n'est pas ouverte aux réservations publiques avant le {{date}}. Veuillez contacter {{email}} si vous avez besoin d'une exception."
    },
    startTime: {
        en: 'Start Time',
        fr: 'Heure de début'
    },
    endTime: {
        en: 'End Time',
        fr: 'Heure de fin'
    },
    lunchTime: {
        en: 'Lunch',
        fr: 'Déjeuner'
    },
    processor: {
        en: 'Processor',
        fr: 'Transformateur'
    },
    transporter: {
        en: 'Transporter',
        fr: 'Transporteur'
    },
    rescheduleDetails: {
        en: 'Reschedule Details',
        fr: 'Détails de la reprogrammation'
    }
};

const validateErrorTranslations = {
    validate1: {
        en: 'Phone number should consist of 10 digits',
        fr: 'Le numéro de téléphone doit être composé de 10 chiffres'
    },
    validate2: {
        en: 'Invalid e-mail format',
        fr: 'Format de courriel invalide'
    },
    validate3: {
        en: 'Invalid currency format',
        fr: 'Format de devise non valide'
    },
    validate4: {
        en: 'This field is required',
        fr: 'Ce champ est requis'
    },
    validate5: {
        en: 'Password should be at least {{chars}} characters long',
        fr: 'Le mot de passe doit comporter au moins {{chars}} caractères'
    },
    validate6: {
        en: 'Password should not exceed 127 characters',
        fr: 'Le mot de passe ne doit pas dépasser 127 caractères'
    },
    validate7: {
        en: 'Answer should be a combination of 3-25 letters (case insensitive), numbers and/or hyphens.',
        fr:
            'La réponse doit être une combinaison de 3 à 25 lettres (insensible à la case), de chiffres et / ou de traits d’union.'
    },
    validate8: {
        en: 'Answer should only contain letters (case insensitive), numbers and/or hyphens with no spaces.',
        fr:
            'La réponse ne doit contenir que des lettres (insensibles à la case), des chiffres et/ou des traits d’union sans espaces.'
    },
    validate9: {
        en: 'Answer should be a combination of 6-15 letters or numbers.',
        fr: 'La réponse doit être une combinaison de 6 à 15 lettres ou chiffres.'
    },
    validate10: {
        en: 'Answer should only contain letters and numbers with no spaces.',
        fr: 'La réponse ne doit contenir que des lettres et des chiffres sans espaces.'
    },
    validate11: {
        en: 'Must be greater than 0',
        fr: 'Doit être supérieur à 0'
    },
    validate12: {
        en: 'We admire your perseverance, but the maximum number allowed is',
        fr: 'Nous admirons votre persévérance, mais le nombre maximum autorisé est'
    },
    validate13a: {
        en: 'The maximum number allowed is',
        fr: 'Le nombre maximum autorisé est'
    },
    validate13b: {
        en: '{{bagNumber}} more bags needed',
        fr: 'Encore {{bagNumber}} sacs nécessaires'
    },
    validate14: {
        en: 'Invalid number of items',
        fr: 'Nombre d’éléments non valide'
    },
    validate15: {
        en: 'You must be really bored or something. The maximum number allowed is 99',
        fr: 'Vous devez vraiment vous ennuyer. Le nombre maximum autorisé est de 99'
    },
    validate16a: {
        en: 'The maximum number allowed is 99',
        fr: 'Le nombre maximum autorisé est 99'
    },
    validate16b: {
        en: 'Invalid number of bags',
        fr: 'Nombre de sacs non valide'
    },
    validate17: {
        en: 'Invalid weight',
        fr: 'Poids non valide'
    },
    validate18: {
        en: 'Too heavy. Maximum weight is 99 kgs',
        fr: 'Trop lourd. Le poids maximum est de 99 kgs'
    },
    validate19: {
        en: 'Invalid number of units',
        fr: 'Quantité non valide'
    },
    validate20: {
        en: 'Must start with http:// or https://',
        fr: 'Doit commencer par http:// ou https://'
    },
    validate21: {
        en: 'Should be a secure URL starting with https://',
        fr: 'Doit être une URL sécurisée commençant par https://'
    },
    validate22: {
        en: 'Should be at least 1 character long',
        fr: 'Doit comporter au moins 1 caractère'
    },
    validate23: {
        en: 'Should not exceed {{arg}} characters',
        fr: 'Ne doit pas dépasser les caractères {{arg}}'
    },
    validate24: {
        en: 'Should be alphanumeric',
        fr: 'Doit être alphanumérique'
    },
    validate25: {
        en: 'Invalid or missing coordinate',
        fr: 'Coordonnées non valides ou manquantes'
    },
    validate26: {
        en: 'Invalid coordinate',
        fr: 'Corrdonnées invalides'
    },
    validate27: {
        en: 'Should be exactly {{num}} characters',
        fr: 'Doit être exactement {{num}} caractères'
    },
    validate28: {
        en: 'Should be exactly {{num}} digits',
        fr: 'devrait être de {{num}} chiffres'
    },
    validate29: {
        en: 'should only contain digits',
        fr: 'ne doit contenir que des chiffres'
    },
    validate30: {
        en: 'Should be {{num}} digits',
        fr: 'Devrait être {{num}} chiffres'
    },
    validate31: {
        en: 'Limit should be a non-negative numeric value',
        fr: 'La limite doit être une valeur numérique non négative'
    },
    validate32: {
        en: 'Entity not supported',
        fr: 'Entité non prise en charge'
    },
    validate33: {
        en: 'Should be {{numA}}-{{numB}} digits',
        fr: 'Devrait être {{numA}}-{{numB}} chiffres'
    },
    validate34: {
        en: 'Name contains invalid characters',
        fr: 'Le nom contient des caractères invalides'
    },
    validate35: {
        en: 'This must contain a number (e.g. 0-9)',
        fr: 'Celui-ci doit contenir un chiffre (par exemple 0-9)'
    },
    validate36: {
        en: 'This must contain both alphabetic uppercase and lowercase letters (e.g. A-Z, a-z)',
        fr: 'Celui-ci doit contenir à la fois des lettres alphabétiques majuscules et minuscules (par exemple A-Z, a-z)'
    },
    validate37: {
        en: 'This must contain at least one of these special characters ({{{charsStr}}})',
        fr: 'Celui-ci doit contenir au moins un de ces caractères spéciaux({{{charsStr}}})'
    },
    validate38: {
        en: 'Password must contain at least {{charsMin}} characters',
        fr: 'Le mot de passe doit contenir au moins {{charsMin}} caractères'
    },
    validate39: {
        en: 'Passwords must match',
        fr: 'Les mots de passe doivent correspondre'
    },
    validate40: {
        en: 'Private relay email address ({{examples}}) are not compatible with e-Transfer services.',
        fr:
            'Les adresses courriel de relais privées ({{examples}}) ne sont pas compatibles avec les services de virement Interac.'
    },
    validate41: {
        en: 'Please double-check to make sure your email address is spelled correctly',
        fr: 'Veuillez vérifier attentivement que votre adresse courriel est correctement orthographiée'
    },
    validate42: {
        en: 'Special characters are not permitted',
        fr: 'Les caractères spéciaux ne sont pas autorisés'
    },
    validate43: {
        en: 'Your security answer may not contain "{{{word}}}"',
        fr: 'Votre réponse de sécurité ne peut pas contenir "{{{word}}}"'
    },
    validate44: {
        en: 'Emojis are not permitted',
        fr: 'Les émojis ne sont pas autorisés'
    },
    validate45: {
        en: 'Must be a numeric value greater than 0, or unset.',
        fr: 'Doit être une valeur numérique supérieure à 0, ou non définie.'
    },
    validate46: {
        en: 'Must be a number greater than 0',
        fr: 'Doit être un nombre supérieur à 0'
    }
};

const labelTranslations = {
    labels1: {
        en: 'Questions/Comments',
        fr: 'Questions/Commentaires'
    },
    labels2: {
        en: 'What describes your issue best?',
        fr: "Qu'est-ce qui décrit le mieux votre problème ?"
    },
    labels3: {
        en: 'Full name',
        fr: 'Nom et prénom'
    },
    labels4: {
        en: 'Question, comment, or concern',
        fr: 'Question, commentaire ou préoccupation'
    },
    labels5: {
        en: 'Shares',
        fr: 'partages'
    },
    labels6: {
        en: "Share {{{charity}}}'s donation link",
        fr: 'Partager le lien de don de {{{charity}}}'
    },
    labels7: {
        en: 'Tips',
        fr: 'Astuces'
    },
    labels8: {
        en: 'Please type {{string}} to confirm',
        fr: 'Veuillez saisir {{string}} pour confirmer'
    },
    labels9: {
        en: 'Unit #',
        fr: '# App'
    },
    labels10: {
        en: '{{organization}} to collect for',
        fr: '{{organisation}} à collecter pour'
    },
    labels11: {
        en: 'Directions/Comments',
        fr: 'Instructions/Commentaires'
    },
    labels12: {
        en: 'New Campaign Name',
        fr: 'Nouveau nom de campagne'
    },
    labels13: {
        en: 'Tax year end date',
        fr: "Date de fin d'année d'imposition"
    },
    labels14: {
        en: 'Confirm Date',
        fr: 'Confirmer la date'
    },
    labels15: {
        en: 'Phone number invalid',
        fr: 'Numéro de téléphone invalide'
    },
    labels16: {
        en: 'First name is required',
        fr: 'Le prénom est requis'
    },
    labels17: {
        en: 'Last name is required',
        fr: 'Le nom de famille est requis'
    },
    labels18: {
        en: 'Bypass Two-Factor Authentication',
        fr: "Contourner l'authentification à deux facteurs"
    },
    labels19: {
        en: 'What area best describes what you are looking for?',
        fr: 'Quel domaine décrit le mieux ce que vous recherchez?'
    },
    labels20: {
        en: 'Any additional details',
        fr: 'Tout détail supplémentaire'
    },
    labels21: {
        en: 'PO Box',
        fr: 'Boîte Postale'
    },
    labels21b: {
        en: 'PO Box #',
        fr: 'Numéro de boîte postale'
    },
    labels22: {
        en: 'Growth Tasks',
        fr: 'Tâches de croissance'
    },
    labels22EXP: {
        en: 'Growth Tips',
        fr: 'Conseils de croissance'
    },
    labels23: {
        en: 'I do business under a different business name',
        fr: "J'ai un nom commercial différent"
    },
    labels23a: {
        en: 'I have a different trading name',
        fr: "J'ai un nom commercial différent"
    },
    labels24: {
        en: 'I have a unit number',
        fr: "J'ai un numéro d'unité"
    },
    labels25: {
        en: 'I have a PO Box',
        fr: "J'ai une boîte postale"
    },
    labels26: {
        en: 'Our agents are here to help you. Please remain respectful.',
        fr: 'Nos agents sont là pour vous aider. Merci de demeurer respectueux.'
    },
    placeholder1: {
        en: 'Enter your address',
        fr: 'Entrez votre adresse'
    },
    placeholder1a: {
        en: 'Enter an address',
        fr: 'Entrez une adresse'
    },
    placeholder2: {
        en: 'optional',
        fr: 'optionnel'
    },
    helperText1: {
        en:
            'Your pickup is scheduled for today and our driver is on their way. If you would like to change your address, please cancel this pickup and reschedule a new one.',
        fr:
            "Votre collecte est prévue pour aujourd'hui et notre chauffeur est en route. Si vous souhaitez modifier votre adresse, veuillez annuler cette collecte et en planifier une nouvelle."
    },
    helperText2: {
        en: 'We pickup from different communities on different days of the week.',
        fr: 'Nous effectuons la collecte dans différentes communautés selon les jours de la semaine.'
    },
    helperText3: {
        en:
            "We will automatically schedule your next pickup for you. Don't worry, we'll remind you again when it comes around! There's no obligation - you can cancel at any time! NOTE: Bottle drives must be booked manually each time.",
        fr:
            "Nous planifierons automatiquement votre prochaine collecte. Ne vous inquiétez pas, nous vous le rappellerons à l'approche de la date! Il n'y a aucune obligation - vous pouvez annuler à tout moment! REMARQUE : Les collectes de bouteilles doivent être réservées manuellement à chaque fois."
    },
    helperText4: {
        en:
            'The following are eligible containers. Please place all containers in large garbage bags and record the number of bags.',
        fr:
            'Les contenants suivants sont éligibles. Veuillez placer tous les contenants dans de grands sacs à ordures et noter le nombre de sacs.'
    },
    helperText5: {
        en: 'Not offered in your area yet.',
        fr: 'Pas encore offert dans votre région.'
    },
    helperText6: {
        en: 'Enter the name of the group or {{organization}} to collect bottles for',
        fr: 'Entrez le nom du groupe ou {{organization}} pour collecter les contenants pour'
    },
    helperText7: {
        en:
            'Looking to fundraise for your charity or sports team? Select this option to upgrade your account into an {{organization}} to start collecting donations from any {{brand}} user!',
        fr:
            "Vous cherchez à collecter des fonds pour votre association caritative ou votre équipe sportive ? Sélectionnez cette option pour mettre à niveau votre compte vers une {{organisation}} afin de commencer à collecter des dons auprès de n'importe quel utilisateur de {{brand}}!"
    }
};

const otherDialogTranslations = {
    confirmDialog1: {
        en: 'Are you sure?',
        fr: 'Êtes-vous certain?'
    },
    confirmDialog2: {
        en: 'Warning: ',
        fr: 'Avertissement:'
    },
    unservicedDialog1: {
        en: 'Pickup request error',
        fr: 'Erreur de demande de collecte'
    },
    unservicedDialog2: {
        en:
            'Unfortunately we are not servicing your area yet! We will be expanding shortly and will inform you when we do.',
        fr:
            'Malheureusement, nous ne desservons pas encore votre région! Nous nous étendrons sous peu et vous informerons lorsque nous le ferons.'
    },
    addressDialog1: {
        en: 'What type of building?',
        fr: 'Quel type de bâtiment?'
    },
    promoCampaign1: {
        en: 'New Campaign',
        fr: 'Nouvelle campagne'
    },
    promoCampaign2: {
        en: 'A campaign with this name already exists',
        fr: 'Une campagne portant ce nom existe déjà'
    },
    promoCampaign3: {
        en: 'Campaign',
        fr: 'Campagne'
    },
    promoInput1: {
        en: 'Only one promo code can be applied at a time.',
        fr: 'Un seul code promotionnel peut être appliqué à la fois.'
    },
    promoInput2: {
        en: 'Select promo to apply',
        fr: 'Sélectionnez la promotion à appliquer'
    },
    promoInput3: {
        en: 'The {{organization}} associated with this promo code must remain featured for it to apply.',
        fr: "L'{{organization}} associée à ce code promotionnel doit rester en vedette pour qu'il s'applique."
    },
    promoInput4: {
        en: `Please update your donation preference`,
        fr: `Veuillez mettre à jour votre préférence d'organisation`
    },
    promoInput5: {
        en: `Using this promo code will change your donation preference to {{{charityName}}}.`,
        fr: `L'utilisation de ce code promotionnel changera votre préférence de don à {{{charityName}}}.`
    },
    promoInput6: {
        en: `This promo code can only be used when donating to {{{charityName}}}. To use this promo code, please update your ${terms.organization.en.toLowerCase()} preference when booking a pickup.`,
        fr: `Ce code promotionnel ne peut être utilisé que lors d'un don à {{{charityName}}}. Pour utiliser ce code promotionnel, veuillez mettre à jour votre préférence d'organisme lors de la réservation d'une collecte.`
    },
    promoInput7: {
        en: `Donate to {{{charityName}}}`,
        fr: `Faire un don à {{{charityName}}}`
    },
    promoInput8: {
        en: `Apply one day event promo code`,
        fr: `Appliquer un code promotionnel d'événement d'un jour`
    },
    promoInput9: {
        en: `This promo code can only be used for pickups scheduled on {{{date}}}. Applying this promo code will automatically adjust your pickup date (if applicable). Would you like to apply this promo code?`,
        fr: `Ce code promotionnel ne peut être utilisé que pour les collectes prévues le {{{date}}}. L'application de ce code promotionnel ajustera automatiquement votre date de collecte (si applicable). Souhaitez-vous appliquer ce code promotionnel?`
    },
    promoInput10: {
        en: `Remove one day event promo code`,
        fr: `Supprimer le code promotionnel de l'événement d'un jour`
    },
    promoInput11: {
        en: `Would you like to remove your promo code for {{{date}}}. If you are in the process of booking a pickup, you will be taken back to the date select screen.`,
        fr: `Souhaitez-vous supprimer votre code promotionnel pour le {{{date}}}? Si vous êtes en train de réserver une collecte, vous serez redirigé vers l'écran de sélection de date.`
    },
    promoWarning1: {
        en: `Warning: This promo is not recurring.`,
        fr: `Attention : Cette promotion n'est pas récurrente.`
    },
    promoWarning2: {
        en: `Warning: This promo will change user's donation preference.`,
        fr: `Attention : Cette promotion modifiera la préférence de don de l'utilisateur.`
    },
    locationSelection1: {
        en: 'Confirm pickup location',
        fr: "Confirmer l'emplacement de collecte"
    },
    locationSelection2: {
        en: 'Drag/Zoom map to adjust red pin',
        fr: "Faites glisser/zoomer la carte pour ajuster l'épingle rouge"
    },
    locationSelection3: {
        en: 'Original Address (Blue pin)',
        fr: "Adresse d'origine (épingle bleue)"
    },
    locationSelection4: {
        en: 'None Selected',
        fr: 'Aucune sélection'
    },
    locationSelection5: {
        en: 'Confirm Location',
        fr: "Confirmer l'emplacement"
    }
};

const feedbackTranslations = {
    complaints1: {
        en: 'How can we help?',
        fr: 'Comment pouvons nous aider?'
    },
    complaints1EXP: {
        en: 'How can we do better?',
        fr: 'Comment pouvons nous faire mieux?'
    },
    complaints2a: {
        en: 'Please choose a category. Select ',
        fr: 'Veuillez choisir une catégorie. Sélectionnez '
    },
    complaints2b: {
        en: 'pickup ',
        fr: 'collecte '
    },
    complaints2c: {
        en: 'to report about the pickup and/or driver, or select ',
        fr: 'pour signaler à propos de la collecte et/ou du chauffeur, ou sélectionner '
    },
    complaints2d: {
        en: 'refund ',
        fr: 'remboursement '
    },
    complaints2e: {
        en: 'to report about your refund value.',
        fr: 'pour signaler la valeur de votre remboursement.'
    },
    complaints3: {
        en: 'Select a category',
        fr: 'Choisissez une catégorie'
    },
    complaints4: {
        en: 'Pickup/Driver problem',
        fr: 'Problème de collecte/chauffeur'
    },
    complaints5: {
        en: 'Refund problem',
        fr: 'Problème de remboursement'
    },
    complaints6: {
        en: 'Generic problem',
        fr: 'Problème général'
    },
    complaints7: {
        en: 'Comment',
        fr: 'Commentaire'
    },
    complaints8: {
        en: 'Go Back',
        fr: 'Retourner'
    },
    complaints9: {
        en: 'Thank you for the feedback. We will get back to you as soon as we can.',
        fr: 'Merci pour votre retour. Nous vous répondrons dès que possible.'
    },
    complaints10: {
        en:
            'Please choose a category. Select the relevant option to report an issue related to service, delivery, or refund.',
        fr:
            'Veuillez choisir une catégorie. Sélectionnez l’option appropriée pour signaler un problème lié au service, à la livraison ou au remboursement.'
    },
    complaints10EXP: {
        en: 'Help us make your Express experience even better.',
        fr: 'Aidez-nous à rendre votre expérience Express encore meilleure.'
    },
    summary1: {
        en: 'You have a donation!',
        fr: 'Vous avez un don!'
    },
    summary2: {
        en: 'You have donated!',
        fr: 'Vous avez fait un don!'
    },
    summary3: {
        en: 'Your refund is ready!',
        fr: 'Votre remboursement est prêt!'
    },
    summary4: {
        en: "Here's what we processed!",
        fr: 'Voici ce que nous avons traité!'
    },
    summary5: {
        en: "Here's what we picked up:",
        fr: 'Voici ce que nous avons ramassé:'
    },
    summary6: {
        en: 'bags of containers',
        fr: 'sacs de contenants'
    },
    summary7: {
        en: 'eligible containers',
        fr: 'contenants éligibles'
    },
    summary8: {
        en: 'non-eligible containers',
        fr: 'contenants non éligibles'
    },
    summary9: {
        en: 'Containers (>1L)',
        fr: 'Contenants (>1L)'
    },
    summary10: {
        en: 'Containers (0-1L)',
        fr: 'Contenants (0-1L)'
    },
    summary11: {
        en: 'Does this look right?',
        fr: 'Êtes-vous satisfait du service de retour?'
    },
    summary11EXP: {
        en: 'How was your experience?',
        fr: 'Vous avez apprécié votre expérience?'
    },
    summary12: {
        en: 'Processed',
        fr: 'Traité'
    },
    summary13: {
        en: 'Donated',
        fr: 'Donné'
    },
    summary14: {
        en: 'Fees:',
        fr: 'Frais:'
    },
    summary15: {
        en: 'Fee',
        fr: 'frais'
    },
    summary16: {
        en: 'Payment processed!',
        fr: 'Paiement traité!'
    },
    summary17: {
        en: 'Balance owing cleared!',
        fr: 'Solde dû réglé!'
    },
    summary18: {
        en: 'Refund',
        fr: 'Remboursement'
    },
    summary19: {
        en: 'Deposit Refund',
        fr: 'Remboursement du dépôt'
    },
    summary20: {
        en: 'Credit Deposited',
        fr: 'Crédit déposé'
    },
    summary21: {
        en: 'Credit Adjusted',
        fr: 'Crédit ajusté'
    },
    summary22: {
        en: 'Your account was adjusted',
        fr: 'Ajustement de crédit déposé'
    },
    summary23: {
        en: 'Credit Donated',
        fr: 'Ajustement de crédit déposé'
    },
    summary24: {
        en: 'Has been added to your account balance',
        fr: 'A été ajouté à votre solde de compte'
    },
    summary25: {
        en: 'Has been removed from your account balance',
        fr: 'A été retiré de votre solde de compte'
    },
    summary26: {
        en: 'Has been donated from your account balance',
        fr: 'A été donné à partir du solde de votre compte'
    },
    summary27: {
        en: 'Credit Adjustment',
        fr: 'Ajustement de crédit'
    },
    summary28: {
        en: 'Donation',
        fr: 'Donation'
    },
    feedback1: {
        en: 'How did we do?',
        fr: 'Comment avons-nous fait?'
    },
    feedback2: {
        en: 'Was the driver on time?',
        fr: "Le chauffeur était-il à l'heure?"
    },
    feedback3: {
        en: 'Did the driver leave bags?',
        fr: 'Le chauffeur a-t-il laissé des sacs?'
    },
    feedback3a: {
        en: 'Did the driver swap bins?',
        fr: 'Le chauffeur a-t-il échangé les bacs?'
    },
    feedback4: {
        en: 'Was the driver professional?',
        fr: 'Le chauffeur était-il professionnel?'
    },
    feedback5: {
        en: 'Want to leave a comment for your driver?',
        fr: 'Vous souhaitez laisser un commentaire à votre chauffeur?'
    },
    feedback6: {
        en: 'Select feedback type',
        fr: 'Sélectionnez le type de commentaires'
    },
    feedback7: {
        en: 'Compliment',
        fr: 'Compliment'
    },
    feedback8: {
        en: 'Complaint',
        fr: 'Plainte'
    },
    feedback9: {
        en: 'Say thanks with a tip!',
        fr: 'Dites merci avec un pourboire!'
    },
    feedback10: {
        en: 'Submit Feedback',
        fr: 'Soumettre des commentaires'
    },
    feedback11: {
        en: 'Submit Feedback With Tip',
        fr: 'Soumettre des commentaires avec un pourboire'
    },
    feedback12: {
        en: 'Tips are not mandatory, simply a way to extend gratitude.',
        fr: "Les pourboires ne sont pas obligatoires, simplement un moyen d'exprimer sa gratitude."
    },
    feedback13: {
        en: 'Other',
        fr: 'Autre'
    },
    feedback14: {
        en: 'Tip Amount',
        fr: 'Montant du pourboire'
    },
    feedback15: {
        en: 'Leave a compliment',
        fr: 'Laisser un compliment'
    },
    feedback16: {
        en: 'Leave a complaint',
        fr: 'Laisser une plainte'
    }
};

const FAQTranslations = {
    'faq-residential': !isMXDRegion()
        ? {
              en: 'Residential, Business & Commercial',
              fr: 'Résidentiel, commercial ou institutionnel'
          }
        : {
              en: 'Bag Drops and Commercial pickups',
              fr: 'Retours express et Collecte commerciale'
          },
    'faq-charity': {
        en: 'Charity & {{organizationName}} Fundraising',
        fr: 'Collecte de fonds pour organismes de bienfaisance'
    },
    'faq-bottleDepot': {
        en: 'Bottle Depots & Mobile Recycling',
        fr: 'Récupérateur de contenants consignés & autres matières recyclabes'
    },
    'faq-tab-residential': !isMXDRegion()
        ? {
              en: 'Residential',
              fr: 'Résidentiel'
          }
        : {
              en: 'Bag Drop',
              fr: 'Dépôts de sacs'
          },
    'faq-tab-commercial-business': {
        en: 'Commercial & Business',
        fr: 'Collecte Commerciale'
    },
    'faq-tab-charities': {
        en: 'Charities',
        fr: 'Organisme de bienfaisance'
    },
    'faq-tab-fundraising-bottle-drives': {
        en: 'Fundraising & Bottle Drives',
        fr: 'Collecte de fonds et collecte de contenants'
    },
    'faq-tab-bottle-depot': {
        en: 'Bottle Depot',
        fr: 'Récupérateur de contenants consignés'
    },
    'faq-tab-mobile-recycling': {
        en: 'Mobile Recycling',
        fr: 'Recyclage mobile'
    }
};

const customerSiteSnackbarTranslations = {
    customerSnackBar1: {
        en: 'You do not have permissions to view customer accounts',
        fr: "Vous n'êtes pas autorisé à afficher les comptes clients"
    },
    customerSnackBar2: {
        en: 'You do not have permissions to view {{organization}} accounts',
        fr: "Vous n'êtes pas autorisé à afficher les comptes {{organization}}"
    },
    customerSnackBar3: {
        en: 'Your donation preference has been set to {{{charity}}}.',
        fr: 'Votre préférence de don a été définie sur {{{charity}}}.'
    },
    customerSnackBar4: {
        en: 'Something went wrong, please try again.',
        fr: "Une erreur s'est produite. Veuillez réessayer."
    },
    customerSnackBar5: {
        en: 'You have postponed your pickup.',
        fr: 'Vous avez reporté votre collecte.'
    },
    customerSnackBar6: {
        en: 'Your pickup was successfully edited!',
        fr: 'Votre collecte a été modifiée avec succès!'
    },
    customerSnackBar7: {
        en: 'You have requested a pickup!',
        fr: 'Vous avez demandé une collecte!'
    },
    customerSnackBar8: {
        en: 'Thank you for your feedback!',
        fr: 'Merci pour votre avis!'
    },
    customerSnackBar9: {
        en: 'Your pickup has been confirmed!',
        fr: 'Votre collecte a été confirmée!'
    },
    customerSnackBar10: {
        en: 'Your donation preference has been updated!',
        fr: 'Votre préférence de don a été mise à jour!'
    },
    customerSnackBar11: {
        en: 'Thanks for giving us a share!',
        fr: 'Merci de partager!'
    },
    customerSnackBar12: {
        en: 'You are not authorized to view this page. Parameters:',
        fr: "Vous n'êtes pas autorisé à afficher cette page. Paramètres:"
    },
    customerSnackBar13: {
        en:
            'Thank you for submitting a ticket. A member of our Customer Relations team will get back to you within two business days.',
        fr:
            "Merci d'avoir soumis un ticket. Un membre de notre équipe des relations avec la clientèle vous répondra dans les deux jours ouvrables."
    },
    customerSnackBar14: {
        en: 'Something went wrong submitting your feedback. Please try again.',
        fr: "Une erreur s'est produite lors de la soumission de vos commentaires. Veuillez réessayer."
    },
    quickDropSnackBar1: {
        en: `Successfully submitted {{{type}}}`,
        fr: `Soumis`
    },
    quickDropSnackBar2: {
        en: `Error submitting {{{type}}}`,
        fr: `Erreur`
    },
    quickDropSnackBar3: {
        en: `Successfully created booking.`,
        fr: `Soumis`
    },
    quickDropSnackBar4: {
        en: `Error submitting booking.`,
        fr: `Erreur`
    },
    quickDropSnackBar5: {
        en: `Successfully updated return site preference.`,
        fr: `Soumis`
    },
    quickDropSnackBar6: {
        en: `Error updating return site preference.`,
        fr: `Erreur`
    },
    quickdropInstructionsStep: {
        en: `Instructions`,
        fr: `Instructions`
    },
    quickdropInstructionsStep1: {
        en: `Please follow the instructions below to use the`,
        fr: `Veuillez suivre les instructions ci-dessous pour utiliser la`
    },

    openAccessDoorStep: {
        en: 'Open Access Door',
        fr: `Ouvrir la porte d'accès`
    },
    quickdropPayloadStep: {
        en: `Recyclables`,
        fr: `Produits recyclables`
    },
    quickdropPictureConfirmationStep: {
        en: `Confirmation`,
        fr: `Confirmation`
    },
    quickdropDonationStep: {
        en: `Donation`,
        fr: `Don`
    },
    quickdropQRPrintStep: {
        en: `Print Label`,
        fr: `Imprimer l'autocollant`
    },
    quickdropQRScanStepStep: {
        en: `Scan Label`,
        fr: `Numériser l'autocollant`
    },
    quickdropNoLocationFound: {
        en: `No {{technology}} Location Available`,
        fr: `Aucun emplacement {{technology}} disponible`
    },
    copyClipSnackBar: {
        en: `{{href}} copied to your clipboard.`,
        fr: `Copié`
    },
    appOnly: {
        en: 'App',
        fr: 'Application'
    },
    kiosk: { en: 'Kiosk', fr: 'Lieux de retour' },
    kioskAndScanner: { en: 'Kiosk & Scanner', fr: 'Lieux de retour et scanner' },
    accessDoor: { en: 'Access Door', fr: `Porte d'acces` },
    reverseVendingMachine: { en: 'Reverse Vending Machine', fr: 'Machine récupératrice à l’unité' },
    primaryReturnSite: { en: 'Primary Return Site', fr: 'Lieu de retour principal' },
    returnSiteLookup: { en: 'Return Site Lookup', fr: 'Lieux de retour' }
};

const binRequestDialogTranslations = {
    binRequest1: {
        en: 'Looking to order rolling bins?',
        fr: 'Vous souhaitez commander des bacs roulants ?'
    },
    binRequest2: {
        en:
            'Let us know what type of bins and how many you need below. Depending on the bins there may be additional charges applied for the service.',
        fr:
            "Faites-nous savoir ci-dessous quel type de bacs et combien vous avez besoin. Selon les bacs, des frais supplémentaires peuvent s'appliquer pour le service."
    },
    binRequest3: {
        en: "No, Don't need bins",
        fr: 'Non, pas besoin de bacs'
    },
    binRequest4: {
        en: 'Yes, I want bins',
        fr: 'Oui, je veux des bacs'
    },
    binRequest5: {
        en: 'Request Bins',
        fr: 'Demander des bacs'
    },
    binRequest6: {
        en: 'Request for bins attached',
        fr: 'Demande de bacs ci-jointe'
    }
};

const commodityRequestDialogTranslations = {
    commodityRequestDialog1: {
        en: 'Need bags or bins?',
        fr: 'Besoin de sacs ou de poubelles ?'
    },
    commodityRequestDialog2: {
        en: 'Certain equipment may incur one-time and recurring fees',
        fr: 'Certains équipements peuvent entraîner des frais ponctuels et récurrents'
    },
    commodityRequestDialog3: {
        en: 'You have a request pending',
        fr: 'Vous avez une demande en attente'
    },
    commodityRequestDialog4: {
        en: 'Update Request',
        fr: 'Mettre à jour la demande'
    },
    commodityRequestDialog5: {
        en: 'Your request has been submitted',
        fr: 'Votre demande a été soumise'
    },
    commodityRequestDialog6: {
        en: 'Request attached',
        fr: 'La demande est jointe'
    },
    commodityRequestDialog7: {
        en: 'Request pending',
        fr: 'La demande est en attente'
    },
    commodityRequestDialogError1: {
        en: 'Please enter a value from {{min}}-{{max}}',
        fr: 'Veuillez saisir une valeur comprise entre {{min}} et {{max}}'
    },
    commodityRequestDialogError2: {
        en: 'Error submitting request',
        fr: "Erreur lors de l'envoi de la demande"
    }
};

const updateDialogTranslations = {
    updateDialog1: {
        en: 'We have introduced important changes that require you to update to the latest version of the app.',
        fr:
            "Nous avons introduit des changements importants qui vous obligent à mettre à jour la dernière version de l'application."
    },
    updateDialog2: {
        en: 'Please refresh the page to continue.',
        fr: 'Veuillez actualiser la page pour continuer.'
    },
    updateDialog3: {
        en: 'Please update through Google Play to continue.',
        fr: 'Veuillez mettre à jour via Google Play pour continuer'
    },
    updateDialog4: {
        en: 'Please update through the App Store to continue.',
        fr: "Veuillez mettre à jour via l'App Store pour continuer."
    },
    updateDialog5: {
        en: "If that doesn't work you can use our web app at",
        fr: "Si cela ne fonctionne pas, vous pouvez utiliser notre application Web à l'adresse {{{url}}}"
    },
    updateDialog6: {
        en: 'Your current version: {{version}}',
        fr: 'Votre version actuelle : {{version}}'
    },
    updateDialog7: {
        en: 'Update required',
        fr: 'Mise à jour requise'
    },
    redeemError: {
        en: 'Cash out type invalid',
        fr: ''
    }
};

const mapMarkerTranslations = {
    mapMarker1: {
        en: 'Check back later for driver ETA',
        fr: "Vérifiez plus tard pour l'heure d'arrivée prévue du chauffeur"
    },
    mapMarker2: {
        en: "You're next! {{name}} will arrive around {{time}}",
        fr: 'Vous êtes le prochain! {{name}} arrivera vers {{time}}'
    },
    mapMarker3: {
        en: "You're next! {{name}} will pick up your bags soon!",
        fr: 'Vous êtes le prochain! {{name}} va bientôt récupérer vos contenants!'
    },
    mapMarker4: {
        en: '{{name}} will arrive between 8:00 AM and 5:30 PM',
        fr: '{{name}} arrivera entre 8h00 et 17h30'
    },
    mapMarker5: {
        en: '{{name}} will arrive at {{time}}',
        fr: '{{name}} arrivera à {{time}}'
    },
    mapMarker6: {
        en: '{{name}} will arrive between {{minEtaTime}} and {{maxEtaTime}}',
        fr: '{{name}} arrivera entre {{minEtaTime}} et {{maxEtaTime}}'
    }
};
const OOSPresetTranslations = {
    OOSPresetSave: {
        en: 'Save Preset',
        fr: 'Save Preset'
    },
    OOSPresetLoad: {
        en: 'Use Preset',
        fr: 'Use Preset'
    },
    OOSNoPreset: {
        en: 'No Preset Saved',
        fr: 'No Preset Saved'
    }
};

const informationFormsTranslations = {
    icon: {
        en: 'Icon',
        fr: 'Icône'
    },
    question: {
        en: 'Question',
        fr: 'Question'
    },
    answer: {
        en: 'Answer',
        fr: 'Réponse'
    },
    title: {
        en: 'Title',
        fr: 'Titre'
    },
    contactEmail: {
        en: 'Contact Email',
        fr: 'Courriel du contact'
    },
    terms: {
        en: 'Terms',
        fr: 'Termes'
    },
    privacy: {
        en: 'Privacy',
        fr: 'Confidentialité'
    },
    issueType: {
        en: 'Issue Type',
        fr: 'Type de Probleme'
    },
    primaryText: {
        en: 'Primary Text',
        fr: 'Texte Principal'
    },
    secondaryText: {
        en: 'Secondary Text',
        fr: 'Texte Secondaire'
    }
};
const reviewUsersTranslations = {
    AUDIT_TYPE_BAGCOUNT: {
        en: 'Bag Difference',
        fr: 'Bag Difference'
    },
    AUDIT_TYPE_DRIVERCOMPLAINT: {
        en: 'Driver Complaint',
        fr: 'Driver Complaint'
    },
    AUDIT_TYPE_COUNTERCOMPLAINT: {
        en: 'Counter Complaint',
        fr: 'Counter Complaint'
    },
    AUDIT_TYPE_AVGCONTAINERCOUNT: {
        en: 'Abnormal Container Numbers',
        fr: 'Abnormal Container Numbers'
    },
    AUDIT_TYPE_AMOUNTDIFFERENCE: {
        en: 'Counting Threshold',
        fr: 'Counting Threshold'
    },
    AUDIT_TYPE_LOSTBAGS: {
        en: 'Lost Bags Threshold',
        fr: 'Lost Bags Threshold'
    },
    AUDIT_TYPE_PRINTEDLABELS: {
        en: 'Max Printed Labels',
        fr: 'Max Printed Labels'
    },
    AUDIT_TYPE_REDEMPTIONAMOUNT: {
        en: 'Redemption Threshold',
        fr: 'Redemption Threshold'
    },
    AUDIT_TYPE_REDEMPTIONEMAIL: {
        en: 'Redemption Email',
        fr: 'Redemption Email'
    },
    AUDIT_TYPE_SAMEIPADDRESS: {
        en: 'IP Address',
        fr: 'IP Address'
    },
    AUDIT_TYPE_SAMEDEVICEID: {
        en: 'Device Id',
        fr: 'Device Id'
    },
    AUDIT_TYPE_HAZARDOUS: {
        en: 'Clerk Hazardous Complaint',
        fr: 'Clerk Hazardous Complaint'
    },
    AUDIT_TYPE_GARBAGE: {
        en: 'Clerk Garbage Complaint',
        fr: 'Clerk Garbage Complaint'
    },
    AUDIT_TYPE_BULK_SUBMISSION_APPROVAL: {
        en: 'Clerk Submission',
        fr: 'Clerk Submission'
    },
    AUDIT_TYPE_MANUAL_ADDRESS_VERIFICATION: {
        en: 'Manual Address Verification',
        fr: `Vérification manuelle d'adresse`
    },
    AUDIT_TYPE_DECLARATION_VERIFICATION: {
        en: 'Refund Declaration Verification',
        fr: 'Vérification de déclaration de remboursement'
    },
    AUDIT_TYPE_DRIVER_GPS_OVERRIDE_APPROVAL: {
        en: 'Driver GPS Override Approval',
        fr: 'Approbation de contournement GPS du chauffeur'
    },
    AUDIT_TYPE_DEPOSIT_CONFIGURATION_ERROR: {
        en: 'Deposit Configuration Conflict Error',
        fr: 'Deposit Configuration Conflict Error'
    },
    AUDIT_TYPE_MISSING_SUPER_GROUP_ERROR: {
        en: 'Invalid Supergroup Error',
        fr: 'Invalid Supergroup Error'
    },
    AUDIT_TYPE_MISSING_COLLECTOR_ERROR: {
        en: 'Invalid Bagtag Error',
        fr: 'Invalid Bagtag Error'
    },
    AUDIT_TYPE_POTENTIAL_DUPLICATE: {
        en: 'Duplicate Order Data',
        fr: 'Duplicate Order Data'
    },
    AUDIT_TYPE_INVALID_CHARITY_ERROR: {
        en: 'Invalid Charity Error',
        fr: 'Invalid Charity Error'
    },
    AUDIT_TYPE_MISSING_TECHNOLOGY_ERROR: {
        en: 'Technology Missing Error',
        fr: 'Technology Missing Error'
    },
    AUDIT_TYPE_BULK_RATES_ERROR: {
        en: 'Bulk Rates Error',
        fr: 'Bulk Rates Error'
    },
    AUDIT_TYPE_BULK_API_ERROR: {
        en: 'API Count Error',
        fr: 'API Count Error'
    },
    AUDIT_TYPE_BULK_TIME_WINDOW_ERROR: {
        en: 'Time Window Error',
        fr: 'Time Window Error'
    },
    AUDIT_TYPE_BULK_THRESHOLD_ERROR: {
        en: 'Count Limit Reached',
        fr: 'Count Limit Reached'
    },
    AUDIT_TYPE_PAYMENT_API_ERROR: {
        en: 'API Payment Error',
        fr: 'API Payment Error'
    },
    AUDIT_TYPE_BAGTAG_SELECTION_ERROR: {
        en: 'Invalid Driver Label Error',
        fr: 'Invalid Driver Label Error'
    },
    AUDIT_TYPE_BULK_QUEUE_ERROR: {
        en: 'Bulk Queue Error',
        fr: 'Bulk Queue Error'
    },
    AUDIT_TYPE_2FA_ERROR: {
        en: '2FA Error',
        fr: '2FA Error'
    },
    AUDIT_TYPE_CRON_TASK_ERROR: {
        en: 'Failed CRON Task Error',
        fr: 'Failed CRON Task Error'
    },
    AUDIT_TYPE_ACCOUNT_LOCKOUT: {
        en: 'Account Lockout',
        fr: 'Account Lockout'
    },
    AUDIT_TYPE_CUSTOMER_ACCOUNT_CLOSED: {
        en: 'Customer Account Closure',
        fr: 'Customer Account Closure'
    },
    AUDIT_TYPE_CUSTOMER_ACCOUNT_DELETED: {
        en: 'Customer Account Deletion',
        fr: 'Customer Account Deletion'
    },
    AUDIT_TYPE_PICKUP_CANCELLED: {
        en: 'Pickup Cancellation',
        fr: 'Pickup Cancellation'
    },
    AUDIT_TYPE_PICKUP_ABORTED: {
        en: 'Pickup Abortion',
        fr: 'Pickup Abortion'
    },
    AUDIT_TYPE_CUSTOMER_COMPLAINT: {
        en: 'Customer Complaint',
        fr: 'Customer Complaint'
    },
    AUDIT_TYPE_COUNTS_COMPLAINT: {
        en: 'Counts Complaint',
        fr: 'Counts Complaint'
    },
    AUDIT_TYPE_PICKUPS_COMPLAINT: {
        en: 'Pickups Complaint',
        fr: 'Pickups Complaint'
    },
    AUDIT_TYPE_PAYMENTS_COMPLAINT: {
        en: 'Payments Complaint',
        fr: 'Payments Complaint'
    },
    AUDIT_CATEGORY_INFRACTIONS: {
        en: 'Infractions',
        fr: 'Infractions'
    },
    AUDIT_CATEGORY_APPROVALS: {
        en: 'Approvals',
        fr: 'Approvals'
    },
    AUDIT_CATEGORY_ERRORS: {
        en: 'Errors',
        fr: 'Errors'
    },
    AUDIT_CATEGORY_ATTRITION: {
        en: 'Customer Attrition',
        fr: 'Customer Attrition'
    },
    AUDIT_CATEGORY_COMPLAINTS: {
        en: 'Complaints',
        fr: 'Complaints'
    },
    AUDIT_CATEGORY_INFRACTIONS_SINGULAR: {
        en: 'Infraction',
        fr: 'Infraction'
    },
    AUDIT_CATEGORY_APPROVALS_SINGULAR: {
        en: 'Approval',
        fr: 'Approval'
    },
    AUDIT_CATEGORY_ERRORS_SINGULAR: {
        en: 'Error',
        fr: 'Error'
    },
    AUDIT_CATEGORY_ATTRITION_SINGULAR: {
        en: 'Customer Attrition',
        fr: 'Customer Attrition'
    },
    AUDIT_CATEGORY_COMPLAINTS_SINGULAR: {
        en: 'Complaint',
        fr: 'Complaint'
    },
    AUDIT_TYPE_BAGCOUNT_hoverText: {
        en:
            'Max. permitted difference: {{{maxDifference}}} {{{direction}}}, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. permitted difference: {{{maxDifference}}} {{{direction}}}, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_DRIVERCOMPLAINT_hoverText: {
        en:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_COUNTERCOMPLAINT_hoverText: {
        en:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_AMOUNTDIFFERENCE_hoverText: {
        en:
            'Max per bag difference (%): {{{maxPercentDifference}}} ({{{percentDirection}}}), Max per bag difference ($): {{{bagTotalThreshold}}} ({{{bagTotalDirection}}}), Max order difference ($): {{{maxOrderDifference}}} ({{{totalDirection}}}), Default/bag: {{{defaultPerBagAmount}}}, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max per bag difference (%): {{{maxPercentDifference}}} ({{{percentDirection}}}), Max per bag difference ($): {{{bagTotalThreshold}}} ({{{bagTotalDirection}}}), Max order difference ($): {{{maxOrderDifference}}} ({{{totalDirection}}}), Default/bag: {{{defaultPerBagAmount}}}, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_PRINTEDLABELS_hoverText: {
        en:
            'Max. labels: {{{maxLabels}}}, Time window: {{{timeWindow}}} days, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. labels: {{{maxLabels}}}, Time window: {{{timeWindow}}} days, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_REDEMPTIONAMOUNT_hoverText: {
        en: 'Max. amount: {{{maxAmount}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}',
        fr: 'Max. amount: {{{maxAmount}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}'
    },
    AUDIT_TYPE_SAMEIPADDRESS_hoverText: {
        en:
            'Ignore: {{{ignoreIPs}}}, Only check current: {{{onlyCheckCurrentLoginIP}}}, All account types: {{{checkBetweenAllAccountTypes}}}, Severity: {{{state}}}',
        fr:
            'Ignore: {{{ignoreIPs}}}, Only check current: {{{onlyCheckCurrentLoginIP}}}, All account types: {{{checkBetweenAllAccountTypes}}}, Severity: {{{state}}}'
    },
    AUDIT_TYPE_HAZARDOUS_hoverText: {
        en:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_GARBAGE_hoverText: {
        en:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. permitted complaints: {{{maxComplaints}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    AUDIT_TYPE_LOSTBAGS_hoverText: {
        en:
            'Max. orders with lost bags: {{{ordersThreshold}}}, Max. lost bags: {{{totalThreshold}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}',
        fr:
            'Max. orders with lost bags: {{{ordersThreshold}}}, Max. lost bags: {{{totalThreshold}}}, Time window: {{{timeWindow}}} months, Severity: {{{state}}}, Applicable commodities: {{{commodities}}}'
    },
    resolve: {
        en: 'Resolve',
        fr: 'Resolve'
    },
    unresolve: {
        en: 'Unresolve',
        fr: 'Unresolve'
    },
    resolveAll: {
        en: 'Resolve All',
        fr: 'Resolve All'
    },
    unresolveAll: {
        en: 'Unresolve All',
        fr: ''
    },
    resolved: {
        en: 'Resolved',
        fr: 'Une plainte réglée'
    },
    unresolved: {
        en: 'Unresolved',
        fr: 'Une plainte non réglée'
    }
};
const PORScreenTranslations = {
    no_dont_exist: {
        en: "No, they don't exist",
        fr: "No, they don't exist"
    },
    delete_image: {
        en: 'Are you sure you want to remove this image?',
        fr: 'Êtes-vous sûr de vouloir supprimer cette image?'
    },
    findOrder: {
        en: 'Find Order',
        fr: 'Trouver la commande'
    },
    processBag: {
        en: 'Process Bag',
        fr: 'Traiter le sac'
    },
    newOrder: {
        en: 'New Order',
        fr: 'Nouvelle commande'
    },
    showFilters: {
        en: 'Show Filters',
        fr: 'Afficher les filtres'
    },
    hideFilters: {
        en: 'Hide Filters',
        fr: 'Masquer les filtres'
    },
    overrideCode: {
        en: 'Override Code',
        fr: 'Remplacer le code'
    },
    overdueIssues: {
        en: 'Overdue & Issues',
        fr: 'Retards et problèmes'
    },
    noMatchingOrdersFound: {
        en: 'No matching orders found',
        fr: 'Aucune commande correspondante trouvée'
    },
    noMatchingLabelsFound: {
        en: 'No matching labels found',
        fr: 'Aucune étiquette correspondante trouvée'
    },
    orderSearch: {
        en: 'Order Search',
        fr: 'Recherche de commande'
    },
    showingXOfTotal: {
        en: 'Showing {{{visibleTotal}}} of {{{total}}}',
        fr: 'Affichage de {{{visibleTotal}}} sur {{{total}}}'
    },
    numTotal: {
        en: '{{{total}}} Total',
        fr: '{{{total}}} au total'
    },
    loading: {
        en: 'Loading...',
        fr: 'Chargement...'
    },
    showingLastXHours: {
        en: 'Showing last {{{numHours}}} hours',
        fr: 'Affichage des {{{numHours}}} dernières heures'
    },
    redeemedByCustomer: {
        en: 'Redeemed by the customer',
        fr: 'Échangé par le client'
    },
    forOwnerOnDate: {
        en: 'For {{{owner}}}. on {{{date}}}',
        fr: 'Pour {{{owner}}}. le {{{date}}}'
    },
    receivedByOwnerOnDate: {
        en: 'Received by {{{owner}}} on {{{date}}}',
        fr: 'Reçu par {{{owner}}} le {{{date}}}'
    },
    countedOn: {
        en: 'Counted on {{{date}}}',
        fr: 'Compté le {{{date}}}'
    },
    notCountedYet: {
        en: 'Not counted yet',
        fr: 'Pas encore compté'
    },
    orderRedeemed: {
        en: 'This order was redeemed by the customer and can no longer be edited/counted',
        fr: 'Cette commande a été échangée par le client et ne peut plus être modifiée ou comptabilisée'
    },
    clearBin: {
        en: 'Please clear the {{{binText}}} bin!',
        fr: 'Veuillez vider le bac en {{{binText}}}!'
    },
    deleteOrderConfirmation: {
        en: 'Are you sure you want to cancel this order? This cannot be undone.',
        fr: 'Êtes-vous certain de vouloir annuler cette commande ? Cette action est irréversible.'
    },
    customerPaymentAmount: { en: 'Customer Payment Amount', fr: 'Montant du paiement du client' },
    customerPayment: {
        en: 'Customer Account Adjustment',
        fr: 'Ajustement du compte client'
    },
    orderFor: {
        en: 'Order for {{{customerName}}}',
        fr: 'Commande pour {{{customerName}}}'
    },
    findOrCreateCustomer: {
        en: 'Find or Create Customer',
        fr: 'Trouver ou créer un client'
    },
    linkCustomerMsg: {
        en:
            'Enter in either the unique customer ID, email, or phone number to link to a customer or an email address to create a new account.',
        fr:
            'Entrez soit l’identifiant client unique, le courriel ou le numéro de téléphone pour lier un client existant, ou un courriel pour créer un nouveau compte.'
    },
    IDEmailPhone: { en: 'ID/Email/Phone', fr: 'ID/Courriel/Téléphone' },
    noCustomerLinked: {
        en: 'No Customer Linked',
        fr: 'Aucun client lié'
    },
    unlinkCustomerMsg: {
        en: 'You are about to remove this customer from this order. Do you wish to continue?',
        fr: 'Vous êtes sur le point de supprimer ce client de cette commande. Voulez-vous continuer ?'
    },
    totalDonation: {
        en: 'Total Donation',
        fr: 'Don total'
    },
    donationForCashMsg: {
        en: 'Donations are only available for eTranfers, the order will no longer be donated.',
        fr: 'Les dons ne sont disponibles que pour le virement électronique, la commande ne sera plus donnée.'
    },
    linkAccountForETransfer: {
        en: 'Please link account or enter email to e-Transfer.',
        fr: 'Veuillez lier votre compte ou entrer votre adresse courriel pour le virement.'
    },
    enterEmail: {
        en: 'Enter Email',
        fr: 'Entrez le courriel'
    },
    emailForReceipt: {
        en: 'Enter an optional email for receipt',
        fr: 'Entrez une adresse courriel facultative pour la réception'
    },
    invalidEmail: {
        en: 'invalid email',
        fr: 'Courriel invalide'
    },
    attachCustomerSuccess: {
        en: 'Successfully attached a customer to this bulk!',
        fr: 'Un client a été associé avec succès à ce groupe.'
    },
    detachCustomerSuccess: {
        en: 'Successfully detached a customer from this bulk!',
        fr: 'Un client de ce groupe a été détaché avec succès'
    },
    payCash: { en: 'Pay Cash', fr: 'Payer comptant' },
    createOrder: { en: 'Create Order', fr: 'Créer une commande' },
    userWantsToDonate: { en: 'User wants to donate', fr: "L'utilisateur veut faire un don" },
    pleaseSelectOrganization: { en: 'Please Select an Organization', fr: 'Veuillez choisir une organisation' },
    existingCustomerIDEmailPhone: {
        en: 'Existing Customer ID, Email, or Phone',
        fr: 'ID client, courriel, ou téléphone existant'
    },
    reopenOrderMsg: {
        en: 'You are about to re-open this bulk and notify the customer. Are you sure you want to do this?',
        fr: "Vous êtes sur le point de rouvrir ce lot et d'avertir le client. Êtes-vous certain de vouloir le faire ?"
    },
    loadingOrder: {
        en: 'Loading Order...',
        fr: 'Chargement de la commande...'
    },
    walkinOrderCreateInfo: {
        en:
            'Only enter in their customer information if they have an existing account, creation of a new account can be done after the order is counted.',
        fr:
            "Entrez seulement vos informations client s'ils ont un compte existant. La création d'un nouveau compte peut être effectuée une fois la commande comptabilisée."
    },
    unlinkPORDeviceMsg: {
        en:
            'Are you sure you want to reset link for this device? You will need to enter a valid link code to login again.',
        fr:
            'Voulez-vous vraiment réinitialiser le lien pour cet appareil ? Vous devrez entrer un code de lien valide pour vous reconnecter.'
    },
    unlinkPORDeviceMsg2: {
        en: 'You are currently linked to {{{collectorName}}}',
        fr: 'Vous êtes actuellement lié à {{{collectorName}}}'
    },
    resetLink: {
        en: 'Reset Link',
        fr: 'Réinitialiser le lien'
    },
    linkCode: { en: 'Link Code', fr: 'Code de lien' },
    createdNewOrder: { en: 'Created new order!', fr: 'Nouvelle commande créée !' },
    orderDeletedMsg: { en: 'Order was successfully deleted!', fr: 'La commande a été retirée avec succès!' },
    reportWarningMsg: {
        en:
            'The report has been updated to include {{{nonConformantIssueText}}}. Please make sure you have an image selected and submit this form once completed.',
        fr:
            'Le rapport a été mis à jour pour inclure {{{nonConformantIssueText}}}. Veuillez sélectionner une image et soumettre ce formulaire une fois rempli.'
    },
    selectAllApply: { en: 'Select all that apply', fr: "Sélectionnez tout ce qui s'applique" },
    uploadPhoto: { en: 'Upload photo', fr: 'Télécharger une photo' },
    uploadIneligiblePhotoMsg: {
        en: 'Upload or take a photo to provide information about the hazard and/or ineligible containers.',
        fr:
            'Téléchargez ou prenez une photo pour fournir des renseignements sur le danger et/ou les contenants non éligibles.'
    },
    reportDisplayToMsg: {
        en: 'This will be displayed to the {{{reportType}}}.',
        fr: 'Ceci sera affiché dans le {{{reportType}}}.'
    },
    countDeleteConfirmMsg: {
        en: 'Are you sure you want to delete {{{itemName}}} from the counts?',
        fr: 'Êtes-vous certain de vouloir supprimer {{{itemName}}} des décomptes ?'
    },
    refundProcessed: { en: 'Refund Processed', fr: 'Remboursement traité' },
    refundDialogMsg: { en: 'Refund has been issued successfully', fr: 'Le remboursement a été émis avec succès' },
    transactionSummary: { en: 'Transaction Summary', fr: 'Résumé de la transaction' },
    refundDialogType1: {
        en: 'Refund Type:',
        fr: 'Type de remboursement:'
    },
    refundDialogType2: {
        en: 'Digital Payment / Cash',
        fr: 'Paiement numérique / Argent comptant'
    },
    refundDialogAmount: { en: 'Refund Amount:', fr: 'Montant du remboursement:' },
    refundDialogCustomer: { en: 'Customer:', fr: 'Client:' },
    linkLocationCode: { en: 'Link Location Code', fr: 'Code de Localisation' },
    linkLocationDescription: {
        en: 'Please enter your location code to configure this location.',
        fr: 'Veuillez entrer votre code de localisation pour configurer cet emplacement.'
    },
    transactionID: { en: 'Transaction ID', fr: 'ID de transaction' },
    createNewCustomerMsg: {
        en: 'No customer account exists with this email, create new customer account with this email?',
        fr: "Aucun compte client n'existe avec ce courriel, créer un nouveau compte client avec ce courriel ?"
    },
    printerStatusTitle: {
        en: 'Printer Issue Detected',
        fr: "Problème d'imprimante détecté"
    },
    printerStatusNotConnected: {
        en: 'Printer disconnected. Please check the power and cable connection.',
        fr: "L'imprimante n'est pas connectée. Assurez-vous qu'elle est allumée et vérifiez le câble de l'imprimante."
    },
    printerStatusCoverOpen: {
        en: 'Printer cover open. Please close it to resume printing.',
        fr: "Le couvercle de l'imprimante est ouvert. Veuillez le fermer pour continuer."
    },
    printerStatusGeneralError: {
        en: 'Printer error detected. Your printer may be out of paper—please check and reload if needed.',
        fr:
            "Erreur d'imprimante détectée. Votre imprimante manque peut-être de papier—veuillez vérifier et recharger au besoin."
    },
    printerStatusReCheck: {
        en: 'Recheck',
        fr: 'Revérifier'
    },
    printerStatusIgnore: {
        en: 'Ignore',
        fr: 'Ignorer'
    },
    containerAddedMsg: {
        en: 'Added {{{amount}}} x {{{label}}} {{{description}}} containers - {{{total}}}',
        fr: 'Ajout de {{{amount}}} x conteneurs {{{label}}} {{{description}}} - {{{total}}}'
    },
    containerRemovedMsg: {
        en: 'Successfully removed {{{quantityRemoved}}} containers from session',
        fr: '{{{quantityRemoved}}} conteneurs ont été retirés de la session avec succès.'
    },
    cashOrderNotFound: {
        en: 'No orders found',
        fr: 'Aucune commande trouvée'
    },
    cashOrderAlreadyPaid: {
        en: 'This order has already been paid',
        fr: 'Cette commande a déjà été payée'
    },
    cashOrderInvalidLocation: {
        en: 'This order isn’t valid at this location',
        fr: 'Cette commande n’est pas valide à cet emplacement'
    },
    invalidOperatorCollector: {
        en: 'Invalid operator collector',
        fr: "Collecteur d'opérateurs invalide"
    },
    cannotChangeRVMItems: { en: 'RVM items cannot be modified', fr: 'Les éléments RVM ne peuvent pas être modifiés.' },
    enterVoucherCode: { en: 'Enter Voucher Code', fr: 'Entrez le code de bon' },
    voucherCode: { en: 'Voucher Code', fr: 'Code de bon' }
};

const verificationLinkTranslations = {
    verificationLink1: {
        en: 'Invalid link, please send again.',
        fr: 'Lien invalide, veuillez le renvoyer.'
    },
    verificationLink2: {
        en: 'Link has expired, please send again.',
        fr: 'Le lien a expiré, veuillez le renvoyer.'
    },
    verificationLink3: {
        en: 'Verification successful. You can sign into your account now.',
        fr: `Vérification réussie.  Vous pouvez maintenant utiliser les services de ${app}`
    },
    verificationLink4: {
        en: 'Your e-mail is verified already.',
        fr: 'Votre e-mail est déjà vérifié.'
    },
    verificationLink5: {
        en: 'Link is invalid or has expired.',
        fr: "Le lien n'est pas valide ou a expiré"
    }
};

const emailAuthorizationTranslations = {
    authorizationLink1: {
        en: 'Invalid link, please send again.',
        fr: 'Lien invalide, veuillez le renvoyer.'
    },
    authorizationLink2: {
        en: 'Link has expired, please send again.',
        fr: 'Le lien a expiré, veuillez le renvoyer.'
    },
    authorizationLink3: {
        en: 'Email authorized. It may now be used to request e-Transfers.',
        fr: `Courriel autorisé. Il peut maintenant être utilisé pour demander des virements Interac.`
    },
    authorizationLink4: {
        en: 'This email is already authorized.',
        fr: 'Ce courriel est déjà autorisé.'
    },
    addAuthorizedEmail: {
        en: 'Add Authorized Email',
        fr: 'Ajouter un courriel autorisé'
    },
    resendAuthorizationEmail: {
        en: 'Resend Authorization Email',
        fr: `Renvoyer le courriel d'autorisation`
    },
    emailAuthorization1: {
        en: `The email address {{email}} has not been authorized to receive funds from ${app}. To authorize it, please follow the link in the corresponding authorization email.`,
        fr: `L'adresse courriel {{email}} n'a pas été autorisée à recevoir des fonds de ${app}. Pour l'autoriser, veuillez suivre le lien dans le courriel d'autorisation correspondant.`
    },
    emailAuthorization2: {
        en: `The email address {{email}} has been authorized to receive funds from ${app}.`,
        fr: `L'adresse courriel {{email}} a été autorisée à recevoir des fonds de ${app}.`
    },
    emailAuthorization3: {
        en: `No email addresses have been authorized to receive funds for this account.`,
        fr: `Aucune adresse courriel n'a été autorisée à recevoir des fonds pour ce compte.`
    },
    emailAuthorization4: {
        en: `Want to send to a different email? Update it in your `,
        fr: `Vous voulez envoyer à un courriel différent? Mettez-le à jour dans votre `
    },
    emailAuthorization4a: {
        en: 'Update Email',
        fr: 'Mettre à jour l’adresse courriel'
    },
    emailAuthorization5: {
        en: `account settings`,
        fr: `paramètres du compte`
    },
    privateRelayText: {
        en:
            "To receive an Interac e-Transfer, please provide an alternative email address. The private relay email address associated with your account, due to using 'Sign in with Apple,' is not compatible with e-Transfer services.",
        fr:
            "Pour recevoir un virement Interac, veuillez fournir une adresse courriel alternative. L'adresse courriel privée associée à votre compte, en raison de l'utilisation de « Connexion avec Apple », n'est pas compatible avec les services de virement Interac."
    }
};

const downloadPageTranslations = {
    downloadPage1a: {
        en: 'Oops!',
        fr: 'Oups!'
    },
    downloadPage1b: {
        en: "That's not how it works.",
        fr: "Ce n'est pas comme ça que ça marche."
    },
    downloadPage2: {
        en: `The QR code you scanned needs to be scanned using the ${app} app. Download the ${app} app below and re-scan the QR code using the app.`,
        fr: `Le code QR que vous avez scanné doit être scanné avec l'application ${app}. Téléchargez l'application ${app} ci-dessous et scannez à nouveau le code QR avec l'application.`
    }
};

const biometricsTranslations = {
    biometrics1: {
        en: 'Allow this device to sign in using biometrics',
        fr: "Autoriser cet appareil à se connecter à l'aide de la biométrie"
    },
    biometrics2: {
        en: 'Continue with biometrics',
        fr: 'Continuer avec la biométrie'
    },
    biometrics3: {
        en: 'Error with authentication, please use regular email and password sign in.',
        fr: `Erreur d'authentification, veuillez utiliser la connexion régulière avec courriel et mot de passe.`
    },
    biometrics4: {
        en: 'Error verifying your identity, please use regular email and password sign in.',
        fr: `Erreur de vérification de votre identité, veuillez utiliser la connexion régulière avec courriel et mot de passe.`
    },
    biometrics5: {
        en: 'The credentials saved to this device are incorrect, please use regular email and password sign in.',
        fr: `Les identifiants enregistrés sur cet appareil sont incorrects, veuillez utiliser la connexion régulière avec courriel et mot de passe.`
    },
    biometrics6: {
        en: 'Delete saved biometric credentials',
        fr: `Supprimer les informations d'identification biométriques enregistrées`
    },
    biometrics7: {
        en:
            'Are you sure, you will no longer be able to sign in using fingerprint/face scan on this device? Any other devices will not be affected.',
        fr: `Êtes-vous sûr de ne plus pouvoir vous connecter à l'aide de la numérisation d'empreintes digitales/visage sur cet appareil ? Aucun autre appareil ne sera affecté.`
    },
    biometrics8: {
        en:
            'If you use a device that uses biometrics, changing your password will require you to sign in using your email and password before you can use the fingerprint/face scan again.',
        fr: `Si vous utilisez un appareil qui utilise la biométrie, la modification de votre mot de passe vous obligera à vous connecter avec votre courriel et mot de passe avant de pouvoir utiliser à nouveau le scan d'empreinte digitale/facial.`
    },
    biometrics9: {
        en:
            'Password confirmation is required to enable biometrics. After a password change, you may have to reactivate fingerprint or face scan features.',
        fr: `La confirmation du mot de passe est requise pour activer les données biométriques. Après un changement de mot de passe, vous devrez peut-être réactiver les fonctionnalités d'empreinte digitale ou de reconnaissance faciale.`
    },
    biometrics10: {
        en: 'Sign in using biometrics',
        fr: 'Connectez-vous en utilisant les données biométriques'
    },
    biometrics11: {
        en: 'Biometrics Enabled',
        fr: 'Biométrie activée'
    },
    biometrics12: {
        en: 'Something went wrong while setting credentials',
        fr: "Une erreur s'est produite lors de la configuration des informations d'identification."
    },
    biometrics13: {
        en: 'Biometrics not available',
        fr: 'Biométrie non disponible'
    },
    biometrics14: {
        en: 'Incorrect Password',
        fr: 'Mot de passe incorrect'
    }
};

const passwordRestLinkTranslations = {
    passwordResetLink1: {
        en: 'Link already used, please send again.',
        fr: 'Lien déjà utilisé, merci de le renvoyer.'
    },
    passwordResetLink2: {
        en: 'Invalid link, please send again.',
        fr: 'Lien invalide, veuillez le renvoyer.'
    },
    passwordResetLink3: {
        en: 'Link has expired, please send again.',
        fr: `Le lien a expiré, veuillez le renvoyer.`
    },
    passwordResetLink4: {
        en: 'Your password has been changed.',
        fr: 'Votre mot de passe a été changé.'
    }
};

const daysOfWeek = {
    monday: {
        en: 'Monday',
        fr: 'Lundi'
    },
    tuesday: {
        en: 'Tuesday',
        fr: 'Mardi'
    },
    wednesday: {
        en: 'Wednesday',
        fr: 'Mercredi'
    },
    thursday: {
        en: 'Thursday',
        fr: 'Jeudi'
    },
    friday: {
        en: 'Friday',
        fr: 'Vendredi'
    },
    saturday: {
        en: 'Saturday',
        fr: 'Samedi'
    },
    sunday: {
        en: 'Sunday',
        fr: 'Dimanche'
    }
};
const externalOTC = {
    OTCPortalTitle: {
        en: 'External Booking',
        fr: 'Réservation externe'
    },
    OTCInstruction: {
        en: 'Please enter your access code. If you forgot, or do not have an access code please contact',
        fr: "Veuillez saisir votre code d'accès. Si vous avez oublié ou n'avez pas de code d'accès, veuillez contacter"
    },
    OTCHelpMessage: {
        en: 'If you need to make changes to your location details please contact',
        fr: 'Si vous devez apporter des modifications aux détails de votre emplacement, veuillez contacter'
    },
    OTCLocationDetails: {
        en: 'Location Details',
        fr: 'Détails de localisation'
    },
    OTCCancelBooking: {
        en: 'cancel booking',
        fr: 'annuler la réservation'
    },
    OTCSelectDate: {
        en: 'Select Pickup Date',
        fr: 'Sélectionner la date de collecte'
    },
    OTCPickupDate: {
        en: 'Pickup Date',
        fr: 'Date de collecte'
    },
    OTCCancelConfirmation: {
        en: 'Are you sure you want to cancel this pickup?',
        fr: 'Êtes-vous certain(e) de vouloir annuler cette collecte?'
    },
    OTCPickupSuccess: {
        en: 'Pickup booked',
        fr: 'Collecte réservée'
    },
    OTCCancelSuccess: {
        en: 'Pickup cancelled',
        fr: 'Collecte annulée'
    },
    OTCGroupDetails: {
        en: 'Group Details',
        fr: 'Détails du groupe'
    },
    OTCNoLocations: {
        en: 'This group does not have any locations',
        fr: "Ce groupe n'a aucun emplacement"
    },
    OTCBookingTitle: {
        en: 'Booking Pickup',
        fr: 'Réservation de collecte'
    },
    OTCInvalidCode: {
        en: 'Invalid access code',
        fr: "Code d'accès invalide"
    },
    OTCMessageSent: {
        en: 'Message sent',
        fr: 'Message envoyé'
    },
    OTCFrequencyOnce: { en: 'Only Once', fr: 'Une seule fois' },
    OTCFrequencyWeekly: { en: 'Weekly', fr: 'Hebdomadaire' },
    OTCFrequencyOnce2Week: { en: 'Every 2 Weeks', fr: 'Toutes les 2 semaines' },
    OTCFrequencyOnce3Week: { en: 'Every 3 Weeks', fr: 'Toutes les 3 semaines' },
    OTCFrequencyOnce4Week: { en: 'Every 4 Weeks', fr: 'Toutes les 4 semaines' },
    OTCFrequencyOnce5Week: { en: 'Every 5 Weeks', fr: 'Toutes les 5 semaines' },
    OTCExternalGroups: {
        en: 'External Groups',
        fr: 'Groupes externes'
    },
    OTCAccessCode: {
        en: 'Access Code',
        fr: "Code d'accès"
    },
    OTCViewLocations: {
        en: 'View locations',
        fr: 'Voir les lieux'
    },
    OTCViewPickups: {
        en: 'View Pickups',
        fr: 'Consulter les collectes'
    },
    OTCViewPastPickups: {
        en: 'View past pickups',
        fr: 'Consulter les collectes passées'
    },
    OTCDeleteGroupWarning1: {
        en: 'Cannot delete groups with existing locations',
        fr: 'Impossible de supprimer des groupes qui contiennent des lieux existants'
    },
    OTCDeleteGroupWarning2: {
        en: 'Are you sure you want to delete this group?',
        fr: 'Êtes-vous sûr de vouloir supprimer ce groupe?'
    },
    OTCDeleteLocationWarning1: {
        en: 'Cannot delete locations with existing pickup booking',
        fr: 'Impossible de supprimer des emplacements ayant une réservation de collecte existante'
    },
    OTCDeleteLocationWarning2: {
        en: 'Are you sure you want to delete this location?',
        fr: 'Êtes-vous sûr de vouloir supprimer cet emplacement?'
    },
    OTCGroups: {
        en: 'OTC Groups',
        fr: 'Groupes OTC'
    },
    OTCDefaultIcon: {
        en: 'Default Icon',
        fr: 'Icône par défaut'
    },
    OTCDefaultColor: {
        en: 'Default Color',
        fr: 'Couleur par défaut'
    },
    OTCPickupsForThisLocation: {
        en: 'Pickups for this location',
        fr: 'Collectes pour cet emplacement'
    },
    OTCNoPickupsBooked: {
        en: 'No pickups booked',
        fr: 'Aucune collecte réservée'
    },
    OTCCancelPickup: {
        en: 'Cancel Pickup',
        fr: 'Annuler la collecte'
    },
    OTCCancelPickupWarning: {
        en: 'Are you sure you want to cancel this pickup?',
        fr: 'Êtes-vous certain(e) de vouloir annuler cette collecte?'
    },
    OTCNewPickup: {
        en: 'New Pickup',
        fr: 'Nouvelle collecte'
    },
    OTCLocations: {
        en: 'OTC Locations',
        fr: 'Emplacements de vente libre'
    },
    OTCDurationMin: {
        en: 'Duration (min)',
        fr: 'Durée (min)'
    },
    OTCForceCollector: {
        en: 'Force Collector',
        fr: 'Collecteur forcé'
    },
    OTCForceDriver: {
        en: 'Force Driver',
        fr: 'Affecter un chauffeur'
    },
    OTCUseZoneConfiguration: {
        en: 'Use Zone Configuration',
        fr: 'Utiliser la configuration de zone'
    },
    OTCGroupRemoved: {
        en: 'Group Removed',
        fr: 'Groupe supprimé'
    }
};

const driverDashboardTranslations = {
    pickupStats: {
        en: 'Pickup Statistics',
        fr: 'Statistiques de collecte'
    },
    combinedStats: {
        en: 'Weekly Statistics',
        fr: 'Statistiques hebdomadaires'
    },
    driverCodeTitle: {
        en: 'Your driver code is',
        fr: 'Votre code de chauffeur est'
    },
    upcomingTrips: {
        en: 'Upcoming Trips',
        fr: 'Trajets à venir'
    },
    completeTrips: {
        en: 'Completed Trips',
        fr: 'Trajets complétés'
    },
    notrips: {
        en: 'No Trips',
        fr: 'Aucun trajet'
    },
    noCompliments: {
        en: 'No Compliments',
        fr: 'Aucun compliment'
    },
    noComplaints: {
        en: 'No Complaints',
        fr: 'Aucune plainte'
    },
    noDriverIncidents: {
        en: 'No Driver Incidents',
        fr: 'Aucun Incident de chauffeur'
    },
    noOptions: {
        en: 'No Options',
        fr: 'Aucune option'
    },
    totalTime: {
        en: 'Total Time',
        fr: 'Temps total'
    },
    timeSlashPickup: {
        en: 'Time/Pickup',
        fr: 'Heure/Collecte'
    },
    timeSlashBag: {
        en: 'Time/Bag',
        fr: 'Heure/Sac'
    },
    tripIs: {
        en: 'Trip is',
        fr: 'Trajet est'
    },
    goToTrip: {
        en: 'Goto Trip',
        fr: 'Aller au trajet'
    },
    proceedToYourStartingLocation: {
        en: 'Proceed to your starting location',
        fr: 'Dirigez-vous vers votre point de départ'
    },
    tripComplete: {
        en: 'Trip Complete',
        fr: 'Trajet terminé.'
    },
    onlyUndoClockedIn: {
        en: 'Can only undo pickups when clocked in.',
        fr: `On peut seulement annuler les collectes lorsqu'on est connecté.`
    },
    customerFeedback: {
        en: 'Customer Feedback',
        fr: `Commentaires des clients`
    },
    onTime: {
        en: 'On Time',
        fr: "À l'heure"
    },
    leftBags: {
        en: 'Left Bags',
        fr: 'Sacs laissés'
    },
    pickupCompliment: {
        en: 'Pickup compliment',
        fr: 'Compliment de collecte'
    },
    pickupDriverLate: {
        en: 'Driver late',
        fr: 'Chauffeur en retard'
    },
    pickupComplaint: {
        en: 'Pickups complaint',
        fr: 'Plainte de collecte'
    },
    systemComplaint: {
        en: 'System complaint',
        fr: 'Plainte du système'
    },
    sortingComplaint: {
        en: 'Sorting complaint',
        fr: 'Plainte concernant le tri'
    },
    viewComplaintImages: {
        en: 'View Complaint Images',
        fr: 'Voir les images de la plainte'
    },
    statsError: {
        en: 'Unrecoverable error occurred. Cannot fetch collector stats.',
        fr: "Une erreur irrécupérable est survenue. Impossible d'obtenir les statistiques du collecteur."
    },
    requestPickup: {
        en: 'Request {{commodity}} Pickup',
        fr: 'Demander une collecte de {{commodity}}'
    },
    pickupScheduled: {
        en: '{{commodity}} Pickup Scheduled',
        fr: 'Collecte de {{commodity}} planifiée'
    },
    pickupCollected: {
        en: '{{commodity}} Pickup Collected',
        fr: 'Collecte de {{commodity}} effectuée'
    },
    notConfigured: {
        en: 'Not configured',
        fr: 'Non configuré'
    },
    schedulePickup: {
        en: 'Schedule A Pickup Here',
        fr: 'Planifier une collecte ici'
    },
    cancelOrComplete: {
        en: 'Cancel Or Complete Pickup Here',
        fr: 'Annuler ou terminer la collecte ici'
    },
    manageInventory: {
        en: 'Manage Inventory',
        fr: "Gérer l'inventaire"
    },
    manageInventory2: {
        en: 'Manage {{commodity}} Inventory',
        fr: "Gérer l'inventaire de {{commodity}}"
    },
    viewPickups: {
        en: 'View All Pickups',
        fr: 'Voir toutes les collectes'
    },
    viewPhoneNumbers: {
        en: 'View phone numbers',
        fr: 'Consulter les numéros de téléphone'
    },
    commodityNotEnabled: {
        en: 'This commodity pickup is not enabled for you. Contact {{brand}} to start collecting this!',
        fr:
            "Cette collecte de matières n'est pas activée pour vous. Contactez {{brand}} pour commencer à collecter ceci!"
    },
    requestCollection: {
        en:
            'To request a collection, please take a picture of the payload and fill out any additional information below. When the collector arrives, please fill out this section again.',
        fr:
            'Pour demander une collecte, veuillez prendre une photo de la charge et remplir toute information supplémentaire ci-dessous. Lorsque le collecteur arrive, veuillez remplir cette section à nouveau.'
    },
    requestCollection2: {
        en: 'When the collection company takes away your {{commodity}}, please complete the pickup below.',
        fr: "Lorsque l'entreprise de collecte récupère votre {{commodity}}, veuillez compléter la collecte ci-dessous."
    },
    imgPlaceholder: {
        en: 'Please upload or take a photo of what needs to be picked up.',
        fr: 'Veuillez téléverser ou prendre une photo de ce qui doit être ramassé.'
    },
    thisWeek: {
        en: 'This Week',
        fr: 'Cette semaine'
    },
    thisMonth: {
        en: 'This Month',
        fr: 'Ce mois-ci'
    },
    thisYear: {
        en: 'This Year',
        fr: 'Cette année'
    },
    lastWeek: {
        en: 'Last Week',
        fr: 'La semaine dernière'
    },
    lastMonth: {
        en: 'Last Month',
        fr: 'Le mois dernier'
    },
    lastYear: {
        en: 'Last Year',
        fr: "L'année dernière"
    },
    recentCompliments: {
        en: 'Recent Compliments',
        fr: 'Compliments récents'
    },
    recentComplaints: {
        en: 'Recent Complaints',
        fr: 'Plaintes récentes'
    },
    driverIncidents: {
        en: 'Driver Incidents',
        fr: 'Incidents de chauffeur'
    },
    submitVacation: {
        en: 'Submit Vacation',
        fr: 'Soumettre des vacances'
    },
    vacationDays: {
        en: 'Vacation Days',
        fr: 'Jours de vacances'
    },
    submitVacationDays: {
        en: 'Submit Vacation Days',
        fr: 'Soumettre des jours de vacances'
    },
    upcomingVacation: {
        en: 'This driver has upcoming vacation days',
        fr: 'Ce chauffeur a des jours de vacances à venir'
    },
    editVacation: {
        en: 'Edit Vacation Days',
        fr: 'Modifier les jours de vacances'
    },
    driverSummary: {
        en: 'Driver Summary',
        fr: 'Résumé du chauffeur'
    },
    driverSummary1: {
        en: 'Containers/Hour (Syn)',
        fr: 'Contenants/heure (syn)'
    },
    driverSummary2: {
        en: 'Paid Hours',
        fr: 'Heures payées'
    },
    driverSummary3: {
        en: 'Collection Hours',
        fr: 'Heures de collecte'
    },
    driverSummary4: {
        en: 'Excluded Hours',
        fr: 'Heures exclues'
    },
    driverSummary5: {
        en: 'Lunch Hours',
        fr: 'Heures de dîner'
    },
    driverSummary6: {
        en: 'Trips',
        fr: 'Trajets'
    },
    driverSummary7: {
        en: 'Pickups',
        fr: 'Collectes'
    },
    driverSummary8: {
        en: 'Truck',
        fr: 'Camion'
    },
    driverSummary9: {
        en: 'Processor',
        fr: 'Transformateur'
    },
    driverSummary10: {
        en: 'Clock In',
        fr: 'Entrée'
    },
    driverSummary11: {
        en: 'Clock Out',
        fr: 'Sortie'
    },
    driverSummary12: {
        en: 'Bags',
        fr: 'Sacs'
    },
    driverSummary13: {
        en: 'Clothing (lbs)',
        fr: 'Vêtements (lb)'
    },
    driverSummary14: {
        en: 'Electronics (Items)',
        fr: 'Électronique (articles)'
    },
    driverSummary15: {
        en: 'Containers',
        fr: 'Contenants'
    },
    driverSummary16: {
        en: 'Containers/Hour',
        fr: 'Contenants/heure'
    },
    driverSummary17: {
        en: 'Containers (Syn)',
        fr: 'Contenants (Syn)'
    },
    driverSummary18: {
        en: 'Infractions',
        fr: 'Infractions'
    },
    driverSummary19: {
        en: 'Customer Complaints',
        fr: 'Plaintes des clients'
    },
    driverSummary20: {
        en: 'Counter Complaints',
        fr: 'Plaintes au comptoir'
    },
    driverSummary21: {
        en: 'System Complaints',
        fr: 'Plaintes du système'
    },
    driverSummary22: {
        en: 'Compliments',
        fr: 'Compliments'
    },
    driverSummary23: {
        en: 'Breaks Hours',
        fr: 'Heures de pause'
    },
    outstandingInvoices: {
        en: 'Outstanding Invoices',
        fr: 'Factures impayées'
    },
    invoicesError: {
        en: 'Invoices were not loaded due to a server error. Please contact us directly for inquiries.',
        fr:
            "Les factures n'ont pas été chargées en raison d'une erreur de serveur. Veuillez nous contacter directement pour toute demande."
    },
    invoiceHeader1: {
        en: 'Invoice number',
        fr: 'Numéro de facture'
    },
    invoiceHeader2: {
        en: 'Due date',
        fr: "Date d'échéance"
    },
    invoiceHeader3: {
        en: 'Total amount',
        fr: 'Montant total'
    },
    invoiceHeader4: {
        en: 'Balance',
        fr: 'Solde'
    },
    invoiceHeader5: {
        en: 'Actions',
        fr: 'Actions'
    },
    financesHeader1: {
        en: 'Period (by date picked up)',
        fr: 'Période (par date de ramassage)'
    },
    financesHeader2: {
        en: 'Number of pickups',
        fr: 'Nombre de collectes'
    },
    financesHeader3: {
        en: 'Number of containers',
        fr: 'Nombre de contenants'
    },
    financesHeader4: {
        en: 'Container deposits',
        fr: 'Consignes de contenants'
    },
    financesHeader5: {
        en: 'Adjustments',
        fr: 'Ajustements'
    },
    financesHeader6: {
        en: 'Balance',
        fr: 'Solde'
    },
    lockScreen: {
        en: 'Lock Screen',
        fr: 'Écran verrouillé'
    },
    exitView: {
        en: 'Exit View',
        fr: 'Vue de sortie'
    },
    sysAdminColumn1: {
        en: 'First Name',
        fr: 'Prénom'
    },
    sysAdminColumn2: {
        en: 'Last Name',
        fr: 'Nom de famille'
    },
    sysAdminColumn3: {
        en: 'Code',
        fr: 'Code'
    },
    sysAdminColumn4: {
        en: 'Email',
        fr: 'Courriel'
    },
    sysAdminColumn5: {
        en: 'Type',
        fr: 'Type'
    },
    sysAdminColumn6: {
        en: 'Permissions',
        fr: 'Permissions'
    },
    sysAdminColumn7: {
        en: 'Phone',
        fr: 'Téléphone'
    },
    sysAdminColumn8: {
        en: 'Collectors',
        fr: 'Collecteurs'
    },
    sysAdminColumn9: {
        en: 'Destination',
        fr: 'Destination'
    },
    sysAdminColumn10: {
        en: 'User ID',
        fr: 'ID Utilisateur'
    },
    sysAdminColumn11: {
        en: 'Last Login',
        fr: 'Dernière connexion'
    },
    sysAdminColumn12: {
        en: 'Start Time',
        fr: 'Heure de début'
    },
    sysAdminColumn13: {
        en: 'Start location',
        fr: 'Lieu de départ'
    },
    sysAdminColumn14: {
        en: 'Bag Capacity',
        fr: 'Capacité de sacs'
    },
    sysAdminColumn15: {
        en: 'Capacity',
        fr: 'Capacité'
    },
    sysAdminColumn16: {
        en: 'Wage',
        fr: 'Salaire'
    },
    sysAdminColumn17: {
        en: 'Fuel Efficiency',
        fr: 'Rendement énergétique'
    },
    sysAdminColumn18: {
        en: 'Gas Cost',
        fr: "Coût d'essence"
    },
    sysAdminColumn19: {
        en: 'View All Pickups',
        fr: 'Voir toutes les collectes'
    },
    sysAdminColumn20: {
        en: "View Phone #'s",
        fr: 'Voir les n° tél'
    },
    sysAdminColumn21: {
        en: 'Collector Code',
        fr: 'Code du Collecteur'
    },
    collectorColumn1: {
        en: 'First Name',
        fr: 'Prénom'
    },
    collectorColumn2: {
        en: 'Last Name',
        fr: 'Nom de famille'
    },
    collectorColumn3: {
        en: 'Code',
        fr: 'Code'
    },
    collectorColumn4: {
        en: 'Destination',
        fr: 'Destination'
    },
    collectorColumn5: {
        en: 'User ID',
        fr: 'ID Utilisateur'
    },
    collectorColumn6: {
        en: 'Email',
        fr: 'Courriel'
    },
    collectorColumn7: {
        en: 'Type',
        fr: 'Type'
    },
    collectorColumn8: {
        en: 'Permissions',
        fr: 'Permissions'
    },
    collectorColumn9: {
        en: 'Phone',
        fr: 'Téléphone'
    },
    collectorColumn10: {
        en: 'Last Login',
        fr: 'Dernière connexion'
    },
    collectorColumn11: {
        en: 'Start Time',
        fr: 'Heure de début'
    },
    collectorColumn12: {
        en: 'Start location',
        fr: 'Lieu de départ'
    },
    collectorColumn13: {
        en: 'Bag Capacity',
        fr: 'Capacité de sacs'
    },
    collectorColumn14: {
        en: 'Capacity',
        fr: 'Capacité'
    },
    collectorColumn15: {
        en: 'Wage',
        fr: 'Salaire'
    },
    collectorColumn16: {
        en: 'Fuel Efficiency',
        fr: 'Rendement énergétique'
    },
    collectorColumn17: {
        en: 'Gas Cost',
        fr: "Coût d'essence"
    },
    collectorColumn18: {
        en: 'See All Pickups',
        fr: 'Voir toutes les collectes'
    },
    collectorColumn19: {
        en: "See Phone #'s",
        fr: 'Voir les n° tél'
    },
    collectorColumn20: {
        en: 'End Time',
        fr: 'Heure de fin'
    },
    updateAccountStatus: {
        en: 'Update Account Status',
        fr: 'Mettre à jour le statut du compte'
    },
    enabledAccounts: {
        en: 'Enabled Accounts',
        fr: 'Comptes activés'
    },
    disabledAccounts: {
        en: 'Banned Accounts',
        fr: 'Comptes bannis'
    },
    commodityHeader1: {
        en: 'Actions',
        fr: 'Actions'
    },
    commodityHeader2: {
        en: 'Status',
        fr: 'Statut'
    },
    commodityHeader3: {
        en: 'Commodity',
        fr: 'Marchandise'
    },
    commodityHeader4: {
        en: 'Trailer Number',
        fr: 'Numéro de remorque'
    },
    commodityHeader5: {
        en: 'From',
        fr: 'depuis'
    },
    commodityHeader6: {
        en: 'Reference Number',
        fr: 'Numéro de référence'
    },
    commodityHeader7: {
        en: 'Date Requested',
        fr: 'Date demandée'
    },
    commodityHeader8: {
        en: 'Collection Period',
        fr: 'Période de collecte'
    },
    commodityHeader9: {
        en: 'Total Items',
        fr: "Nombre total d'articles"
    },
    commodityHeader10: {
        en: 'Associated Orders',
        fr: 'Commandes associées'
    },
    commodityHeader11: {
        en: 'Associated Bags/Items',
        fr: 'Sacs/Articles associés'
    },
    commodityHeader12: {
        en: 'Payment Total',
        fr: 'Montant total du paiement'
    },
    commodityHeader13: {
        en: 'Processor Payment',
        fr: 'Paiement du transformateur'
    },
    commodityHeader14: {
        en: 'Driver Payment',
        fr: 'Paiement du chauffeur'
    },
    commodityHeader15: {
        en: 'Customer Payment',
        fr: 'Paiement du client'
    },
    commodityHeader16: {
        en: 'Charity Payment',
        fr: "Paiement de l'organisme de bienfaisance"
    },
    commodityHeader17: {
        en: 'Payload',
        fr: 'Chargement'
    },
    commodityHeader18: {
        en: 'By',
        fr: 'Par'
    },
    commodityHeader19: {
        en: 'To',
        fr: 'À'
    },
    commodityHeader20: {
        en: 'Date Requested',
        fr: 'Date demandée'
    },
    commodityHeader21: {
        en: 'Date Collected',
        fr: 'Date de collecte'
    },
    commodityHeader22: {
        en: 'Date Processed',
        fr: 'Date de traitement'
    },
    requestedPickup: {
        en: 'Requested Pickup',
        fr: 'Collecte demandée'
    },
    completedPickup: {
        en: 'Completed Pickup',
        fr: 'Collecte complétée'
    },
    pendingTransfer: {
        en: 'Pending Transfer',
        fr: 'En attente de transfert'
    },
    completedTransfer: {
        en: 'Completed Transfer',
        fr: 'Transfert terminé'
    },
    contactInfo: {
        en: 'Contact Info',
        fr: 'Coordonnées'
    },
    lunchBreak: {
        en: 'lunch break',
        fr: 'pause dîner'
    },
    break: {
        en: 'break',
        fr: 'pause'
    },
    etaRecalc: {
        en: 'ETA Recalc Triggered By',
        fr: "Recalcul d'HAP déclenché par"
    },
    notificationSent: {
        en: 'Notification Sent',
        fr: 'Notification envoyée'
    },
    systemPostpones: {
        en: 'System Postpones',
        fr: 'Report différé par le système'
    },
    postponesAborts: {
        en: 'Postpones/Aborts',
        fr: 'Reporte/Annule'
    },
    oosStop: {
        en: 'out-of-system stop',
        fr: 'arrêt hors-système'
    },
    editBagTag: {
        en: 'Edit bagtag',
        fr: "Modifier l'étiquette de sac"
    },
    breakdownWarning: {
        en:
            "The Breakdown may not reflect the estimated duration accurately if a driver's efficiency data has been changed, and the trip does not have it's own efficiency data.",
        fr:
            "La répartition pourrait ne pas refléter la durée estimée avec précision si les données d'efficacité d'un chauffeur ont été modifiées, et que le trajet n'a pas ses propres données d'efficacité."
    },
    loadingPickupsData: {
        en: 'Loading pickups data',
        fr: 'Chargement des données de collectes'
    },
    disconnectedWarning: {
        en:
            'Someone has logged into your account from another device. Only one connection at a time can be maintained. If you wish to disconnect them and use current device, click Reconnect.',
        fr:
            "Quelqu'un s'est connecté à votre compte à partir d'un autre appareil. Une seule connexion à la fois peut être maintenue. Si vous souhaitez les déconnecter et utiliser l'appareil actuel, cliquez sur Reconnecter."
    },
    unconfirmedPickups: {
        en: 'Unconfirmed Pickups',
        fr: 'Collectes non confirmées'
    },
    recurringPickups: {
        en: 'Recurring Pickups',
        fr: 'Collectes récurrentes'
    },
    hiddenPickups: {
        en: 'Hidden Pickups',
        fr: 'Collectes masquées'
    },
    unroutedPickups: {
        en: 'Unrouted Pickups',
        fr: 'Collectes non planifiées'
    },
    showAllPickups: {
        en: 'Show all pickups',
        fr: 'Afficher toutes les collectes'
    },
    assigningTrips: {
        en: 'Assigning trips...',
        fr: "En cours d'attribution des trajets..."
    },
    autoAssignTrips: {
        en: 'Auto Assign Trips',
        fr: 'Attribution automatique des trajets'
    },
    noTripsDate: {
        en: 'No trips on this date.',
        fr: 'Aucun trajet à cette date.'
    },
    sendETAUpdates: {
        en: 'Send ETA updates to customers',
        fr: "Envoyer les mises à jour d'heure d'arrivée prévue aux clients"
    },
    sendingETANotifications: {
        en: 'Sending eta notifications now',
        fr: "Envoi des notifications d'heure d'arrivée prévue en cours"
    },
    cannotETAFuture: {
        en: 'Cannot send ETA updates for future dates',
        fr: "Impossible d'envoyer des mises à jour d'heure d'arrivée prévue pour des dates futures"
    },
    cannotETAPast: {
        en: 'Cannot send ETA updates for past dates',
        fr: "Impossible d'envoyer des mises à jour d'heure d'arrivée prévue pour des dates passées"
    },
    allETAAcceptable: {
        en: 'All ETAs within acceptable window',
        fr: "Toutes les heures d'arrivée prévues dans la fenêtre acceptable"
    },
    maxETANoteReached: {
        en: 'Max ETA notifications reached',
        fr: "Maximum de notifications d'heure d'arrivée prévue atteint"
    },
    sendNoteToXCustomers: {
        en: 'Send notifications to {{etasToUpdate}} customers',
        fr: 'Envoyer des notifications à {{etasToUpdate}} clients'
    },
    sendNoteToXXCustomers: {
        en: 'Send notifications to {{etasToUpdate}}/{{etasOutOfSync}} customers',
        fr: 'Envoyer des notifications à {{etasToUpdate}}/{{etasOutOfSync}} clients'
    },
    upcomingUnservicedDate: {
        en: 'Upcoming Unserviced Date',
        fr: 'Prochaine date non desservie'
    },
    disableZone: {
        en: 'Disable Zone',
        fr: 'Désactiver la zone'
    },
    disableZoneWarning: {
        en:
            'You should only disable a zone if you are no longer offering collections in that area. Any new pickups for this zone will be unserviced.',
        fr:
            'Vous ne devez désactiver une zone que si vous ne proposez plus de collectes dans cette zone. Toutes les nouvelles collectes pour cette zone seront non desservies.'
    },
    viewCollectors: {
        en: 'View Collectors',
        fr: 'Voir les collecteurs'
    },
    createZone: {
        en: 'Click the map to start creating a zone',
        fr: 'Cliquez sur la carte pour commencer à créer une zone'
    },
    serviceStartingDates: {
        en: 'Service Starting Dates',
        fr: 'Programme de collecte débutant le'
    },
    acceptedPayloads: {
        en: 'Accepted Payloads',
        fr: 'Charges utiles acceptées'
    },
    requiredPayloads: {
        en: 'Required Payloads',
        fr: 'Charges utiles requises'
    },
    everyXWeeks: {
        en: 'Every {{amount}} Weeks',
        fr: 'Toutes les {{amount}} semaines'
    },
    difficultyModifier: {
        en: 'Difficulty Modifier',
        fr: 'Modificateur de difficulté'
    },
    difficultyWarning: {
        en: 'Multiplies the number of bags to give the driver more time to complete the route',
        fr: 'Multiplie le nombre de sacs pour donner plus de temps au chauffeur pour compléter la route'
    },
    allowedPickupTypes: {
        en: 'Allowed Pickup Types',
        fr: 'Types de collectes autorisés'
    },
    allowCollectionPickups: {
        en: 'Allow Collection ({{type}}) Program Pickups',
        fr: 'Autoriser les collectes du programme ({{type}})'
    },
    differenceLastETA: {
        en: 'Difference from last ETA',
        fr: "Différence par rapport à la dernière heure d'arrivée prévue"
    },
    fromLastETA: {
        en: ' from last ETA)',
        fr: " de la dernière heure d'arrivée prévue)"
    },
    baseStopDuration: {
        en: 'Base Stop Duration (min)',
        fr: "Durée de base d'un arrêt (min)"
    },
    timePerBag: {
        en: 'Time Per Bag (min)',
        fr: 'Temps par sac (min)'
    },
    timePerBagSec: {
        en: 'Time Per Bag (sec)',
        fr: 'Temps par sac (sec)'
    },
    timePerStopSec: {
        en: 'Time Per Stop (sec)',
        fr: 'Temps par arrêt (sec)'
    },
    drivingTime: {
        en: 'Driving Time (min)',
        fr: 'Temps de conduite (min)'
    },
    startAddress: {
        en: 'Start Address',
        fr: 'Adresse de départ'
    },
    endAddress: {
        en: 'End Address',
        fr: 'Adresse de fin'
    },
    reviewLocation: {
        en: 'Review location',
        fr: "Réviser l'emplacement"
    },
    scheduleUnserviced: {
        en: 'Schedule Unserviced',
        fr: 'Planifier non desservi'
    },
    createStop: {
        en: 'Create stop',
        fr: 'Créer un arrêt'
    },
    editStop: {
        en: 'Edit Stop',
        fr: 'Modifier l’arrêt'
    },
    editView: {
        en: 'Edit/View',
        fr: 'Modifier/Voir'
    },
    deleteOOSStopsWarning: {
        en: 'Are you sure you want to delete {{count}} out of system stops?',
        fr: 'Êtes-vous sûr de vouloir supprimer {{count}} arrêts hors système?'
    },
    deleteStops: {
        en: 'Delete stops',
        fr: 'Supprimer les arrêts'
    },
    mapFilters: {
        en: 'Map Filters',
        fr: 'Filtres de carte'
    },
    mapPin: {
        en: 'Map Pin',
        fr: 'Épingle de carte'
    },
    pickupTypes: {
        en: 'Pickup Types',
        fr: 'Types de collectes'
    },
    commodityTypes: {
        en: 'Commodity Types',
        fr: 'Types de marchandises'
    },
    routingClusterID: {
        en: 'Routing Cluster ID',
        fr: "Identifiant de groupe d'acheminement"
    },
    clusterPickupMarkers: {
        en: 'Cluster Pickup Markers',
        fr: 'Regrouper les marqueurs de collectes'
    },
    zonesActivity: {
        en: 'Zones Activity',
        fr: 'Activité des zones'
    },
    activeToday: {
        en: 'Active Today',
        fr: "Actif aujourd'hui"
    },
    collectorAndDates: {
        en: 'Collector & Dates',
        fr: 'Collecteur et dates'
    },
    zoneLegend: {
        en: 'Zone Legend',
        fr: 'Légende des zones'
    },
    tripID: {
        en: 'Trip ID',
        fr: 'ID du trajet'
    },
    defaultDuration: {
        en: 'Default Duration',
        fr: 'Durée par défaut'
    },
    estimatedValue: {
        en: 'Estimated value',
        fr: 'Valeur estimée'
    },
    noTransporterSelected: {
        en: 'No transporter selected!',
        fr: 'Aucun transporteur sélectionné !'
    },
    noDriverSelected: {
        en: 'No driver selected!',
        fr: 'Aucun chauffeur sélectionné !'
    },
    noProcessorSelected: {
        en: 'No processor selected!',
        fr: 'Aucun transformateur sélectionné !'
    },
    driverDefaultStartTime: {
        en: 'Driver default start time',
        fr: 'Heure de début par défaut du chauffeur'
    },
    dateTime: {
        en: 'Date/Time',
        fr: 'Date et heure'
    },
    noDateTimeSelected: {
        en: 'No date/time selected!',
        fr: 'Aucune date ni heure sélectionnée !'
    },
    startLocation: {
        en: 'Start location',
        fr: 'Lieu de départ'
    },
    useDriver: {
        en: 'Use Driver',
        fr: 'Utiliser le chauffeur'
    },
    useCollector: {
        en: 'Use Collector',
        fr: 'Utiliser le collecteur'
    },
    noLocationSelected: {
        en: 'No location selected!',
        fr: 'Aucun emplacement sélectionné !'
    },
    routingAlgorithm: {
        en: 'Routing algorithm',
        fr: 'Algorithme de routage'
    },
    verifyStartWarning: {
        en: 'Warning: Verify Start Location',
        fr: 'Avertissement : Vérifiez le lieu de départ'
    },
    verifyStartText: {
        en:
            'The start location for this trip is located over {{warningDistanceFromDepot}}km away from the depot. Double check that you have selected the correct start location.',
        fr:
            'Le point de départ de ce trajet est situé à plus de {{warningDistanceFromDepot}}km du dépôt. Vérifiez que vous avez sélectionné le bon point de départ.'
    },
    bulkAssignment: {
        en: 'Bulk Assignment',
        fr: 'Assignation en lot'
    },
    tripAssigned: {
        en: 'Trip assigned',
        fr: 'Trajet assigné'
    },
    alterCustomerETA: {
        en: 'This operation will alter customer ETAs',
        fr: "Cette opération modifiera les heures d'arrivée prévues des clients"
    },
    photoPickupVerification: {
        en: 'Upload or take a photo of the bags for pickup verification.',
        fr: 'Téléversez ou prenez une photo des sacs pour la vérification de la collecte.'
    },
    clothingBagsWarning: {
        en:
            'ATTENTION! This pickup request originally included clothing. Proceeding will confirm that you did not collect any clothing.',
        fr:
            "ATTENTION! Cette demande de collecte comprenait initialement des vêtements. En poursuivant, vous confirmerez que vous n'avez collecté aucun vêtement."
    },
    schemeID: {
        en: 'SchemeID',
        fr: 'Identifiant du Système'
    },
    inProgress: {
        en: 'In progress',
        fr: 'En cours'
    },
    bagtagError: {
        en: 'Bagtag error!',
        fr: "Erreur d'étiquette de sac!"
    },
    unrecoverableError: {
        en: 'Unrecoverable error. Please try again.',
        fr: 'Erreur irrécupérable. Veuillez réessayer.'
    },
    updateGPSTitle: {
        en: 'Update GPS?',
        fr: 'Mettre à jour le GPS?'
    },
    updateGPSText: {
        en:
            'Are you currently at the correct pickup location? Clicking yes will update the pickup location to your current GPS position.',
        fr:
            "Êtes-vous actuellement au bon emplacement de collecte? En cliquant sur oui, l'emplacement de collecte sera mis à jour selon votre position GPS actuelle."
    },
    pickupSms: {
        en: "Hey it’s {{brand}}, I'm here to grab your recycling.",
        fr: "Salut, c'est {{brand}}, je suis ici pour ramasser votre recyclage."
    },
    bulkReschedule: {
        en: 'Bulk Reschedule',
        fr: 'Reprogrammation en lot'
    },
    notificationsEmailSMS: {
        en: 'Notifications (email/sms)',
        fr: 'Notifications (courriel/texto)'
    },
    willBeSent: {
        en: 'will be sent to affected customers',
        fr: 'sera envoyé aux clients concernés'
    },
    willNotBeSent: {
        en: 'will not be sent',
        fr: 'ne sera pas envoyé'
    },
    willNotBeUpdated: {
        en: 'will not be updated',
        fr: 'ne sera pas mis à jour'
    },
    nextDateWarning: {
        en: 'Next dates will be forcefully updated because of 7+ days difference in previous and selected dates',
        fr:
            "Les prochaines dates seront mises à jour de force en raison d'une différence de plus de 7 jours entre les dates précédentes et les dates sélectionnées"
    },
    nextDateWarning2: {
        en:
            'Next dates will be forcefully updated because the selected date is within 4 days of the next scheduled date',
        fr:
            'Les prochaines dates seront mises à jour de force car la date sélectionnée est à moins de 4 jours de la prochaine date prévue'
    },
    sendOutNotifications: {
        en: 'Send out notifications',
        fr: 'Envoyer des notifications'
    },
    preserveCustomersDay: {
        en: "Preserve customer's preferred day",
        fr: 'Préserver le jour préféré du client'
    },
    sendOutEmails: {
        en: 'Send out emails',
        fr: 'Envoyer des courriels'
    },
    allowFuturePickupsOnDate: {
        en: 'Allow future pickups on {{date}}s',
        fr: 'Autoriser les collectes futures les {{date}}s'
    },
    allowFuturePickupsAsWell: {
        en: 'Allow future pickups as well',
        fr: 'Autoriser les collectes futures également'
    },
    bypassZoneCheck: {
        en: 'Bypass Zone Check',
        fr: 'Contourner la vérification de zone'
    },
    justOnce: {
        en: 'Just Once',
        fr: 'Une fois'
    },
    rescheduleReason: {
        en: 'Reschedule Reason',
        fr: 'Raison du report'
    },
    emailBody: {
        en: 'Email body',
        fr: 'Corps du courriel'
    },
    customEmailBody: {
        en: 'Custom Email Body',
        fr: 'Corps de courriel personnalisé'
    },
    scheduleUnservicedPickups: {
        en: 'Schedule Unserviced Pickups',
        fr: 'Planifier des collectes non desservies'
    },
    notificationEmails: {
        en: 'Notification emails',
        fr: 'Courriels de notification'
    },
    tripPickupsAssigned: {
        en: 'Trip that the pickups will be assigned to',
        fr: 'Trajet auquel les collectes seront assignées'
    },
    deletionWarning: {
        en: 'Are you sure you want to delete this preset?',
        fr: 'Êtes-vous sûr de vouloir supprimer ce préréglage?'
    },
    stopsGeneralPurpose: {
        en: 'Stops are general purpose tasks.',
        fr: 'Les arrêts sont des tâches à usage général.'
    },
    stopName: {
        en: 'Stop Name',
        fr: 'Nom de l’arrêt'
    },
    iconColor: {
        en: 'Icon Color',
        fr: 'Couleur de l’icône'
    },
    selectACollector: {
        en: 'Please select a collector',
        fr: 'Veuillez sélectionner un collecteur.'
    },
    mustSelectACollector: {
        en: 'You must select a collector',
        fr: 'Vous devez sélectionner un collecteur'
    },
    mustSelectAtLeastOneCollector: {
        en: 'You must select at least one collector',
        fr: 'Vous devez sélectionner au moins un collecteur'
    },
    payDollars: {
        en: 'Pay (Dollars)',
        fr: 'Paye (Dollars)'
    },
    estDuration: {
        en: 'Est. Duration (Min)',
        fr: 'Durée est. (min)'
    },
    firstPickup: {
        en: 'First Pickup',
        fr: 'Première collecte'
    },
    onePerTrip: {
        en: 'One per Trip',
        fr: 'Un par trajet'
    },
    previewMarkdown: {
        en: 'Preview Markdown',
        fr: 'Aperçu Markdown'
    },
    warningPickups: {
        en: 'Warning: Pickups not shown',
        fr: 'Avertissement : Collectes non affichées'
    },
    tripsPickupsFurtherText: {
        en:
            "Trips and pickups further than {{numberOfDays}} days out from the current date for {{collectorName}} aren't shown on the map, but may still exist. Check the pickups calendar to see actual counts.",
        fr:
            'Attention : Les trajets et les collectes prévus plus de {{numberOfDays}} jours après la date actuelle pour {{collectorName}} ne sont pas affichés sur la carte, mais peuvent toujours exister. Consultez le calendrier des collectes pour voir les décomptes réels.'
    },
    driverHistoryHeader1: {
        en: 'Trip Details',
        fr: 'Détails du trajet'
    },
    driverHistoryHeader2: {
        en: 'Incomplete^',
        fr: 'Incomplet^'
    },
    driverHistoryHeader3: {
        en: 'Date^',
        fr: 'Date^'
    },
    driverHistoryHeader4: {
        en: 'Day^',
        fr: 'Jour^'
    },
    driverHistoryHeader5: {
        en: 'Start Time Est^',
        fr: 'Heure début estimé^'
    },
    driverHistoryHeader6: {
        en: 'Start Time Act^',
        fr: 'Heure début réelle^'
    },
    driverHistoryHeader7: {
        en: 'Start Time Diff(hr)^',
        fr: 'Diff. heure début(hr)^'
    },
    driverHistoryHeader8: {
        en: 'Transporter^',
        fr: 'Transporteur^'
    },
    driverHistoryHeader9: {
        en: 'Processor^',
        fr: 'Transformateur^'
    },
    driverHistoryHeader10: {
        en: 'Driver^',
        fr: 'Chauffeur^'
    },
    driverHistoryHeader11: {
        en: 'Truck #^',
        fr: 'Camion n°^'
    },
    driverHistoryHeader12: {
        en: 'License Plate^',
        fr: 'Immatriculation^'
    },
    driverHistoryHeader13: {
        en: 'Distance Est(km)^',
        fr: 'Dist. estimé(km)^'
    },
    driverHistoryHeader14: {
        en: 'Distance Act(km)^',
        fr: 'Dist. réelle(km)^'
    },
    driverHistoryHeader15: {
        en: 'Distance Diff^',
        fr: 'Différence de distance^'
    },
    driverHistoryHeader16: {
        en: 'Distance Depot(km)^',
        fr: 'Distance du dépôt (km)^'
    },
    driverHistoryHeader17: {
        en: 'Vehicle Eff(km/L)^',
        fr: 'Efficacité du véhicule (km/L)^'
    },
    driverHistoryHeader18: {
        en: 'Gas Price($)^',
        fr: "Prix de l'essence ($)^"
    },
    driverHistoryHeader19: {
        en: 'Gas Cost($)^',
        fr: "Coût de l'essence ($)^"
    },
    driverHistoryHeader20: {
        en: 'Time Driving Est(hr)^',
        fr: 'Temps de conduite estimé (h)^'
    },
    driverHistoryHeader21: {
        en: 'Time Driving Act(hr)^',
        fr: 'Temps de conduite réel (h)^'
    },
    driverHistoryHeader22: {
        en: 'Time Driving Diff(hr)^',
        fr: 'Différence de temps de conduite (h)^'
    },
    driverHistoryHeader23: {
        en: 'Time Driving Depot(hr)^',
        fr: 'Temps de conduite au dépôt (h)^'
    },
    driverHistoryHeader24: {
        en: 'Time Start Trip(hr)^',
        fr: 'Heure de départ du trajet (h)^'
    },
    driverHistoryHeader25: {
        en: 'Time Offload(hr)^',
        fr: 'Temps de déchargement (h)^'
    },
    driverHistoryHeader26: {
        en: 'Time Total(hr)^',
        fr: 'Temps total (h)^'
    },
    driverHistoryHeader27: {
        en: 'Scheduled^',
        fr: 'Planifié^'
    },
    driverHistoryHeader27a: {
        en: 'Completed^',
        fr: 'Complété^'
    },
    driverHistoryHeader28: {
        en: 'Processed^',
        fr: 'Traité^'
    },
    driverHistoryHeader29: {
        en: 'Aborted^',
        fr: 'Annulé^'
    },
    driverHistoryHeader30: {
        en: 'Rescheduled^',
        fr: 'Reporté^'
    },
    driverHistoryHeader31: {
        en: 'OOS Stops^',
        fr: 'Arrêts HDS^'
    },
    driverHistoryHeader32: {
        en: 'OOS Pay^',
        fr: 'Prime HDS^'
    },
    driverHistoryHeader33: {
        en: 'Bags Split^',
        fr: 'Sacs divisés^'
    },
    driverHistoryHeader34: {
        en: 'Units Split^',
        fr: 'Unités divisées^'
    },
    driverHistoryHeader35: {
        en: 'Containers / Hour^',
        fr: 'Contenants / heure^'
    },
    driverHistoryHeader36: {
        en: 'Synthetic Containers^',
        fr: 'Contenants synthétiques'
    },
    driverHistoryHeader37: {
        en: 'Synthetic Containers / Hour^',
        fr: 'Contenants synthétiques / heure^'
    },
    driverHistoryHeader38: {
        en: 'Cost / Container($)^',
        fr: 'Coût / Contenant ($)^'
    },
    driverHistoryHeader39: {
        en: 'Cost / Synthetic Containers($)^',
        fr: 'Coût / Contenants synthétiques ($)^'
    },
    driverHistoryHeader40: {
        en: 'Time / Pickup(min)^',
        fr: 'Temps / Collecte(min)^'
    },
    driverHistoryHeader41: {
        en: 'Time / Bag(min)^',
        fr: 'Temps / Sac (min)^'
    },
    driverHistoryHeader42: {
        en: 'Pay Contractor^',
        fr: "Payer l'entrepreneur^"
    },
    driverHistoryHeader43: {
        en: 'Payment Type^',
        fr: 'Type de paiement^'
    },
    driverHistoryHeader44: {
        en: 'Pay Rate($)^',
        fr: 'Taux de rémunération ($)^'
    },
    driverHistoryHeader45: {
        en: 'Pay Breakdown($)^',
        fr: 'Ventilation de la paie ($)^'
    },
    driverHistoryHeader46: {
        en: 'Pay Total($)^',
        fr: 'Paiement total ($)^'
    },
    driverHistoryHeader47: {
        en: 'CSF Breakdown($)^',
        fr: 'Ventilation des FSC ($)^'
    },
    driverHistoryHeader48: {
        en: 'CSF Total($)^',
        fr: 'Total des FSC ($)^'
    },
    driverHistoryHeader49: {
        en: 'HFs($)^',
        fr: 'FMs($)^'
    },
    driverHistoryHeader50: {
        en: 'Volume Fee($)^',
        fr: 'Frais de volume ($)^'
    },
    driverHistoryHeader51: {
        en: 'Depot Cost Breakdown($)^',
        fr: 'Répartition des coûts du dépôt($)^'
    },
    driverHistoryHeader52: {
        en: 'Depot Cost($)^',
        fr: 'Coût du dépôt($)^'
    },
    driverHistoryHeader53: {
        en: 'Depot CSF-Cost($)^',
        fr: 'Coût FSC du dépôt($)^'
    },
    driverHistoryHeader54: {
        en: 'Depot Profit($)^',
        fr: 'Profit sur dépôt ($)^'
    },
    costTitle: {
        en: '*Depot Values from depot to first pickup, and last pickup to depot',
        fr: '*Valeurs du dépôt du dépôt à la première collecte, et de la dernière collecte au dépôt'
    },
    depotPart: {
        en: 'Depot Part',
        fr: 'Part du dépôt'
    },
    wageHr: {
        en: 'Wage hr',
        fr: 'Salaire horaire'
    },
    gasKm: {
        en: 'Gas km',
        fr: 'Essence km'
    },
    containersPerHour: {
        en: 'Containers per hour',
        fr: 'Contenants par heure'
    },
    containerTitle: {
        en: 'Number of containers picked up per hour of driving',
        fr: 'Nombre de contenants ramassés par heure de conduite'
    },
    containersCollected: {
        en: 'Containers Collected',
        fr: 'Contenants collectés'
    },
    handlingFees: {
        en: 'Handling Fees',
        fr: 'Frais de manutention'
    },
    fixedCostPerContainer: {
        en: 'Fixed Cost / Container',
        fr: 'Coût Fixe / Contenant'
    },
    costPerContainer: {
        en: 'Cost / Container',
        fr: 'Coût / Contenant'
    },
    costMinCSFPerContainer: {
        en: '(Cost - CSF) / Containers',
        fr: '(Coût - FSC) / Contenants'
    },
    csfMinCost: {
        en: 'CSF - Cost',
        fr: 'FSC - Coût'
    },
    csfPlusHFMinCost: {
        en: 'CSF + HF - Cost',
        fr: 'FSC + FM - Coût'
    },
    revenueProjected: {
        en: 'Revenue (Projected)',
        fr: 'Revenus (projetés)'
    },
    incompleteOrders: {
        en: 'Incomplete orders',
        fr: 'Commandes incomplètes'
    },
    costOfTrip: {
        en: 'Cost of trip',
        fr: 'Coût du trajet'
    },
    driverPaymentType: {
        en: 'Driver Payment Type',
        fr: 'Type de paiement du chauffeur'
    },
    driverWageDolPerHr: {
        en: 'Driver Wage ($/hr)',
        fr: 'Salaire du chauffeur ($/h)'
    },
    gasPriceDolPerL: {
        en: 'Gas Price ($/L)',
        fr: "Prix de l'essence ($/L)"
    },
    reimburseGasCost: {
        en: 'Reimburse Gas Cost',
        fr: "Rembourser les frais d'essence"
    },
    truckEfficiencyKmPerL: {
        en: 'Truck Efficiency (km/L)',
        fr: 'Efficacité du camion (km/L)'
    },
    distanceKm: {
        en: 'Distance (km)',
        fr: 'Distance (km)'
    },
    durationHrs: {
        en: 'Duration (hours)',
        fr: 'Durée (heures)'
    },
    useDefaultValues: {
        en: 'Use default values',
        fr: 'Utiliser les valeurs par défaut'
    },
    driverWage: {
        en: 'Driver Wage',
        fr: 'Salaire du chauffeur'
    },
    totalCommission: {
        en: 'Total Commission',
        fr: 'Commission totale'
    },
    gasCost: {
        en: 'Gas Cost',
        fr: "Coût d'essence"
    },
    gasReimbursmentCapped: {
        en: 'Gas reimbursement capped',
        fr: "Remboursement d'essence plafonné"
    },
    totalCost: {
        en: 'Total Cost',
        fr: 'Coût total'
    },
    measuredDuration: {
        en: 'Measured Duration',
        fr: 'Durée mesurée'
    },
    updateTripStatistics: {
        en: 'Update Trip Statistics',
        fr: 'Mettre à jour les statistiques de trajet'
    },
    driverOptions: {
        en: 'Driver Options',
        fr: 'Options de chauffeur'
    },
    pickupClusteringAlgorithm: {
        en: 'Pickup Clustering Algorithm',
        fr: 'Algorithme de regroupement des collectes'
    },
    capacityFirst: {
        en: 'Capacity First (Minimum number of drivers)',
        fr: "Capacité d'abord (Nombre minimum de chauffeurs)"
    },
    routeFirst: {
        en: 'Route First (Optimize driving distance)',
        fr: "Route d'abord (Optimiser la distance de conduite)"
    },
    evenSplit: {
        en: 'Even Split (Equal pickups per driver)',
        fr: 'Répartition égale (Collectes égales par chauffeur)'
    },
    minDriversEvenSplit: {
        en: 'Even Split + Minimum Drivers',
        fr: 'Répartition égale + Chauffeurs minimum'
    },
    routeDestinationBy: {
        en: 'Route Destination By',
        fr: "Destination de l'itinéraire par"
    },
    pickupOptions: {
        en: 'Pickup Options',
        fr: 'Options de collecte'
    },
    pictureConfirmationStatus: {
        en: 'Picture Confirmation is {{status}}',
        fr: 'Confirmation par photo est {{status}}'
    },
    pictureConfirmationReadOnly: {
        en: 'Picture confirmation setting cannot be changed here, please contact support to modify',
        fr:
            'Le paramètre de confirmation par image ne peut pas être modifié ici. Veuillez communiquer avec le soutien technique pour le modifier.'
    },
    minimumBagsRequired: {
        en: 'Minimum Bags Required',
        fr: 'Nombre minimum de sacs requis'
    },
    defaultGasPrice: {
        en: 'Default Gas Price',
        fr: "Prix d'essence par défaut"
    },
    defaultEmployeeWageDolPerHr: {
        en: 'Default Employee Wage ($/hr)',
        fr: 'Salaire par défaut des employés ($/h)'
    },
    defaultDriverFuelEffKmPerL: {
        en: 'Default Driver Fuel Efficiency (km/L)',
        fr: 'Efficacité de carburant du chauffeur par défaut (km/L)'
    },
    collectorOptions: {
        en: 'Collector Options',
        fr: 'Options de collecteur'
    },
    collectorName: {
        en: 'Collector Name',
        fr: 'Nom du collecteur'
    },
    enterValidPhone: {
        en: 'Please enter a valid phone.',
        fr: 'Veuillez entrer un numéro de téléphone valide.'
    },
    unservicedDates: {
        en: 'Unserviced Dates',
        fr: 'Dates non desservies'
    },
    monthlyCosts: {
        en: 'Monthly Costs',
        fr: 'Coûts mensuels'
    },
    costsFor: {
        en: 'Costs for',
        fr: 'Coûts pour'
    },
    recurringCosts: {
        en: 'Recurring Costs',
        fr: 'Coûts récurrents'
    },
    oneTime: {
        en: 'One Time',
        fr: 'Une fois'
    },
    bagCapacity: {
        en: 'Bag Capacity',
        fr: 'Capacité de sacs'
    },
    noDriversPickupNotRouted: {
        en: 'No Drivers available. Pickups will not be routed',
        fr: 'Aucun chauffeur disponible. Les collectes ne seront pas acheminées'
    },
    addInactiveDriver: {
        en: 'Add Inactive Driver',
        fr: 'Ajouter chauffeur inactif'
    },
    addDriverToAllDays: {
        en: 'Add driver to all days',
        fr: 'Ajouter un chauffeur à tous les jours'
    },
    addDriverAllDaysWarning: {
        en: 'This will add the driver to all days of the week. Would you like to continue?',
        fr: 'Ceci ajoutera le chauffeur à tous les jours de la semaine. Voulez-vous continuer?'
    },
    addDriversTo: {
        en: 'Add Drivers to',
        fr: 'Ajouter des chauffeurs à'
    },
    addToAllDays: {
        en: 'Add to all days',
        fr: 'Ajouter à tous les jours'
    },
    pleaseSelectTime: {
        en: 'Please select a time',
        fr: 'Veuillez sélectionner une heure'
    },
    loadsPerDay: {
        en: 'Loads Per Day',
        fr: 'Charges par jour'
    },
    loadTimeOffset: {
        en: 'Load Time Offset (hrs)',
        fr: "Décalage de l'heure de chargement (heures)"
    },
    useDestinationAddress: {
        en: 'Use Destination Address',
        fr: "Utiliser l'adresse de destination"
    },
    addDate: {
        en: 'Add date',
        fr: 'Ajouter date'
    },
    estimatedVolume: {
        en: 'Estimated Volume',
        fr: 'Volume estimé'
    },
    estimatedLoads: {
        en: 'Estimated Loads',
        fr: 'Charges estimées'
    },
    overCapacity: {
        en: ' over capacity',
        fr: ' au-delà de la capacité'
    },
    resumeTrip: {
        en: 'Resume Trip',
        fr: 'Reprendre la tournée'
    },
    customerPayloadConfirmation: {
        en: 'Customer Payload Confirmation',
        fr: 'Confirmation de charge du client'
    },
    contactSupportToAbortPickup: {
        en: 'Please contact support to abort this pickup.',
        fr: 'Veuillez contacter le service de soutien pour annuler cette collecte.'
    },
    inputDriverCodeForUser: {
        en: 'Please input a driver code for this user',
        fr: 'Veuillez saisir un code de chauffeur pour cet utilisateur'
    },
    driverCodeRequired: {
        en: 'Driver code Required',
        fr: 'Code de chauffeur requis'
    },
    employeeWageRequired: {
        en: 'Employee wage is required',
        fr: "Salaire de l'employé requis"
    },
    fuelEfficiencyRequired: {
        en: 'Fuel efficiency is required',
        fr: 'Efficacité énergétique est requise'
    },
    enterPickupCapacity: {
        en: 'You must enter a pickup capacity',
        fr: 'Vous devez saisir une capacité de collecte'
    },
    enterBagCapacity: {
        en: 'You must enter a bag capacity',
        fr: 'Vous devez saisir une capacité de sacs'
    },
    enterLoadsPerDay: {
        en: 'You must enter loads per day',
        fr: 'Vous devez saisir le nombre de chargements par jour'
    },
    enterLoadTime: {
        en: 'You must enter load time',
        fr: 'Vous devez saisir le temps de chargement'
    },
    userID: {
        en: 'User ID',
        fr: 'ID Utilisateur'
    },
    loginPIN: {
        en: 'Login PIN',
        fr: 'NIP de connexion'
    },
    userIDRequired: {
        en: 'Login PIN Required',
        fr: 'NIP de connexion requis'
    },
    PORID: {
        en: 'POR ID',
        fr: 'POR ID'
    },
    PORIDRequired: {
        en: 'ID POR',
        fr: 'ID POR requis'
    },
    use2FA: {
        en: 'Use 2FA',
        fr: "Utilisez l'A2F"
    },
    bypass2FA: {
        en: 'Bypass 2FA',
        fr: "Contourner l'A2F"
    },
    accountBanned: {
        en: 'This account is currently banned',
        fr: 'Ce compte est actuellement banni'
    },
    userInfo: {
        en: 'User Info',
        fr: "Information de l'utilisateur"
    },
    accountPermissions: {
        en: 'Account Permissions',
        fr: 'Permissions du compte'
    },
    driverInfo: {
        en: 'Driver Info',
        fr: 'Information du chauffeur'
    },
    driverUniqueCode: {
        en: 'Driver Unique Code',
        fr: 'Code unique du chauffeur'
    },
    fuelEfficiency: {
        en: 'Fuel Efficiency',
        fr: 'Rendement énergétique'
    },
    pickupCapacity: {
        en: 'Pickup Capacity',
        fr: 'Capacité de collecte'
    },
    zoneDetermined: {
        en: 'Zone Determined',
        fr: 'Zone déterminée'
    },
    autoUpdate: {
        en: 'Auto Update',
        fr: 'Auto-màj'
    },
    takeLunch: {
        en: 'Take Lunch',
        fr: 'Prendre le dîner'
    },
    takeBreak: {
        en: 'Take Break',
        fr: 'Prendre une pause'
    },
    recordVehicleData: {
        en: 'Record Vehicle Data',
        fr: 'Enregistrer les données du véhicule'
    },
    displayAccountabilityBanner: {
        en: 'Display Accountability Banner',
        fr: 'Afficher la bannière de responsabilité'
    },
    displayAccountability: {
        en: 'Display Accountability',
        fr: 'Afficher la responsabilité'
    },
    maxCompleteDistance: {
        en: 'Max Complete Distance Allowed',
        fr: 'Distance maximale de complétion autorisée'
    },
    overrideMaxCompleteDistance: {
        en: 'Override Maximum Complete Distance Allowed',
        fr: 'Outrepasser la distance maximale de complétion autorisée'
    },
    distanceInMeters: {
        en: 'Max Distance (m)',
        fr: 'Distance max. (m)'
    },
    maxApproval: {
        en: 'Maximum GPS update distance allowed (m)',
        fr: 'Distance maximale de mise à jour GPS autorisée (m)'
    },
    maxDriverApprovalDistance: {
        en: 'Maximum distance from pickup location for driver to request GPS location update',
        fr:
            'Distance maximale depuis le point de collecte pour que le conducteur puisse demander une mise à jour de localisation GPS'
    },
    forceCameraCapture: {
        en: 'Force Camera Capture',
        fr: 'Forcer la capture par caméra'
    },
    forceCameraCaptureHelper: {
        en:
            'When enabled, drivers must take photos directly with their camera when prompted. They will not be able to upload existing images from their photo gallery.',
        fr:
            "Lorsqu'activé, les chauffeurs doivent prendre des photos directement avec leur caméra lorsque demandé. Ils ne pourront pas téléverser des images existantes à partir de leur galerie de photos."
    },
    abortPickups: {
        en: 'Abort Pickups',
        fr: 'Annuler les collectes'
    },
    paymentModel: {
        en: 'Payment Model',
        fr: 'Modèle de paiement'
    },
    payThroughSystem: {
        en: 'Pay Through System',
        fr: 'Payer via le système'
    },
    paidLunch: {
        en: 'Paid Lunch',
        fr: 'Dîner rémunéré'
    },
    paidBreak: {
        en: 'Paid Break',
        fr: 'Pause rémunérée'
    },
    chargeWageToDepot: {
        en: 'Charge Wage To Depot',
        fr: 'Facturer le salaire au dépôt'
    },
    payThroughSystemWarning: {
        en: 'This will pay the driver through our e-transfer process and charge back the depot if applicable.',
        fr:
            'Ceci permettra de payer le chauffeur via notre processus de virement électronique et de facturer le dépôt si applicable.'
    },
    lightView: {
        en: 'Limit Clerks View',
        fr: 'Limiter la vue des commis'
    },
    PORUser: {
        en: 'POR User',
        fr: 'Utilisateur POR'
    },
    fullView: {
        en: 'Full View',
        fr: 'Vue complète'
    },
    RVMView: { en: 'RVM Restricted', fr: 'Restreint RVM' },
    PORView: { en: 'POR Restricted', fr: 'Restreint POR' },
    locationUpdateRequestSent: {
        en: 'Location Pin update request sent',
        fr: "Demande de mise à jour de l'épingle envoyée"
    },
    locationUpdateSuccess: {
        en: 'Location Pin updated successfully',
        fr: 'Épingle mise à jour avec succès'
    },
    unableToUpdateLocationPin: {
        en:
            "Unable to update location pin - you're too far from the original pickup address. Contact support if you need help.",
        fr:
            "Impossible de mettre à jour l'épingle - vous êtes trop loin de l'adresse de collecte d'origine. Contactez le support si vous avez besoin d'aide."
    },
    unexpectedErrorUpdatingPin: {
        en: 'Unexpected Error updating pickup location pin',
        fr: "Erreur inattendue lors de la mise à jour de l'épingle"
    },
    perBagTime: {
        en: 'Per Bag Time',
        fr: 'Temps par sac'
    },
    stopTime: {
        en: 'Stop Time',
        fr: "Temps d'arrêt"
    },
    addedTime: {
        en: 'Added Time',
        fr: 'Temps ajouté'
    },
    hasDifficultyModifiers: {
        en: 'Has difficulty modifiers',
        fr: 'A des modificateurs de difficulté'
    }
};

const driverPickupTranslations = {
    proceedToStart: {
        en: 'Proceed to your starting location',
        fr: 'Dirigez-vous vers votre point de départ'
    },
    youHaveClockedIn: {
        en: "You've clocked in!",
        fr: 'Vous avez pointé!'
    },
    rememberTo: {
        en: 'Please remember to:',
        fr: 'Veuillez vous rappeler de:'
    },
    shouldLeave: {
        en: 'You should leave for your first pickup at',
        fr: 'Vous devriez partir pour votre première collecte à'
    },
    shouldHaveLeft: {
        en: 'You should have left for your first pickup at',
        fr: 'Vous auriez dû partir pour votre première collecte à'
    },
    lateReason: {
        en: 'Reason for being late',
        fr: 'Raison du retard'
    },
    completePreTrip: {
        en: 'Complete Pre Trip',
        fr: 'Compléter le pré-trajet'
    },
    proceedToFirstPickup: {
        en: 'Proceed to First Pickup',
        fr: 'Se rendre à la première collecte'
    },
    goNextPickup: {
        en: 'Go to next pickup',
        fr: 'Se rendre à la prochaine collecte'
    },
    undoPickups: {
        en: 'Undo pickups',
        fr: 'Modifier la collecte courante'
    },
    selectNextActions: {
        en: 'Select your next action:',
        fr: 'Sélectionnez votre prochaine action:'
    },
    noSpeedingObeyTrafficLaws: {
        en: 'No speeding. Obey all traffic laws - safety is not optional.',
        fr:
            "Veuillez respecter les limites de vitesse. Respectez le code de la route - La sécurité n'est pas optionnelle."
    },
    sendSMS: {
        en: 'Send SMS?',
        fr: 'Envoyer un SMS?'
    },
    confirmSendSMSMessage1: {
        en: "We'll send an SMS to the next customer ",
        fr: 'Désirez-vous envoyer un SMS au prochain client '
    },
    confirmSendSMSMessage2: {
        en: " that you're on your way. Confirm?",
        fr: " pour l'informer que vous êtes en route?"
    },
    customerComments: {
        en: 'Customer comments:',
        fr: 'Commentaires du client :'
    },
    finishPickup: {
        en: 'Finish Pickup',
        fr: 'Terminer la collecte'
    },
    customerNotes: {
        en: 'Customer Notes',
        fr: 'Notes du client'
    },
    completeFoundBags: {
        en: 'Complete (Found the bags)',
        fr: 'Terminé (Sacs trouvés)'
    },
    skipBackLater: {
        en: 'Skip (Come back later today)',
        fr: `Sauter (Revenir plus tard)`
    },
    abortCantFind: {
        en: `Abort (Can't find the bags)`,
        fr: `Abandonner (Sacs introuvables)`
    },
    whyAreYouSkipping: {
        en: 'Why are you skipping?',
        fr: 'Pourquoi passez-vous?'
    },
    updateTimeOfDayPreference: {
        en: 'Update time-of-day preference for pickup?',
        fr: "Mettre à jour la préférence d'heure pour la collecte?"
    },
    explanation: {
        en: 'Explanation',
        fr: 'Explication'
    },
    whyAreYouAborting: {
        en: 'Why are you aborting?',
        fr: 'Pourquoi abandonnez-vous?'
    },
    pleaseProvideReason: {
        en: 'Please provide an explanation',
        fr: 'Veuillez fournir une explication'
    },
    haveYouDoneTheFollowing: {
        en: 'Have you done the following?',
        fr: ' Avez-vous fait ce qui suit?'
    },
    beforeAbortDoSteps: {
        en: 'Before aborting, please follow these steps:',
        fr: `Avant d'annuler, veuillez suivre ces étapes:`
    },
    confirmThePlayload: {
        en: 'Confirm the payload',
        fr: 'Confirmez la cargaison'
    },
    pictureRequired: {
        en: 'Picture Required',
        fr: 'Photo requise'
    },
    recordBagIdentifier: {
        en: 'Record bag identifier',
        fr: `Enregistrer l'identifiant du sac`
    },
    bagTagMustNotBeUsed: {
        en: 'Bagtag must not be currently used',
        fr: `L'autocollant de sac ne doit pas être actuellement utilisée`
    },
    apply: {
        en: 'Apply',
        fr: 'Appliquer'
    },
    makeSureWriteOnBag: {
        en: 'Make sure to write this on the bags!',
        fr: `Assurez-vous de l'écrire sur les sacs!`
    },
    anyIssuesWithBags: {
        en: 'Any issues with the pickup?',
        fr: 'Problèmes avec la collecte?'
    },
    additionalDetails: {
        en: 'Additional Details',
        fr: 'Détails supplémentaires'
    },
    comments: {
        en: 'Comments',
        fr: 'Commentaires'
    },
    additionalComments: {
        en: 'Additional Comments',
        fr: 'Commentaires additionnels'
    },
    customer: {
        en: 'Customer',
        fr: 'Client'
    },
    confirmBags: {
        en: 'Confirm Bags',
        fr: 'Confirmer les sacs'
    },
    recordBagtag: {
        en: 'Record Bagtag',
        fr: `Enregistrer l'autocollant de sac`
    },
    completePickup: {
        en: 'Complete Pickup',
        fr: 'Complétez la collecte'
    },
    incompletePickup: {
        en: 'Incomplete Pickups',
        fr: 'Collectes incomplètes'
    },
    take: {
        en: 'Take',
        fr: 'Prendre'
    },
    picture: {
        en: 'Picture',
        fr: 'Photo'
    },
    addNote: {
        en: 'Add Note',
        fr: 'Ajouter une note'
    },
    enterReason: {
        en: 'Enter Reason',
        fr: 'Entrer la raison'
    },
    captureBags: {
        en: 'Capture Bags',
        fr: 'Capturer les sacs'
    },
    captureSkippedLocationImage: {
        en: 'Capture Skipped Location Image',
        fr: "Capturer l'image de l'emplacement ignoré"
    },
    captureAbortLocationImage: {
        en: 'Capture Aborted Location Image',
        fr: "Capturer l'image de l'emplacement annulé"
    },
    followUp: {
        en: 'Follow Up',
        fr: 'Suivi'
    },
    timePreference: {
        en: 'Time Preference',
        fr: 'Préférence de temps'
    },
    dropOffPoint: {
        en: 'Drop-off point',
        fr: 'Point de dépôt'
    },
    offLoadAndPrepare: {
        en: 'take picture of truck contents',
        fr: 'prendre une photo du contenu du camion, préparer pour le prochain trajet'
    },
    iveArrivedAtCollector: {
        en: "I've Arrived at {{depotLocation}}",
        fr: `Je suis arrivé à {{depotLocation}}`
    },
    clockOut: {
        en: 'Clock Out',
        fr: 'Sortie'
    },
    whenDone: {
        en: 'when done.',
        fr: 'Quand vous avez terminé.'
    },
    yourNextPickup: {
        en: '{{min}} drive to your next pickup:',
        fr: '{{min}} de trajet vers votre prochaine collecte:'
    },
    proceedToYourNextDropZone: {
        en: 'Proceed to your drop zone:',
        fr: 'Dirigez-vous vers votre zone de dépôt:'
    },
    selectHowToManage: {
        en: 'Select how to handle this pickup:',
        fr: 'Sélectionnez comment gérer cette collecte :'
    },
    proceedToNextPickup: {
        en: 'Proceed to your next pickup:',
        fr: 'Passez à votre prochaine collecte :'
    },
    headToNextStop: {
        en: 'Head to next stop:',
        fr: 'Dirigez-vous vers le prochain arrêt:'
    },
    timeRemainingForLunch: {
        en: 'Time remaining for lunch:',
        fr: `Temps restant pour le dîner:`
    },
    timeRemainingForBreak: {
        en: 'Time remaining for break:',
        fr: `Temps restant pour la pause:`
    },
    onBreak: {
        en: 'On Break',
        fr: 'En pause'
    },
    in: {
        en: 'in',
        fr: 'dans'
    },
    onLunch: {
        en: 'On Lunch',
        fr: 'Au lunch'
    },
    signOut: {
        en: 'Sign out',
        fr: 'Se déconnecter'
    },
    skippedReason: {
        en: 'Skipped Reason',
        fr: 'Raison sautée'
    },
    noDirections: {
        en: 'No Directions Provided',
        fr: 'Aucune indication fournie'
    },
    pickupInfo: {
        en: 'Pickup info',
        fr: 'Info de collecte'
    },
    driverNote: {
        en: 'Driver note',
        fr: 'Note du chauffeur'
    },
    reAddPickupRouteMessage: {
        en: `This will put the pickup back on today's route.`,
        fr: `Cela remettra la collecte sur la route d'aujourd'hui.`
    },
    undoPickup: {
        en: 'Undo pickup',
        fr: 'Annuler la collecte'
    },
    additionalInformation: {
        en: 'Enter additional information',
        fr: 'Entrez des informations supplémentaires'
    },
    proceedToNextTrip: {
        en: 'Proceed to Next Trip',
        fr: 'Procéder au prochain trajet'
    },
    yourDroveFor1: {
        en: 'You drove for',
        fr: 'Vous avez conduit pendant'
    },
    yourDroveFor2: {
        en: 'and completed',
        fr: 'et complété.'
    },
    finished: {
        en: 'Finished',
        fr: 'Terminé'
    },
    perPickup: {
        en: 'Per Pickup',
        fr: 'Par collecte'
    },
    perBag: {
        en: 'Per Bag',
        fr: 'Par sac'
    },
    importPickups: {
        en: 'Import Pickups',
        fr: 'Importer les collectes'
    },
    uploadFile: {
        en: 'Upload File',
        fr: 'Télécharger le fichier'
    },
    customerName: {
        en: 'Customer Name',
        fr: 'Nom du client'
    },
    importUnsuccesful: {
        en: 'Import Unsuccessful',
        fr: `Importation échouée`
    },
    noPickupsThisDate: {
        en: 'No pickups on this date.',
        fr: `Aucune collecte à cette date.`
    },
    youArrivedToEarly: {
        en: 'You arrived too early',
        fr: `T'es arrivé(e) trop tôt.`
    },
    noEarlierThan: {
        en: 'Please arrive no earlier than {{maxEarlyStartRouteTime}} min before the scheduled starting time.',
        fr: `S'il te plaît, n'arrive pas plus tôt que {{maxEarlyStartRouteTime}} minutes avant l'heure prévue du début.`
    },
    gpsNotRegistered: {
        en: 'GPS not registered',
        fr: 'GPS non enregistré.'
    },
    turnLocationsOn: {
        en: 'Please turn your location services ON',
        fr: `S'il te plaît, active tes services de localisation.`
    },
    youMustBeCloser: {
        en:
            'You must be at the pickup location to proceed. Please move closer to the address and try again. Contact support if you continue to have issues.',
        fr:
            "Vous devez être à l'emplacement de la collecte pour continuer. Veuillez vous rapprocher de l'adresse et réessayer. Contactez le support si le problème persiste."
    },
    youMustBeCloser2: {
        en: `You must take photos of the customer's order where it was placed. Move closer to the pickup location and try again. If you're already at the order location, tap "Update using my location".`,
        fr: `Vous devez prendre des photos de la commande du client à l'endroit où elle a été placée. Rapprochez-vous du lieu de collecte et réessayez. Si vous êtes déjà à l'emplacement de la commande, appuyez sur « Mettre à jour en utilisant ma position ».`
    },
    distanceCheckedAgain: {
        en: 'Reminder: Distance will be checked again when you complete this pickup.',
        fr: 'Rappel : La distance sera vérifiée à nouveau lorsque vous terminerez cette collecte.'
    },
    scheduledStartTimeIs: {
        en: 'Scheduled starting time is',
        fr: "L'heure prévue de début est."
    },
    truckNumber: {
        en: 'Truck Number',
        fr: 'Numéro du camion'
    },
    captureStop: {
        en: 'Capture Stop',
        fr: "Capturez l'arrêt."
    },
    tripsRerouted: {
        en: `Today's Route Has Been Updated`,
        fr: `L'itinéraire d'aujourd'hui a été mis à jour.`
    },
    reviewTripUpdate: {
        en: 'There was an update to your route. Please review before continuing.',
        fr: `"Il y a eu une mise à jour de votre itinéraire. Veuillez vérifier avant de continuer.`
    },
    canOnlyClockOutWhenDone: {
        en:
            'You can only clock out once all your pickups are completed. If you cannot complete your pickups contact SkipTheDepot support',
        fr:
            'Vous pouvez seulement terminer votre quart de travail une fois toutes vos collectes complétées. Si vous ne pouvez pas compléter vos collectes, contactez le soutien de SkipTheDepot'
    },
    permittedLocations: {
        en:
            'Accessing hallways, recycling rooms, lobbies, elevators, and garages is permitted. Entering the residence is NOT permitted.',
        fr: `L'accès aux couloirs, salles de recyclage, halls d'entrée, ascenseurs et garages est autorisé. L'entrée dans la résidence n'est PAS autorisée.`
    },
    somePickupsCouldNotBeReassigned: {
        en: 'Some pickups could not be assigned.  Recalculating trip...',
        fr: "Certaines prises en charge n'ont pas pu être attribuées.. Recalcul du trajet..."
    },
    pickupAssignedRecalculating: {
        en: 'Pickup{{plural}} assigned.  Recalculating trip...',
        fr: 'Collecte{{plural}} assignée(s). Recalcul du trajet...'
    },
    pickupAbortedRecalculating: {
        en: 'Pickup aborted. Recalculating trip...',
        fr: 'Collecte annulée. Recalcul du trajet...'
    },
    tripRecalculationComplete: {
        en: 'Trip recalculation complete.',
        fr: 'Recalcul du trajet terminé'
    },
    failedToRecalculate: {
        en: 'Failed to recalculate trip. Please manually trigger trip recalculation',
        fr: `Échec du recalcul du trajet. Veuillez déclencher manuellement le recalcul du trajet.`
    },
    failedToReassign: {
        en: 'Failed to reassign pickups. Please try again in a moment.',
        fr: 'Échec de réassignation des collectes. Veuillez réessayer dans un instant.'
    },
    unableToCompletePickup: {
        en: 'Unable to complete pickup. Please contact support.',
        fr: 'Impossible de compléter la collecte. Veuillez contacter le soutien.'
    },
    unableToCompleteStop: {
        en: 'Unable to complete stop, please try again.',
        fr: "Impossible de compléter l'arrêt, veuillez réessayer."
    },
    truckInformation: {
        en: 'Truck information',
        fr: 'Informations sur le camion'
    },
    locationAccess: {
        en: 'Location Access',
        fr: 'Accès au lieu'
    },
    thisAppCollectionLocation: {
        en:
            'This app collects location data to enable pickup routing, driver location updates, and pickups statistics even when the app is closed or not in use.',
        fr:
            "Cette application recueille des données de localisation pour permettre le routage des collectes, les mises à jour de l'emplacement des chauffeurs et les statistiques de collectes, même lorsque l'application est fermée ou non utilisée."
    },
    doNotShowThisAgain: {
        en: 'Do not show this again',
        fr: 'Ne plus afficher ceci'
    },
    toSaveTime1: {
        en:
            'To save time, only use the customer 4 digit code if the bags are pre-labeled and secure. Otherwise use your ',
        fr:
            'Pour gagner du temps, utilisez seulement le code à 4 chiffres du client si les sacs sont déjà étiquetés et bien fermés. Sinon, utilisez votre propre code. '
    },
    toSaveTime2: {
        en: ' driver code + next available number',
        fr: ' Code du chauffeur + prochain numéro disponible'
    },
    toSaveTime3: {
        en:
            ' Boxes are accepted! To save time, place boxes directly into {{container}} and move multiple boxes at the same time.',
        fr:
            ' Les boîtes sont acceptées! Pour gagner du temps, placez les boîtes directement dans le {{container}} et déplacez plusieurs boîtes en même temps.'
    },
    contactForDriverCode: {
        en: 'Please contact {{brandName}} for your Driver Code',
        fr: 'Veuillez contacter {{brandName}} pour obtenir votre code de chauffeur.'
    },
    gasReimbursment: {
        en: 'Gas Reimbursement',
        fr: 'Remboursement d’essence'
    },
    stopPayment: {
        en: 'Stop Payment',
        fr: 'Arrêt de paiement'
    },
    earningsThisWeek: {
        en: 'Earnings this week',
        fr: 'Revenus cette semaine'
    },
    areYouSureClockout: {
        en: 'Are you sure you want to clock out right now?',
        fr: 'Êtes-vous certain de vouloir vous enregistrer à la sortie maintenant?'
    },
    pleaseLoadBins: {
        en: 'Please load {{numOfBinsForTrip}} bins',
        fr: 'Veuillez charger {{numOfBinsForTrip}} bacs'
    },
    lunchBreakAt: {
        en: 'lunch break at',
        fr: 'pause dîner à'
    },
    labelMustBe: {
        en: 'Label must be exactly {{length}} characters long',
        fr: "L'étiquette doit comporter exactement {{length}} caractères."
    },
    completeRequest: {
        en: 'Complete request',
        fr: 'Compléter la demande'
    },
    noEmployees: {
        en: 'No employees currently associated with this collector.',
        fr: 'Aucun employé actuellement associé à ce collecteur.'
    },
    noTechnologies: {
        en: 'No technologies currently associated with this collector.',
        fr: 'Aucune technologie actuellement associée à ce collecteur.'
    },
    bagtagAlreadyInUse: {
        en: 'The bagtag is already in use.',
        fr: "L'étiquette de sac est déjà utilisée"
    },
    bagtagBelongsToAnother: {
        en: 'The bagtag belongs to another customer. The current customers bagtag is: {{bagtag}}.',
        fr: "L'étiquette de sac appartient à un autre client. L'étiquette de sac du client actuel est: {{bagtag}}."
    },
    customerIssue: {
        en: 'Customer Issue',
        fr: 'Problème client'
    },
    driverIssue: {
        en: 'Driver Issue',
        fr: 'Problème de chauffeur'
    },
    behind: {
        en: 'Behind',
        fr: 'En retard'
    },
    onTime: {
        en: 'On Time',
        fr: `À l'heure`
    },
    etaRecalc: { en: 'Eta Recalc:', fr: 'ETA recalculé' },
    collectionTimingAlert: {
        en: 'Collection Timing Alert',
        fr: 'Alerte de Timing de Collecte'
    },
    cameraRequired: {
        en: 'Camera Required',
        fr: 'Caméra requise'
    },
    capture: {
        en: 'Capture',
        fr: 'Capturer'
    },
    yourRunningLate: {
        en:
            'You’re running {{lateTime}} minutes behind - please consider ending your {{breakType}} early to stay on schedule.',
        fr:
            'Vous accusez {{lateTime}} minutes de retard - pensez à écourter votre {{breakType}} pour rester dans les temps.'
    },
    yourCurrentlyOnBreak: {
        en: "You're currently on a {{breakType}}. Tap the button below when you're ready to return.",
        fr:
            'Vous êtes actuellement en {{breakType}}. Appuyez sur le bouton ci-dessous quand vous êtes prêt à reprendre.'
    },
    collectionPaceIssue: {
        en:
            'Your collection pace is outside the expected range - either too fast or too slow. This is disrupting schedule adherence and negatively affecting customer satisfaction.',
        fr:
            "Votre rythme de collecte est en dehors de la plage attendue - soit trop rapide ou trop lent. Ceci perturbe le respect de l'horaire et nuit à la satisfaction de la clientèle."
    },
    followAllTrafficLaws: {
        en: 'Follow all traffic laws.',
        fr: 'Respectez toutes les lois de la circulation.'
    },
    maintainPerformance: {
        en: 'Maintain consistent performance.',
        fr: 'Maintenez une performance constante.'
    },
    ensureTiming: {
        en:
            'Please ensure your timing aligns with the schedule for each stop. Continued non-compliance may lead to formal review and disciplinary action.',
        fr:
            "Veuillez vous assurer que votre horaire correspond à l'horaire prévu pour chaque arrêt. Le non-respect continu peut mener à une révision formelle et à des mesures disciplinaires."
    },
    nextAction: {
        en: 'Next action',
        fr: 'prochaine action'
    },
    warnings: {
        en: 'Warnings',
        fr: 'avertissements'
    },
    adjustPacing: {
        en: 'Adjust pacing to match route experience.',
        fr: "Ajustez le rythme pour correspondre à l'expérience de la route."
    },
    noSpeeding: {
        en: 'No speeding - drive safely',
        fr: "Pas d'excès de vitesse - conduisez prudemment"
    },
    takeFinishPicture: {
        en: `Open the rear door and take a photo of the vehicle's contents.`,
        fr: `Ouvrez la porte arrière et prenez une photo du contenu du véhicule.`
    },
    takeStartPicture: {
        en: 'Take a photo of your starting location.',
        fr: 'Prenez une photo de votre lieu de départ.'
    },
    takeBreakNow: {
        en: 'Are you sure you want to take break now?',
        fr: `Êtes-vous sûr de vouloir prendre une pause maintenant?`
    },
    takeLunchNow: {
        en: 'Are you sure you want to take lunch now?',
        fr: `Êtes-vous sûr de vouloir prendre votre dîner maintenant?`
    },
    drive: {
        en: 'Drive',
        fr: 'Conduire'
    },
    collect: {
        en: 'Collect',
        fr: 'Collecter'
    },
    userOverRideLunch: {
        en: 'Override collector lunch/break',
        fr: 'Annuler la pause/dîner du collecteur'
    },
    userOverRideLunch2: {
        en: 'Override Lunch/Break',
        fr: 'Annuler la pause/dîner'
    },
    lunchDuration: {
        en: 'Lunch Duration(m)',
        fr: 'Durée du dîner(m)'
    },
    lunchPolicy: {
        en: 'Lunch policy',
        fr: 'Politique de dîner'
    },
    breakDuration: {
        en: 'Break Duration(m)',
        fr: 'Durée de la pause(m)'
    },
    breakPolicy: {
        en: 'Break policy',
        fr: 'Politique de pause'
    },
    breakNumber: {
        en: 'Break Number',
        fr: 'Numéro de pause'
    },
    functionality: {
        en: 'Functionality',
        fr: 'Fonctionnalité'
    },
    lunchBreakConfiguration: {
        en: 'Lunch/Break configuration',
        fr: 'Configuration pause/dîner'
    },
    tripEnd: {
        en: 'Trip Ended',
        fr: 'Voyage terminé'
    },
    tripStart: {
        en: 'Trip Started',
        fr: 'Voyage commencé'
    },
    updateUsingMyLocation: {
        en: 'Update using my location',
        fr: 'Mettre à jour en utilisant ma position'
    },
    leaveBags: {
        en: 'Leave {{bagAmount}} {{unit}}',
        fr: 'Laisser {{bagAmount}} {{unit}}'
    },
    didYouRememberToLeaveBags: {
        en: 'Did you remember to leave customer {{bagAmount}} {{unit}}?',
        fr: 'Avez-vous pensé à laisser {{bagAmount}} {{unit}} au client?'
    },
    finishOffloading: {
        en: 'Finish Offloading',
        fr: 'Terminer le déchargement'
    },
    takePictureOfVehicleContents: {
        en: 'Take Picture Of Vehicle Contents',
        fr: 'Prendre une photo du contenu du véhicule'
    }
};

const abortReminders = {
    ringTheDoorBell: {
        en: '1. Ring the doorbell',
        fr: '1. Sonnez à la porte'
    },
    callTheCustomer: {
        en: '2. Call the customer - {{customerName}} - {{customerPhone}}',
        fr: '2. Appelez le client - {{customerName}} - {{customerPhone}}'
    },
    textCustomer: {
        en: '3. If no answer - Text Customer',
        fr: '3. Si pas de réponse - Envoyez un message texte au client'
    },
    wait5Mins: {
        en: '4. If no answer - Wait 5 Minutes',
        fr: '4. Si pas de réponse - Attendez 5 minutes.'
    },
    callAgain: {
        en: '5. If no answer - Call Customer Again',
        fr: '5. Si pas de réponse - Appelez à nouveau le client.'
    }
};

const adminUITranslations = {
    nextDate: {
        en: 'NextDate',
        fr: 'Date suivante'
    },
    byPassZones: {
        en: 'ByPassZones',
        fr: 'Zones de contournement'
    },
    onePerTrip: {
        en: '1 per Trip',
        fr: '1 par voyage'
    },
    appliedPromoCode: {
        en: 'Applied PromoCode',
        fr: 'Code promo appliqué'
    },
    etaCalculations: {
        en: 'ETA Calculations',
        fr: 'Calculs de l’HEA'
    },
    lastRecalc: {
        en: 'Last Recalc',
        fr: 'Dernier recalcul'
    },
    initiator: {
        en: 'Initiator',
        fr: 'Initiateur'
    },
    inOrderToComplete: {
        en: 'In order to complete this pickup, it must first be assigned to a driver and a trip.',
        fr: "Pour compléter ce ramassage, il doit d'abord être assigné à un chauffeur et à un trajet."
    },
    cannotCompleteUnrouted: {
        en: 'Cannot complete unrouted pickup. Please assign to a trip/driver and recalculate the route.',
        fr:
            "Impossible de compléter la collecte non assignée. Veuillez l'assigner à un voyage/chauffeur et recalculer l'itinéraire."
    },
    cannotAbortUnrouted: {
        en: "Cannot abort unrouted pickup. Please cancel from the customer's account.",
        fr: "Impossible d'annuler la collecte non assignée. Veuillez annuler depuis le compte du client."
    },
    cannotCompleteNotToday: {
        en: 'Cannot complete pickups on past/future dates. Please reschedule first.',
        fr: "Impossible de compléter les collectes à des dates passées/futures. Veuillez d'abord reprogrammer."
    },
    cannotAbortNotToday: {
        en: "Cannot abort pickups on past/future dates. Please cancel from the customer's account.",
        fr:
            "Impossible d'annuler les collectes à des dates passées/futures. Veuillez annuler depuis le compte du client."
    },
    stopDuration: {
        en: 'Stop Duration',
        fr: `Durée de l’arrêt`
    },
    stopPay: {
        en: 'Stop Pay',
        fr: 'Rémunération pour l’arrêt'
    },
    timeOverrideCantBeFirst: {
        en: 'Time override cannot be set as first pickup',
        fr: 'La surcharge de temps ne peut pas être définie comme premier ramassage'
    },
    oneTimePickup: {
        en: 'One-time pickup',
        fr: 'Ramassage ponctuel'
    },
    pickupHasDisabledCommodity: {
        en: 'Pickup has disabled commodity. ',
        fr: 'Le ramassage a un produit désactivé. '
    },
    commodityShouldBeHidden: {
        en: 'Commodity should be hidden from customer. ',
        fr: 'Le produit doit être caché au client. '
    },
    hasInvalidSubCommodity: {
        en: 'Pickup has invalid sub-commodity type. ',
        fr: 'Le produit doit être caché au client. '
    },
    hasPrimaryCommodityHidden: {
        en: 'Pickup has primary commodity (hidden). ',
        fr: 'Le ramassage a un produit principal. '
    },
    notAcceptedInZone: {
        en: 'Commodity type is not accepted in this zone. ',
        fr: "Le type de produit n'est pas accepté dans cette zone. "
    },
    zoneIsNull: {
        en: 'Pickup zone is null. ',
        fr: 'Zone de ramassage inexistante. '
    },
    recalculationInitatedBy: {
        en: 'Recalculation initated by',
        fr: 'Recalcul initié par'
    },
    timeOverride: {
        en: 'Time Override',
        fr: 'Surcharge de temps'
    },
    areYouSureRemoveFirstPickup: {
        en: 'Are you sure you want to remove the First Pickup flag from this pickup?',
        fr: `Êtes-vous sûr de vouloir retirer l’indicateur de premier ramassage de ce ramassage?`
    },
    areYouSureMakeFirstPickup: {
        en:
            'Are you sure you want make this the first pickup? This action will overwrite the previous first pickup for this trip.',
        fr:
            'Êtes-vous sûr de vouloir en faire le premier ramassage ? Cette action remplacera le précédent premier ramassage pour ce trajet'
    },
    pickupUnSkipped: {
        en: 'Pickup unskipped',
        fr: 'Ramassage non sauté'
    },
    failedToUnskipPickup: {
        en: 'Failed to unskip this pickup. Please try again in a moment',
        fr: 'Échec de la désactivation du saut de ce ramassage. Veuillez réessayer dans un moment'
    },
    removedOutOfSystemStop: {
        en: 'Removed out of system stop.',
        fr: 'Arrêt retiré du système'
    },
    successUpdateUserNotes: {
        en: 'Successfully updated user notes.',
        fr: "Notes de l'utilisateur mises à jour avec succès."
    },
    successDeletingUserNotes: {
        en: 'Successfully deleted user notes.',
        fr: "Notes de l'utilisateur supprimées avec succès"
    },
    errorLoadingCustomerInfo: {
        en: 'Error loading customer info',
        fr: 'Erreur lors du chargement des informations du client.'
    },
    minuteLunch: {
        en: '{{minutes}} minute lunch',
        fr: 'Pause dîner de {{minutes}} minutes'
    },
    minuteBreak: {
        en: '{{minutes}} minute break',
        fr: 'Pause de {{minutes}} minutes'
    },
    viewUnservicedPickups: {
        en: 'View Unserviced Pickups',
        fr: 'Voir les ramassages non effectués'
    },
    areYouSureDeleteNote: {
        en: 'Are you sure you want to delete this note?',
        fr: 'Êtes-vous sûr de vouloir supprimer cette note?'
    },
    truckToArriveAt: {
        en: 'Truck to Arrive At',
        fr: "Heure d'arrivée du camion"
    }
};

const cameraDialog = {
    cameraDialogText1: {
        en: 'Upload or take a photo to help provide information for skipping this pickup.',
        fr: 'Téléversez ou prenez une photo pour aider à fournir des informations justifiant le saut de cette collecte.'
    },
    cameraDialogText2: {
        en: 'This will be displayed to the customer.',
        fr: 'Ceci sera affiché au client.'
    },
    skipPickupHelper: {
        en:
            'Please take a picture of the location you are skipping. Try and capture the customer address in the image.',
        fr:
            "Veuillez prendre une photo de l'emplacement que vous ignorez. Essayez de capturer l'adresse du client dans l'image."
    },
    abortPickupHelper: {
        en:
            'Please take a picture of the location you are aborting. Try and capture the customer address in the image.',
        fr:
            "Veuillez prendre une photo de l'emplacement que vous annulez. Essayez de capturer l'adresse du client dans l'image."
    },
    cameraDialogText3: {
        en: 'Upload or take a photo to help provide information for aborting this pickup.',
        fr:
            "Téléversez ou prenez une photo pour aider à fournir des informations justifiant l'annulation de cette collecte."
    },
    abortNote: {
        en: 'Note: You can press the buttons above to perform the associated action',
        fr: `Remarque : Vous pouvez appuyer sur les boutons ci-dessus pour effectuer l'action associée.`
    },
    deleteImage: {
        en: 'Delete Image',
        fr: `Supprimer l'image`
    },
    noImageToDisplay: {
        en: 'No images to display',
        fr: 'Aucune image à afficher'
    },
    issueRetrievingImage: {
        en: 'Issue retrieving image',
        fr: `Problème lors de la récupération de l'image`
    },
    usePreviousImage: {
        en: 'Use Previous Image',
        fr: "Utiliser l'image précédente"
    }
};

const questionnaireTranslations = {
    completeAllToSubmit: {
        en: 'Please complete all questions to submit.',
        fr: 'Veuillez répondre à toutes les questions avant de soumettre.'
    },
    thankYou: {
        en: 'Thank you!',
        fr: 'Merci!'
    },
    responseSubmittedSuccessfully: {
        en: 'Your responses have been submitted successfully.',
        fr: 'Vos réponses ont été soumises avec succès.'
    },
    failedToSubmit: {
        en: 'Failed to submit responses. Please try again.',
        fr: 'Échec de la soumission des réponses. Veuillez réessayer.'
    },
    loadingQuestionnaire: {
        en: 'Loading Questionnaire...',
        fr: 'Chargement du questionnaire...'
    },
    pleaseWaitQuestionnaire: {
        en: 'Please wait while we prepare your questionnaire.',
        fr: 'Veuillez patienter pendant que nous préparons votre questionnaire.'
    },
    linkExpired: {
        en: 'Link Expired',
        fr: 'Lien expiré'
    },
    questionnaireExpired: {
        en: 'This questionnaire link has expired or is no longer available.',
        fr: "Ce lien de questionnaire a expiré ou n'est plus disponible."
    },
    pleaseContactNewLink: {
        en: 'Please contact the sender for a new link if you need to complete this questionnaire.',
        fr: "Veuillez contacter l'expéditeur pour obtenir un nouveau lien si vous devez compléter ce questionnaire."
    },
    safelyClosePage: {
        en: 'You can now safely close this page.',
        fr: 'Vous pouvez maintenant fermer cette page en toute sécurité.'
    },
    submitting: {
        en: 'Submitting...',
        fr: 'Soumission en cours...'
    },
    poweredBy: {
        en: 'Powered by {{brand}}',
        fr: 'Propulsé par {{brand}}'
    },
    readyToSubmit: {
        en: 'Ready to submit your responses',
        fr: 'Prêt à soumettre vos réponses'
    }
};

const ratingPlatformTranslations = {
    enterValidURL: {
        en: 'This must be a valid URL',
        fr: 'Ceci doit être une URL valide'
    },
    selectRatingPlatformFirst: {
        en: 'Please select a rating platform first',
        fr: "Veuillez d'abord sélectionner une plateforme d'évaluation"
    },
    updatedCollectorPlatforms: {
        en: 'Successfully updated collector rating platforms',
        fr: "Plateformes d'évaluation des collecteurs mises à jour avec succès"
    },
    errorUpdatingCollectorPlatforms: {
        en: 'Error updating collector rating platforms',
        fr: "Erreur lors de la mise à jour des plateformes d'évaluation des collecteurs"
    },
    unsavedChangesLost: {
        en: 'You have unsaved changes that will be lost if you change the rating platform. Do you want to continue?',
        fr:
            "Vous avez des modifications non sauvegardées qui seront perdues si vous changez de plateforme d'évaluation. Voulez-vous continuer?"
    },
    selectRatingPlatform: {
        en: 'Select Rating Platform',
        fr: "Sélectionner la plateforme d'évaluation"
    },
    applyDefaultURL: {
        en: 'Apply default URL',
        fr: "Appliquer l'URL par défaut"
    },
    selectRatingToConfigure: {
        en: 'Please select a rating platform to configure collector URLs',
        fr: "Veuillez sélectionner une plateforme d'évaluation pour configurer les URL des collecteurs"
    },
    allPlatforms: {
        en: 'All Platforms',
        fr: 'Toutes les plateformes'
    },
    configureURLs: {
        en: 'Configure URLs',
        fr: 'Configurer les URL'
    },
    updatedRatingPlatform: {
        en: 'Successfully updated rating platform.',
        fr: "Plateforme d'évaluation mise à jour avec succès."
    },
    createdRatingPlatform: {
        en: 'Successfully created rating platform.',
        fr: "Plateforme d'évaluation créée avec succès."
    },
    updatedRatingOrdering: {
        en: 'Successfully updated rating platform ordering.',
        fr: "Ordre des plateformes d'évaluation mis à jour avec succès."
    },
    allRatingPlatforms: {
        en: 'All Rating Platforms',
        fr: "Toutes les plateformes d'évaluation"
    },
    changesApplyToAllCollectors: {
        en: 'Changes apply to all collectors',
        fr: "Les modifications s'appliquent à tous les collecteurs"
    },
    createNewPlatform: {
        en: 'Create New Platform',
        fr: 'Créer une nouvelle plateforme'
    },
    unsavedOrderingChanges: {
        en: 'Unsaved ordering changes',
        fr: "Modifications d'ordre non sauvegardées"
    },
    mustEnterPlatformName: {
        en: 'You must enter a platform name.',
        fr: 'Vous devez saisir un nom de plateforme.'
    },
    mustSelectAnAppVersion: {
        en: 'You must select an app version.',
        fr: "Vous devez sélectionner une version d'application."
    },
    mustFillOut: {
        en: 'You must fill this out',
        fr: 'Vous devez remplir ce champ'
    },
    platformName: {
        en: 'Platform Name',
        fr: 'Nom de la plateforme'
    },
    rateButtonText: {
        en: 'Rate Button Text',
        fr: "Texte du bouton d'évaluation"
    },
    showPlatformOn: {
        en: 'Show Platform On',
        fr: 'Afficher la plateforme sur'
    },
    defaultURLOptional: {
        en: 'Default URL (Optional)',
        fr: 'URL par défaut (facultatif)'
    },
    defaultURLHelperText: {
        en: 'Url used to pre-populate the text field when adding it to collectors',
        fr: "URL utilisée pour pré-remplir le champ de texte lors de l'ajout aux collecteurs"
    },
    bulkEnable: {
        en: 'Bulk Enable/Disable',
        fr: 'Activation/Désactivation en lot'
    },
    bulkApplyDefault: {
        en: 'Bulk Apply Default',
        fr: 'Application par défaut en lot'
    },
    confirmResetChanges: {
        en: 'Are you sure you want to reset all changes? This will discard any unsaved work.',
        fr: 'Êtes-vous sûr de vouloir réinitialiser tous les changements? Ceci annulera tout travail non sauvegardé.'
    }
};

const refundDeclarationWidgetTranslations = {
    // Main title
    downloadRefundDeclaration: {
        en: 'Download Refund Declaration',
        fr: 'Télécharger la déclaration de remboursement'
    },

    // Caption for collapsed state
    generatePdfsForQualifyingTransactions: {
        en: 'Generate PDFs for qualifying transactions',
        fr: 'Générer des PDF pour les transactions éligibles'
    },

    // Form labels
    startDate: {
        en: 'Start Date',
        fr: 'Date de début'
    },
    start: {
        en: 'Start',
        fr: 'Début'
    },
    endDate: {
        en: 'End Date',
        fr: 'Date de fin'
    },
    end: {
        en: 'End',
        fr: 'Fin'
    },
    state: {
        en: 'State',
        fr: 'État'
    },

    // Dropdown placeholder text
    loadingStates: {
        en: 'Loading states...',
        fr: 'Chargement des états...'
    },
    selectAState: {
        en: 'Select a state',
        fr: 'Sélectionnez un état'
    },

    // Button text
    download: {
        en: 'Download',
        fr: 'Télécharger'
    },
    downloadDeclarations: {
        en: 'Download Declarations',
        fr: 'Télécharger les déclarations'
    },
    generating: {
        en: 'Generating...',
        fr: 'Génération en cours...'
    },
    generatingPdfs: {
        en: 'Generating PDFs...',
        fr: 'Génération des PDF...'
    },

    // Help text
    downloadsHelp: {
        en: 'Downloads PDFs for qualifying transactions.',
        fr: 'Télécharge des PDF pour les transactions éligibles.'
    },
    zipFileHelp: {
        en:
            'This will download a ZIP file containing refund declaration PDFs for all qualifying transactions in the selected date range.',
        fr:
            'Cela téléchargera un fichier ZIP contenant les déclarations de remboursement au format PDF pour toutes les transactions éligibles dans la plage de dates sélectionnée.'
    },
    thresholdHelp: {
        en: 'Only transactions exceeding state-specific thresholds will be included.',
        fr: 'Seules les transactions dépassant les seuils spécifiques à chaque état seront incluses.'
    },
    startDateNote: {
        en: 'Note: The start date cannot be more than 1 year in the past.',
        fr: "Remarque : La date de début ne peut pas remonter à plus d'un an dans le passé."
    }
};
const accountTypes = {
    Customer: {
        en: 'Customer',
        fr: 'Client'
    },
    'System Administrator': {
        en: 'System Administrator',
        fr: 'Administrateur système'
    },
    'Collector Administrator': {
        en: 'Collector Administrator',
        fr: 'Administrateur collecteur'
    },
    'Collector Employee': {
        en: 'Collector Employee',
        fr: 'Employé collecteur'
    },
    'Customer Service': {
        en: 'Customer Service',
        fr: 'Service à la clientèle'
    },
    'Customer Service Administrator': {
        en: 'Customer Service Administrator',
        fr: 'Administrateur du service à la clientèle'
    },
    'Finance Administrator': {
        en: 'Finance Administrator',
        fr: 'Administrateur des finances'
    },
    Marketing: {
        en: 'Marketing',
        fr: 'Marketing'
    },
    Manager: {
        en: 'Manager',
        fr: 'Gestionnaire'
    },
    'IT Administrator': {
        en: 'IT Administrator',
        fr: 'Administrateur TI'
    },
    Administrator: {
        en: 'Administrator',
        fr: 'Administrateur'
    }
};

const receiptTranslations = {
    doneBy: { en: 'Done by', fr: 'Effectué par' },
    downloadText1: { en: 'Make your returns easier!', fr: 'Simplifiez vos retours!' },
    downloadText2: {
        en: "Scan the QR code to download the Consignaction app - it's that simple!",
        fr: "Balayez le code QR pour télécharger l'application Consignaction - tout devient plus facile!"
    }
};

const allTranslations = {
    ...account,
    ...words,
    ...confirmPickupTranslations,
    ...cancelPickupTranslations,
    ...pickupWidgetTranslations,
    ...managePickupsDialogTranslations,
    ...sidebarTranslations,
    ...sideWidgetTranslations,
    ...dashboardTranslations,
    ...growthTranslations,
    ...taxReceiptsTranslations,
    ...referralTranslations,
    ...historyTranslations,
    ...redemptionTranslations,
    ...impactReportTranslations,
    ...pickupDialogDropAndGoTranslations,
    ...pickupDialogBottleDriveTranslations,
    ...registrationTranslations,
    ...loginTranslations,
    ...generalTranslations,
    ...errors,
    ...snackbar,
    ...terms,
    ...pickupDialogTranslations,
    ...promoErrors,
    ...FAQTranslations,
    ...validateErrorTranslations,
    ...charitySnackBarTranslations,
    ...charitySelectTranslations,
    ...charityStatsTranslations,
    ...growthPlanTranslations,
    ...labelTranslations,
    ...otherDialogTranslations,
    ...feedbackTranslations,
    ...customerSiteSnackbarTranslations,
    ...updateDialogTranslations,
    ...OOSPresetTranslations,
    ...pickupDialogSelectTranslations,
    ...mapMarkerTranslations,
    ...informationFormsTranslations,
    ...binRequestDialogTranslations,
    ...commodityRequestDialogTranslations,
    ...volumnReportTranslations,
    ...reviewUsersTranslations,
    ...verificationLinkTranslations,
    ...emailAuthorizationTranslations,
    ...passwordRestLinkTranslations,
    ...PORScreenTranslations,
    ...biometricsTranslations,
    ...downloadPageTranslations,
    ...daysOfWeek,
    ...externalOTC,
    ...driverDashboardTranslations,
    ...driverPickupTranslations,
    ...abortReminders,
    ...cameraDialog,
    ...adminUITranslations,
    ...questionnaireTranslations,
    ...refundDeclarationWidgetTranslations,
    ...accountTypes,
    ...ratingPlatformTranslations,
    ...receiptTranslations
};
